var lm = Object.defineProperty;
var dm = (e, n, t) => n in e ? lm(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var te = (e, n, t) => dm(e, typeof n != "symbol" ? n + "" : n, t);
import * as y from "react";
import he, { useCallback as Pe, useRef as me, useEffect as le, useMemo as dt, useReducer as rl, forwardRef as A, createContext as Se, useContext as ve, useState as De, Children as uo, useLayoutEffect as ni, useImperativeHandle as fm, Fragment as lo, cloneElement as pm, Component as hm, createElement as qo, PureComponent as mm } from "react";
import * as ri from "react-dom";
import vm, { createPortal as gm } from "react-dom";
import { ChevronDown as fo, Close as Bt, ChevronRight as oi, Edit as ym, Check as ol, ChevronLeft as al, Globe as bm, Calendar as xm, ArrowRight as wm, ExclamationTriangleSolid as Da, InfoCircleSolid as il, CheckCircleSolid as sl, PanelOpen as _m, PanelClose as Cm, Search as Im, ChevronsLeft as Tm, Menu as Em, CloseCircleSolid as Pm } from "@primer-io/goat-icons";
function Sm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ra = { exports: {} }, qn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nc;
function Dm() {
  if (Nc) return qn;
  Nc = 1;
  var e = he, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(s, c, l) {
    var d, f = {}, p = null, m = null;
    l !== void 0 && (p = "" + l), c.key !== void 0 && (p = "" + c.key), c.ref !== void 0 && (m = c.ref);
    for (d in c) r.call(c, d) && !a.hasOwnProperty(d) && (f[d] = c[d]);
    if (s && s.defaultProps) for (d in c = s.defaultProps, c) f[d] === void 0 && (f[d] = c[d]);
    return { $$typeof: n, type: s, key: p, ref: m, props: f, _owner: o.current };
  }
  return qn.Fragment = t, qn.jsx = i, qn.jsxs = i, qn;
}
var Xn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mc;
function Rm() {
  return Mc || (Mc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = he, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = Symbol.iterator, h = "@@iterator";
    function v(I) {
      if (I === null || typeof I != "object")
        return null;
      var H = g && I[g] || I[h];
      return typeof H == "function" ? H : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(I) {
      {
        for (var H = arguments.length, Z = new Array(H > 1 ? H - 1 : 0), ie = 1; ie < H; ie++)
          Z[ie - 1] = arguments[ie];
        x("error", I, Z);
      }
    }
    function x(I, H, Z) {
      {
        var ie = w.ReactDebugCurrentFrame, we = ie.getStackAddendum();
        we !== "" && (H += "%s", Z = Z.concat([we]));
        var Re = Z.map(function(ge) {
          return String(ge);
        });
        Re.unshift("Warning: " + H), Function.prototype.apply.call(console[I], console, Re);
      }
    }
    var C = !1, _ = !1, E = !1, D = !1, T = !1, S;
    S = Symbol.for("react.module.reference");
    function N(I) {
      return !!(typeof I == "string" || typeof I == "function" || I === r || I === a || T || I === o || I === l || I === d || D || I === m || C || _ || E || typeof I == "object" && I !== null && (I.$$typeof === p || I.$$typeof === f || I.$$typeof === i || I.$$typeof === s || I.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      I.$$typeof === S || I.getModuleId !== void 0));
    }
    function k(I, H, Z) {
      var ie = I.displayName;
      if (ie)
        return ie;
      var we = H.displayName || H.name || "";
      return we !== "" ? Z + "(" + we + ")" : Z;
    }
    function Y(I) {
      return I.displayName || "Context";
    }
    function U(I) {
      if (I == null)
        return null;
      if (typeof I.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof I == "function")
        return I.displayName || I.name || null;
      if (typeof I == "string")
        return I;
      switch (I) {
        case r:
          return "Fragment";
        case t:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case l:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case s:
            var H = I;
            return Y(H) + ".Consumer";
          case i:
            var Z = I;
            return Y(Z._context) + ".Provider";
          case c:
            return k(I, I.render, "ForwardRef");
          case f:
            var ie = I.displayName || null;
            return ie !== null ? ie : U(I.type) || "Memo";
          case p: {
            var we = I, Re = we._payload, ge = we._init;
            try {
              return U(ge(Re));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, oe = 0, q, O, M, B, R, V, F;
    function $() {
    }
    $.__reactDisabledLog = !0;
    function L() {
      {
        if (oe === 0) {
          q = console.log, O = console.info, M = console.warn, B = console.error, R = console.group, V = console.groupCollapsed, F = console.groupEnd;
          var I = {
            configurable: !0,
            enumerable: !0,
            value: $,
            writable: !0
          };
          Object.defineProperties(console, {
            info: I,
            log: I,
            warn: I,
            error: I,
            group: I,
            groupCollapsed: I,
            groupEnd: I
          });
        }
        oe++;
      }
    }
    function G() {
      {
        if (oe--, oe === 0) {
          var I = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, I, {
              value: q
            }),
            info: j({}, I, {
              value: O
            }),
            warn: j({}, I, {
              value: M
            }),
            error: j({}, I, {
              value: B
            }),
            group: j({}, I, {
              value: R
            }),
            groupCollapsed: j({}, I, {
              value: V
            }),
            groupEnd: j({}, I, {
              value: F
            })
          });
        }
        oe < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var z = w.ReactCurrentDispatcher, Q;
    function J(I, H, Z) {
      {
        if (Q === void 0)
          try {
            throw Error();
          } catch (we) {
            var ie = we.stack.trim().match(/\n( *(at )?)/);
            Q = ie && ie[1] || "";
          }
        return `
` + Q + I;
      }
    }
    var ee = !1, re;
    {
      var de = typeof WeakMap == "function" ? WeakMap : Map;
      re = new de();
    }
    function W(I, H) {
      if (!I || ee)
        return "";
      {
        var Z = re.get(I);
        if (Z !== void 0)
          return Z;
      }
      var ie;
      ee = !0;
      var we = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Re;
      Re = z.current, z.current = null, L();
      try {
        if (H) {
          var ge = function() {
            throw Error();
          };
          if (Object.defineProperty(ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ge, []);
            } catch (st) {
              ie = st;
            }
            Reflect.construct(I, [], ge);
          } else {
            try {
              ge.call();
            } catch (st) {
              ie = st;
            }
            I.call(ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (st) {
            ie = st;
          }
          I();
        }
      } catch (st) {
        if (st && ie && typeof st.stack == "string") {
          for (var fe = st.stack.split(`
`), Je = ie.stack.split(`
`), Fe = fe.length - 1, Be = Je.length - 1; Fe >= 1 && Be >= 0 && fe[Fe] !== Je[Be]; )
            Be--;
          for (; Fe >= 1 && Be >= 0; Fe--, Be--)
            if (fe[Fe] !== Je[Be]) {
              if (Fe !== 1 || Be !== 1)
                do
                  if (Fe--, Be--, Be < 0 || fe[Fe] !== Je[Be]) {
                    var bt = `
` + fe[Fe].replace(" at new ", " at ");
                    return I.displayName && bt.includes("<anonymous>") && (bt = bt.replace("<anonymous>", I.displayName)), typeof I == "function" && re.set(I, bt), bt;
                  }
                while (Fe >= 1 && Be >= 0);
              break;
            }
        }
      } finally {
        ee = !1, z.current = Re, G(), Error.prepareStackTrace = we;
      }
      var yn = I ? I.displayName || I.name : "", an = yn ? J(yn) : "";
      return typeof I == "function" && re.set(I, an), an;
    }
    function ye(I, H, Z) {
      return W(I, !1);
    }
    function X(I) {
      var H = I.prototype;
      return !!(H && H.isReactComponent);
    }
    function je(I, H, Z) {
      if (I == null)
        return "";
      if (typeof I == "function")
        return W(I, X(I));
      if (typeof I == "string")
        return J(I);
      switch (I) {
        case l:
          return J("Suspense");
        case d:
          return J("SuspenseList");
      }
      if (typeof I == "object")
        switch (I.$$typeof) {
          case c:
            return ye(I.render);
          case f:
            return je(I.type, H, Z);
          case p: {
            var ie = I, we = ie._payload, Re = ie._init;
            try {
              return je(Re(we), H, Z);
            } catch {
            }
          }
        }
      return "";
    }
    var Ae = Object.prototype.hasOwnProperty, at = {}, Qe = w.ReactDebugCurrentFrame;
    function ze(I) {
      if (I) {
        var H = I._owner, Z = je(I.type, I._source, H ? H.type : null);
        Qe.setExtraStackFrame(Z);
      } else
        Qe.setExtraStackFrame(null);
    }
    function $t(I, H, Z, ie, we) {
      {
        var Re = Function.call.bind(Ae);
        for (var ge in I)
          if (Re(I, ge)) {
            var fe = void 0;
            try {
              if (typeof I[ge] != "function") {
                var Je = Error((ie || "React class") + ": " + Z + " type `" + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof I[ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Je.name = "Invariant Violation", Je;
              }
              fe = I[ge](H, ge, ie, Z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Fe) {
              fe = Fe;
            }
            fe && !(fe instanceof Error) && (ze(we), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ie || "React class", Z, ge, typeof fe), ze(null)), fe instanceof Error && !(fe.message in at) && (at[fe.message] = !0, ze(we), b("Failed %s type: %s", Z, fe.message), ze(null));
          }
      }
    }
    var xe = Array.isArray;
    function yt(I) {
      return xe(I);
    }
    function zn(I) {
      {
        var H = typeof Symbol == "function" && Symbol.toStringTag, Z = H && I[Symbol.toStringTag] || I.constructor.name || "Object";
        return Z;
      }
    }
    function vn(I) {
      try {
        return _t(I), !1;
      } catch {
        return !0;
      }
    }
    function _t(I) {
      return "" + I;
    }
    function Dt(I) {
      if (vn(I))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", zn(I)), _t(I);
    }
    var it = w.ReactCurrentOwner, pt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pr, Cc, Ko;
    Ko = {};
    function Gh(I) {
      if (Ae.call(I, "ref")) {
        var H = Object.getOwnPropertyDescriptor(I, "ref").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return I.ref !== void 0;
    }
    function zh(I) {
      if (Ae.call(I, "key")) {
        var H = Object.getOwnPropertyDescriptor(I, "key").get;
        if (H && H.isReactWarning)
          return !1;
      }
      return I.key !== void 0;
    }
    function qh(I, H) {
      if (typeof I.ref == "string" && it.current && H && it.current.stateNode !== H) {
        var Z = U(it.current.type);
        Ko[Z] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', U(it.current.type), I.ref), Ko[Z] = !0);
      }
    }
    function Xh(I, H) {
      {
        var Z = function() {
          Pr || (Pr = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
        };
        Z.isReactWarning = !0, Object.defineProperty(I, "key", {
          get: Z,
          configurable: !0
        });
      }
    }
    function Qh(I, H) {
      {
        var Z = function() {
          Cc || (Cc = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
        };
        Z.isReactWarning = !0, Object.defineProperty(I, "ref", {
          get: Z,
          configurable: !0
        });
      }
    }
    var Zh = function(I, H, Z, ie, we, Re, ge) {
      var fe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: I,
        key: H,
        ref: Z,
        props: ge,
        // Record the component responsible for creating this element.
        _owner: Re
      };
      return fe._store = {}, Object.defineProperty(fe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(fe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ie
      }), Object.defineProperty(fe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: we
      }), Object.freeze && (Object.freeze(fe.props), Object.freeze(fe)), fe;
    };
    function Jh(I, H, Z, ie, we) {
      {
        var Re, ge = {}, fe = null, Je = null;
        Z !== void 0 && (Dt(Z), fe = "" + Z), zh(H) && (Dt(H.key), fe = "" + H.key), Gh(H) && (Je = H.ref, qh(H, we));
        for (Re in H)
          Ae.call(H, Re) && !pt.hasOwnProperty(Re) && (ge[Re] = H[Re]);
        if (I && I.defaultProps) {
          var Fe = I.defaultProps;
          for (Re in Fe)
            ge[Re] === void 0 && (ge[Re] = Fe[Re]);
        }
        if (fe || Je) {
          var Be = typeof I == "function" ? I.displayName || I.name || "Unknown" : I;
          fe && Xh(ge, Be), Je && Qh(ge, Be);
        }
        return Zh(I, fe, Je, we, ie, it.current, ge);
      }
    }
    var Yo = w.ReactCurrentOwner, Ic = w.ReactDebugCurrentFrame;
    function gn(I) {
      if (I) {
        var H = I._owner, Z = je(I.type, I._source, H ? H.type : null);
        Ic.setExtraStackFrame(Z);
      } else
        Ic.setExtraStackFrame(null);
    }
    var Uo;
    Uo = !1;
    function Go(I) {
      return typeof I == "object" && I !== null && I.$$typeof === n;
    }
    function Tc() {
      {
        if (Yo.current) {
          var I = U(Yo.current.type);
          if (I)
            return `

Check the render method of \`` + I + "`.";
        }
        return "";
      }
    }
    function em(I) {
      return "";
    }
    var Ec = {};
    function tm(I) {
      {
        var H = Tc();
        if (!H) {
          var Z = typeof I == "string" ? I : I.displayName || I.name;
          Z && (H = `

Check the top-level render call using <` + Z + ">.");
        }
        return H;
      }
    }
    function Pc(I, H) {
      {
        if (!I._store || I._store.validated || I.key != null)
          return;
        I._store.validated = !0;
        var Z = tm(H);
        if (Ec[Z])
          return;
        Ec[Z] = !0;
        var ie = "";
        I && I._owner && I._owner !== Yo.current && (ie = " It was passed a child from " + U(I._owner.type) + "."), gn(I), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Z, ie), gn(null);
      }
    }
    function Sc(I, H) {
      {
        if (typeof I != "object")
          return;
        if (yt(I))
          for (var Z = 0; Z < I.length; Z++) {
            var ie = I[Z];
            Go(ie) && Pc(ie, H);
          }
        else if (Go(I))
          I._store && (I._store.validated = !0);
        else if (I) {
          var we = v(I);
          if (typeof we == "function" && we !== I.entries)
            for (var Re = we.call(I), ge; !(ge = Re.next()).done; )
              Go(ge.value) && Pc(ge.value, H);
        }
      }
    }
    function nm(I) {
      {
        var H = I.type;
        if (H == null || typeof H == "string")
          return;
        var Z;
        if (typeof H == "function")
          Z = H.propTypes;
        else if (typeof H == "object" && (H.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        H.$$typeof === f))
          Z = H.propTypes;
        else
          return;
        if (Z) {
          var ie = U(H);
          $t(Z, I.props, "prop", ie, I);
        } else if (H.PropTypes !== void 0 && !Uo) {
          Uo = !0;
          var we = U(H);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", we || "Unknown");
        }
        typeof H.getDefaultProps == "function" && !H.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rm(I) {
      {
        for (var H = Object.keys(I.props), Z = 0; Z < H.length; Z++) {
          var ie = H[Z];
          if (ie !== "children" && ie !== "key") {
            gn(I), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ie), gn(null);
            break;
          }
        }
        I.ref !== null && (gn(I), b("Invalid attribute `ref` supplied to `React.Fragment`."), gn(null));
      }
    }
    var Dc = {};
    function Rc(I, H, Z, ie, we, Re) {
      {
        var ge = N(I);
        if (!ge) {
          var fe = "";
          (I === void 0 || typeof I == "object" && I !== null && Object.keys(I).length === 0) && (fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Je = em();
          Je ? fe += Je : fe += Tc();
          var Fe;
          I === null ? Fe = "null" : yt(I) ? Fe = "array" : I !== void 0 && I.$$typeof === n ? (Fe = "<" + (U(I.type) || "Unknown") + " />", fe = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof I, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fe, fe);
        }
        var Be = Jh(I, H, Z, we, Re);
        if (Be == null)
          return Be;
        if (ge) {
          var bt = H.children;
          if (bt !== void 0)
            if (ie)
              if (yt(bt)) {
                for (var yn = 0; yn < bt.length; yn++)
                  Sc(bt[yn], I);
                Object.freeze && Object.freeze(bt);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Sc(bt, I);
        }
        if (Ae.call(H, "key")) {
          var an = U(I), st = Object.keys(H).filter(function(um) {
            return um !== "key";
          }), zo = st.length > 0 ? "{key: someKey, " + st.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Dc[an + zo]) {
            var cm = st.length > 0 ? "{" + st.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, zo, an, cm, an), Dc[an + zo] = !0;
          }
        }
        return I === r ? rm(Be) : nm(Be), Be;
      }
    }
    function om(I, H, Z) {
      return Rc(I, H, Z, !0);
    }
    function am(I, H, Z) {
      return Rc(I, H, Z, !1);
    }
    var im = am, sm = om;
    Xn.Fragment = r, Xn.jsx = im, Xn.jsxs = sm;
  }()), Xn;
}
process.env.NODE_ENV === "production" ? Ra.exports = Dm() : Ra.exports = Rm();
var u = Ra.exports;
function Nm(e, n) {
  const t = y.createContext(n), r = (a) => {
    const { children: i, ...s } = a, c = y.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ u.jsx(t.Provider, { value: c, children: i });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const i = y.useContext(t);
    if (i) return i;
    if (n !== void 0) return n;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function At(e, n = []) {
  let t = [];
  function r(a, i) {
    const s = y.createContext(i), c = t.length;
    t = [...t, i];
    const l = (f) => {
      var w;
      const { scope: p, children: m, ...g } = f, h = ((w = p == null ? void 0 : p[e]) == null ? void 0 : w[c]) || s, v = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u.jsx(h.Provider, { value: v, children: m });
    };
    l.displayName = a + "Provider";
    function d(f, p) {
      var h;
      const m = ((h = p == null ? void 0 : p[e]) == null ? void 0 : h[c]) || s, g = y.useContext(m);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [l, d];
  }
  const o = () => {
    const a = t.map((i) => y.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, Mm(o, ...n)];
}
function Mm(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const t = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = n.scopeName, t;
}
function Om(e, n = []) {
  let t = [];
  function r(a, i) {
    const s = y.createContext(i), c = t.length;
    t = [...t, i];
    function l(f) {
      const { scope: p, children: m, ...g } = f, h = (p == null ? void 0 : p[e][c]) || s, v = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u.jsx(h.Provider, { value: v, children: m });
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][c]) || s, g = y.useContext(m);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = t.map((i) => y.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, jm(o, ...n)];
}
function jm(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const t = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = n.scopeName, t;
}
function Am(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function po(...e) {
  return (n) => e.forEach((t) => Am(t, n));
}
function Me(...e) {
  return y.useCallback(po(...e), e);
}
var ln = y.forwardRef((e, n) => {
  const { children: t, ...r } = e, o = y.Children.toArray(t), a = o.find(km);
  if (a) {
    const i = a.props.children, s = o.map((c) => c === a ? y.Children.count(i) > 1 ? y.Children.only(null) : y.isValidElement(i) ? i.props.children : null : c);
    return /* @__PURE__ */ u.jsx(Na, { ...r, ref: n, children: y.isValidElement(i) ? y.cloneElement(i, void 0, s) : null });
  }
  return /* @__PURE__ */ u.jsx(Na, { ...r, ref: n, children: t });
});
ln.displayName = "Slot";
var Na = y.forwardRef((e, n) => {
  const { children: t, ...r } = e;
  if (y.isValidElement(t)) {
    const o = $m(t);
    return y.cloneElement(t, {
      ...Lm(r, t.props),
      // @ts-ignore
      ref: n ? po(n, o) : o
    });
  }
  return y.Children.count(t) > 1 ? y.Children.only(null) : null;
});
Na.displayName = "SlotClone";
var cl = ({ children: e }) => /* @__PURE__ */ u.jsx(u.Fragment, { children: e });
function km(e) {
  return y.isValidElement(e) && e.type === cl;
}
function Lm(e, n) {
  const t = { ...n };
  for (const r in n) {
    const o = e[r], a = n[r];
    /^on[A-Z]/.test(r) ? o && a ? t[r] = (...s) => {
      a(...s), o(...s);
    } : o && (t[r] = o) : r === "style" ? t[r] = { ...o, ...a } : r === "className" && (t[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...t };
}
function $m(e) {
  var r, o;
  let n = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, t = n && "isReactWarning" in n && n.isReactWarning;
  return t ? e.ref : (n = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, t = n && "isReactWarning" in n && n.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
function ho(e) {
  const n = e + "CollectionProvider", [t, r] = Om(n), [o, a] = t(
    n,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: g, children: h } = m, v = he.useRef(null), w = he.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ u.jsx(o, { scope: g, itemMap: w, collectionRef: v, children: h });
  };
  i.displayName = n;
  const s = e + "CollectionSlot", c = he.forwardRef(
    (m, g) => {
      const { scope: h, children: v } = m, w = a(s, h), b = Me(g, w.collectionRef);
      return /* @__PURE__ */ u.jsx(ln, { ref: b, children: v });
    }
  );
  c.displayName = s;
  const l = e + "CollectionItemSlot", d = "data-radix-collection-item", f = he.forwardRef(
    (m, g) => {
      const { scope: h, children: v, ...w } = m, b = he.useRef(null), x = Me(g, b), C = a(l, h);
      return he.useEffect(() => (C.itemMap.set(b, { ref: b, ...w }), () => void C.itemMap.delete(b))), /* @__PURE__ */ u.jsx(ln, { [d]: "", ref: x, children: v });
    }
  );
  f.displayName = l;
  function p(m) {
    const g = a(e + "CollectionConsumer", m);
    return he.useCallback(() => {
      const v = g.collectionRef.current;
      if (!v) return [];
      const w = Array.from(v.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (C, _) => w.indexOf(C.ref.current) - w.indexOf(_.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: f },
    p,
    r
  ];
}
function ne(e, n, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), t === !1 || !o.defaultPrevented)
      return n == null ? void 0 : n(o);
  };
}
function tt(e) {
  const n = y.useRef(e);
  return y.useEffect(() => {
    n.current = e;
  }), y.useMemo(() => (...t) => {
    var r;
    return (r = n.current) == null ? void 0 : r.call(n, ...t);
  }, []);
}
function Ue({
  prop: e,
  defaultProp: n,
  onChange: t = () => {
  }
}) {
  const [r, o] = Fm({ defaultProp: n, onChange: t }), a = e !== void 0, i = a ? e : r, s = tt(t), c = y.useCallback(
    (l) => {
      if (a) {
        const f = typeof l == "function" ? l(e) : l;
        f !== e && s(f);
      } else
        o(l);
    },
    [a, e, o, s]
  );
  return [i, c];
}
function Fm({
  defaultProp: e,
  onChange: n
}) {
  const t = y.useState(e), [r] = t, o = y.useRef(r), a = tt(n);
  return y.useEffect(() => {
    o.current !== r && (a(r), o.current = r);
  }, [r, o, a]), t;
}
var Vm = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], se = Vm.reduce((e, n) => {
  const t = y.forwardRef((r, o) => {
    const { asChild: a, ...i } = r, s = a ? ln : n;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u.jsx(s, { ...i, ref: o });
  });
  return t.displayName = `Primitive.${n}`, { ...e, [n]: t };
}, {});
function ai(e, n) {
  e && ri.flushSync(() => e.dispatchEvent(n));
}
var Kt = globalThis != null && globalThis.document ? y.useLayoutEffect : () => {
};
function Hm(e, n) {
  return y.useReducer((t, r) => n[t][r] ?? t, e);
}
var nt = (e) => {
  const { present: n, children: t } = e, r = Wm(n), o = typeof t == "function" ? t({ present: r.isPresent }) : y.Children.only(t), a = Me(r.ref, Bm(o));
  return typeof t == "function" || r.isPresent ? y.cloneElement(o, { ref: a }) : null;
};
nt.displayName = "Presence";
function Wm(e) {
  const [n, t] = y.useState(), r = y.useRef({}), o = y.useRef(e), a = y.useRef("none"), i = e ? "mounted" : "unmounted", [s, c] = Hm(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return y.useEffect(() => {
    const l = Sr(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), Kt(() => {
    const l = r.current, d = o.current;
    if (d !== e) {
      const p = a.current, m = Sr(l);
      e ? c("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(d && p !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), Kt(() => {
    if (n) {
      let l;
      const d = n.ownerDocument.defaultView ?? window, f = (m) => {
        const h = Sr(r.current).includes(m.animationName);
        if (m.target === n && h && (c("ANIMATION_END"), !o.current)) {
          const v = n.style.animationFillMode;
          n.style.animationFillMode = "forwards", l = d.setTimeout(() => {
            n.style.animationFillMode === "forwards" && (n.style.animationFillMode = v);
          });
        }
      }, p = (m) => {
        m.target === n && (a.current = Sr(r.current));
      };
      return n.addEventListener("animationstart", p), n.addEventListener("animationcancel", f), n.addEventListener("animationend", f), () => {
        d.clearTimeout(l), n.removeEventListener("animationstart", p), n.removeEventListener("animationcancel", f), n.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [n, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: y.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), t(l);
    }, [])
  };
}
function Sr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Bm(e) {
  var r, o;
  let n = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, t = n && "isReactWarning" in n && n.isReactWarning;
  return t ? e.ref : (n = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, t = n && "isReactWarning" in n && n.isReactWarning, t ? e.props.ref : e.props.ref || e.ref);
}
var Km = y.useId || (() => {
}), Ym = 0;
function It(e) {
  const [n, t] = y.useState(Km());
  return Kt(() => {
    t((r) => r ?? String(Ym++));
  }, [e]), n ? `radix-${n}` : "";
}
var ii = "Collapsible", [Um, ul] = At(ii), [Gm, si] = Um(ii), ci = y.forwardRef(
  (e, n) => {
    const {
      __scopeCollapsible: t,
      open: r,
      defaultOpen: o,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [c = !1, l] = Ue({
      prop: r,
      defaultProp: o,
      onChange: i
    });
    return /* @__PURE__ */ u.jsx(
      Gm,
      {
        scope: t,
        disabled: a,
        contentId: It(),
        open: c,
        onOpenToggle: y.useCallback(() => l((d) => !d), [l]),
        children: /* @__PURE__ */ u.jsx(
          se.div,
          {
            "data-state": fi(c),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: n
          }
        )
      }
    );
  }
);
ci.displayName = ii;
var ll = "CollapsibleTrigger", ui = y.forwardRef(
  (e, n) => {
    const { __scopeCollapsible: t, ...r } = e, o = si(ll, t);
    return /* @__PURE__ */ u.jsx(
      se.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": fi(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...r,
        ref: n,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
  }
);
ui.displayName = ll;
var li = "CollapsibleContent", di = y.forwardRef(
  (e, n) => {
    const { forceMount: t, ...r } = e, o = si(li, e.__scopeCollapsible);
    return /* @__PURE__ */ u.jsx(nt, { present: t || o.open, children: ({ present: a }) => /* @__PURE__ */ u.jsx(zm, { ...r, ref: n, present: a }) });
  }
);
di.displayName = li;
var zm = y.forwardRef((e, n) => {
  const { __scopeCollapsible: t, present: r, children: o, ...a } = e, i = si(li, t), [s, c] = y.useState(r), l = y.useRef(null), d = Me(n, l), f = y.useRef(0), p = f.current, m = y.useRef(0), g = m.current, h = i.open || s, v = y.useRef(h), w = y.useRef();
  return y.useEffect(() => {
    const b = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(b);
  }, []), Kt(() => {
    const b = l.current;
    if (b) {
      w.current = w.current || {
        transitionDuration: b.style.transitionDuration,
        animationName: b.style.animationName
      }, b.style.transitionDuration = "0s", b.style.animationName = "none";
      const x = b.getBoundingClientRect();
      f.current = x.height, m.current = x.width, v.current || (b.style.transitionDuration = w.current.transitionDuration, b.style.animationName = w.current.animationName), c(r);
    }
  }, [i.open, r]), /* @__PURE__ */ u.jsx(
    se.div,
    {
      "data-state": fi(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !h,
      ...a,
      ref: d,
      style: {
        "--radix-collapsible-content-height": p ? `${p}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: h && o
    }
  );
});
function fi(e) {
  return e ? "open" : "closed";
}
var qm = ci, Xm = ui, Qm = di, Zm = y.createContext(void 0);
function dr(e) {
  const n = y.useContext(Zm);
  return e || n || "ltr";
}
var zt = "Accordion", Jm = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [pi, ev, tv] = ho(zt), [mo, iD] = At(zt, [
  tv,
  ul
]), hi = ul(), dl = he.forwardRef(
  (e, n) => {
    const { type: t, ...r } = e, o = r, a = r;
    return /* @__PURE__ */ u.jsx(pi.Provider, { scope: e.__scopeAccordion, children: t === "multiple" ? /* @__PURE__ */ u.jsx(av, { ...a, ref: n }) : /* @__PURE__ */ u.jsx(ov, { ...o, ref: n }) });
  }
);
dl.displayName = zt;
var [fl, nv] = mo(zt), [pl, rv] = mo(
  zt,
  { collapsible: !1 }
), ov = he.forwardRef(
  (e, n) => {
    const {
      value: t,
      defaultValue: r,
      onValueChange: o = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, c] = Ue({
      prop: t,
      defaultProp: r,
      onChange: o
    });
    return /* @__PURE__ */ u.jsx(
      fl,
      {
        scope: e.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: c,
        onItemClose: he.useCallback(() => a && c(""), [a, c]),
        children: /* @__PURE__ */ u.jsx(pl, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ u.jsx(hl, { ...i, ref: n }) })
      }
    );
  }
), av = he.forwardRef((e, n) => {
  const {
    value: t,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i = [], s] = Ue({
    prop: t,
    defaultProp: r,
    onChange: o
  }), c = he.useCallback(
    (d) => s((f = []) => [...f, d]),
    [s]
  ), l = he.useCallback(
    (d) => s((f = []) => f.filter((p) => p !== d)),
    [s]
  );
  return /* @__PURE__ */ u.jsx(
    fl,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: c,
      onItemClose: l,
      children: /* @__PURE__ */ u.jsx(pl, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ u.jsx(hl, { ...a, ref: n }) })
    }
  );
}), [iv, vo] = mo(zt), hl = he.forwardRef(
  (e, n) => {
    const { __scopeAccordion: t, disabled: r, dir: o, orientation: a = "vertical", ...i } = e, s = he.useRef(null), c = Me(s, n), l = ev(t), f = dr(o) === "ltr", p = ne(e.onKeyDown, (m) => {
      var T;
      if (!Jm.includes(m.key)) return;
      const g = m.target, h = l().filter((S) => {
        var N;
        return !((N = S.ref.current) != null && N.disabled);
      }), v = h.findIndex((S) => S.ref.current === g), w = h.length;
      if (v === -1) return;
      m.preventDefault();
      let b = v;
      const x = 0, C = w - 1, _ = () => {
        b = v + 1, b > C && (b = x);
      }, E = () => {
        b = v - 1, b < x && (b = C);
      };
      switch (m.key) {
        case "Home":
          b = x;
          break;
        case "End":
          b = C;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? _() : E());
          break;
        case "ArrowDown":
          a === "vertical" && _();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? E() : _());
          break;
        case "ArrowUp":
          a === "vertical" && E();
          break;
      }
      const D = b % w;
      (T = h[D].ref.current) == null || T.focus();
    });
    return /* @__PURE__ */ u.jsx(
      iv,
      {
        scope: t,
        disabled: r,
        direction: o,
        orientation: a,
        children: /* @__PURE__ */ u.jsx(pi.Slot, { scope: t, children: /* @__PURE__ */ u.jsx(
          se.div,
          {
            ...i,
            "data-orientation": a,
            ref: c,
            onKeyDown: r ? void 0 : p
          }
        ) })
      }
    );
  }
), zr = "AccordionItem", [sv, mi] = mo(zr), ml = he.forwardRef(
  (e, n) => {
    const { __scopeAccordion: t, value: r, ...o } = e, a = vo(zr, t), i = nv(zr, t), s = hi(t), c = It(), l = r && i.value.includes(r) || !1, d = a.disabled || e.disabled;
    return /* @__PURE__ */ u.jsx(
      sv,
      {
        scope: t,
        open: l,
        disabled: d,
        triggerId: c,
        children: /* @__PURE__ */ u.jsx(
          qm,
          {
            "data-orientation": a.orientation,
            "data-state": wl(l),
            ...s,
            ...o,
            ref: n,
            disabled: d,
            open: l,
            onOpenChange: (f) => {
              f ? i.onItemOpen(r) : i.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
ml.displayName = zr;
var vl = "AccordionHeader", gl = he.forwardRef(
  (e, n) => {
    const { __scopeAccordion: t, ...r } = e, o = vo(zt, t), a = mi(vl, t);
    return /* @__PURE__ */ u.jsx(
      se.h3,
      {
        "data-orientation": o.orientation,
        "data-state": wl(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: n
      }
    );
  }
);
gl.displayName = vl;
var Ma = "AccordionTrigger", yl = he.forwardRef(
  (e, n) => {
    const { __scopeAccordion: t, ...r } = e, o = vo(zt, t), a = mi(Ma, t), i = rv(Ma, t), s = hi(t);
    return /* @__PURE__ */ u.jsx(pi.ItemSlot, { scope: t, children: /* @__PURE__ */ u.jsx(
      Xm,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": o.orientation,
        id: a.triggerId,
        ...s,
        ...r,
        ref: n
      }
    ) });
  }
);
yl.displayName = Ma;
var bl = "AccordionContent", xl = he.forwardRef(
  (e, n) => {
    const { __scopeAccordion: t, ...r } = e, o = vo(zt, t), a = mi(bl, t), i = hi(t);
    return /* @__PURE__ */ u.jsx(
      Qm,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": o.orientation,
        ...i,
        ...r,
        ref: n,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
xl.displayName = bl;
function wl(e) {
  return e ? "open" : "closed";
}
var cv = dl;
const sD = [
  "neutral",
  "positive",
  "negative",
  "informative",
  "attentive"
], uv = {
  neutral: "gray",
  positive: "green",
  negative: "red",
  informative: "blue",
  attentive: "yellow"
}, cD = ["high", "low"];
function P(...e) {
  let n = "";
  for (let t = 0, r; t < e.length; t++)
    (r = lv(e[t])) && (n += (n && " ") + r);
  return n;
}
function lv(e) {
  if (typeof e == "string" || typeof e == "number") return e;
  if (Array.isArray(e)) return P(...e);
  let n = "";
  for (const t in e)
    e[t] && (n += (n && " ") + t);
  return n;
}
function Oa(e, n) {
  var r;
  const t = e.value;
  e.value = n, (r = e._valueTracker) == null || r.setValue(t), e.dispatchEvent(new InputEvent("change", { bubbles: !0 }));
}
function dv(e) {
  const n = {};
  for (const t in e) n[t] = e[t];
  return n;
}
function _l(e, n) {
  for (const t in n)
    if (e[t] !== n[t]) return !1;
  return !0;
}
const uD = (e) => `var(--goat-animation-timing-function-${e})`, fv = (e) => `var(--goat-radius-${e})`, kn = (e) => `var(--goat-color-${e})`, pv = "base", Cl = (e) => `calc(var(--goat-space-${pv}) * ${e})`, hv = "base", lD = (e) => `calc(var(--goat-time-${hv}) * ${e})`, mv = (e) => e.replace(/([A-Z])/g, (n) => `-${n.toLowerCase()}`), vv = (e) => Object.entries(e).map(([n, t]) => `${mv(n)}: ${t};`).join(`
`), dD = (e) => {
  const n = (r) => `var(--goat-typography-${e}-${r})`, t = {
    font: n("font"),
    letterSpacing: n("letter-spacing"),
    textTransform: n("text-transform"),
    fontStyle: n("font-style")
  };
  return Object.defineProperty(t, "toString", { value: () => vv(t) }), t;
}, gv = (e) => e == null ? [] : Array.isArray(e) ? e : [e], yv = (e) => typeof e == "string" ? e : gv(e).map(Cl).join(" "), bv = (e) => e && kn(e), xv = (e) => e && fv(e), wv = {
  color: {
    properties: ["borderColor", "backgroundColor"],
    transformer: bv
  },
  space: {
    properties: ["padding", "gap", "rowGap", "columnGap"],
    transformer: yv
  },
  radius: {
    properties: ["borderRadius"],
    transformer: xv
  }
}, vi = (e) => {
  const n = { ...e };
  for (const { properties: t, transformer: r } of Object.values(wv))
    for (const o of t)
      o in e && (n[o] = r(e[o]));
  return n;
};
function _v(e, n) {
  typeof e == "function" ? e(n) : e != null && (e.current = n);
}
function gi(...e) {
  return (n) => e.forEach((t) => _v(t, n));
}
function fr(...e) {
  return Pe(gi(...e), e);
}
function Cv(e, n = 0) {
  const t = me(), r = me(e);
  return le(() => {
    r.current = e;
  }, [e]), Pe(
    (...o) => {
      clearTimeout(t.current), typeof window < "u" && (t.current = window.setTimeout(
        () => r.current(...o),
        n
      ));
    },
    [n]
    // Ensure that the function updates when the delay time changes.
  );
}
function go(e) {
  const n = me(null);
  return le(() => {
    e instanceof Function ? e(n.current) : e && (e.current = n.current);
  }, []), n;
}
function yi(e) {
  const n = me({ value: e, previous: e });
  return dt(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
function Il() {
  const [, e] = rl(() => ({}), {});
  return e;
}
function fD(e) {
  const n = Il();
  le(n, e);
}
const bi = ({
  className: e,
  contrast: n = "high",
  sentiment: t = "neutral",
  ...r
}) => /* @__PURE__ */ u.jsx(
  "span",
  {
    ...r,
    className: P(
      "goat-Badge",
      `goat-Badge_${t}`,
      `goat-Badge_${n}`,
      e
    )
  }
), Iv = A(function({ children: n, className: t, as: r = "div", maxHeight: o, ...a }, i) {
  return /* @__PURE__ */ u.jsx(
    xl,
    {
      ...a,
      ref: i,
      asChild: !0,
      style: o ? {
        "--radix-accordion-content-height": o,
        "--radix-collapsible-content-height": o
      } : {},
      className: P("goat-AccordionContent", t),
      children: /* @__PURE__ */ u.jsx(r, { children: /* @__PURE__ */ u.jsx("div", { className: P("goat-AccordionContentWrapper"), children: n }) })
    }
  );
}), Tv = A(function({ children: n, className: t, as: r = "div", ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    ml,
    {
      ...o,
      ref: a,
      asChild: !0,
      className: P("goat-AccordionItem", t),
      children: /* @__PURE__ */ u.jsx(r, { children: n })
    }
  );
}), Tl = Se({}), El = Tl.Provider, Ev = () => ve(Tl), Pv = "medium", Ke = A(function({ as: n = "svg", className: t, color: r, size: o, ...a }, i) {
  const s = Ev(), c = r ?? s.color, l = o ?? s.size ?? Pv, d = n[l] ?? n;
  return d ? /* @__PURE__ */ u.jsx(
    d,
    {
      ...a,
      ref: i,
      className: P("goat-Icon", `goat-Icon_${l}`, t),
      style: {
        color: c ? kn(c) : void 0,
        ...a.style
      }
    }
  ) : null;
}), Sv = A(function({ children: n, as: t = "span", size: r = "medium", className: o, ...a }, i) {
  return /* @__PURE__ */ u.jsx(
    gl,
    {
      ...a,
      asChild: !0,
      ref: i,
      className: P("goat-AccordionTrigger", o),
      children: /* @__PURE__ */ u.jsx(t, { children: /* @__PURE__ */ u.jsxs(
        yl,
        {
          className: P(
            "goat-AccordionButton",
            `goat-AccordionButton_${r}`,
            {
              "goat-AccordionButton_text": typeof n == "string"
            }
          ),
          children: [
            n,
            /* @__PURE__ */ u.jsx(Ke, { as: fo, size: r, className: "goat-AccordionIcon" })
          ]
        }
      ) })
    }
  );
}), yo = ({ children: e, ...n }) => /* @__PURE__ */ u.jsx(cv, { ...n, children: e });
yo.Trigger = Sv;
yo.Item = Tv;
yo.Content = Iv;
yo.Badge = function({ className: n, ...t }) {
  return /* @__PURE__ */ u.jsx(bi, { ...t, className: P("goat-AccordionBadge", n) });
};
const Pl = ({ children: e, className: n, ...t }) => /* @__PURE__ */ u.jsx("div", { ...t, className: P("goat-Topbar__Actions", n), children: e }), Sl = A(function({ as: n = "span", children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-Topbar__Logo", r),
      ref: a,
      children: t
    }
  );
}), Dl = Se({
  portalRef: null,
  border: !1
}), Rl = () => {
  const e = ve(Dl);
  if (e === void 0)
    throw new Error(
      "useAppTopbarContextRef must be used within a AppTopbarContextRef"
    );
  return e;
}, Nl = Se(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
), Dv = () => {
  const e = ve(Nl);
  if (e === void 0)
    throw new Error(
      "useAppTopbarContextSetRef must be used within a AppTopbarContextSetRef"
    );
  return e;
}, Ml = Se(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
), Rv = () => {
  const e = ve(Ml);
  if (e === void 0)
    throw new Error(
      "useAppTopbarContextSetVariant must be used within a AppTopbarContextSetVariant"
    );
  return e;
}, Nv = ({
  children: e,
  border: n = !1
}) => {
  const { portalRef: t, border: r } = Rl(), o = Rv();
  return le(() => {
    n !== r && o(n);
  }, [n, r, o]), le(() => () => {
    o(!1);
  }, [o]), t ? gm(e, t) : null;
}, xi = A(function({ as: n = "nav", children: t, className: r, border: o, ...a }, i) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...a,
      className: P("goat-Topbar", { "goat-Topbar_border": o }, r),
      ref: i,
      children: t
    }
  );
});
xi.Actions = Pl;
xi.Logo = Sl;
const Mv = A(
  function({ children: n, ...t }, r) {
    const { border: o } = Rl(), a = Dv(), [i, s] = De(null);
    return le(() => {
      a(i);
    }, [i, a]), /* @__PURE__ */ u.jsxs(xi, { ...t, ref: r, border: o, children: [
      n,
      /* @__PURE__ */ u.jsx("div", { ref: s, className: "goat-AppTopbarPortal" })
    ] });
  }
), bo = ({ children: e }) => {
  const [n, t] = De(null), [r, o] = De(!1);
  return /* @__PURE__ */ u.jsx(Nl.Provider, { value: t, children: /* @__PURE__ */ u.jsx(Ml.Provider, { value: o, children: /* @__PURE__ */ u.jsx(Dl.Provider, { value: { portalRef: n, border: r }, children: e }) }) });
};
bo.Actions = Pl;
bo.Logo = Sl;
bo.Portal = Nv;
bo.Root = Mv;
const Ol = A(function({
  as: n = "div",
  borderColor: t,
  borderRadius: r,
  bgColor: o,
  children: a,
  className: i,
  display: s,
  height: c,
  padding: l,
  style: d,
  width: f,
  ...p
}, m) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...p,
      className: i,
      style: vi({
        backgroundColor: o,
        ...t && {
          // can't use `border` directly as it wouldn't be transformed by `sx`
          borderColor: t,
          borderStyle: "solid",
          borderWidth: 1
        },
        borderRadius: r,
        display: s,
        height: c,
        padding: l,
        width: f,
        // Allow overriding with Box so Flex can set display without having to make another component
        ...d
      }),
      ref: m,
      children: a
    }
  );
}), Ov = ({
  src: e,
  size: n = "small",
  beta: t = !1,
  className: r,
  ...o
}) => {
  const a = P(
    "goat-BrandIcon",
    `goat-BrandIcon_${n}`,
    { "goat-BrandIcon_beta": t },
    r
  );
  return /* @__PURE__ */ u.jsx("div", { className: a, children: /* @__PURE__ */ u.jsx("img", { alt: "", ...o, src: e }) });
}, ft = A(function({
  as: n = "button",
  className: t,
  type: r = "button",
  disabled: o,
  icon: a,
  size: i = "medium",
  variant: s = "ghost",
  ...c
}, l) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...c,
      className: P("goat-IconButton", `goat-IconButton_${s}`, t),
      disabled: o,
      ref: l,
      type: r,
      children: /* @__PURE__ */ u.jsx(Ke, { as: a, size: i })
    }
  );
}), jv = (e) => /* @__PURE__ */ u.jsx(Ke, { size: "small", ...e, className: "goat-Tag__Icon" }), wi = A(function({ as: n = ft, onClick: t, icon: r = Bt, className: o, ...a }, i) {
  const s = P("goat-Tag__Remove", o);
  return t ? /* @__PURE__ */ u.jsx(
    n,
    {
      className: s,
      ref: i,
      size: "small",
      icon: r,
      onClick: t,
      ...a
    }
  ) : /* @__PURE__ */ u.jsx(Ke, { as: Bt, className: s, size: "small" });
}), Sn = A(function({
  as: n = "span",
  children: t,
  className: r,
  color: o = "gray",
  size: a = "medium",
  variant: i = "contained",
  wrap: s,
  ...c
}, l) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...c,
      className: P(
        "goat-Tag",
        `goat-Tag_${o}`,
        `goat-Tag_${a}`,
        `goat-Tag_${i}`,
        {
          "goat-Tag_wrap": s,
          "goat-disabled": c.disabled
        },
        r
      ),
      ref: l,
      children: t
    }
  );
});
Sn.Icon = jv;
Sn.Remove = wi;
const Av = ({
  children: e,
  className: n,
  ...t
}) => {
  const r = P("goat-BrandTagBadge", n);
  return /* @__PURE__ */ u.jsx(bi, { className: r, ...t, children: e });
}, jl = A(function({
  className: n,
  icon: t,
  children: r,
  disabled: o = !1,
  beta: a = !1,
  color: i = "gray",
  ...s
}, c) {
  const l = P(
    "goat-BrandTag",
    { "goat-BrandTag_disabled": o },
    n
  );
  return /* @__PURE__ */ u.jsxs(
    Sn,
    {
      ...s,
      color: i,
      variant: "contained",
      className: l,
      ref: c,
      children: [
        t && /* @__PURE__ */ u.jsx(
          Ov,
          {
            src: t,
            beta: a,
            className: P("goat-BrandTag__BrandIcon", {
              "goat-BrandTag__BrandIcon_disabled": o
            })
          }
        ),
        r
      ]
    }
  );
});
jl.Remove = wi;
jl.Badge = Av;
const kv = A(function({
  as: n = "a",
  children: t,
  className: r,
  disabled: o,
  href: a,
  variant: i = "body",
  ...s
}, c) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...s,
      ref: c,
      className: P(
        "goat-Breadcrumb__Item",
        `goat-Breadcrumb__Item_${i}`,
        { "goat-disabled": o },
        r
      ),
      href: o ? void 0 : a,
      children: t
    }
  );
}), Al = (e) => {
  const { children: n, onEdit: t, className: r, ...o } = e, a = uo.toArray(n).filter(Boolean), i = !!t, s = a.length;
  return /* @__PURE__ */ u.jsxs("div", { ...o, className: P("goat-Breadcrumb", r), children: [
    a.map((c, l) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      c,
      l < s - 1 && /* @__PURE__ */ u.jsx(Ke, { as: oi })
    ] })),
    i && s > 1 && /* @__PURE__ */ u.jsx(ft, { onClick: t, icon: ym })
  ] });
};
Al.Item = kv;
const Lv = Al;
Lv.displayName = "Breadcrumb";
const $v = ({
  className: e,
  size: n = "medium",
  ...t
}) => /* @__PURE__ */ u.jsx(
  "span",
  {
    ...t,
    className: P("goat-Loader", `goat-Loader_${n}`, e)
  }
);
function Fv(e) {
  return /* @__PURE__ */ u.jsxs(
    "svg",
    {
      ...e,
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 30 50",
      children: [
        /* @__PURE__ */ u.jsx("clipPath", { id: "a", children: /* @__PURE__ */ u.jsx("path", { d: "M0 0h30v50H0z" }) }),
        /* @__PURE__ */ u.jsxs("g", { clipPath: "url(#a)", children: [
          /* @__PURE__ */ u.jsx(
            "path",
            {
              stroke: "#e0e0e0",
              d: "M26.48 14.932h-7.664a3.949 3.949 0 01-3.948-3.947V7.967A6.966 6.966 0 007.9 1C4.053 1 .934 4.119.934 7.967s3.119 6.967 6.967 6.967h3.019a3.948 3.948 0 013.947 3.948v7.198a3.946 3.946 0 01-3.947 3.947H7.9a6.966 6.966 0 00-6.967 6.967v5.04A6.966 6.966 0 007.901 49a6.966 6.966 0 006.967-6.967v-8.057a3.949 3.949 0 013.948-3.949h7.664a2.323 2.323 0 002.323-2.323v-10.45a2.324 2.324 0 00-2.323-2.322z"
            }
          ),
          /* @__PURE__ */ u.jsxs(
            "path",
            {
              stroke: "#212121",
              d: "M26.48 14.932h-7.664a3.949 3.949 0 01-3.948-3.947V7.967A6.966 6.966 0 007.9 1C4.053 1 .934 4.119.934 7.967s3.119 6.967 6.967 6.967h3.019a3.948 3.948 0 013.947 3.948v7.198a3.946 3.946 0 01-3.947 3.947H7.9a6.966 6.966 0 00-6.967 6.967v5.04A6.966 6.966 0 007.901 49a6.966 6.966 0 006.967-6.967v-8.057a3.949 3.949 0 013.948-3.949h7.664a2.323 2.323 0 002.323-2.323v-10.45a2.324 2.324 0 00-2.323-2.322z",
              children: [
                /* @__PURE__ */ u.jsx(
                  "animate",
                  {
                    attributeName: "stroke-dasharray",
                    dur: "3s",
                    repeatCount: "indefinite",
                    values: "155 0;77.5 77.5;155 0"
                  }
                ),
                /* @__PURE__ */ u.jsx(
                  "animate",
                  {
                    attributeName: "stroke-dashoffset",
                    dur: "3s",
                    repeatCount: "indefinite",
                    values: "-155;-77.5;0;77.5;155"
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}
function Vv({ className: e, ...n }) {
  return /* @__PURE__ */ u.jsx("div", { ...n, className: P("goat-PremierLoader", e) });
}
const pD = Object.assign(Vv, { Icon: Fv }), ja = {
  variant: "contained",
  size: "medium"
}, kl = Se(ja), Hv = () => ve(kl), Wv = ({ children: e, value: n }) => /* @__PURE__ */ u.jsx(kl.Provider, { value: n, children: e }), Ge = A(function({
  as: n = "button",
  variant: t,
  size: r,
  children: o,
  className: a,
  disabled: i,
  type: s,
  loading: c = !1,
  ...l
}, d) {
  const { variant: f, size: p } = Hv(), m = t ?? f ?? ja.variant, g = r ?? p ?? ja.size, h = P(
    "goat-Button",
    `goat-Button_${m}`,
    `goat-Button_${g}`,
    a,
    {
      "goat-Button_loading": c,
      "goat-Button_disabled": i,
      [`goat-Button_${m}_disabled`]: i
    }
  ), v = n === "button";
  return /* @__PURE__ */ u.jsxs(
    n,
    {
      ...l,
      ref: d,
      className: h,
      disabled: v ? c || i : void 0,
      type: v ? s || "button" : s,
      children: [
        /* @__PURE__ */ u.jsx(El, { value: { size: g }, children: uo.map(
          o,
          (w) => typeof w == "string" ? /* @__PURE__ */ u.jsx("span", { children: w }) : w
        ) }),
        c && /* @__PURE__ */ u.jsx($v, { size: g })
      ]
    }
  );
});
Ge.Icon = Ke;
const Xo = "goat-ButtonGroup", Ll = A(
  ({
    children: e,
    as: n = "div",
    size: t = "medium",
    variant: r = "contained",
    ...o
  }, a) => /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      ref: a,
      className: P([
        Xo,
        `${Xo}_${t}`,
        `${Xo}_${r}`
      ]),
      children: /* @__PURE__ */ u.jsx(Wv, { value: { size: t, variant: r }, children: e })
    }
  )
);
Ll.displayName = "ButtonGroup";
const Bv = A(function({
  as: n = "section",
  variant: t = "outlined",
  size: r = "medium",
  children: o,
  className: a,
  ...i
}, s) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...i,
      className: P(
        "goat-Card",
        `goat-Card_${t}`,
        `goat-Card_${r}`,
        { "goat-Card_disabled": i.disabled },
        a
      ),
      ref: s,
      children: o
    }
  );
}), $l = Se({}), Kv = $l.Provider, Fl = () => ve($l);
let Yv = 0;
const Vl = () => dt(() => `goat-${++Yv}`, []), Hl = Se({
  addDescribedById: Qn,
  describedBy: Qn,
  setTouched: Qn,
  setValidationMessage: Qn,
  setValidity: Qn,
  validity: {}
}), Uv = Hl.Provider, Wl = () => ve(Hl);
function Gv() {
  const e = Fl(), [n = e.touched, t] = De(), [r, o] = De({}), [a, i] = De(), [s, c] = De(/* @__PURE__ */ new Set());
  return {
    touched: n,
    validationMessage: a,
    validity: r,
    addDescribedById(l) {
      c((d) => !l || d.has(l) ? d : /* @__PURE__ */ new Set([...d, l]));
    },
    describedBy(l) {
      return [l["aria-describedby"], ...s].filter(Boolean).join(" ") || void 0;
    },
    setTouched: t,
    setValidationMessage: i,
    setValidity(l) {
      o((d) => _l(d, l) ? d : dv(l));
    }
  };
}
function Qn() {
}
const _i = Se({ set: zv }), xo = _i.Provider;
function gt(e) {
  const n = ve(_i), t = Fl(), r = Wl();
  return e && (e = qv(e)), le(() => {
    e && n.set(e);
  }), le(() => {
    r.setTouched(!1);
  }, [t.resetToken]), {
    ...t,
    ...n,
    ...r,
    ...e,
    touched: t.touched || r.touched
  };
}
function pr() {
  const e = Vl(), n = ve(_i), [t, r] = De({ id: e });
  return n.id ? n : {
    ...t,
    id: e,
    set(o) {
      r((a) => _l(a, o) ? a : { ...a, ...o });
    }
  };
}
function zv() {
}
const qv = (e) => Object.fromEntries(
  Object.entries(e).filter(([, n]) => n != null)
), Bl = A(function({ as: n = "div", children: t, onBlur: r, onChange: o, onInvalid: a, ...i }, s) {
  const c = Gv();
  return /* @__PURE__ */ u.jsx(Uv, { value: c, children: /* @__PURE__ */ u.jsx(
    n,
    {
      ...i,
      ref: s,
      onBlur: (l) => {
        r == null || r(l), tr(c, l, { touched: !0 });
      },
      onChange: (l) => {
        o == null || o(l), tr(c, l);
      },
      onInvalid: (l) => {
        a == null || a(l), tr(c, l);
      },
      children: t
    }
  ) });
}), Xv = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]), Qv = ({ target: e }) => Xv.has(e.nodeName);
function tr(e, n, { touched: t } = {}) {
  if (!Qv(n)) return;
  const r = n.target;
  e.setValidationMessage(r.validationMessage), e.setValidity(r.validity), t != null && e.setTouched(t);
}
const hD = A(function({ className: n, ...t }, r) {
  const o = pr();
  return /* @__PURE__ */ u.jsx(xo, { value: o, children: /* @__PURE__ */ u.jsx(
    Bl,
    {
      ...t,
      className: P("goat-Field", n),
      ref: r
    }
  ) });
}), Kl = A(function({ className: n, disabled: t, id: r, indeterminate: o, ...a }, i) {
  const s = go(i), c = gt({ disabled: t, id: r, inline: !0 });
  return le(() => {
    s.current && (s.current.indeterminate = !s.current.checked && !!o);
  }, [o, s]), /* @__PURE__ */ u.jsx(
    "input",
    {
      ...a,
      "aria-describedby": c.describedBy(a),
      className: P(
        "goat-Checkbox",
        { "goat-touched": c.touched },
        n
      ),
      disabled: c.disabled,
      id: c.id,
      ref: s,
      type: "checkbox"
    }
  );
});
function Zv(e, n, t) {
  return ({ value: r }) => ({
    value: r,
    checked: e.has(r),
    onChange: (o) => {
      var s;
      const a = o.currentTarget.value;
      e.has(a) ? e.delete(a) : e.add(a);
      const i = new Set(e);
      n(i), (s = t == null ? void 0 : t.onChange) == null || s.call(t, Array.from(i));
    },
    onBlur: t == null ? void 0 : t.onBlur
  });
}
function Jv(e, n, t) {
  return ({ allValues: r }) => ({
    indeterminate: e.size > 0 && e.size < r.length,
    checked: e.size === r.length,
    onChange: () => {
      var o, a;
      if (e.size === r.length)
        n(/* @__PURE__ */ new Set()), (o = t == null ? void 0 : t.onChange) == null || o.call(t, []);
      else {
        const i = new Set(r);
        n(i), (a = t == null ? void 0 : t.onChange) == null || a.call(t, Array.from(i));
      }
    },
    onBlur: t == null ? void 0 : t.onBlur
  });
}
const mD = (e) => {
  var l;
  const [n, t] = De(/* @__PURE__ */ new Set()), r = (l = e == null ? void 0 : e.value) == null ? void 0 : l.toString(), o = Array.from(n).toString(), a = (d) => n.has(d), i = (d) => {
    var p;
    const f = new Set(n);
    Array.isArray(d) ? d.forEach((m) => f.add(m)) : f.add(d), t(f), (p = e == null ? void 0 : e.onChange) == null || p.call(e, Array.from(f));
  }, s = (d) => {
    var p;
    const f = new Set(n);
    Array.isArray(d) ? d.forEach((m) => f.delete(m)) : f.delete(d), t(f), (p = e == null ? void 0 : e.onChange) == null || p.call(e, Array.from(f));
  }, c = () => t(/* @__PURE__ */ new Set());
  return le(() => {
    r != null && r !== o && t(new Set(e == null ? void 0 : e.value));
  }, [r, o]), {
    indeterminateProps: Jv(n, t, e),
    checkboxProps: Zv(n, t, e),
    isChecked: a,
    reset: c,
    selected: Array.from(n),
    check: i,
    uncheck: s
  };
};
var eg = "Toggle", Ci = y.forwardRef((e, n) => {
  const { pressed: t, defaultPressed: r = !1, onPressedChange: o, ...a } = e, [i = !1, s] = Ue({
    prop: t,
    onChange: o,
    defaultProp: r
  });
  return /* @__PURE__ */ u.jsx(
    se.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: n,
      onClick: ne(e.onClick, () => {
        e.disabled || s(!i);
      })
    }
  );
});
Ci.displayName = eg;
var tg = Ci;
const vD = A(function({
  as: n = "button",
  children: t,
  className: r,
  disabled: o,
  size: a = "medium",
  trailingIcon: i,
  pressed: s,
  ...c
}, l) {
  return /* @__PURE__ */ u.jsx(
    tg,
    {
      asChild: !0,
      ...c,
      disabled: o,
      pressed: s,
      className: P(
        "goat-Chip",
        `goat-Chip_${a}`,
        { "goat-Chip_disabled": o },
        { "goat-Chip_selected": s },
        r
      ),
      ref: l,
      children: /* @__PURE__ */ u.jsxs(n, { children: [
        t,
        i && s && /* @__PURE__ */ u.jsx(Ke, { as: ol })
      ] })
    }
  );
});
function ng(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = tt(e);
  y.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && t(o);
    };
    return n.addEventListener("keydown", r, { capture: !0 }), () => n.removeEventListener("keydown", r, { capture: !0 });
  }, [t, n]);
}
var rg = "DismissableLayer", Aa = "dismissableLayer.update", og = "dismissableLayer.pointerDownOutside", ag = "dismissableLayer.focusOutside", Oc, Yl = y.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ln = y.forwardRef(
  (e, n) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...c
    } = e, l = y.useContext(Yl), [d, f] = y.useState(null), p = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = y.useState({}), g = Me(n, (D) => f(D)), h = Array.from(l.layers), [v] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), w = h.indexOf(v), b = d ? h.indexOf(d) : -1, x = l.layersWithOutsidePointerEventsDisabled.size > 0, C = b >= w, _ = sg((D) => {
      const T = D.target, S = [...l.branches].some((N) => N.contains(T));
      !C || S || (o == null || o(D), i == null || i(D), D.defaultPrevented || s == null || s());
    }, p), E = cg((D) => {
      const T = D.target;
      [...l.branches].some((N) => N.contains(T)) || (a == null || a(D), i == null || i(D), D.defaultPrevented || s == null || s());
    }, p);
    return ng((D) => {
      b === l.layers.size - 1 && (r == null || r(D), !D.defaultPrevented && s && (D.preventDefault(), s()));
    }, p), y.useEffect(() => {
      if (d)
        return t && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Oc = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(d)), l.layers.add(d), jc(), () => {
          t && l.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = Oc);
        };
    }, [d, p, t, l]), y.useEffect(() => () => {
      d && (l.layers.delete(d), l.layersWithOutsidePointerEventsDisabled.delete(d), jc());
    }, [d, l]), y.useEffect(() => {
      const D = () => m({});
      return document.addEventListener(Aa, D), () => document.removeEventListener(Aa, D);
    }, []), /* @__PURE__ */ u.jsx(
      se.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: x ? C ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ne(e.onFocusCapture, E.onFocusCapture),
        onBlurCapture: ne(e.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: ne(
          e.onPointerDownCapture,
          _.onPointerDownCapture
        )
      }
    );
  }
);
Ln.displayName = rg;
var ig = "DismissableLayerBranch", Ul = y.forwardRef((e, n) => {
  const t = y.useContext(Yl), r = y.useRef(null), o = Me(n, r);
  return y.useEffect(() => {
    const a = r.current;
    if (a)
      return t.branches.add(a), () => {
        t.branches.delete(a);
      };
  }, [t.branches]), /* @__PURE__ */ u.jsx(se.div, { ...e, ref: o });
});
Ul.displayName = ig;
function sg(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = tt(e), r = y.useRef(!1), o = y.useRef(() => {
  });
  return y.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          Gl(
            og,
            t,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (n.removeEventListener("click", o.current), o.current = c, n.addEventListener("click", o.current, { once: !0 })) : c();
      } else
        n.removeEventListener("click", o.current);
      r.current = !1;
    }, i = window.setTimeout(() => {
      n.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), n.removeEventListener("pointerdown", a), n.removeEventListener("click", o.current);
    };
  }, [n, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function cg(e, n = globalThis == null ? void 0 : globalThis.document) {
  const t = tt(e), r = y.useRef(!1);
  return y.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Gl(ag, t, { originalEvent: a }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", o), () => n.removeEventListener("focusin", o);
  }, [n, t]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function jc() {
  const e = new CustomEvent(Aa);
  document.dispatchEvent(e);
}
function Gl(e, n, t, { discrete: r }) {
  const o = t.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  n && o.addEventListener(e, n, { once: !0 }), r ? ai(o, a) : o.dispatchEvent(a);
}
var ug = Ln, lg = Ul, Qo = "focusScope.autoFocusOnMount", Zo = "focusScope.autoFocusOnUnmount", Ac = { bubbles: !1, cancelable: !0 }, dg = "FocusScope", wo = y.forwardRef((e, n) => {
  const {
    loop: t = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, c] = y.useState(null), l = tt(o), d = tt(a), f = y.useRef(null), p = Me(n, (h) => c(h)), m = y.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  y.useEffect(() => {
    if (r) {
      let h = function(x) {
        if (m.paused || !s) return;
        const C = x.target;
        s.contains(C) ? f.current = C : Zt(f.current, { select: !0 });
      }, v = function(x) {
        if (m.paused || !s) return;
        const C = x.relatedTarget;
        C !== null && (s.contains(C) || Zt(f.current, { select: !0 }));
      }, w = function(x) {
        if (document.activeElement === document.body)
          for (const _ of x)
            _.removedNodes.length > 0 && Zt(s);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", v);
      const b = new MutationObserver(w);
      return s && b.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", v), b.disconnect();
      };
    }
  }, [r, s, m.paused]), y.useEffect(() => {
    if (s) {
      Lc.add(m);
      const h = document.activeElement;
      if (!s.contains(h)) {
        const w = new CustomEvent(Qo, Ac);
        s.addEventListener(Qo, l), s.dispatchEvent(w), w.defaultPrevented || (fg(gg(zl(s)), { select: !0 }), document.activeElement === h && Zt(s));
      }
      return () => {
        s.removeEventListener(Qo, l), setTimeout(() => {
          const w = new CustomEvent(Zo, Ac);
          s.addEventListener(Zo, d), s.dispatchEvent(w), w.defaultPrevented || Zt(h ?? document.body, { select: !0 }), s.removeEventListener(Zo, d), Lc.remove(m);
        }, 0);
      };
    }
  }, [s, l, d, m]);
  const g = y.useCallback(
    (h) => {
      if (!t && !r || m.paused) return;
      const v = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, w = document.activeElement;
      if (v && w) {
        const b = h.currentTarget, [x, C] = pg(b);
        x && C ? !h.shiftKey && w === C ? (h.preventDefault(), t && Zt(x, { select: !0 })) : h.shiftKey && w === x && (h.preventDefault(), t && Zt(C, { select: !0 })) : w === b && h.preventDefault();
      }
    },
    [t, r, m.paused]
  );
  return /* @__PURE__ */ u.jsx(se.div, { tabIndex: -1, ...i, ref: p, onKeyDown: g });
});
wo.displayName = dg;
function fg(e, { select: n = !1 } = {}) {
  const t = document.activeElement;
  for (const r of e)
    if (Zt(r, { select: n }), document.activeElement !== t) return;
}
function pg(e) {
  const n = zl(e), t = kc(n, e), r = kc(n.reverse(), e);
  return [t, r];
}
function zl(e) {
  const n = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) n.push(t.currentNode);
  return n;
}
function kc(e, n) {
  for (const t of e)
    if (!hg(t, { upTo: n })) return t;
}
function hg(e, { upTo: n }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (n !== void 0 && e === n) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function mg(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Zt(e, { select: n = !1 } = {}) {
  if (e && e.focus) {
    const t = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== t && mg(e) && n && e.select();
  }
}
var Lc = vg();
function vg() {
  let e = [];
  return {
    add(n) {
      const t = e[0];
      n !== t && (t == null || t.pause()), e = $c(e, n), e.unshift(n);
    },
    remove(n) {
      var t;
      e = $c(e, n), (t = e[0]) == null || t.resume();
    }
  };
}
function $c(e, n) {
  const t = [...e], r = t.indexOf(n);
  return r !== -1 && t.splice(r, 1), t;
}
function gg(e) {
  return e.filter((n) => n.tagName !== "A");
}
var yg = "Portal", $n = y.forwardRef((e, n) => {
  var s;
  const { container: t, ...r } = e, [o, a] = y.useState(!1);
  Kt(() => a(!0), []);
  const i = t || o && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? vm.createPortal(/* @__PURE__ */ u.jsx(se.div, { ...r, ref: n }), i) : null;
});
$n.displayName = yg;
var Jo = 0;
function Ii() {
  y.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Fc()), document.body.insertAdjacentElement("beforeend", e[1] ?? Fc()), Jo++, () => {
      Jo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((n) => n.remove()), Jo--;
    };
  }, []);
}
function Fc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var lt = function() {
  return lt = Object.assign || function(n) {
    for (var t, r = 1, o = arguments.length; r < o; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (n[a] = t[a]);
    }
    return n;
  }, lt.apply(this, arguments);
};
function ql(e, n) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
}
function bg(e, n, t) {
  if (t || arguments.length === 2) for (var r = 0, o = n.length, a; r < o; r++)
    (a || !(r in n)) && (a || (a = Array.prototype.slice.call(n, 0, r)), a[r] = n[r]);
  return e.concat(a || Array.prototype.slice.call(n));
}
var Fr = "right-scroll-bar-position", Vr = "width-before-scroll-bar", xg = "with-scroll-bars-hidden", wg = "--removed-body-scroll-bar-size";
function ea(e, n) {
  return typeof e == "function" ? e(n) : e && (e.current = n), e;
}
function _g(e, n) {
  var t = De(function() {
    return {
      // value
      value: e,
      // last callback
      callback: n,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(r) {
          var o = t.value;
          o !== r && (t.value = r, t.callback(r, o));
        }
      }
    };
  })[0];
  return t.callback = n, t.facade;
}
var Cg = typeof window < "u" ? y.useLayoutEffect : y.useEffect, Vc = /* @__PURE__ */ new WeakMap();
function Ig(e, n) {
  var t = _g(null, function(r) {
    return e.forEach(function(o) {
      return ea(o, r);
    });
  });
  return Cg(function() {
    var r = Vc.get(t);
    if (r) {
      var o = new Set(r), a = new Set(e), i = t.current;
      o.forEach(function(s) {
        a.has(s) || ea(s, null);
      }), a.forEach(function(s) {
        o.has(s) || ea(s, i);
      });
    }
    Vc.set(t, e);
  }, [e]), t;
}
function Tg(e) {
  return e;
}
function Eg(e, n) {
  n === void 0 && (n = Tg);
  var t = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : e;
    },
    useMedium: function(a) {
      var i = n(a, r);
      return t.push(i), function() {
        t = t.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; t.length; ) {
        var i = t;
        t = [], i.forEach(a);
      }
      t = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var i = [];
      if (t.length) {
        var s = t;
        t = [], s.forEach(a), i = t;
      }
      var c = function() {
        var d = i;
        i = [], d.forEach(a);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), t = {
        push: function(d) {
          i.push(d), l();
        },
        filter: function(d) {
          return i = i.filter(d), t;
        }
      };
    }
  };
  return o;
}
function Pg(e) {
  e === void 0 && (e = {});
  var n = Eg(null);
  return n.options = lt({ async: !0, ssr: !1 }, e), n;
}
var Xl = function(e) {
  var n = e.sideCar, t = ql(e, ["sideCar"]);
  if (!n)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = n.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return y.createElement(r, lt({}, t));
};
Xl.isSideCarExport = !0;
function Sg(e, n) {
  return e.useMedium(n), Xl;
}
var Ql = Pg(), ta = function() {
}, _o = y.forwardRef(function(e, n) {
  var t = y.useRef(null), r = y.useState({
    onScrollCapture: ta,
    onWheelCapture: ta,
    onTouchMoveCapture: ta
  }), o = r[0], a = r[1], i = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, m = e.noIsolation, g = e.inert, h = e.allowPinchZoom, v = e.as, w = v === void 0 ? "div" : v, b = e.gapMode, x = ql(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = p, _ = Ig([t, n]), E = lt(lt({}, x), o);
  return y.createElement(
    y.Fragment,
    null,
    d && y.createElement(C, { sideCar: Ql, removeScrollBar: l, shards: f, noIsolation: m, inert: g, setCallbacks: a, allowPinchZoom: !!h, lockRef: t, gapMode: b }),
    i ? y.cloneElement(y.Children.only(s), lt(lt({}, E), { ref: _ })) : y.createElement(w, lt({}, E, { className: c, ref: _ }), s)
  );
});
_o.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
_o.classNames = {
  fullWidth: Vr,
  zeroRight: Fr
};
var Dg = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Rg() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var n = Dg();
  return n && e.setAttribute("nonce", n), e;
}
function Ng(e, n) {
  e.styleSheet ? e.styleSheet.cssText = n : e.appendChild(document.createTextNode(n));
}
function Mg(e) {
  var n = document.head || document.getElementsByTagName("head")[0];
  n.appendChild(e);
}
var Og = function() {
  var e = 0, n = null;
  return {
    add: function(t) {
      e == 0 && (n = Rg()) && (Ng(n, t), Mg(n)), e++;
    },
    remove: function() {
      e--, !e && n && (n.parentNode && n.parentNode.removeChild(n), n = null);
    }
  };
}, jg = function() {
  var e = Og();
  return function(n, t) {
    y.useEffect(function() {
      return e.add(n), function() {
        e.remove();
      };
    }, [n && t]);
  };
}, Zl = function() {
  var e = jg(), n = function(t) {
    var r = t.styles, o = t.dynamic;
    return e(r, o), null;
  };
  return n;
}, Ag = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, na = function(e) {
  return parseInt(e || "", 10) || 0;
}, kg = function(e) {
  var n = window.getComputedStyle(document.body), t = n[e === "padding" ? "paddingLeft" : "marginLeft"], r = n[e === "padding" ? "paddingTop" : "marginTop"], o = n[e === "padding" ? "paddingRight" : "marginRight"];
  return [na(t), na(r), na(o)];
}, Lg = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Ag;
  var n = kg(e), t = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: n[0],
    top: n[1],
    right: n[2],
    gap: Math.max(0, r - t + n[2] - n[0])
  };
}, $g = Zl(), In = "data-scroll-locked", Fg = function(e, n, t, r) {
  var o = e.left, a = e.top, i = e.right, s = e.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(xg, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(In, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    n && "position: relative ".concat(r, ";"),
    t === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    t === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Fr, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Vr, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Fr, " .").concat(Fr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(Vr, " .").concat(Vr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(In, `] {
    `).concat(wg, ": ").concat(s, `px;
  }
`);
}, Hc = function() {
  var e = parseInt(document.body.getAttribute(In) || "0", 10);
  return isFinite(e) ? e : 0;
}, Vg = function() {
  y.useEffect(function() {
    return document.body.setAttribute(In, (Hc() + 1).toString()), function() {
      var e = Hc() - 1;
      e <= 0 ? document.body.removeAttribute(In) : document.body.setAttribute(In, e.toString());
    };
  }, []);
}, Hg = function(e) {
  var n = e.noRelative, t = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Vg();
  var a = y.useMemo(function() {
    return Lg(o);
  }, [o]);
  return y.createElement($g, { styles: Fg(a, !n, o, t ? "" : "!important") });
}, ka = !1;
if (typeof window < "u")
  try {
    var Dr = Object.defineProperty({}, "passive", {
      get: function() {
        return ka = !0, !0;
      }
    });
    window.addEventListener("test", Dr, Dr), window.removeEventListener("test", Dr, Dr);
  } catch {
    ka = !1;
  }
var bn = ka ? { passive: !1 } : !1, Wg = function(e) {
  return e.tagName === "TEXTAREA";
}, Jl = function(e, n) {
  if (!(e instanceof Element))
    return !1;
  var t = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    t[n] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !Wg(e) && t[n] === "visible")
  );
}, Bg = function(e) {
  return Jl(e, "overflowY");
}, Kg = function(e) {
  return Jl(e, "overflowX");
}, Wc = function(e, n) {
  var t = n.ownerDocument, r = n;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = ed(e, r);
    if (o) {
      var a = td(e, r), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== t.body);
  return !1;
}, Yg = function(e) {
  var n = e.scrollTop, t = e.scrollHeight, r = e.clientHeight;
  return [
    n,
    t,
    r
  ];
}, Ug = function(e) {
  var n = e.scrollLeft, t = e.scrollWidth, r = e.clientWidth;
  return [
    n,
    t,
    r
  ];
}, ed = function(e, n) {
  return e === "v" ? Bg(n) : Kg(n);
}, td = function(e, n) {
  return e === "v" ? Yg(n) : Ug(n);
}, Gg = function(e, n) {
  return e === "h" && n === "rtl" ? -1 : 1;
}, zg = function(e, n, t, r, o) {
  var a = Gg(e, window.getComputedStyle(n).direction), i = a * r, s = t.target, c = n.contains(s), l = !1, d = i > 0, f = 0, p = 0;
  do {
    var m = td(e, s), g = m[0], h = m[1], v = m[2], w = h - v - a * g;
    (g || w) && ed(e, s) && (f += w, p += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (n.contains(s) || n === s)
  );
  return (d && (Math.abs(f) < 1 || !o) || !d && (Math.abs(p) < 1 || !o)) && (l = !0), l;
}, Rr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Bc = function(e) {
  return [e.deltaX, e.deltaY];
}, Kc = function(e) {
  return e && "current" in e ? e.current : e;
}, qg = function(e, n) {
  return e[0] === n[0] && e[1] === n[1];
}, Xg = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Qg = 0, xn = [];
function Zg(e) {
  var n = y.useRef([]), t = y.useRef([0, 0]), r = y.useRef(), o = y.useState(Qg++)[0], a = y.useState(Zl)[0], i = y.useRef(e);
  y.useEffect(function() {
    i.current = e;
  }, [e]), y.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = bg([e.lockRef.current], (e.shards || []).map(Kc), !0).filter(Boolean);
      return h.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = y.useCallback(function(h, v) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = Rr(h), b = t.current, x = "deltaX" in h ? h.deltaX : b[0] - w[0], C = "deltaY" in h ? h.deltaY : b[1] - w[1], _, E = h.target, D = Math.abs(x) > Math.abs(C) ? "h" : "v";
    if ("touches" in h && D === "h" && E.type === "range")
      return !1;
    var T = Wc(D, E);
    if (!T)
      return !0;
    if (T ? _ = D : (_ = D === "v" ? "h" : "v", T = Wc(D, E)), !T)
      return !1;
    if (!r.current && "changedTouches" in h && (x || C) && (r.current = _), !_)
      return !0;
    var S = r.current || _;
    return zg(S, v, h, S === "h" ? x : C, !0);
  }, []), c = y.useCallback(function(h) {
    var v = h;
    if (!(!xn.length || xn[xn.length - 1] !== a)) {
      var w = "deltaY" in v ? Bc(v) : Rr(v), b = n.current.filter(function(_) {
        return _.name === v.type && (_.target === v.target || v.target === _.shadowParent) && qg(_.delta, w);
      })[0];
      if (b && b.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!b) {
        var x = (i.current.shards || []).map(Kc).filter(Boolean).filter(function(_) {
          return _.contains(v.target);
        }), C = x.length > 0 ? s(v, x[0]) : !i.current.noIsolation;
        C && v.cancelable && v.preventDefault();
      }
    }
  }, []), l = y.useCallback(function(h, v, w, b) {
    var x = { name: h, delta: v, target: w, should: b, shadowParent: Jg(w) };
    n.current.push(x), setTimeout(function() {
      n.current = n.current.filter(function(C) {
        return C !== x;
      });
    }, 1);
  }, []), d = y.useCallback(function(h) {
    t.current = Rr(h), r.current = void 0;
  }, []), f = y.useCallback(function(h) {
    l(h.type, Bc(h), h.target, s(h, e.lockRef.current));
  }, []), p = y.useCallback(function(h) {
    l(h.type, Rr(h), h.target, s(h, e.lockRef.current));
  }, []);
  y.useEffect(function() {
    return xn.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", c, bn), document.addEventListener("touchmove", c, bn), document.addEventListener("touchstart", d, bn), function() {
      xn = xn.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", c, bn), document.removeEventListener("touchmove", c, bn), document.removeEventListener("touchstart", d, bn);
    };
  }, []);
  var m = e.removeScrollBar, g = e.inert;
  return y.createElement(
    y.Fragment,
    null,
    g ? y.createElement(a, { styles: Xg(o) }) : null,
    m ? y.createElement(Hg, { gapMode: e.gapMode }) : null
  );
}
function Jg(e) {
  for (var n = null; e !== null; )
    e instanceof ShadowRoot && (n = e.host, e = e.host), e = e.parentNode;
  return n;
}
const ey = Sg(Ql, Zg);
var Co = y.forwardRef(function(e, n) {
  return y.createElement(_o, lt({}, e, { ref: n, sideCar: ey }));
});
Co.classNames = _o.classNames;
var ty = function(e) {
  if (typeof document > "u")
    return null;
  var n = Array.isArray(e) ? e[0] : e;
  return n.ownerDocument.body;
}, wn = /* @__PURE__ */ new WeakMap(), Nr = /* @__PURE__ */ new WeakMap(), Mr = {}, ra = 0, nd = function(e) {
  return e && (e.host || nd(e.parentNode));
}, ny = function(e, n) {
  return n.map(function(t) {
    if (e.contains(t))
      return t;
    var r = nd(t);
    return r && e.contains(r) ? r : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, ry = function(e, n, t, r) {
  var o = ny(n, Array.isArray(e) ? e : [e]);
  Mr[t] || (Mr[t] = /* @__PURE__ */ new WeakMap());
  var a = Mr[t], i = [], s = /* @__PURE__ */ new Set(), c = new Set(o), l = function(f) {
    !f || s.has(f) || (s.add(f), l(f.parentNode));
  };
  o.forEach(l);
  var d = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(p) {
      if (s.has(p))
        d(p);
      else
        try {
          var m = p.getAttribute(r), g = m !== null && m !== "false", h = (wn.get(p) || 0) + 1, v = (a.get(p) || 0) + 1;
          wn.set(p, h), a.set(p, v), i.push(p), h === 1 && g && Nr.set(p, !0), v === 1 && p.setAttribute(t, "true"), g || p.setAttribute(r, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", p, w);
        }
    });
  };
  return d(n), s.clear(), ra++, function() {
    i.forEach(function(f) {
      var p = wn.get(f) - 1, m = a.get(f) - 1;
      wn.set(f, p), a.set(f, m), p || (Nr.has(f) || f.removeAttribute(r), Nr.delete(f)), m || f.removeAttribute(t);
    }), ra--, ra || (wn = /* @__PURE__ */ new WeakMap(), wn = /* @__PURE__ */ new WeakMap(), Nr = /* @__PURE__ */ new WeakMap(), Mr = {});
  };
}, Ti = function(e, n, t) {
  t === void 0 && (t = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = ty(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), ry(r, o, t, "aria-hidden")) : function() {
    return null;
  };
}, Ei = "Dialog", [rd, gD] = At(Ei), [oy, St] = rd(Ei), Io = (e) => {
  const {
    __scopeDialog: n,
    children: t,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !0
  } = e, s = y.useRef(null), c = y.useRef(null), [l = !1, d] = Ue({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ u.jsx(
    oy,
    {
      scope: n,
      triggerRef: s,
      contentRef: c,
      contentId: It(),
      titleId: It(),
      descriptionId: It(),
      open: l,
      onOpenChange: d,
      onOpenToggle: y.useCallback(() => d((f) => !f), [d]),
      modal: i,
      children: t
    }
  );
};
Io.displayName = Ei;
var od = "DialogTrigger", Pi = y.forwardRef(
  (e, n) => {
    const { __scopeDialog: t, ...r } = e, o = St(od, t), a = Me(n, o.triggerRef);
    return /* @__PURE__ */ u.jsx(
      se.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Mi(o.open),
        ...r,
        ref: a,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Pi.displayName = od;
var Si = "DialogPortal", [ay, ad] = rd(Si, {
  forceMount: void 0
}), Di = (e) => {
  const { __scopeDialog: n, forceMount: t, children: r, container: o } = e, a = St(Si, n);
  return /* @__PURE__ */ u.jsx(ay, { scope: n, forceMount: t, children: y.Children.map(r, (i) => /* @__PURE__ */ u.jsx(nt, { present: t || a.open, children: /* @__PURE__ */ u.jsx($n, { asChild: !0, container: o, children: i }) })) });
};
Di.displayName = Si;
var qr = "DialogOverlay", Ri = y.forwardRef(
  (e, n) => {
    const t = ad(qr, e.__scopeDialog), { forceMount: r = t.forceMount, ...o } = e, a = St(qr, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ u.jsx(nt, { present: r || a.open, children: /* @__PURE__ */ u.jsx(iy, { ...o, ref: n }) }) : null;
  }
);
Ri.displayName = qr;
var iy = y.forwardRef(
  (e, n) => {
    const { __scopeDialog: t, ...r } = e, o = St(qr, t);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u.jsx(Co, { as: ln, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ u.jsx(
        se.div,
        {
          "data-state": Mi(o.open),
          ...r,
          ref: n,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), dn = "DialogContent", To = y.forwardRef(
  (e, n) => {
    const t = ad(dn, e.__scopeDialog), { forceMount: r = t.forceMount, ...o } = e, a = St(dn, e.__scopeDialog);
    return /* @__PURE__ */ u.jsx(nt, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u.jsx(sy, { ...o, ref: n }) : /* @__PURE__ */ u.jsx(cy, { ...o, ref: n }) });
  }
);
To.displayName = dn;
var sy = y.forwardRef(
  (e, n) => {
    const t = St(dn, e.__scopeDialog), r = y.useRef(null), o = Me(n, t.contentRef, r);
    return y.useEffect(() => {
      const a = r.current;
      if (a) return Ti(a);
    }, []), /* @__PURE__ */ u.jsx(
      id,
      {
        ...e,
        ref: o,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = t.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: ne(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: ne(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), cy = y.forwardRef(
  (e, n) => {
    const t = St(dn, e.__scopeDialog), r = y.useRef(!1), o = y.useRef(!1);
    return /* @__PURE__ */ u.jsx(
      id,
      {
        ...e,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (r.current || (s = t.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((l = t.triggerRef.current) == null ? void 0 : l.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), id = y.forwardRef(
  (e, n) => {
    const { __scopeDialog: t, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...i } = e, s = St(dn, t), c = y.useRef(null), l = Me(n, c);
    return Ii(), /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      /* @__PURE__ */ u.jsx(
        wo,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ u.jsx(
            Ln,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Mi(s.open),
              ...i,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
        /* @__PURE__ */ u.jsx(ly, { titleId: s.titleId }),
        /* @__PURE__ */ u.jsx(fy, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Ni = "DialogTitle", Eo = y.forwardRef(
  (e, n) => {
    const { __scopeDialog: t, ...r } = e, o = St(Ni, t);
    return /* @__PURE__ */ u.jsx(se.h2, { id: o.titleId, ...r, ref: n });
  }
);
Eo.displayName = Ni;
var sd = "DialogDescription", uy = y.forwardRef(
  (e, n) => {
    const { __scopeDialog: t, ...r } = e, o = St(sd, t);
    return /* @__PURE__ */ u.jsx(se.p, { id: o.descriptionId, ...r, ref: n });
  }
);
uy.displayName = sd;
var cd = "DialogClose", Po = y.forwardRef(
  (e, n) => {
    const { __scopeDialog: t, ...r } = e, o = St(cd, t);
    return /* @__PURE__ */ u.jsx(
      se.button,
      {
        type: "button",
        ...r,
        ref: n,
        onClick: ne(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Po.displayName = cd;
function Mi(e) {
  return e ? "open" : "closed";
}
var ud = "DialogTitleWarning", [yD, ld] = Nm(ud, {
  contentName: dn,
  titleName: Ni,
  docsSlug: "dialog"
}), ly = ({ titleId: e }) => {
  const n = ld(ud), t = `\`${n.contentName}\` requires a \`${n.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${n.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${n.docsSlug}`;
  return y.useEffect(() => {
    e && (document.getElementById(e) || console.error(t));
  }, [t, e]), null;
}, dy = "DialogDescriptionWarning", fy = ({ contentRef: e, descriptionId: n }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ld(dy).contentName}}.`;
  return y.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    n && o && (document.getElementById(n) || console.warn(r));
  }, [r, e, n]), null;
}, py = Pi;
const Oi = A(function({ as: n = Ge, children: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx(Pi, { asChild: !0, children: /* @__PURE__ */ u.jsx(n, { ...r, ref: o, children: t }) });
}), dd = A(function({
  align: n,
  center: t,
  children: r,
  direction: o,
  flex: a,
  gap: i,
  inline: s,
  justify: c,
  placeSelf: l,
  style: d,
  wrap: f,
  ...p
}, m) {
  return /* @__PURE__ */ u.jsx(
    Ol,
    {
      ...p,
      ref: m,
      style: vi({
        ...d,
        // Do NOT allow overriding of these, there is no use case to allow this
        alignItems: t ? "center" : n,
        display: s ? "inline-flex" : "flex",
        flexDirection: o,
        justifyContent: t ? "center" : c,
        flex: a,
        flexWrap: f === "reverse" ? "wrap-reverse" : f ? "wrap" : "nowrap",
        ...Array.isArray(i) ? { rowGap: i[0], columnGap: i[1] } : { gap: i },
        placeSelf: l
      }),
      children: r
    }
  );
});
function bD({ children: e, ...n }) {
  return /* @__PURE__ */ u.jsx(dd, { ...n, direction: "column", children: e });
}
const fd = A(function({ children: n, className: t, as: r = "div", ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    di,
    {
      ...o,
      className: P("goat-Collapsible", t),
      asChild: !0,
      ref: a,
      children: /* @__PURE__ */ u.jsx(r, { children: n })
    }
  );
}), pd = A(function({ children: n, as: t = Ge, ...r }, o) {
  return /* @__PURE__ */ u.jsx(ui, { ...r, asChild: !0, ref: o, children: /* @__PURE__ */ u.jsx(t, { children: n }) });
}), hd = ({
  children: e,
  ...n
}) => /* @__PURE__ */ u.jsx(ci, { ...n, children: e }), ji = {
  Trigger: pd,
  Content: fd,
  Root: hd
}, hy = ["top", "right", "bottom", "left"], en = Math.min, ht = Math.max, Xr = Math.round, Or = Math.floor, Ot = (e) => ({
  x: e,
  y: e
}), my = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, vy = {
  start: "end",
  end: "start"
};
function La(e, n, t) {
  return ht(e, en(n, t));
}
function Yt(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Ut(e) {
  return e.split("-")[0];
}
function Fn(e) {
  return e.split("-")[1];
}
function Ai(e) {
  return e === "x" ? "y" : "x";
}
function ki(e) {
  return e === "y" ? "height" : "width";
}
function tn(e) {
  return ["top", "bottom"].includes(Ut(e)) ? "y" : "x";
}
function Li(e) {
  return Ai(tn(e));
}
function gy(e, n, t) {
  t === void 0 && (t = !1);
  const r = Fn(e), o = Li(e), a = ki(o);
  let i = o === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return n.reference[a] > n.floating[a] && (i = Qr(i)), [i, Qr(i)];
}
function yy(e) {
  const n = Qr(e);
  return [$a(e), n, $a(n)];
}
function $a(e) {
  return e.replace(/start|end/g, (n) => vy[n]);
}
function by(e, n, t) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? o : r : n ? r : o;
    case "left":
    case "right":
      return n ? a : i;
    default:
      return [];
  }
}
function xy(e, n, t, r) {
  const o = Fn(e);
  let a = by(Ut(e), t === "start", r);
  return o && (a = a.map((i) => i + "-" + o), n && (a = a.concat(a.map($a)))), a;
}
function Qr(e) {
  return e.replace(/left|right|bottom|top/g, (n) => my[n]);
}
function wy(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function md(e) {
  return typeof e != "number" ? wy(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zr(e) {
  const {
    x: n,
    y: t,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: t,
    left: n,
    right: n + r,
    bottom: t + o,
    x: n,
    y: t
  };
}
function Yc(e, n, t) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = tn(n), i = Li(n), s = ki(i), c = Ut(n), l = a === "y", d = r.x + r.width / 2 - o.width / 2, f = r.y + r.height / 2 - o.height / 2, p = r[s] / 2 - o[s] / 2;
  let m;
  switch (c) {
    case "top":
      m = {
        x: d,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: f
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (Fn(n)) {
    case "start":
      m[i] -= p * (t && l ? -1 : 1);
      break;
    case "end":
      m[i] += p * (t && l ? -1 : 1);
      break;
  }
  return m;
}
const _y = async (e, n, t) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = t, s = a.filter(Boolean), c = await (i.isRTL == null ? void 0 : i.isRTL(n));
  let l = await i.getElementRects({
    reference: e,
    floating: n,
    strategy: o
  }), {
    x: d,
    y: f
  } = Yc(l, r, c), p = r, m = {}, g = 0;
  for (let h = 0; h < s.length; h++) {
    const {
      name: v,
      fn: w
    } = s[h], {
      x: b,
      y: x,
      data: C,
      reset: _
    } = await w({
      x: d,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: o,
      middlewareData: m,
      rects: l,
      platform: i,
      elements: {
        reference: e,
        floating: n
      }
    });
    d = b ?? d, f = x ?? f, m = {
      ...m,
      [v]: {
        ...m[v],
        ...C
      }
    }, _ && g <= 50 && (g++, typeof _ == "object" && (_.placement && (p = _.placement), _.rects && (l = _.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: n,
      strategy: o
    }) : _.rects), {
      x: d,
      y: f
    } = Yc(l, p, c)), h = -1);
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: o,
    middlewareData: m
  };
};
async function or(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = Yt(n, e), g = md(m), v = s[p ? f === "floating" ? "reference" : "floating" : f], w = Zr(await a.getClippingRect({
    element: (t = await (a.isElement == null ? void 0 : a.isElement(v))) == null || t ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: d,
    strategy: c
  })), b = f === "floating" ? {
    x: r,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, x = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), C = await (a.isElement == null ? void 0 : a.isElement(x)) ? await (a.getScale == null ? void 0 : a.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, _ = Zr(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: b,
    offsetParent: x,
    strategy: c
  }) : b);
  return {
    top: (w.top - _.top + g.top) / C.y,
    bottom: (_.bottom - w.bottom + g.bottom) / C.y,
    left: (w.left - _.left + g.left) / C.x,
    right: (_.right - w.right + g.right) / C.x
  };
}
const Cy = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: r,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: c
    } = n, {
      element: l,
      padding: d = 0
    } = Yt(e, n) || {};
    if (l == null)
      return {};
    const f = md(d), p = {
      x: t,
      y: r
    }, m = Li(o), g = ki(m), h = await i.getDimensions(l), v = m === "y", w = v ? "top" : "left", b = v ? "bottom" : "right", x = v ? "clientHeight" : "clientWidth", C = a.reference[g] + a.reference[m] - p[m] - a.floating[g], _ = p[m] - a.reference[m], E = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l));
    let D = E ? E[x] : 0;
    (!D || !await (i.isElement == null ? void 0 : i.isElement(E))) && (D = s.floating[x] || a.floating[g]);
    const T = C / 2 - _ / 2, S = D / 2 - h[g] / 2 - 1, N = en(f[w], S), k = en(f[b], S), Y = N, U = D - h[g] - k, j = D / 2 - h[g] / 2 + T, oe = La(Y, j, U), q = !c.arrow && Fn(o) != null && j !== oe && a.reference[g] / 2 - (j < Y ? N : k) - h[g] / 2 < 0, O = q ? j < Y ? j - Y : j - U : 0;
    return {
      [m]: p[m] + O,
      data: {
        [m]: oe,
        centerOffset: j - oe - O,
        ...q && {
          alignmentOffset: O
        }
      },
      reset: q
    };
  }
}), Iy = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, r;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: c,
        elements: l
      } = n, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: h = !0,
        ...v
      } = Yt(e, n);
      if ((t = a.arrow) != null && t.alignmentOffset)
        return {};
      const w = Ut(o), b = tn(s), x = Ut(s) === s, C = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), _ = p || (x || !h ? [Qr(s)] : yy(s)), E = g !== "none";
      !p && E && _.push(...xy(s, h, g, C));
      const D = [s, ..._], T = await or(n, v), S = [];
      let N = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (d && S.push(T[w]), f) {
        const j = gy(o, i, C);
        S.push(T[j[0]], T[j[1]]);
      }
      if (N = [...N, {
        placement: o,
        overflows: S
      }], !S.every((j) => j <= 0)) {
        var k, Y;
        const j = (((k = a.flip) == null ? void 0 : k.index) || 0) + 1, oe = D[j];
        if (oe)
          return {
            data: {
              index: j,
              overflows: N
            },
            reset: {
              placement: oe
            }
          };
        let q = (Y = N.filter((O) => O.overflows[0] <= 0).sort((O, M) => O.overflows[1] - M.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!q)
          switch (m) {
            case "bestFit": {
              var U;
              const O = (U = N.filter((M) => {
                if (E) {
                  const B = tn(M.placement);
                  return B === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((M) => [M.placement, M.overflows.filter((B) => B > 0).reduce((B, R) => B + R, 0)]).sort((M, B) => M[1] - B[1])[0]) == null ? void 0 : U[0];
              O && (q = O);
              break;
            }
            case "initialPlacement":
              q = s;
              break;
          }
        if (o !== q)
          return {
            reset: {
              placement: q
            }
          };
      }
      return {};
    }
  };
};
function Uc(e, n) {
  return {
    top: e.top - n.height,
    right: e.right - n.width,
    bottom: e.bottom - n.height,
    left: e.left - n.width
  };
}
function Gc(e) {
  return hy.some((n) => e[n] >= 0);
}
const Ty = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(n) {
      const {
        rects: t
      } = n, {
        strategy: r = "referenceHidden",
        ...o
      } = Yt(e, n);
      switch (r) {
        case "referenceHidden": {
          const a = await or(n, {
            ...o,
            elementContext: "reference"
          }), i = Uc(a, t.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Gc(i)
            }
          };
        }
        case "escaped": {
          const a = await or(n, {
            ...o,
            altBoundary: !0
          }), i = Uc(a, t.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Gc(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Ey(e, n) {
  const {
    placement: t,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), i = Ut(t), s = Fn(t), c = tn(t) === "y", l = ["left", "top"].includes(i) ? -1 : 1, d = a && c ? -1 : 1, f = Yt(n, e);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof g == "number" && (m = s === "end" ? g * -1 : g), c ? {
    x: m * d,
    y: p * l
  } : {
    x: p * l,
    y: m * d
  };
}
const Py = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, r;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = n, c = await Ey(n, e);
      return i === ((t = s.offset) == null ? void 0 : t.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, Sy = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: r,
        placement: o
      } = n, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (v) => {
            let {
              x: w,
              y: b
            } = v;
            return {
              x: w,
              y: b
            };
          }
        },
        ...c
      } = Yt(e, n), l = {
        x: t,
        y: r
      }, d = await or(n, c), f = tn(Ut(o)), p = Ai(f);
      let m = l[p], g = l[f];
      if (a) {
        const v = p === "y" ? "top" : "left", w = p === "y" ? "bottom" : "right", b = m + d[v], x = m - d[w];
        m = La(b, m, x);
      }
      if (i) {
        const v = f === "y" ? "top" : "left", w = f === "y" ? "bottom" : "right", b = g + d[v], x = g - d[w];
        g = La(b, g, x);
      }
      const h = s.fn({
        ...n,
        [p]: m,
        [f]: g
      });
      return {
        ...h,
        data: {
          x: h.x - t,
          y: h.y - r,
          enabled: {
            [p]: a,
            [f]: i
          }
        }
      };
    }
  };
}, Dy = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(n) {
      const {
        x: t,
        y: r,
        placement: o,
        rects: a,
        middlewareData: i
      } = n, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = Yt(e, n), d = {
        x: t,
        y: r
      }, f = tn(o), p = Ai(f);
      let m = d[p], g = d[f];
      const h = Yt(s, n), v = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (c) {
        const x = p === "y" ? "height" : "width", C = a.reference[p] - a.floating[x] + v.mainAxis, _ = a.reference[p] + a.reference[x] - v.mainAxis;
        m < C ? m = C : m > _ && (m = _);
      }
      if (l) {
        var w, b;
        const x = p === "y" ? "width" : "height", C = ["top", "left"].includes(Ut(o)), _ = a.reference[f] - a.floating[x] + (C && ((w = i.offset) == null ? void 0 : w[f]) || 0) + (C ? 0 : v.crossAxis), E = a.reference[f] + a.reference[x] + (C ? 0 : ((b = i.offset) == null ? void 0 : b[f]) || 0) - (C ? v.crossAxis : 0);
        g < _ ? g = _ : g > E && (g = E);
      }
      return {
        [p]: m,
        [f]: g
      };
    }
  };
}, Ry = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(n) {
      var t, r;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: s
      } = n, {
        apply: c = () => {
        },
        ...l
      } = Yt(e, n), d = await or(n, l), f = Ut(o), p = Fn(o), m = tn(o) === "y", {
        width: g,
        height: h
      } = a.floating;
      let v, w;
      f === "top" || f === "bottom" ? (v = f, w = p === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = f, v = p === "end" ? "top" : "bottom");
      const b = h - d.top - d.bottom, x = g - d.left - d.right, C = en(h - d[v], b), _ = en(g - d[w], x), E = !n.middlewareData.shift;
      let D = C, T = _;
      if ((t = n.middlewareData.shift) != null && t.enabled.x && (T = x), (r = n.middlewareData.shift) != null && r.enabled.y && (D = b), E && !p) {
        const N = ht(d.left, 0), k = ht(d.right, 0), Y = ht(d.top, 0), U = ht(d.bottom, 0);
        m ? T = g - 2 * (N !== 0 || k !== 0 ? N + k : ht(d.left, d.right)) : D = h - 2 * (Y !== 0 || U !== 0 ? Y + U : ht(d.top, d.bottom));
      }
      await c({
        ...n,
        availableWidth: T,
        availableHeight: D
      });
      const S = await i.getDimensions(s.floating);
      return g !== S.width || h !== S.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function So() {
  return typeof window < "u";
}
function Vn(e) {
  return vd(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function mt(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function kt(e) {
  var n;
  return (n = (vd(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function vd(e) {
  return So() ? e instanceof Node || e instanceof mt(e).Node : !1;
}
function Tt(e) {
  return So() ? e instanceof Element || e instanceof mt(e).Element : !1;
}
function jt(e) {
  return So() ? e instanceof HTMLElement || e instanceof mt(e).HTMLElement : !1;
}
function zc(e) {
  return !So() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof mt(e).ShadowRoot;
}
function hr(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: r,
    display: o
  } = Et(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + r + t) && !["inline", "contents"].includes(o);
}
function Ny(e) {
  return ["table", "td", "th"].includes(Vn(e));
}
function Do(e) {
  return [":popover-open", ":modal"].some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function $i(e) {
  const n = Fi(), t = Tt(e) ? Et(e) : e;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function My(e) {
  let n = nn(e);
  for (; jt(n) && !Dn(n); ) {
    if ($i(n))
      return n;
    if (Do(n))
      return null;
    n = nn(n);
  }
  return null;
}
function Fi() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Dn(e) {
  return ["html", "body", "#document"].includes(Vn(e));
}
function Et(e) {
  return mt(e).getComputedStyle(e);
}
function Ro(e) {
  return Tt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function nn(e) {
  if (Vn(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    zc(e) && e.host || // Fallback.
    kt(e)
  );
  return zc(n) ? n.host : n;
}
function gd(e) {
  const n = nn(e);
  return Dn(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : jt(n) && hr(n) ? n : gd(n);
}
function ar(e, n, t) {
  var r;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const o = gd(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), i = mt(o);
  if (a) {
    const s = Fa(i);
    return n.concat(i, i.visualViewport || [], hr(o) ? o : [], s && t ? ar(s) : []);
  }
  return n.concat(o, ar(o, [], t));
}
function Fa(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function yd(e) {
  const n = Et(e);
  let t = parseFloat(n.width) || 0, r = parseFloat(n.height) || 0;
  const o = jt(e), a = o ? e.offsetWidth : t, i = o ? e.offsetHeight : r, s = Xr(t) !== a || Xr(r) !== i;
  return s && (t = a, r = i), {
    width: t,
    height: r,
    $: s
  };
}
function Vi(e) {
  return Tt(e) ? e : e.contextElement;
}
function Tn(e) {
  const n = Vi(e);
  if (!jt(n))
    return Ot(1);
  const t = n.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = yd(n);
  let i = (a ? Xr(t.width) : t.width) / r, s = (a ? Xr(t.height) : t.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const Oy = /* @__PURE__ */ Ot(0);
function bd(e) {
  const n = mt(e);
  return !Fi() || !n.visualViewport ? Oy : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function jy(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== mt(e) ? !1 : n;
}
function fn(e, n, t, r) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), a = Vi(e);
  let i = Ot(1);
  n && (r ? Tt(r) && (i = Tn(r)) : i = Tn(e));
  const s = jy(a, t, r) ? bd(a) : Ot(0);
  let c = (o.left + s.x) / i.x, l = (o.top + s.y) / i.y, d = o.width / i.x, f = o.height / i.y;
  if (a) {
    const p = mt(a), m = r && Tt(r) ? mt(r) : r;
    let g = p, h = Fa(g);
    for (; h && r && m !== g; ) {
      const v = Tn(h), w = h.getBoundingClientRect(), b = Et(h), x = w.left + (h.clientLeft + parseFloat(b.paddingLeft)) * v.x, C = w.top + (h.clientTop + parseFloat(b.paddingTop)) * v.y;
      c *= v.x, l *= v.y, d *= v.x, f *= v.y, c += x, l += C, g = mt(h), h = Fa(g);
    }
  }
  return Zr({
    width: d,
    height: f,
    x: c,
    y: l
  });
}
function Hi(e, n) {
  const t = Ro(e).scrollLeft;
  return n ? n.left + t : fn(kt(e)).left + t;
}
function xd(e, n, t) {
  t === void 0 && (t = !1);
  const r = e.getBoundingClientRect(), o = r.left + n.scrollLeft - (t ? 0 : (
    // RTL <body> scrollbar.
    Hi(e, r)
  )), a = r.top + n.scrollTop;
  return {
    x: o,
    y: a
  };
}
function Ay(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", i = kt(r), s = n ? Do(n.floating) : !1;
  if (r === i || s && a)
    return t;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Ot(1);
  const d = Ot(0), f = jt(r);
  if ((f || !f && !a) && ((Vn(r) !== "body" || hr(i)) && (c = Ro(r)), jt(r))) {
    const m = fn(r);
    l = Tn(r), d.x = m.x + r.clientLeft, d.y = m.y + r.clientTop;
  }
  const p = i && !f && !a ? xd(i, c, !0) : Ot(0);
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - c.scrollLeft * l.x + d.x + p.x,
    y: t.y * l.y - c.scrollTop * l.y + d.y + p.y
  };
}
function ky(e) {
  return Array.from(e.getClientRects());
}
function Ly(e) {
  const n = kt(e), t = Ro(e), r = e.ownerDocument.body, o = ht(n.scrollWidth, n.clientWidth, r.scrollWidth, r.clientWidth), a = ht(n.scrollHeight, n.clientHeight, r.scrollHeight, r.clientHeight);
  let i = -t.scrollLeft + Hi(e);
  const s = -t.scrollTop;
  return Et(r).direction === "rtl" && (i += ht(n.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function $y(e, n) {
  const t = mt(e), r = kt(e), o = t.visualViewport;
  let a = r.clientWidth, i = r.clientHeight, s = 0, c = 0;
  if (o) {
    a = o.width, i = o.height;
    const l = Fi();
    (!l || l && n === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: c
  };
}
function Fy(e, n) {
  const t = fn(e, !0, n === "fixed"), r = t.top + e.clientTop, o = t.left + e.clientLeft, a = jt(e) ? Tn(e) : Ot(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, c = o * a.x, l = r * a.y;
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
function qc(e, n, t) {
  let r;
  if (n === "viewport")
    r = $y(e, t);
  else if (n === "document")
    r = Ly(kt(e));
  else if (Tt(n))
    r = Fy(n, t);
  else {
    const o = bd(e);
    r = {
      x: n.x - o.x,
      y: n.y - o.y,
      width: n.width,
      height: n.height
    };
  }
  return Zr(r);
}
function wd(e, n) {
  const t = nn(e);
  return t === n || !Tt(t) || Dn(t) ? !1 : Et(t).position === "fixed" || wd(t, n);
}
function Vy(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let r = ar(e, [], !1).filter((s) => Tt(s) && Vn(s) !== "body"), o = null;
  const a = Et(e).position === "fixed";
  let i = a ? nn(e) : e;
  for (; Tt(i) && !Dn(i); ) {
    const s = Et(i), c = $i(i);
    !c && s.position === "fixed" && (o = null), (a ? !c && !o : !c && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || hr(i) && !c && wd(e, i)) ? r = r.filter((d) => d !== i) : o = s, i = nn(i);
  }
  return n.set(e, r), r;
}
function Hy(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: r,
    strategy: o
  } = e;
  const i = [...t === "clippingAncestors" ? Do(n) ? [] : Vy(n, this._c) : [].concat(t), r], s = i[0], c = i.reduce((l, d) => {
    const f = qc(n, d, o);
    return l.top = ht(f.top, l.top), l.right = en(f.right, l.right), l.bottom = en(f.bottom, l.bottom), l.left = ht(f.left, l.left), l;
  }, qc(n, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Wy(e) {
  const {
    width: n,
    height: t
  } = yd(e);
  return {
    width: n,
    height: t
  };
}
function By(e, n, t) {
  const r = jt(n), o = kt(n), a = t === "fixed", i = fn(e, !0, a, n);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Ot(0);
  if (r || !r && !a)
    if ((Vn(n) !== "body" || hr(o)) && (s = Ro(n)), r) {
      const p = fn(n, !0, a, n);
      c.x = p.x + n.clientLeft, c.y = p.y + n.clientTop;
    } else o && (c.x = Hi(o));
  const l = o && !r && !a ? xd(o, s) : Ot(0), d = i.left + s.scrollLeft - c.x - l.x, f = i.top + s.scrollTop - c.y - l.y;
  return {
    x: d,
    y: f,
    width: i.width,
    height: i.height
  };
}
function oa(e) {
  return Et(e).position === "static";
}
function Xc(e, n) {
  if (!jt(e) || Et(e).position === "fixed")
    return null;
  if (n)
    return n(e);
  let t = e.offsetParent;
  return kt(e) === t && (t = t.ownerDocument.body), t;
}
function _d(e, n) {
  const t = mt(e);
  if (Do(e))
    return t;
  if (!jt(e)) {
    let o = nn(e);
    for (; o && !Dn(o); ) {
      if (Tt(o) && !oa(o))
        return o;
      o = nn(o);
    }
    return t;
  }
  let r = Xc(e, n);
  for (; r && Ny(r) && oa(r); )
    r = Xc(r, n);
  return r && Dn(r) && oa(r) && !$i(r) ? t : r || My(e) || t;
}
const Ky = async function(e) {
  const n = this.getOffsetParent || _d, t = this.getDimensions, r = await t(e.floating);
  return {
    reference: By(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Yy(e) {
  return Et(e).direction === "rtl";
}
const Uy = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ay,
  getDocumentElement: kt,
  getClippingRect: Hy,
  getOffsetParent: _d,
  getElementRects: Ky,
  getClientRects: ky,
  getDimensions: Wy,
  getScale: Tn,
  isElement: Tt,
  isRTL: Yy
};
function Gy(e, n) {
  let t = null, r;
  const o = kt(e);
  function a() {
    var s;
    clearTimeout(r), (s = t) == null || s.disconnect(), t = null;
  }
  function i(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const {
      left: l,
      top: d,
      width: f,
      height: p
    } = e.getBoundingClientRect();
    if (s || n(), !f || !p)
      return;
    const m = Or(d), g = Or(o.clientWidth - (l + f)), h = Or(o.clientHeight - (d + p)), v = Or(l), b = {
      rootMargin: -m + "px " + -g + "px " + -h + "px " + -v + "px",
      threshold: ht(0, en(1, c)) || 1
    };
    let x = !0;
    function C(_) {
      const E = _[0].intersectionRatio;
      if (E !== c) {
        if (!x)
          return i();
        E ? i(!1, E) : r = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      x = !1;
    }
    try {
      t = new IntersectionObserver(C, {
        ...b,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(C, b);
    }
    t.observe(e);
  }
  return i(!0), a;
}
function zy(e, n, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Vi(e), d = o || a ? [...l ? ar(l) : [], ...ar(n)] : [];
  d.forEach((w) => {
    o && w.addEventListener("scroll", t, {
      passive: !0
    }), a && w.addEventListener("resize", t);
  });
  const f = l && s ? Gy(l, t) : null;
  let p = -1, m = null;
  i && (m = new ResizeObserver((w) => {
    let [b] = w;
    b && b.target === l && m && (m.unobserve(n), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var x;
      (x = m) == null || x.observe(n);
    })), t();
  }), l && !c && m.observe(l), m.observe(n));
  let g, h = c ? fn(e) : null;
  c && v();
  function v() {
    const w = fn(e);
    h && (w.x !== h.x || w.y !== h.y || w.width !== h.width || w.height !== h.height) && t(), h = w, g = requestAnimationFrame(v);
  }
  return t(), () => {
    var w;
    d.forEach((b) => {
      o && b.removeEventListener("scroll", t), a && b.removeEventListener("resize", t);
    }), f == null || f(), (w = m) == null || w.disconnect(), m = null, c && cancelAnimationFrame(g);
  };
}
const qy = Py, Xy = Sy, Qy = Iy, Zy = Ry, Jy = Ty, Qc = Cy, eb = Dy, tb = (e, n, t) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Uy,
    ...t
  }, a = {
    ...o.platform,
    _c: r
  };
  return _y(e, n, {
    ...o,
    platform: a
  });
};
var Hr = typeof document < "u" ? ni : le;
function Jr(e, n) {
  if (e === n)
    return !0;
  if (typeof e != typeof n)
    return !1;
  if (typeof e == "function" && e.toString() === n.toString())
    return !0;
  let t, r, o;
  if (e && n && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== n.length) return !1;
      for (r = t; r-- !== 0; )
        if (!Jr(e[r], n[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), t = o.length, t !== Object.keys(n).length)
      return !1;
    for (r = t; r-- !== 0; )
      if (!{}.hasOwnProperty.call(n, o[r]))
        return !1;
    for (r = t; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !Jr(e[a], n[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}
function Cd(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Zc(e, n) {
  const t = Cd(e);
  return Math.round(n * t) / t;
}
function aa(e) {
  const n = y.useRef(e);
  return Hr(() => {
    n.current = e;
  }), n;
}
function nb(e) {
  e === void 0 && (e = {});
  const {
    placement: n = "bottom",
    strategy: t = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [d, f] = y.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: n,
    middlewareData: {},
    isPositioned: !1
  }), [p, m] = y.useState(r);
  Jr(p, r) || m(r);
  const [g, h] = y.useState(null), [v, w] = y.useState(null), b = y.useCallback((M) => {
    M !== E.current && (E.current = M, h(M));
  }, []), x = y.useCallback((M) => {
    M !== D.current && (D.current = M, w(M));
  }, []), C = a || g, _ = i || v, E = y.useRef(null), D = y.useRef(null), T = y.useRef(d), S = c != null, N = aa(c), k = aa(o), Y = aa(l), U = y.useCallback(() => {
    if (!E.current || !D.current)
      return;
    const M = {
      placement: n,
      strategy: t,
      middleware: p
    };
    k.current && (M.platform = k.current), tb(E.current, D.current, M).then((B) => {
      const R = {
        ...B,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: Y.current !== !1
      };
      j.current && !Jr(T.current, R) && (T.current = R, ri.flushSync(() => {
        f(R);
      }));
    });
  }, [p, n, t, k, Y]);
  Hr(() => {
    l === !1 && T.current.isPositioned && (T.current.isPositioned = !1, f((M) => ({
      ...M,
      isPositioned: !1
    })));
  }, [l]);
  const j = y.useRef(!1);
  Hr(() => (j.current = !0, () => {
    j.current = !1;
  }), []), Hr(() => {
    if (C && (E.current = C), _ && (D.current = _), C && _) {
      if (N.current)
        return N.current(C, _, U);
      U();
    }
  }, [C, _, U, N, S]);
  const oe = y.useMemo(() => ({
    reference: E,
    floating: D,
    setReference: b,
    setFloating: x
  }), [b, x]), q = y.useMemo(() => ({
    reference: C,
    floating: _
  }), [C, _]), O = y.useMemo(() => {
    const M = {
      position: t,
      left: 0,
      top: 0
    };
    if (!q.floating)
      return M;
    const B = Zc(q.floating, d.x), R = Zc(q.floating, d.y);
    return s ? {
      ...M,
      transform: "translate(" + B + "px, " + R + "px)",
      ...Cd(q.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: B,
      top: R
    };
  }, [t, s, q.floating, d.x, d.y]);
  return y.useMemo(() => ({
    ...d,
    update: U,
    refs: oe,
    elements: q,
    floatingStyles: O
  }), [d, U, oe, q, O]);
}
const rb = (e) => {
  function n(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(t) : e;
      return r && n(r) ? r.current != null ? Qc({
        element: r.current,
        padding: o
      }).fn(t) : {} : r ? Qc({
        element: r,
        padding: o
      }).fn(t) : {};
    }
  };
}, ob = (e, n) => ({
  ...qy(e),
  options: [e, n]
}), ab = (e, n) => ({
  ...Xy(e),
  options: [e, n]
}), ib = (e, n) => ({
  ...eb(e),
  options: [e, n]
}), sb = (e, n) => ({
  ...Qy(e),
  options: [e, n]
}), cb = (e, n) => ({
  ...Zy(e),
  options: [e, n]
}), ub = (e, n) => ({
  ...Jy(e),
  options: [e, n]
}), lb = (e, n) => ({
  ...rb(e),
  options: [e, n]
});
var db = "Arrow", Id = y.forwardRef((e, n) => {
  const { children: t, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ u.jsx(
    se.svg,
    {
      ...a,
      ref: n,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? t : /* @__PURE__ */ u.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Id.displayName = db;
var fb = Id;
function pb(e, n = []) {
  let t = [];
  function r(a, i) {
    const s = y.createContext(i), c = t.length;
    t = [...t, i];
    function l(f) {
      const { scope: p, children: m, ...g } = f, h = (p == null ? void 0 : p[e][c]) || s, v = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u.jsx(h.Provider, { value: v, children: m });
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][c]) || s, g = y.useContext(m);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = t.map((i) => y.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, hb(o, ...n)];
}
function hb(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const t = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = n.scopeName, t;
}
function Td(e) {
  const [n, t] = y.useState(void 0);
  return Kt(() => {
    if (e) {
      t({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          i = l.inlineSize, s = l.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        t({ width: i, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      t(void 0);
  }, [e]), n;
}
var Wi = "Popper", [Ed, Hn] = pb(Wi), [mb, Pd] = Ed(Wi), Bi = (e) => {
  const { __scopePopper: n, children: t } = e, [r, o] = y.useState(null);
  return /* @__PURE__ */ u.jsx(mb, { scope: n, anchor: r, onAnchorChange: o, children: t });
};
Bi.displayName = Wi;
var Sd = "PopperAnchor", mr = y.forwardRef(
  (e, n) => {
    const { __scopePopper: t, virtualRef: r, ...o } = e, a = Pd(Sd, t), i = y.useRef(null), s = Me(n, i);
    return y.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || i.current);
    }), r ? null : /* @__PURE__ */ u.jsx(se.div, { ...o, ref: s });
  }
);
mr.displayName = Sd;
var Ki = "PopperContent", [vb, gb] = Ed(Ki), Yi = y.forwardRef(
  (e, n) => {
    var Q, J, ee, re, de, W;
    const {
      __scopePopper: t,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: g,
      ...h
    } = e, v = Pd(Ki, t), [w, b] = y.useState(null), x = Me(n, (ye) => b(ye)), [C, _] = y.useState(null), E = Td(C), D = (E == null ? void 0 : E.width) ?? 0, T = (E == null ? void 0 : E.height) ?? 0, S = r + (a !== "center" ? "-" + a : ""), N = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, k = Array.isArray(l) ? l : [l], Y = k.length > 0, U = {
      padding: N,
      boundary: k.filter(bb),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Y
    }, { refs: j, floatingStyles: oe, placement: q, isPositioned: O, middlewareData: M } = nb({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: S,
      whileElementsMounted: (...ye) => zy(...ye, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        ob({ mainAxis: o + T, alignmentAxis: i }),
        c && ab({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? ib() : void 0,
          ...U
        }),
        c && sb({ ...U }),
        cb({
          ...U,
          apply: ({ elements: ye, rects: X, availableWidth: je, availableHeight: Ae }) => {
            const { width: at, height: Qe } = X.reference, ze = ye.floating.style;
            ze.setProperty("--radix-popper-available-width", `${je}px`), ze.setProperty("--radix-popper-available-height", `${Ae}px`), ze.setProperty("--radix-popper-anchor-width", `${at}px`), ze.setProperty("--radix-popper-anchor-height", `${Qe}px`);
          }
        }),
        C && lb({ element: C, padding: s }),
        xb({ arrowWidth: D, arrowHeight: T }),
        p && ub({ strategy: "referenceHidden", ...U })
      ]
    }), [B, R] = Nd(q), V = tt(g);
    Kt(() => {
      O && (V == null || V());
    }, [O, V]);
    const F = (Q = M.arrow) == null ? void 0 : Q.x, $ = (J = M.arrow) == null ? void 0 : J.y, L = ((ee = M.arrow) == null ? void 0 : ee.centerOffset) !== 0, [G, z] = y.useState();
    return Kt(() => {
      w && z(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ u.jsx(
      "div",
      {
        ref: j.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...oe,
          transform: O ? oe.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: G,
          "--radix-popper-transform-origin": [
            (re = M.transformOrigin) == null ? void 0 : re.x,
            (de = M.transformOrigin) == null ? void 0 : de.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((W = M.hide) == null ? void 0 : W.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ u.jsx(
          vb,
          {
            scope: t,
            placedSide: B,
            onArrowChange: _,
            arrowX: F,
            arrowY: $,
            shouldHideArrow: L,
            children: /* @__PURE__ */ u.jsx(
              se.div,
              {
                "data-side": B,
                "data-align": R,
                ...h,
                ref: x,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: O ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Yi.displayName = Ki;
var Dd = "PopperArrow", yb = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Rd = y.forwardRef(function(n, t) {
  const { __scopePopper: r, ...o } = n, a = gb(Dd, r), i = yb[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ u.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ u.jsx(
          fb,
          {
            ...o,
            ref: t,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Rd.displayName = Dd;
function bb(e) {
  return e !== null;
}
var xb = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(n) {
    var v, w, b;
    const { placement: t, rects: r, middlewareData: o } = n, i = ((v = o.arrow) == null ? void 0 : v.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [l, d] = Nd(t), f = { start: "0%", center: "50%", end: "100%" }[d], p = (((w = o.arrow) == null ? void 0 : w.x) ?? 0) + s / 2, m = (((b = o.arrow) == null ? void 0 : b.y) ?? 0) + c / 2;
    let g = "", h = "";
    return l === "bottom" ? (g = i ? f : `${p}px`, h = `${-c}px`) : l === "top" ? (g = i ? f : `${p}px`, h = `${r.floating.height + c}px`) : l === "right" ? (g = `${-c}px`, h = i ? f : `${m}px`) : l === "left" && (g = `${r.floating.width + c}px`, h = i ? f : `${m}px`), { data: { x: g, y: h } };
  }
});
function Nd(e) {
  const [n, t = "center"] = e.split("-");
  return [n, t];
}
var Ui = Bi, No = mr, Gi = Yi, zi = Rd, qi = "Popover", [Md, xD] = At(qi, [
  Hn
]), vr = Hn(), [wb, rn] = Md(qi), Xi = (e) => {
  const {
    __scopePopover: n,
    children: t,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: i = !1
  } = e, s = vr(n), c = y.useRef(null), [l, d] = y.useState(!1), [f = !1, p] = Ue({
    prop: r,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ u.jsx(Ui, { ...s, children: /* @__PURE__ */ u.jsx(
    wb,
    {
      scope: n,
      contentId: It(),
      triggerRef: c,
      open: f,
      onOpenChange: p,
      onOpenToggle: y.useCallback(() => p((m) => !m), [p]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: y.useCallback(() => d(!0), []),
      onCustomAnchorRemove: y.useCallback(() => d(!1), []),
      modal: i,
      children: t
    }
  ) });
};
Xi.displayName = qi;
var Od = "PopoverAnchor", jd = y.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...r } = e, o = rn(Od, t), a = vr(t), { onCustomAnchorAdd: i, onCustomAnchorRemove: s } = o;
    return y.useEffect(() => (i(), () => s()), [i, s]), /* @__PURE__ */ u.jsx(No, { ...a, ...r, ref: n });
  }
);
jd.displayName = Od;
var Ad = "PopoverTrigger", kd = y.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...r } = e, o = rn(Ad, t), a = vr(t), i = Me(n, o.triggerRef), s = /* @__PURE__ */ u.jsx(
      se.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Vd(o.open),
        ...r,
        ref: i,
        onClick: ne(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ u.jsx(No, { asChild: !0, ...a, children: s });
  }
);
kd.displayName = Ad;
var Qi = "PopoverPortal", [_b, Cb] = Md(Qi, {
  forceMount: void 0
}), Zi = (e) => {
  const { __scopePopover: n, forceMount: t, children: r, container: o } = e, a = rn(Qi, n);
  return /* @__PURE__ */ u.jsx(_b, { scope: n, forceMount: t, children: /* @__PURE__ */ u.jsx(nt, { present: t || a.open, children: /* @__PURE__ */ u.jsx($n, { asChild: !0, container: o, children: r }) }) });
};
Zi.displayName = Qi;
var Rn = "PopoverContent", Ji = y.forwardRef(
  (e, n) => {
    const t = Cb(Rn, e.__scopePopover), { forceMount: r = t.forceMount, ...o } = e, a = rn(Rn, e.__scopePopover);
    return /* @__PURE__ */ u.jsx(nt, { present: r || a.open, children: a.modal ? /* @__PURE__ */ u.jsx(Ib, { ...o, ref: n }) : /* @__PURE__ */ u.jsx(Tb, { ...o, ref: n }) });
  }
);
Ji.displayName = Rn;
var Ib = y.forwardRef(
  (e, n) => {
    const t = rn(Rn, e.__scopePopover), r = y.useRef(null), o = Me(n, r), a = y.useRef(!1);
    return y.useEffect(() => {
      const i = r.current;
      if (i) return Ti(i);
    }, []), /* @__PURE__ */ u.jsx(Co, { as: ln, allowPinchZoom: !0, children: /* @__PURE__ */ u.jsx(
      Ld,
      {
        ...e,
        ref: o,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (i) => {
          var s;
          i.preventDefault(), a.current || (s = t.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: ne(
          e.onPointerDownOutside,
          (i) => {
            const s = i.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
            a.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: ne(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Tb = y.forwardRef(
  (e, n) => {
    const t = rn(Rn, e.__scopePopover), r = y.useRef(!1), o = y.useRef(!1);
    return /* @__PURE__ */ u.jsx(
      Ld,
      {
        ...e,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (r.current || (s = t.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const i = a.target;
          ((l = t.triggerRef.current) == null ? void 0 : l.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Ld = y.forwardRef(
  (e, n) => {
    const {
      __scopePopover: t,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: d,
      ...f
    } = e, p = rn(Rn, t), m = vr(t);
    return Ii(), /* @__PURE__ */ u.jsx(
      wo,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ u.jsx(
          Ln,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: d,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => p.onOpenChange(!1),
            children: /* @__PURE__ */ u.jsx(
              Gi,
              {
                "data-state": Vd(p.open),
                role: "dialog",
                id: p.contentId,
                ...m,
                ...f,
                ref: n,
                style: {
                  ...f.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), $d = "PopoverClose", es = y.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...r } = e, o = rn($d, t);
    return /* @__PURE__ */ u.jsx(
      se.button,
      {
        type: "button",
        ...r,
        ref: n,
        onClick: ne(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
es.displayName = $d;
var Eb = "PopoverArrow", Fd = y.forwardRef(
  (e, n) => {
    const { __scopePopover: t, ...r } = e, o = vr(t);
    return /* @__PURE__ */ u.jsx(zi, { ...o, ...r, ref: n });
  }
);
Fd.displayName = Eb;
function Vd(e) {
  return e ? "open" : "closed";
}
const ts = 6048e5, Pb = 864e5, Sb = 6e4, Db = 36e5, Rb = 1e3, Jc = Symbol.for("constructDateFrom");
function Ne(e, n) {
  return typeof e == "function" ? e(n) : e && typeof e == "object" && Jc in e ? e[Jc](n) : e instanceof Date ? new e.constructor(n) : new Date(n);
}
function ue(e, n) {
  return Ne(n || e, e);
}
function Xe(e, n, t) {
  const r = ue(e, t == null ? void 0 : t.in);
  return isNaN(n) ? Ne((t == null ? void 0 : t.in) || e, NaN) : (n && r.setDate(r.getDate() + n), r);
}
function et(e, n, t) {
  const r = ue(e, t == null ? void 0 : t.in);
  if (isNaN(n)) return Ne((t == null ? void 0 : t.in) || e, NaN);
  if (!n)
    return r;
  const o = r.getDate(), a = Ne((t == null ? void 0 : t.in) || e, r.getTime());
  a.setMonth(r.getMonth() + n + 1, 0);
  const i = a.getDate();
  return o >= i ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    o
  ), r);
}
let Nb = {};
function pn() {
  return Nb;
}
function vt(e, n) {
  var s, c, l, d;
  const t = pn(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((c = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? t.weekStartsOn ?? ((d = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = ue(e, n == null ? void 0 : n.in), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function Gt(e, n) {
  return vt(e, { ...n, weekStartsOn: 1 });
}
function Hd(e, n) {
  const t = ue(e, n == null ? void 0 : n.in), r = t.getFullYear(), o = Ne(t, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Gt(o), i = Ne(t, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const s = Gt(i);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= s.getTime() ? r : r - 1;
}
function Nn(e) {
  const n = ue(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Wn(e, ...n) {
  const t = Ne.bind(
    null,
    e || n.find((r) => typeof r == "object")
  );
  return n.map(t);
}
function Mn(e, n) {
  const t = ue(e, n == null ? void 0 : n.in);
  return t.setHours(0, 0, 0, 0), t;
}
function Mt(e, n, t) {
  const [r, o] = Wn(
    t == null ? void 0 : t.in,
    e,
    n
  ), a = Mn(r), i = Mn(o), s = +a - Nn(a), c = +i - Nn(i);
  return Math.round((s - c) / Pb);
}
function Mb(e, n) {
  const t = Hd(e, n), r = Ne(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), Gt(r);
}
function Va(e, n, t) {
  return Xe(e, n * 7, t);
}
function Ob(e, n, t) {
  return et(e, n * 12, t);
}
function jb(e, n) {
  let t, r = n == null ? void 0 : n.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Ne.bind(null, o));
    const a = ue(o, r);
    (!t || t < a || isNaN(+a)) && (t = a);
  }), Ne(r, t || NaN);
}
function Ab(e, n) {
  let t, r = n == null ? void 0 : n.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Ne.bind(null, o));
    const a = ue(o, r);
    (!t || t > a || isNaN(+a)) && (t = a);
  }), Ne(r, t || NaN);
}
function Ye(e, n, t) {
  const [r, o] = Wn(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return +Mn(r) == +Mn(o);
}
function ns(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Mo(e) {
  return !(!ns(e) && typeof e != "number" || isNaN(+ue(e)));
}
function ir(e, n, t) {
  const [r, o] = Wn(
    t == null ? void 0 : t.in,
    e,
    n
  ), a = r.getFullYear() - o.getFullYear(), i = r.getMonth() - o.getMonth();
  return a * 12 + i;
}
function kb(e, n, t) {
  const [r, o] = Wn(
    t == null ? void 0 : t.in,
    e,
    n
  ), a = vt(r, t), i = vt(o, t), s = +a - Nn(a), c = +i - Nn(i);
  return Math.round((s - c) / ts);
}
function Lb(e, n) {
  const t = ue(e, n == null ? void 0 : n.in);
  return t.setHours(23, 59, 59, 999), t;
}
function gr(e, n) {
  const t = ue(e, n == null ? void 0 : n.in), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function $b(e, n) {
  const t = ue(e, n == null ? void 0 : n.in);
  return +Lb(t, n) == +gr(t, n);
}
function Ve(e, n) {
  const t = ue(e, n == null ? void 0 : n.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function Wd(e, n) {
  const t = ue(e, n == null ? void 0 : n.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function rs(e, n) {
  var s, c, l, d;
  const t = pn(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((c = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : c.weekStartsOn) ?? t.weekStartsOn ?? ((d = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : d.weekStartsOn) ?? 0, o = ue(e, n == null ? void 0 : n.in), a = o.getDay(), i = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function Bd(e, n) {
  return rs(e, { ...n, weekStartsOn: 1 });
}
const Fb = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Vb = (e, n, t) => {
  let r;
  const o = Fb[e];
  return typeof o == "string" ? r = o : n === 1 ? r = o.one : r = o.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ia(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Hb = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Wb = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Bb = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kb = {
  date: ia({
    formats: Hb,
    defaultWidth: "full"
  }),
  time: ia({
    formats: Wb,
    defaultWidth: "full"
  }),
  dateTime: ia({
    formats: Bb,
    defaultWidth: "full"
  })
}, Yb = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ub = (e, n, t, r) => Yb[e];
function Zn(e) {
  return (n, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(n) : n;
    return o[a];
  };
}
const Gb = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, zb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, qb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Xb = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Qb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, Zb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Jb = (e, n) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, ex = {
  ordinalNumber: Jb,
  era: Zn({
    values: Gb,
    defaultWidth: "wide"
  }),
  quarter: Zn({
    values: zb,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Zn({
    values: qb,
    defaultWidth: "wide"
  }),
  day: Zn({
    values: Xb,
    defaultWidth: "wide"
  }),
  dayPeriod: Zn({
    values: Qb,
    defaultWidth: "wide",
    formattingValues: Zb,
    defaultFormattingWidth: "wide"
  })
};
function Jn(e) {
  return (n, t = {}) => {
    const r = t.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = n.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? nx(s, (f) => f.test(i)) : (
      // [TODO] -- I challenge you to fix the type
      tx(s, (f) => f.test(i))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(l)
    ) : l;
    const d = n.slice(i.length);
    return { value: l, rest: d };
  };
}
function tx(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function nx(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function rx(e) {
  return (n, t = {}) => {
    const r = n.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], a = n.match(e.parsePattern);
    if (!a) return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const s = n.slice(o.length);
    return { value: i, rest: s };
  };
}
const ox = /^(\d+)(th|st|nd|rd)?/i, ax = /\d+/i, ix = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, sx = {
  any: [/^b/i, /^(a|c)/i]
}, cx = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, ux = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, lx = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, dx = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, fx = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, px = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, hx = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, mx = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, vx = {
  ordinalNumber: rx({
    matchPattern: ox,
    parsePattern: ax,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Jn({
    matchPatterns: ix,
    defaultMatchWidth: "wide",
    parsePatterns: sx,
    defaultParseWidth: "any"
  }),
  quarter: Jn({
    matchPatterns: cx,
    defaultMatchWidth: "wide",
    parsePatterns: ux,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Jn({
    matchPatterns: lx,
    defaultMatchWidth: "wide",
    parsePatterns: dx,
    defaultParseWidth: "any"
  }),
  day: Jn({
    matchPatterns: fx,
    defaultMatchWidth: "wide",
    parsePatterns: px,
    defaultParseWidth: "any"
  }),
  dayPeriod: Jn({
    matchPatterns: hx,
    defaultMatchWidth: "any",
    parsePatterns: mx,
    defaultParseWidth: "any"
  })
}, os = {
  code: "en-US",
  formatDistance: Vb,
  formatLong: Kb,
  formatRelative: Ub,
  localize: ex,
  match: vx,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function gx(e, n) {
  const t = ue(e, n == null ? void 0 : n.in);
  return Mt(t, Wd(t)) + 1;
}
function as(e, n) {
  const t = ue(e, n == null ? void 0 : n.in), r = +Gt(t) - +Mb(t);
  return Math.round(r / ts) + 1;
}
function is(e, n) {
  var d, f, p, m;
  const t = ue(e, n == null ? void 0 : n.in), r = t.getFullYear(), o = pn(), a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (d = n == null ? void 0 : n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((m = (p = o.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = Ne((n == null ? void 0 : n.in) || e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = vt(i, n), c = Ne((n == null ? void 0 : n.in) || e, 0);
  c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
  const l = vt(c, n);
  return +t >= +s ? r + 1 : +t >= +l ? r : r - 1;
}
function yx(e, n) {
  var s, c, l, d;
  const t = pn(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((c = (s = n == null ? void 0 : n.locale) == null ? void 0 : s.options) == null ? void 0 : c.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((d = (l = t.locale) == null ? void 0 : l.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, o = is(e, n), a = Ne((n == null ? void 0 : n.in) || e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), vt(a, n);
}
function ss(e, n) {
  const t = ue(e, n == null ? void 0 : n.in), r = +vt(t, n) - +yx(t, n);
  return Math.round(r / ts) + 1;
}
function Ee(e, n) {
  const t = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(n, "0");
  return t + r;
}
const Qt = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), r = t > 0 ? t : 1 - t;
    return Ee(n === "yy" ? r % 100 : r, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : Ee(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return Ee(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return Ee(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return Ee(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return Ee(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return Ee(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return Ee(o, n.length);
  }
}, _n = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, eu = {
  // Era
  G: function(e, n, t) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return Qt.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, r) {
    const o = is(e, r), a = o > 0 ? o : 1 - o;
    if (n === "YY") {
      const i = a % 100;
      return Ee(i, 2);
    }
    return n === "Yo" ? t.ordinalNumber(a, { unit: "year" }) : Ee(a, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = Hd(e);
    return Ee(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return Ee(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(r);
      case "QQ":
        return Ee(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(r);
      case "qq":
        return Ee(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Qt.M(e, n);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "L":
        return String(r + 1);
      case "LL":
        return Ee(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, r) {
    const o = ss(e, r);
    return n === "wo" ? t.ordinalNumber(o, { unit: "week" }) : Ee(o, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const r = as(e);
    return n === "Io" ? t.ordinalNumber(r, { unit: "week" }) : Ee(r, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Qt.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const r = gx(e);
    return n === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : Ee(r, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const r = e.getDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return Ee(a, 2);
      case "eo":
        return t.ordinalNumber(a, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return Ee(a, n.length);
      case "co":
        return t.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return Ee(o, n.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = _n.noon : r === 0 ? o = _n.midnight : o = r / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = _n.evening : r >= 12 ? o = _n.afternoon : r >= 4 ? o = _n.morning : o = _n.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Qt.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Qt.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const r = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : Ee(r, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let r = e.getHours();
    return r === 0 && (r = 24), n === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : Ee(r, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Qt.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Qt.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Qt.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (n) {
      case "X":
        return nu(r);
      case "XXXX":
      case "XX":
        return sn(r);
      case "XXXXX":
      case "XXX":
      default:
        return sn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "x":
        return nu(r);
      case "xxxx":
      case "xx":
        return sn(r);
      case "xxxxx":
      case "xxx":
      default:
        return sn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + tu(r, ":");
      case "OOOO":
      default:
        return "GMT" + sn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + tu(r, ":");
      case "zzzz":
      default:
        return "GMT" + sn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const r = Math.trunc(+e / 1e3);
    return Ee(r, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    return Ee(+e, n.length);
  }
};
function tu(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? t + String(o) : t + String(o) + n + Ee(a, 2);
}
function nu(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Ee(Math.abs(e) / 60, 2) : sn(e, n);
}
function sn(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), o = Ee(Math.trunc(r / 60), 2), a = Ee(r % 60, 2);
  return t + o + n + a;
}
const ru = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, Kd = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, bx = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], r = t[1], o = t[2];
  if (!o)
    return ru(e, n);
  let a;
  switch (r) {
    case "P":
      a = n.dateTime({ width: "short" });
      break;
    case "PP":
      a = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = n.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", ru(r, n)).replace("{{time}}", Kd(o, n));
}, Ha = {
  p: Kd,
  P: bx
}, xx = /^D+$/, wx = /^Y+$/, _x = ["D", "DD", "YY", "YYYY"];
function Yd(e) {
  return xx.test(e);
}
function Ud(e) {
  return wx.test(e);
}
function Wa(e, n, t) {
  const r = Cx(e, n, t);
  if (console.warn(r), _x.includes(e)) throw new RangeError(r);
}
function Cx(e, n, t) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Ix = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Tx = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ex = /^'([^]*?)'?$/, Px = /''/g, Sx = /[a-zA-Z]/;
function pe(e, n, t) {
  var d, f, p, m, g, h, v, w;
  const r = pn(), o = (t == null ? void 0 : t.locale) ?? r.locale ?? os, a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((h = (g = t == null ? void 0 : t.locale) == null ? void 0 : g.options) == null ? void 0 : h.weekStartsOn) ?? r.weekStartsOn ?? ((w = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : w.weekStartsOn) ?? 0, s = ue(e, t == null ? void 0 : t.in);
  if (!Mo(s))
    throw new RangeError("Invalid time value");
  let c = n.match(Tx).map((b) => {
    const x = b[0];
    if (x === "p" || x === "P") {
      const C = Ha[x];
      return C(b, o.formatLong);
    }
    return b;
  }).join("").match(Ix).map((b) => {
    if (b === "''")
      return { isToken: !1, value: "'" };
    const x = b[0];
    if (x === "'")
      return { isToken: !1, value: Dx(b) };
    if (eu[x])
      return { isToken: !0, value: b };
    if (x.match(Sx))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: b };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return c.map((b) => {
    if (!b.isToken) return b.value;
    const x = b.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Ud(x) || !(t != null && t.useAdditionalDayOfYearTokens) && Yd(x)) && Wa(x, n, String(e));
    const C = eu[x[0]];
    return C(s, x, o.localize, l);
  }).join("");
}
function Dx(e) {
  const n = e.match(Ex);
  return n ? n[1].replace(Px, "'") : e;
}
function Rx(e, n) {
  const t = ue(e, n == null ? void 0 : n.in), r = t.getFullYear(), o = t.getMonth(), a = Ne(t, 0);
  return a.setFullYear(r, o + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function Nx() {
  return Object.assign({}, pn());
}
function Mx(e, n) {
  const t = ue(e, n == null ? void 0 : n.in).getDay();
  return t === 0 ? 7 : t;
}
function Ox(e) {
  return Math.trunc(+ue(e) / 1e3);
}
function jx(e, n) {
  const t = ue(e, n == null ? void 0 : n.in), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), ue(t, n == null ? void 0 : n.in);
}
function Ax(e, n) {
  const t = ue(e, n == null ? void 0 : n.in);
  return kb(
    jx(t, n),
    Ve(t, n),
    n
  ) + 1;
}
function On(e, n) {
  return +ue(e) > +ue(n);
}
function En(e, n) {
  return +ue(e) < +ue(n);
}
function kx(e, n) {
  return ue(e, n == null ? void 0 : n.in).getDate() === 1;
}
function Lx(e, n) {
  const t = $x(n) ? new n(0) : Ne(n, 0);
  return t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
function $x(e) {
  var n;
  return typeof e == "function" && ((n = e.prototype) == null ? void 0 : n.constructor) === e;
}
const Fx = 10;
class Gd {
  constructor() {
    te(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class Vx extends Gd {
  constructor(n, t, r, o, a) {
    super(), this.value = n, this.validateValue = t, this.setValue = r, this.priority = o, a && (this.subPriority = a);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, r) {
    return this.setValue(n, t, this.value, r);
  }
}
class Hx extends Gd {
  constructor(t, r) {
    super();
    te(this, "priority", Fx);
    te(this, "subPriority", -1);
    this.context = t || ((o) => Ne(r, o));
  }
  set(t, r) {
    return r.timestampIsSet ? t : Ne(t, Lx(t, this.context));
  }
}
class be {
  run(n, t, r, o) {
    const a = this.parse(n, t, r, o);
    return a ? {
      setter: new Vx(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(n, t, r) {
    return !0;
  }
}
class Wx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 140);
    te(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
      case "GGGGG":
        return o.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(t, { width: "wide" }) || o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
    }
  }
  set(t, r, o) {
    return r.era = o, t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const He = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Rt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function We(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function Le(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Nt(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, o = t[2] ? parseInt(t[2], 10) : 0, a = t[3] ? parseInt(t[3], 10) : 0, i = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (o * Db + a * Sb + i * Rb),
    rest: n.slice(t[0].length)
  };
}
function zd(e) {
  return Le(He.anyDigitsSigned, e);
}
function $e(e, n) {
  switch (e) {
    case 1:
      return Le(He.singleDigit, n);
    case 2:
      return Le(He.twoDigits, n);
    case 3:
      return Le(He.threeDigits, n);
    case 4:
      return Le(He.fourDigits, n);
    default:
      return Le(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function eo(e, n) {
  switch (e) {
    case 1:
      return Le(He.singleDigitSigned, n);
    case 2:
      return Le(He.twoDigitsSigned, n);
    case 3:
      return Le(He.threeDigitsSigned, n);
    case 4:
      return Le(He.fourDigitsSigned, n);
    default:
      return Le(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function cs(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function qd(e, n) {
  const t = n > 0, r = t ? n : 1 - n;
  let o;
  if (r <= 50)
    o = e || 100;
  else {
    const a = r + 50, i = Math.trunc(a / 100) * 100, s = e >= a % 100;
    o = e + i - (s ? 100 : 0);
  }
  return t ? o : 1 - o;
}
function Xd(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class Bx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, o) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return We($e(4, t), a);
      case "yo":
        return We(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          a
        );
      default:
        return We($e(r.length, t), a);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, o) {
    const a = t.getFullYear();
    if (o.isTwoDigitYear) {
      const s = qd(
        o.year,
        a
      );
      return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Kx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return We($e(4, t), a);
      case "Yo":
        return We(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          a
        );
      default:
        return We($e(r.length, t), a);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, o, a) {
    const i = is(t, a);
    if (o.isTwoDigitYear) {
      const c = qd(
        o.year,
        i
      );
      return t.setFullYear(
        c,
        0,
        a.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), vt(t, a);
    }
    const s = !("era" in r) || r.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(s, 0, a.firstWeekContainsDate), t.setHours(0, 0, 0, 0), vt(t, a);
  }
}
class Yx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return eo(r === "R" ? 4 : r.length, t);
  }
  set(t, r, o) {
    const a = Ne(t, 0);
    return a.setFullYear(o, 0, 4), a.setHours(0, 0, 0, 0), Gt(a);
  }
}
class Ux extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 130);
    te(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return eo(r === "u" ? 4 : r.length, t);
  }
  set(t, r, o) {
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Gx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 120);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "Q":
      case "QQ":
        return $e(r.length, t);
      case "Qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class zx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 120);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "q":
      case "qq":
        return $e(r.length, t);
      case "qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class qx extends be {
  constructor() {
    super(...arguments);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    te(this, "priority", 110);
  }
  parse(t, r, o) {
    const a = (i) => i - 1;
    switch (r) {
      case "M":
        return We(
          Le(He.month, t),
          a
        );
      case "MM":
        return We($e(2, t), a);
      case "Mo":
        return We(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          a
        );
      case "MMM":
        return o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(t, { width: "wide", context: "formatting" }) || o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class Xx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 110);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    const a = (i) => i - 1;
    switch (r) {
      case "L":
        return We(
          Le(He.month, t),
          a
        );
      case "LL":
        return We($e(2, t), a);
      case "Lo":
        return We(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          a
        );
      case "LLL":
        return o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(t, { width: "wide", context: "standalone" }) || o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function Qx(e, n, t) {
  const r = ue(e, t == null ? void 0 : t.in), o = ss(r, t) - n;
  return r.setDate(r.getDate() - o * 7), ue(r, t == null ? void 0 : t.in);
}
class Zx extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 100);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "w":
        return Le(He.week, t);
      case "wo":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, o, a) {
    return vt(Qx(t, o, a), a);
  }
}
function Jx(e, n, t) {
  const r = ue(e, t == null ? void 0 : t.in), o = as(r, t) - n;
  return r.setDate(r.getDate() - o * 7), r;
}
class ew extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 100);
    te(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "I":
        return Le(He.week, t);
      case "Io":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, o) {
    return Gt(Jx(t, o));
  }
}
const tw = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], nw = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class rw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "subPriority", 1);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "d":
        return Le(He.date, t);
      case "do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    const o = t.getFullYear(), a = Xd(o), i = t.getMonth();
    return a ? r >= 1 && r <= nw[i] : r >= 1 && r <= tw[i];
  }
  set(t, r, o) {
    return t.setDate(o), t.setHours(0, 0, 0, 0), t;
  }
}
class ow extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "subpriority", 1);
    te(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    switch (r) {
      case "D":
      case "DD":
        return Le(He.dayOfYear, t);
      case "Do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    const o = t.getFullYear();
    return Xd(o) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, o) {
    return t.setMonth(0, o), t.setHours(0, 0, 0, 0), t;
  }
}
function us(e, n, t) {
  var f, p, m, g;
  const r = pn(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : p.weekStartsOn) ?? r.weekStartsOn ?? ((g = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) ?? 0, a = ue(e, t == null ? void 0 : t.in), i = a.getDay(), c = (n % 7 + 7) % 7, l = 7 - o, d = n < 0 || n > 6 ? n - (i + l) % 7 : (c + l) % 7 - (i + l) % 7;
  return Xe(a, d, t);
}
class aw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, a) {
    return t = us(t, o, a), t.setHours(0, 0, 0, 0), t;
  }
}
class iw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o, a) {
    const i = (s) => {
      const c = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "e":
      case "ee":
        return We($e(r.length, t), i);
      case "eo":
        return We(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, a) {
    return t = us(t, o, a), t.setHours(0, 0, 0, 0), t;
  }
}
class sw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, o, a) {
    const i = (s) => {
      const c = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + c;
    };
    switch (r) {
      case "c":
      case "cc":
        return We($e(r.length, t), i);
      case "co":
        return We(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(t, { width: "wide", context: "standalone" }) || o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, o, a) {
    return t = us(t, o, a), t.setHours(0, 0, 0, 0), t;
  }
}
function cw(e, n, t) {
  const r = ue(e, t == null ? void 0 : t.in), o = Mx(r, t), a = n - o;
  return Xe(r, a, t);
}
class uw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 90);
    te(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, o) {
    const a = (i) => i === 0 ? 7 : i;
    switch (r) {
      case "i":
      case "ii":
        return $e(r.length, t);
      case "io":
        return o.ordinalNumber(t, { unit: "day" });
      case "iii":
        return We(
          o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiii":
        return We(
          o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiiii":
        return We(
          o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiii":
      default:
        return We(
          o.day(t, {
            width: "wide",
            context: "formatting"
          }) || o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, o) {
    return t = cw(t, o), t.setHours(0, 0, 0, 0), t;
  }
}
class lw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 80);
    te(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(cs(o), 0, 0, 0), t;
  }
}
class dw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 80);
    te(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(cs(o), 0, 0, 0), t;
  }
}
class fw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 80);
    te(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, o) {
    return t.setHours(cs(o), 0, 0, 0), t;
  }
}
class pw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "h":
        return Le(He.hour12h, t);
      case "ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, o) {
    const a = t.getHours() >= 12;
    return a && o < 12 ? t.setHours(o + 12, 0, 0, 0) : !a && o === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class hw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "H":
        return Le(He.hour23h, t);
      case "Ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, o) {
    return t.setHours(o, 0, 0, 0), t;
  }
}
class mw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "K":
        return Le(He.hour11h, t);
      case "Ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, o) {
    return t.getHours() >= 12 && o < 12 ? t.setHours(o + 12, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class vw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 70);
    te(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "k":
        return Le(He.hour24h, t);
      case "ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, o) {
    const a = o <= 24 ? o % 24 : o;
    return t.setHours(a, 0, 0, 0), t;
  }
}
class gw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 60);
    te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "m":
        return Le(He.minute, t);
      case "mo":
        return o.ordinalNumber(t, { unit: "minute" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, o) {
    return t.setMinutes(o, 0, 0), t;
  }
}
class yw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 50);
    te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, o) {
    switch (r) {
      case "s":
        return Le(He.second, t);
      case "so":
        return o.ordinalNumber(t, { unit: "second" });
      default:
        return $e(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, o) {
    return t.setSeconds(o, 0), t;
  }
}
class bw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 30);
    te(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const o = (a) => Math.trunc(a * Math.pow(10, -r.length + 3));
    return We($e(r.length, t), o);
  }
  set(t, r, o) {
    return t.setMilliseconds(o), t;
  }
}
class xw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 10);
    te(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return Nt(
          Rt.basicOptionalMinutes,
          t
        );
      case "XX":
        return Nt(Rt.basic, t);
      case "XXXX":
        return Nt(
          Rt.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Nt(
          Rt.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Nt(Rt.extended, t);
    }
  }
  set(t, r, o) {
    return r.timestampIsSet ? t : Ne(
      t,
      t.getTime() - Nn(t) - o
    );
  }
}
class ww extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 10);
    te(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return Nt(
          Rt.basicOptionalMinutes,
          t
        );
      case "xx":
        return Nt(Rt.basic, t);
      case "xxxx":
        return Nt(
          Rt.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Nt(
          Rt.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Nt(Rt.extended, t);
    }
  }
  set(t, r, o) {
    return r.timestampIsSet ? t : Ne(
      t,
      t.getTime() - Nn(t) - o
    );
  }
}
class _w extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 40);
    te(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return zd(t);
  }
  set(t, r, o) {
    return [Ne(t, o * 1e3), { timestampIsSet: !0 }];
  }
}
class Cw extends be {
  constructor() {
    super(...arguments);
    te(this, "priority", 20);
    te(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return zd(t);
  }
  set(t, r, o) {
    return [Ne(t, o), { timestampIsSet: !0 }];
  }
}
const Iw = {
  G: new Wx(),
  y: new Bx(),
  Y: new Kx(),
  R: new Yx(),
  u: new Ux(),
  Q: new Gx(),
  q: new zx(),
  M: new qx(),
  L: new Xx(),
  w: new Zx(),
  I: new ew(),
  d: new rw(),
  D: new ow(),
  E: new aw(),
  e: new iw(),
  c: new sw(),
  i: new uw(),
  a: new lw(),
  b: new dw(),
  B: new fw(),
  h: new pw(),
  H: new hw(),
  K: new mw(),
  k: new vw(),
  m: new gw(),
  s: new yw(),
  S: new bw(),
  X: new xw(),
  x: new ww(),
  t: new _w(),
  T: new Cw()
}, Tw = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ew = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Pw = /^'([^]*?)'?$/, Sw = /''/g, Dw = /\S/, Rw = /[a-zA-Z]/;
function ls(e, n, t, r) {
  var v, w, b, x;
  const o = () => Ne(t, NaN), a = Nx(), i = a.locale ?? os, s = a.firstWeekContainsDate ?? ((w = (v = a.locale) == null ? void 0 : v.options) == null ? void 0 : w.firstWeekContainsDate) ?? 1, c = a.weekStartsOn ?? ((x = (b = a.locale) == null ? void 0 : b.options) == null ? void 0 : x.weekStartsOn) ?? 0;
  if (!n)
    return e ? o() : ue(t, r == null ? void 0 : r.in);
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: c,
    locale: i
  }, d = [new Hx(r == null ? void 0 : r.in, t)], f = n.match(Ew).map((C) => {
    const _ = C[0];
    if (_ in Ha) {
      const E = Ha[_];
      return E(C, i.formatLong);
    }
    return C;
  }).join("").match(Tw), p = [];
  for (let C of f) {
    Ud(C) && Wa(C, n, e), Yd(C) && Wa(C, n, e);
    const _ = C[0], E = Iw[_];
    if (E) {
      const { incompatibleTokens: D } = E;
      if (Array.isArray(D)) {
        const S = p.find(
          (N) => D.includes(N.token) || N.token === _
        );
        if (S)
          throw new RangeError(
            `The format string mustn't contain \`${S.fullToken}\` and \`${C}\` at the same time`
          );
      } else if (E.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${C}\` and any other token at the same time`
        );
      p.push({ token: _, fullToken: C });
      const T = E.run(
        e,
        C,
        i.match,
        l
      );
      if (!T)
        return o();
      d.push(T.setter), e = T.rest;
    } else {
      if (_.match(Rw))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (C === "''" ? C = "'" : _ === "'" && (C = Nw(C)), e.indexOf(C) === 0)
        e = e.slice(C.length);
      else
        return o();
    }
  }
  if (e.length > 0 && Dw.test(e))
    return o();
  const m = d.map((C) => C.priority).sort((C, _) => _ - C).filter((C, _, E) => E.indexOf(C) === _).map(
    (C) => d.filter((_) => _.priority === C).sort((_, E) => E.subPriority - _.subPriority)
  ).map((C) => C[0]);
  let g = ue(t, r == null ? void 0 : r.in);
  if (isNaN(+g)) return o();
  const h = {};
  for (const C of m) {
    if (!C.validate(g, l))
      return o();
    const _ = C.set(g, h, l);
    Array.isArray(_) ? (g = _[0], Object.assign(h, _[1])) : g = _;
  }
  return g;
}
function Nw(e) {
  return e.match(Pw)[1].replace(Sw, "'");
}
function Ht(e, n, t) {
  const [r, o] = Wn(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function Mw(e, n, t) {
  const [r, o] = Wn(
    t == null ? void 0 : t.in,
    e,
    n
  );
  return r.getFullYear() === o.getFullYear();
}
function ou(e, n, t) {
  const r = +ue(e, t == null ? void 0 : t.in), [o, a] = [
    +ue(n.start, t == null ? void 0 : t.in),
    +ue(n.end, t == null ? void 0 : t.in)
  ].sort((i, s) => i - s);
  return r >= o && r <= a;
}
function sa(e, n, t) {
  return Xe(e, -n, t);
}
function ca(e, n, t) {
  const r = ue(e, t == null ? void 0 : t.in), o = r.getFullYear(), a = r.getDate(), i = Ne(e, 0);
  i.setFullYear(o, n, 15), i.setHours(0, 0, 0, 0);
  const s = Rx(i);
  return r.setMonth(n, Math.min(a, s)), r;
}
function au(e, n, t) {
  const r = ue(e, t == null ? void 0 : t.in);
  return isNaN(+r) ? Ne(e, NaN) : (r.setFullYear(n), r);
}
var ae = function() {
  return ae = Object.assign || function(n) {
    for (var t, r = 1, o = arguments.length; r < o; r++) {
      t = arguments[r];
      for (var a in t) Object.prototype.hasOwnProperty.call(t, a) && (n[a] = t[a]);
    }
    return n;
  }, ae.apply(this, arguments);
};
function Ow(e, n) {
  var t = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
}
function Qd(e, n, t) {
  for (var r = 0, o = n.length, a; r < o; r++)
    (a || !(r in n)) && (a || (a = Array.prototype.slice.call(n, 0, r)), a[r] = n[r]);
  return e.concat(a || Array.prototype.slice.call(n));
}
function yr(e) {
  return e.mode === "multiple";
}
function br(e) {
  return e.mode === "range";
}
function Oo(e) {
  return e.mode === "single";
}
var jw = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function Aw(e, n) {
  return pe(e, "LLLL y", n);
}
function kw(e, n) {
  return pe(e, "d", n);
}
function Lw(e, n) {
  return pe(e, "LLLL", n);
}
function $w(e) {
  return "".concat(e);
}
function Fw(e, n) {
  return pe(e, "cccccc", n);
}
function Vw(e, n) {
  return pe(e, "yyyy", n);
}
var Hw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: Aw,
  formatDay: kw,
  formatMonthCaption: Lw,
  formatWeekNumber: $w,
  formatWeekdayName: Fw,
  formatYearCaption: Vw
}), Ww = function(e, n, t) {
  return pe(e, "do MMMM (EEEE)", t);
}, Bw = function() {
  return "Month: ";
}, Kw = function() {
  return "Go to next month";
}, Yw = function() {
  return "Go to previous month";
}, Uw = function(e, n) {
  return pe(e, "cccc", n);
}, Gw = function(e) {
  return "Week n. ".concat(e);
}, zw = function() {
  return "Year: ";
}, qw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: Ww,
  labelMonthDropdown: Bw,
  labelNext: Kw,
  labelPrevious: Yw,
  labelWeekNumber: Gw,
  labelWeekday: Uw,
  labelYearDropdown: zw
});
function Xw() {
  var e = "buttons", n = jw, t = os, r = {}, o = {}, a = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: n,
    formatters: Hw,
    labels: qw,
    locale: t,
    modifiersClassNames: r,
    modifiers: o,
    numberOfMonths: a,
    styles: i,
    today: s,
    mode: "default"
  };
}
function Qw(e) {
  var n = e.fromYear, t = e.toYear, r = e.fromMonth, o = e.toMonth, a = e.fromDate, i = e.toDate;
  return r ? a = Ve(r) : n && (a = new Date(n, 0, 1)), o ? i = gr(o) : t && (i = new Date(t, 11, 31)), {
    fromDate: a ? Mn(a) : void 0,
    toDate: i ? Mn(i) : void 0
  };
}
var Zd = Se(void 0);
function Zw(e) {
  var n, t = e.initialProps, r = Xw(), o = Qw(t), a = o.fromDate, i = o.toDate, s = (n = t.captionLayout) !== null && n !== void 0 ? n : r.captionLayout;
  s !== "buttons" && (!a || !i) && (s = "buttons");
  var c;
  (Oo(t) || yr(t) || br(t)) && (c = t.onSelect);
  var l = ae(ae(ae({}, r), t), { captionLayout: s, classNames: ae(ae({}, r.classNames), t.classNames), components: ae({}, t.components), formatters: ae(ae({}, r.formatters), t.formatters), fromDate: a, labels: ae(ae({}, r.labels), t.labels), mode: t.mode || r.mode, modifiers: ae(ae({}, r.modifiers), t.modifiers), modifiersClassNames: ae(ae({}, r.modifiersClassNames), t.modifiersClassNames), onSelect: c, styles: ae(ae({}, r.styles), t.styles), toDate: i });
  return u.jsx(Zd.Provider, { value: l, children: e.children });
}
function Oe() {
  var e = ve(Zd);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function Jd(e) {
  var n = Oe(), t = n.locale, r = n.classNames, o = n.styles, a = n.formatters.formatCaption;
  return u.jsx("div", { className: r.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: a(e.displayMonth, { locale: t }) });
}
function Jw(e) {
  return u.jsx("svg", ae({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: u.jsx("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function ef(e) {
  var n, t, r = e.onChange, o = e.value, a = e.children, i = e.caption, s = e.className, c = e.style, l = Oe(), d = (t = (n = l.components) === null || n === void 0 ? void 0 : n.IconDropdown) !== null && t !== void 0 ? t : Jw;
  return u.jsxs("div", { className: s, style: c, children: [u.jsx("span", { className: l.classNames.vhidden, children: e["aria-label"] }), u.jsx("select", { name: e.name, "aria-label": e["aria-label"], className: l.classNames.dropdown, style: l.styles.dropdown, value: o, onChange: r, children: a }), u.jsxs("div", { className: l.classNames.caption_label, style: l.styles.caption_label, "aria-hidden": "true", children: [i, u.jsx(d, { className: l.classNames.dropdown_icon, style: l.styles.dropdown_icon })] })] });
}
function e_(e) {
  var n, t = Oe(), r = t.fromDate, o = t.toDate, a = t.styles, i = t.locale, s = t.formatters.formatMonthCaption, c = t.classNames, l = t.components, d = t.labels.labelMonthDropdown;
  if (!r)
    return u.jsx(u.Fragment, {});
  if (!o)
    return u.jsx(u.Fragment, {});
  var f = [];
  if (Mw(r, o))
    for (var p = Ve(r), m = r.getMonth(); m <= o.getMonth(); m++)
      f.push(ca(p, m));
  else
    for (var p = Ve(/* @__PURE__ */ new Date()), m = 0; m <= 11; m++)
      f.push(ca(p, m));
  var g = function(v) {
    var w = Number(v.target.value), b = ca(Ve(e.displayMonth), w);
    e.onChange(b);
  }, h = (n = l == null ? void 0 : l.Dropdown) !== null && n !== void 0 ? n : ef;
  return u.jsx(h, { name: "months", "aria-label": d(), className: c.dropdown_month, style: a.dropdown_month, onChange: g, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: f.map(function(v) {
    return u.jsx("option", { value: v.getMonth(), children: s(v, { locale: i }) }, v.getMonth());
  }) });
}
function t_(e) {
  var n, t = e.displayMonth, r = Oe(), o = r.fromDate, a = r.toDate, i = r.locale, s = r.styles, c = r.classNames, l = r.components, d = r.formatters.formatYearCaption, f = r.labels.labelYearDropdown, p = [];
  if (!o)
    return u.jsx(u.Fragment, {});
  if (!a)
    return u.jsx(u.Fragment, {});
  for (var m = o.getFullYear(), g = a.getFullYear(), h = m; h <= g; h++)
    p.push(au(Wd(/* @__PURE__ */ new Date()), h));
  var v = function(b) {
    var x = au(Ve(t), Number(b.target.value));
    e.onChange(x);
  }, w = (n = l == null ? void 0 : l.Dropdown) !== null && n !== void 0 ? n : ef;
  return u.jsx(w, { name: "years", "aria-label": f(), className: c.dropdown_year, style: s.dropdown_year, onChange: v, value: t.getFullYear(), caption: d(t, { locale: i }), children: p.map(function(b) {
    return u.jsx("option", { value: b.getFullYear(), children: d(b, { locale: i }) }, b.getFullYear());
  }) });
}
function n_(e, n) {
  var t = De(e), r = t[0], o = t[1], a = n === void 0 ? r : n;
  return [a, o];
}
function r_(e) {
  var n = e.month, t = e.defaultMonth, r = e.today, o = n || t || r || /* @__PURE__ */ new Date(), a = e.toDate, i = e.fromDate, s = e.numberOfMonths, c = s === void 0 ? 1 : s;
  if (a && ir(a, o) < 0) {
    var l = -1 * (c - 1);
    o = et(a, l);
  }
  return i && ir(o, i) < 0 && (o = i), Ve(o);
}
function o_() {
  var e = Oe(), n = r_(e), t = n_(n, e.month), r = t[0], o = t[1], a = function(i) {
    var s;
    if (!e.disableNavigation) {
      var c = Ve(i);
      o(c), (s = e.onMonthChange) === null || s === void 0 || s.call(e, c);
    }
  };
  return [r, a];
}
function a_(e, n) {
  for (var t = n.reverseMonths, r = n.numberOfMonths, o = Ve(e), a = Ve(et(o, r)), i = ir(a, o), s = [], c = 0; c < i; c++) {
    var l = et(o, c);
    s.push(l);
  }
  return t && (s = s.reverse()), s;
}
function i_(e, n) {
  if (!n.disableNavigation) {
    var t = n.toDate, r = n.pagedNavigation, o = n.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = Ve(e);
    if (!t)
      return et(s, i);
    var c = ir(t, e);
    if (!(c < a))
      return et(s, i);
  }
}
function s_(e, n) {
  if (!n.disableNavigation) {
    var t = n.fromDate, r = n.pagedNavigation, o = n.numberOfMonths, a = o === void 0 ? 1 : o, i = r ? a : 1, s = Ve(e);
    if (!t)
      return et(s, -i);
    var c = ir(s, t);
    if (!(c <= 0))
      return et(s, -i);
  }
}
var tf = Se(void 0);
function c_(e) {
  var n = Oe(), t = o_(), r = t[0], o = t[1], a = a_(r, n), i = i_(r, n), s = s_(r, n), c = function(f) {
    return a.some(function(p) {
      return Ht(f, p);
    });
  }, l = function(f, p) {
    c(f) || (p && En(f, p) ? o(et(f, 1 + n.numberOfMonths * -1)) : o(f));
  }, d = {
    currentMonth: r,
    displayMonths: a,
    goToMonth: o,
    goToDate: l,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: c
  };
  return u.jsx(tf.Provider, { value: d, children: e.children });
}
function Bn() {
  var e = ve(tf);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function iu(e) {
  var n, t = Oe(), r = t.classNames, o = t.styles, a = t.components, i = Bn().goToMonth, s = function(d) {
    i(et(d, e.displayIndex ? -e.displayIndex : 0));
  }, c = (n = a == null ? void 0 : a.CaptionLabel) !== null && n !== void 0 ? n : Jd, l = u.jsx(c, { id: e.id, displayMonth: e.displayMonth });
  return u.jsxs("div", { className: r.caption_dropdowns, style: o.caption_dropdowns, children: [u.jsx("div", { className: r.vhidden, children: l }), u.jsx(e_, { onChange: s, displayMonth: e.displayMonth }), u.jsx(t_, { onChange: s, displayMonth: e.displayMonth })] });
}
function u_(e) {
  return u.jsx("svg", ae({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: u.jsx("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function l_(e) {
  return u.jsx("svg", ae({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: u.jsx("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var to = A(function(e, n) {
  var t = Oe(), r = t.classNames, o = t.styles, a = [r.button_reset, r.button];
  e.className && a.push(e.className);
  var i = a.join(" "), s = ae(ae({}, o.button_reset), o.button);
  return e.style && Object.assign(s, e.style), u.jsx("button", ae({}, e, { ref: n, type: "button", className: i, style: s }));
});
function d_(e) {
  var n, t, r = Oe(), o = r.dir, a = r.locale, i = r.classNames, s = r.styles, c = r.labels, l = c.labelPrevious, d = c.labelNext, f = r.components;
  if (!e.nextMonth && !e.previousMonth)
    return u.jsx(u.Fragment, {});
  var p = l(e.previousMonth, { locale: a }), m = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), g = d(e.nextMonth, { locale: a }), h = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), v = (n = f == null ? void 0 : f.IconRight) !== null && n !== void 0 ? n : l_, w = (t = f == null ? void 0 : f.IconLeft) !== null && t !== void 0 ? t : u_;
  return u.jsxs("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && u.jsx(to, { name: "previous-month", "aria-label": p, className: m, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? u.jsx(v, { className: i.nav_icon, style: s.nav_icon }) : u.jsx(w, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && u.jsx(to, { name: "next-month", "aria-label": g, className: h, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? u.jsx(w, { className: i.nav_icon, style: s.nav_icon }) : u.jsx(v, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function su(e) {
  var n = Oe().numberOfMonths, t = Bn(), r = t.previousMonth, o = t.nextMonth, a = t.goToMonth, i = t.displayMonths, s = i.findIndex(function(g) {
    return Ht(e.displayMonth, g);
  }), c = s === 0, l = s === i.length - 1, d = n > 1 && (c || !l), f = n > 1 && (l || !c), p = function() {
    r && a(r);
  }, m = function() {
    o && a(o);
  };
  return u.jsx(d_, { displayMonth: e.displayMonth, hideNext: d, hidePrevious: f, nextMonth: o, previousMonth: r, onPreviousClick: p, onNextClick: m });
}
function f_(e) {
  var n, t = Oe(), r = t.classNames, o = t.disableNavigation, a = t.styles, i = t.captionLayout, s = t.components, c = (n = s == null ? void 0 : s.CaptionLabel) !== null && n !== void 0 ? n : Jd, l;
  return o ? l = u.jsx(c, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? l = u.jsx(iu, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? l = u.jsxs(u.Fragment, { children: [u.jsx(iu, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), u.jsx(su, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : l = u.jsxs(u.Fragment, { children: [u.jsx(c, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), u.jsx(su, { displayMonth: e.displayMonth, id: e.id })] }), u.jsx("div", { className: r.caption, style: a.caption, children: l });
}
function p_(e) {
  var n = Oe(), t = n.footer, r = n.styles, o = n.classNames.tfoot;
  return t ? u.jsx("tfoot", { className: o, style: r.tfoot, children: u.jsx("tr", { children: u.jsx("td", { colSpan: 8, children: t }) }) }) : u.jsx(u.Fragment, {});
}
function h_(e, n, t) {
  for (var r = t ? Gt(/* @__PURE__ */ new Date()) : vt(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: n }), o = [], a = 0; a < 7; a++) {
    var i = Xe(r, a);
    o.push(i);
  }
  return o;
}
function m_() {
  var e = Oe(), n = e.classNames, t = e.styles, r = e.showWeekNumber, o = e.locale, a = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, c = e.labels.labelWeekday, l = h_(o, a, i);
  return u.jsxs("tr", { style: t.head_row, className: n.head_row, children: [r && u.jsx("td", { style: t.head_cell, className: n.head_cell }), l.map(function(d, f) {
    return u.jsx("th", { scope: "col", className: n.head_cell, style: t.head_cell, "aria-label": c(d, { locale: o }), children: s(d, { locale: o }) }, f);
  })] });
}
function v_() {
  var e, n = Oe(), t = n.classNames, r = n.styles, o = n.components, a = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : m_;
  return u.jsx("thead", { style: r.head, className: t.head, children: u.jsx(a, {}) });
}
function g_(e) {
  var n = Oe(), t = n.locale, r = n.formatters.formatDay;
  return u.jsx(u.Fragment, { children: r(e.date, { locale: t }) });
}
var ds = Se(void 0);
function y_(e) {
  if (!yr(e.initialProps)) {
    var n = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return u.jsx(ds.Provider, { value: n, children: e.children });
  }
  return u.jsx(b_, { initialProps: e.initialProps, children: e.children });
}
function b_(e) {
  var n = e.initialProps, t = e.children, r = n.selected, o = n.min, a = n.max, i = function(l, d, f) {
    var p, m;
    (p = n.onDayClick) === null || p === void 0 || p.call(n, l, d, f);
    var g = !!(d.selected && o && (r == null ? void 0 : r.length) === o);
    if (!g) {
      var h = !!(!d.selected && a && (r == null ? void 0 : r.length) === a);
      if (!h) {
        var v = r ? Qd([], r) : [];
        if (d.selected) {
          var w = v.findIndex(function(b) {
            return Ye(l, b);
          });
          v.splice(w, 1);
        } else
          v.push(l);
        (m = n.onSelect) === null || m === void 0 || m.call(n, v, l, d, f);
      }
    }
  }, s = {
    disabled: []
  };
  r && s.disabled.push(function(l) {
    var d = a && r.length > a - 1, f = r.some(function(p) {
      return Ye(p, l);
    });
    return !!(d && !f);
  });
  var c = {
    selected: r,
    onDayClick: i,
    modifiers: s
  };
  return u.jsx(ds.Provider, { value: c, children: t });
}
function fs() {
  var e = ve(ds);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function x_(e, n) {
  var t = n || {}, r = t.from, o = t.to;
  return r && o ? Ye(o, e) && Ye(r, e) ? void 0 : Ye(o, e) ? { from: o, to: void 0 } : Ye(r, e) ? void 0 : On(r, e) ? { from: e, to: o } : { from: r, to: e } : o ? On(e, o) ? { from: o, to: e } : { from: e, to: o } : r ? En(e, r) ? { from: e, to: r } : { from: r, to: e } : { from: e, to: void 0 };
}
var ps = Se(void 0);
function w_(e) {
  if (!br(e.initialProps)) {
    var n = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return u.jsx(ps.Provider, { value: n, children: e.children });
  }
  return u.jsx(__, { initialProps: e.initialProps, children: e.children });
}
function __(e) {
  var n = e.initialProps, t = e.children, r = n.selected, o = r || {}, a = o.from, i = o.to, s = n.min, c = n.max, l = function(m, g, h) {
    var v, w;
    (v = n.onDayClick) === null || v === void 0 || v.call(n, m, g, h);
    var b = x_(m, r);
    (w = n.onSelect) === null || w === void 0 || w.call(n, b, m, g, h);
  }, d = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (a ? (d.range_start = [a], i ? (d.range_end = [i], Ye(a, i) || (d.range_middle = [
    {
      after: a,
      before: i
    }
  ])) : d.range_end = [a]) : i && (d.range_start = [i], d.range_end = [i]), s && (a && !i && d.disabled.push({
    after: sa(a, s - 1),
    before: Xe(a, s - 1)
  }), a && i && d.disabled.push({
    after: a,
    before: Xe(a, s - 1)
  }), !a && i && d.disabled.push({
    after: sa(i, s - 1),
    before: Xe(i, s - 1)
  })), c) {
    if (a && !i && (d.disabled.push({
      before: Xe(a, -c + 1)
    }), d.disabled.push({
      after: Xe(a, c - 1)
    })), a && i) {
      var f = Mt(i, a) + 1, p = c - f;
      d.disabled.push({
        before: sa(a, p)
      }), d.disabled.push({
        after: Xe(i, p)
      });
    }
    !a && i && (d.disabled.push({
      before: Xe(i, -c + 1)
    }), d.disabled.push({
      after: Xe(i, c - 1)
    }));
  }
  return u.jsx(ps.Provider, { value: { selected: r, onDayClick: l, modifiers: d }, children: t });
}
function hs() {
  var e = ve(ps);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function Wr(e) {
  return Array.isArray(e) ? Qd([], e) : e !== void 0 ? [e] : [];
}
function C_(e) {
  var n = {};
  return Object.entries(e).forEach(function(t) {
    var r = t[0], o = t[1];
    n[r] = Wr(o);
  }), n;
}
var Pt;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(Pt || (Pt = {}));
var I_ = Pt.Selected, Ft = Pt.Disabled, T_ = Pt.Hidden, E_ = Pt.Today, ua = Pt.RangeEnd, la = Pt.RangeMiddle, da = Pt.RangeStart, P_ = Pt.Outside;
function S_(e, n, t) {
  var r, o = (r = {}, r[I_] = Wr(e.selected), r[Ft] = Wr(e.disabled), r[T_] = Wr(e.hidden), r[E_] = [e.today], r[ua] = [], r[la] = [], r[da] = [], r[P_] = [], r);
  return e.fromDate && o[Ft].push({ before: e.fromDate }), e.toDate && o[Ft].push({ after: e.toDate }), yr(e) ? o[Ft] = o[Ft].concat(n.modifiers[Ft]) : br(e) && (o[Ft] = o[Ft].concat(t.modifiers[Ft]), o[da] = t.modifiers[da], o[la] = t.modifiers[la], o[ua] = t.modifiers[ua]), o;
}
var nf = Se(void 0);
function D_(e) {
  var n = Oe(), t = fs(), r = hs(), o = S_(n, t, r), a = C_(n.modifiers), i = ae(ae({}, o), a);
  return u.jsx(nf.Provider, { value: i, children: e.children });
}
function rf() {
  var e = ve(nf);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function R_(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function N_(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function M_(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function O_(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function j_(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function A_(e, n) {
  var t, r = n.from, o = n.to;
  if (r && o) {
    var a = Mt(o, r) < 0;
    a && (t = [o, r], r = t[0], o = t[1]);
    var i = Mt(e, r) >= 0 && Mt(o, e) >= 0;
    return i;
  }
  return o ? Ye(o, e) : r ? Ye(r, e) : !1;
}
function k_(e) {
  return ns(e);
}
function L_(e) {
  return Array.isArray(e) && e.every(ns);
}
function $_(e, n) {
  return n.some(function(t) {
    if (typeof t == "boolean")
      return t;
    if (k_(t))
      return Ye(e, t);
    if (L_(t))
      return t.includes(e);
    if (N_(t))
      return A_(e, t);
    if (j_(t))
      return t.dayOfWeek.includes(e.getDay());
    if (R_(t)) {
      var r = Mt(t.before, e), o = Mt(t.after, e), a = r > 0, i = o < 0, s = On(t.before, t.after);
      return s ? i && a : a || i;
    }
    return M_(t) ? Mt(e, t.after) > 0 : O_(t) ? Mt(t.before, e) > 0 : typeof t == "function" ? t(e) : !1;
  });
}
function ms(e, n, t) {
  var r = Object.keys(n).reduce(function(a, i) {
    var s = n[i];
    return $_(e, s) && a.push(i), a;
  }, []), o = {};
  return r.forEach(function(a) {
    return o[a] = !0;
  }), t && !Ht(e, t) && (o.outside = !0), o;
}
function F_(e, n) {
  for (var t = Ve(e[0]), r = gr(e[e.length - 1]), o, a, i = t; i <= r; ) {
    var s = ms(i, n), c = !s.disabled && !s.hidden;
    if (!c) {
      i = Xe(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !a && (a = i), o || (o = i), i = Xe(i, 1);
  }
  return a || o;
}
var V_ = 365;
function of(e, n) {
  var t = n.moveBy, r = n.direction, o = n.context, a = n.modifiers, i = n.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, c = o.weekStartsOn, l = o.fromDate, d = o.toDate, f = o.locale, p = {
    day: Xe,
    week: Va,
    month: et,
    year: Ob,
    startOfWeek: function(v) {
      return o.ISOWeek ? Gt(v) : vt(v, { locale: f, weekStartsOn: c });
    },
    endOfWeek: function(v) {
      return o.ISOWeek ? Bd(v) : rs(v, { locale: f, weekStartsOn: c });
    }
  }, m = p[t](e, r === "after" ? 1 : -1);
  r === "before" && l ? m = jb([l, m]) : r === "after" && d && (m = Ab([d, m]));
  var g = !0;
  if (a) {
    var h = ms(m, a);
    g = !h.disabled && !h.hidden;
  }
  return g ? m : s.count > V_ ? s.lastFocused : of(m, {
    moveBy: t,
    direction: r,
    context: o,
    modifiers: a,
    retry: ae(ae({}, s), { count: s.count + 1 })
  });
}
var af = Se(void 0);
function H_(e) {
  var n = Bn(), t = rf(), r = De(), o = r[0], a = r[1], i = De(), s = i[0], c = i[1], l = F_(n.displayMonths, t), d = o ?? (s && n.isDateDisplayed(s)) ? s : l, f = function() {
    c(o), a(void 0);
  }, p = function(v) {
    a(v);
  }, m = Oe(), g = function(v, w) {
    if (o) {
      var b = of(o, {
        moveBy: v,
        direction: w,
        context: m,
        modifiers: t
      });
      Ye(o, b) || (n.goToDate(b, o), p(b));
    }
  }, h = {
    focusedDay: o,
    focusTarget: d,
    blur: f,
    focus: p,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return u.jsx(af.Provider, { value: h, children: e.children });
}
function vs() {
  var e = ve(af);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function W_(e, n) {
  var t = rf(), r = ms(e, t, n);
  return r;
}
var gs = Se(void 0);
function B_(e) {
  if (!Oo(e.initialProps)) {
    var n = {
      selected: void 0
    };
    return u.jsx(gs.Provider, { value: n, children: e.children });
  }
  return u.jsx(K_, { initialProps: e.initialProps, children: e.children });
}
function K_(e) {
  var n = e.initialProps, t = e.children, r = function(a, i, s) {
    var c, l, d;
    if ((c = n.onDayClick) === null || c === void 0 || c.call(n, a, i, s), i.selected && !n.required) {
      (l = n.onSelect) === null || l === void 0 || l.call(n, void 0, a, i, s);
      return;
    }
    (d = n.onSelect) === null || d === void 0 || d.call(n, a, a, i, s);
  }, o = {
    selected: n.selected,
    onDayClick: r
  };
  return u.jsx(gs.Provider, { value: o, children: t });
}
function sf() {
  var e = ve(gs);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function Y_(e, n) {
  var t = Oe(), r = sf(), o = fs(), a = hs(), i = vs(), s = i.focusDayAfter, c = i.focusDayBefore, l = i.focusWeekAfter, d = i.focusWeekBefore, f = i.blur, p = i.focus, m = i.focusMonthBefore, g = i.focusMonthAfter, h = i.focusYearBefore, v = i.focusYearAfter, w = i.focusStartOfWeek, b = i.focusEndOfWeek, x = function(O) {
    var M, B, R, V;
    Oo(t) ? (M = r.onDayClick) === null || M === void 0 || M.call(r, e, n, O) : yr(t) ? (B = o.onDayClick) === null || B === void 0 || B.call(o, e, n, O) : br(t) ? (R = a.onDayClick) === null || R === void 0 || R.call(a, e, n, O) : (V = t.onDayClick) === null || V === void 0 || V.call(t, e, n, O);
  }, C = function(O) {
    var M;
    p(e), (M = t.onDayFocus) === null || M === void 0 || M.call(t, e, n, O);
  }, _ = function(O) {
    var M;
    f(), (M = t.onDayBlur) === null || M === void 0 || M.call(t, e, n, O);
  }, E = function(O) {
    var M;
    (M = t.onDayMouseEnter) === null || M === void 0 || M.call(t, e, n, O);
  }, D = function(O) {
    var M;
    (M = t.onDayMouseLeave) === null || M === void 0 || M.call(t, e, n, O);
  }, T = function(O) {
    var M;
    (M = t.onDayPointerEnter) === null || M === void 0 || M.call(t, e, n, O);
  }, S = function(O) {
    var M;
    (M = t.onDayPointerLeave) === null || M === void 0 || M.call(t, e, n, O);
  }, N = function(O) {
    var M;
    (M = t.onDayTouchCancel) === null || M === void 0 || M.call(t, e, n, O);
  }, k = function(O) {
    var M;
    (M = t.onDayTouchEnd) === null || M === void 0 || M.call(t, e, n, O);
  }, Y = function(O) {
    var M;
    (M = t.onDayTouchMove) === null || M === void 0 || M.call(t, e, n, O);
  }, U = function(O) {
    var M;
    (M = t.onDayTouchStart) === null || M === void 0 || M.call(t, e, n, O);
  }, j = function(O) {
    var M;
    (M = t.onDayKeyUp) === null || M === void 0 || M.call(t, e, n, O);
  }, oe = function(O) {
    var M;
    switch (O.key) {
      case "ArrowLeft":
        O.preventDefault(), O.stopPropagation(), t.dir === "rtl" ? s() : c();
        break;
      case "ArrowRight":
        O.preventDefault(), O.stopPropagation(), t.dir === "rtl" ? c() : s();
        break;
      case "ArrowDown":
        O.preventDefault(), O.stopPropagation(), l();
        break;
      case "ArrowUp":
        O.preventDefault(), O.stopPropagation(), d();
        break;
      case "PageUp":
        O.preventDefault(), O.stopPropagation(), O.shiftKey ? h() : m();
        break;
      case "PageDown":
        O.preventDefault(), O.stopPropagation(), O.shiftKey ? v() : g();
        break;
      case "Home":
        O.preventDefault(), O.stopPropagation(), w();
        break;
      case "End":
        O.preventDefault(), O.stopPropagation(), b();
        break;
    }
    (M = t.onDayKeyDown) === null || M === void 0 || M.call(t, e, n, O);
  }, q = {
    onClick: x,
    onFocus: C,
    onBlur: _,
    onKeyDown: oe,
    onKeyUp: j,
    onMouseEnter: E,
    onMouseLeave: D,
    onPointerEnter: T,
    onPointerLeave: S,
    onTouchCancel: N,
    onTouchEnd: k,
    onTouchMove: Y,
    onTouchStart: U
  };
  return q;
}
function U_() {
  var e = Oe(), n = sf(), t = fs(), r = hs(), o = Oo(e) ? n.selected : yr(e) ? t.selected : br(e) ? r.selected : void 0;
  return o;
}
function G_(e) {
  return Object.values(Pt).includes(e);
}
function z_(e, n) {
  var t = [e.classNames.day];
  return Object.keys(n).forEach(function(r) {
    var o = e.modifiersClassNames[r];
    if (o)
      t.push(o);
    else if (G_(r)) {
      var a = e.classNames["day_".concat(r)];
      a && t.push(a);
    }
  }), t;
}
function q_(e, n) {
  var t = ae({}, e.styles.day);
  return Object.keys(n).forEach(function(r) {
    var o;
    t = ae(ae({}, t), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[r]);
  }), t;
}
function cf(e, n, t) {
  var r, o, a, i = Oe(), s = vs(), c = W_(e, n), l = Y_(e, c), d = U_(), f = !!(i.onDayClick || i.mode !== "default");
  le(function() {
    var E;
    c.outside || s.focusedDay && f && Ye(s.focusedDay, e) && ((E = t.current) === null || E === void 0 || E.focus());
  }, [
    s.focusedDay,
    e,
    t,
    f,
    c.outside
  ]);
  var p = z_(i, c).join(" "), m = q_(i, c), g = !!(c.outside && !i.showOutsideDays || c.hidden), h = (a = (o = i.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && a !== void 0 ? a : g_, v = u.jsx(h, { date: e, displayMonth: n, activeModifiers: c }), w = {
    style: m,
    className: p,
    children: v,
    role: "gridcell"
  }, b = s.focusTarget && Ye(s.focusTarget, e) && !c.outside, x = s.focusedDay && Ye(s.focusedDay, e), C = ae(ae(ae({}, w), (r = { disabled: c.disabled, role: "gridcell" }, r["aria-selected"] = c.selected, r.tabIndex = x || b ? 0 : -1, r)), l), _ = {
    isButton: f,
    isHidden: g,
    activeModifiers: c,
    selectedDays: d,
    buttonProps: C,
    divProps: w
  };
  return _;
}
function X_(e) {
  var n = me(null), t = cf(e.date, e.displayMonth, n);
  return t.isHidden ? u.jsx("div", { role: "gridcell" }) : t.isButton ? u.jsx(to, ae({ name: "day", ref: n }, t.buttonProps)) : u.jsx("div", ae({}, t.divProps));
}
function Q_(e) {
  var n = e.number, t = e.dates, r = Oe(), o = r.onWeekNumberClick, a = r.styles, i = r.classNames, s = r.locale, c = r.labels.labelWeekNumber, l = r.formatters.formatWeekNumber, d = l(Number(n), { locale: s });
  if (!o)
    return u.jsx("span", { className: i.weeknumber, style: a.weeknumber, children: d });
  var f = c(Number(n), { locale: s }), p = function(m) {
    o(n, t, m);
  };
  return u.jsx(to, { name: "week-number", "aria-label": f, className: i.weeknumber, style: a.weeknumber, onClick: p, children: d });
}
function Z_(e) {
  var n, t, r = Oe(), o = r.styles, a = r.classNames, i = r.showWeekNumber, s = r.components, c = (n = s == null ? void 0 : s.Day) !== null && n !== void 0 ? n : X_, l = (t = s == null ? void 0 : s.WeekNumber) !== null && t !== void 0 ? t : Q_, d;
  return i && (d = u.jsx("td", { className: a.cell, style: o.cell, children: u.jsx(l, { number: e.weekNumber, dates: e.dates }) })), u.jsxs("tr", { className: a.row, style: o.row, children: [d, e.dates.map(function(f) {
    return u.jsx("td", { className: a.cell, style: o.cell, role: "presentation", children: u.jsx(c, { displayMonth: e.displayMonth, date: f }) }, Ox(f));
  })] });
}
function cu(e, n, t) {
  for (var r = t != null && t.ISOWeek ? Bd(n) : rs(n, t), o = t != null && t.ISOWeek ? Gt(e) : vt(e, t), a = Mt(r, o), i = [], s = 0; s <= a; s++)
    i.push(Xe(o, s));
  var c = i.reduce(function(l, d) {
    var f = t != null && t.ISOWeek ? as(d) : ss(d, t), p = l.find(function(m) {
      return m.weekNumber === f;
    });
    return p ? (p.dates.push(d), l) : (l.push({
      weekNumber: f,
      dates: [d]
    }), l);
  }, []);
  return c;
}
function J_(e, n) {
  var t = cu(Ve(e), gr(e), n);
  if (n != null && n.useFixedWeeks) {
    var r = Ax(e, n);
    if (r < 6) {
      var o = t[t.length - 1], a = o.dates[o.dates.length - 1], i = Va(a, 6 - r), s = cu(Va(a, 1), i, n);
      t.push.apply(t, s);
    }
  }
  return t;
}
function eC(e) {
  var n, t, r, o = Oe(), a = o.locale, i = o.classNames, s = o.styles, c = o.hideHead, l = o.fixedWeeks, d = o.components, f = o.weekStartsOn, p = o.firstWeekContainsDate, m = o.ISOWeek, g = J_(e.displayMonth, {
    useFixedWeeks: !!l,
    ISOWeek: m,
    locale: a,
    weekStartsOn: f,
    firstWeekContainsDate: p
  }), h = (n = d == null ? void 0 : d.Head) !== null && n !== void 0 ? n : v_, v = (t = d == null ? void 0 : d.Row) !== null && t !== void 0 ? t : Z_, w = (r = d == null ? void 0 : d.Footer) !== null && r !== void 0 ? r : p_;
  return u.jsxs("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!c && u.jsx(h, {}), u.jsx("tbody", { className: i.tbody, style: s.tbody, children: g.map(function(b) {
    return u.jsx(v, { displayMonth: e.displayMonth, dates: b.dates, weekNumber: b.weekNumber }, b.weekNumber);
  }) }), u.jsx(w, { displayMonth: e.displayMonth })] });
}
function tC() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var nC = tC() ? ni : le, fa = !1, rC = 0;
function uu() {
  return "react-day-picker-".concat(++rC);
}
function oC(e) {
  var n, t = e ?? (fa ? uu() : null), r = De(t), o = r[0], a = r[1];
  return nC(function() {
    o === null && a(uu());
  }, []), le(function() {
    fa === !1 && (fa = !0);
  }, []), (n = e ?? o) !== null && n !== void 0 ? n : void 0;
}
function aC(e) {
  var n, t, r = Oe(), o = r.dir, a = r.classNames, i = r.styles, s = r.components, c = Bn().displayMonths, l = oC(r.id ? "".concat(r.id, "-").concat(e.displayIndex) : void 0), d = r.id ? "".concat(r.id, "-grid-").concat(e.displayIndex) : void 0, f = [a.month], p = i.month, m = e.displayIndex === 0, g = e.displayIndex === c.length - 1, h = !m && !g;
  o === "rtl" && (n = [m, g], g = n[0], m = n[1]), m && (f.push(a.caption_start), p = ae(ae({}, p), i.caption_start)), g && (f.push(a.caption_end), p = ae(ae({}, p), i.caption_end)), h && (f.push(a.caption_between), p = ae(ae({}, p), i.caption_between));
  var v = (t = s == null ? void 0 : s.Caption) !== null && t !== void 0 ? t : f_;
  return u.jsxs("div", { className: f.join(" "), style: p, children: [u.jsx(v, { id: l, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), u.jsx(eC, { id: d, "aria-labelledby": l, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function iC(e) {
  var n = Oe(), t = n.classNames, r = n.styles;
  return u.jsx("div", { className: t.months, style: r.months, children: e.children });
}
function sC(e) {
  var n, t, r = e.initialProps, o = Oe(), a = vs(), i = Bn(), s = De(!1), c = s[0], l = s[1];
  le(function() {
    o.initialFocus && a.focusTarget && (c || (a.focus(a.focusTarget), l(!0)));
  }, [
    o.initialFocus,
    c,
    a.focus,
    a.focusTarget,
    a
  ]);
  var d = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && d.push(o.classNames.multiple_months), o.showWeekNumber && d.push(o.classNames.with_weeknumber);
  var f = ae(ae({}, o.styles.root), o.style), p = Object.keys(r).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, h) {
    var v;
    return ae(ae({}, g), (v = {}, v[h] = r[h], v));
  }, {}), m = (t = (n = r.components) === null || n === void 0 ? void 0 : n.Months) !== null && t !== void 0 ? t : iC;
  return u.jsx("div", ae({ className: d.join(" "), style: f, dir: o.dir, id: o.id, nonce: r.nonce, title: r.title, lang: r.lang }, p, { children: u.jsx(m, { children: i.displayMonths.map(function(g, h) {
    return u.jsx(aC, { displayIndex: h, displayMonth: g }, h);
  }) }) }));
}
function cC(e) {
  var n = e.children, t = Ow(e, ["children"]);
  return u.jsx(Zw, { initialProps: t, children: u.jsx(c_, { children: u.jsx(B_, { initialProps: t, children: u.jsx(y_, { initialProps: t, children: u.jsx(w_, { initialProps: t, children: u.jsx(D_, { children: u.jsx(H_, { children: n }) }) }) }) }) }) });
}
function lu(e) {
  return u.jsx(cC, ae({}, e, { children: u.jsx(sC, { initialProps: e }) }));
}
const uC = A(
  function({ children: n, className: t, endAligned: r, size: o = "medium", ...a }, i) {
    const s = gt();
    return /* @__PURE__ */ u.jsx(
      "div",
      {
        ...a,
        className: P(
          "goat-Input",
          `goat-Input_${o}`,
          { "goat-Input_suffixed": r },
          { "goat-disabled": s.disabled },
          { "goat-invalid": s.touched && s.validity.valid === !1 },
          t
        ),
        ref: i,
        children: n
      }
    );
  }
), lC = A(
  function({ className: n, disabled: t, id: r, ...o }, a) {
    const i = gt({ disabled: t, id: r });
    return /* @__PURE__ */ u.jsx(
      "input",
      {
        ...o,
        "aria-describedby": i.describedBy(o),
        className: P("goat-Input__Text", n),
        disabled: i.disabled,
        id: i.id,
        ref: a
      }
    );
  }
), dC = A(
  function({ resize: n = "both", size: t, className: r, disabled: o, id: a, ...i }, s) {
    const c = gt({ disabled: o, id: a });
    return /* @__PURE__ */ u.jsx(
      "textarea",
      {
        ...i,
        "aria-describedby": c.describedBy(i),
        className: P(
          "goat-Input",
          "goat-Input__Area",
          `goat-Input_${t}`,
          { "goat-disabled": c.disabled },
          { "goat-invalid": c.touched && c.validity.valid === !1 },
          r
        ),
        style: { "--goat-Input__Area-resize": n },
        disabled: c.disabled,
        id: c.id,
        ref: s
      }
    );
  }
), Ba = {
  Root: uC,
  Text: lC,
  Area: dC
}, rt = A(function({
  as: n = "span",
  color: t = "gray-900",
  type: r = "body-medium",
  className: o,
  style: a,
  ...i
}, s) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...i,
      ref: s,
      style: {
        ...a,
        "--goat-color": kn(t)
      },
      className: P(
        "goat-Typography",
        `goat-Typography--${r}`,
        `goat-Typography--${t}`,
        o
      )
    }
  );
}), wD = A(
  function({ type: n = "header-large", ...t }, r) {
    return /* @__PURE__ */ u.jsx(rt, { type: n, ...t, ref: r, as: "h1" });
  }
), fC = A(
  function({ type: n = "header-medium", ...t }, r) {
    return /* @__PURE__ */ u.jsx(rt, { type: n, ...t, ref: r, as: "h2" });
  }
), _D = A(
  function({ type: n = "header-small", ...t }, r) {
    return /* @__PURE__ */ u.jsx(rt, { type: n, ...t, ref: r, as: "h3" });
  }
), CD = A(
  function({ type: n = "body-large", ...t }, r) {
    return /* @__PURE__ */ u.jsx(rt, { type: n, ...t, ref: r, as: "h4" });
  }
), ID = A(
  function({ type: n = "body-medium", ...t }, r) {
    return /* @__PURE__ */ u.jsx(rt, { type: n, ...t, ref: r, as: "h5" });
  }
), TD = A(
  function({ type: n = "body-medium", ...t }, r) {
    return /* @__PURE__ */ u.jsx(rt, { type: n, ...t, ref: r, as: "p" });
  }
), ED = A(
  function({ type: n = "body-medium", ...t }, r) {
    return /* @__PURE__ */ u.jsx(rt, { type: n, ...t, ref: r, as: "span" });
  }
);
function pC({ displayMonth: e }) {
  const { goToMonth: n, nextMonth: t, previousMonth: r, displayMonths: o } = Bn();
  return /* @__PURE__ */ u.jsxs(
    fC,
    {
      type: "body-medium",
      className: P("goat-DatePicker__Caption", {
        "goat-DatePicker__Caption_multiple": o.length > 1
      }),
      children: [
        /* @__PURE__ */ u.jsx(
          ft,
          {
            className: P("goat-DatePicker__CaptionPrev"),
            icon: al,
            disabled: !r,
            onClick: () => r && n(r)
          }
        ),
        pe(e, "MMMM yyy"),
        /* @__PURE__ */ u.jsx(
          ft,
          {
            className: P("goat-DatePicker__CaptionNext"),
            icon: oi,
            disabled: !t,
            onClick: () => t && n(t)
          }
        )
      ]
    }
  );
}
function hC(e) {
  const n = me(null), t = cf(e.date, e.displayMonth, n);
  if (t.isHidden)
    return null;
  if (!t.isButton)
    return /* @__PURE__ */ u.jsx("div", { ...t.divProps });
  const { range_start: r, range_middle: o, range_end: a, selected: i, disabled: s, today: c } = t.activeModifiers, l = $b(e.date), d = kx(e.date), f = r && a && t.selectedDays && "from" in t.selectedDays && t.selectedDays.to ? "startend" : r ? "start" : o ? "middle" : a ? "end" : "none";
  return /* @__PURE__ */ u.jsx(
    "button",
    {
      ...t.buttonProps,
      type: "button",
      className: P(
        "goat-Button",
        "goat-DatePicker__DayButton",
        `goat-DatePicker__DayButton_${f}`,
        {
          "goat-Button_disabled": s,
          "goat-DatePicker__DayButton_disabled": s,
          "goat-DatePicker__DayButton_selected": i,
          "goat-DatePicker__DayButton_today": c,
          "goat-DatePicker__DayButton_firstDay": d,
          "goat-DatePicker__DayButton_lastDay": l
        }
      ),
      ref: n
    }
  );
}
const mC = ({ presets: e, onRangeClick: n }) => /* @__PURE__ */ u.jsx("div", { className: P("goat-DatePicker__RangePresets"), children: e.map(({ label: t, range: r }) => /* @__PURE__ */ u.jsx(
  Ge,
  {
    variant: "subtle",
    size: "small",
    onClick: () => n(r()),
    children: t
  },
  t
)) }), qe = (e, n) => {
  if (!e) return;
  const t = ls(e, n, /* @__PURE__ */ new Date());
  return Mo(t) ? t : void 0;
}, xr = (e, n, t) => {
  const r = e && t && !e.includes("T") ? `${e}T00:00:00` : e, o = n && t && !n.includes("T") ? `${n}T23:59:59` : n;
  return {
    minDate: qe(
      r,
      t ? "yyyy-MM-dd'T'HH:mm:ss" : "yyyy-MM-dd"
    ),
    maxDate: qe(
      o,
      t ? "yyyy-MM-dd'T'HH:mm:ss" : "yyyy-MM-dd"
    )
  };
}, uf = {
  h12: "hh",
  h23: "HH",
  h11: "kk",
  h24: "KK"
}, vC = (e, n) => {
  const t = { hours: null, minutes: null, timePeriod: "AM" };
  if (!e) return t;
  const r = ls(e, "HH:mm", /* @__PURE__ */ new Date());
  if (!Mo(r)) return t;
  const o = `${uf[n]} mm a`, [a, i, s] = pe(r, o).split(" ");
  return {
    hours: +a,
    minutes: +i,
    timePeriod: s
  };
}, pa = (e, n, t) => {
  if (!e) return "";
  const r = ["h12", "h11"].includes(t), o = `${uf[t]}:mm${r ? " a" : ""}`, a = ls(
    `${e}${r ? " " + n : ""}`,
    o,
    /* @__PURE__ */ new Date()
  );
  return Mo(a) ? pe(a, "HH:mm") : "";
}, gC = ({
  from: e,
  to: n,
  max: t,
  min: r,
  singleMonth: o,
  time: a
}) => {
  const { minDate: i, maxDate: s } = xr(r, t, a);
  let c = n ?? e ?? /* @__PURE__ */ new Date();
  return i && En(c, i) && (c = i), s && On(c, s) && (c = s), (s && !o && Ht(c, s) || e && n && !Ht(e, n) && Ht(n, c)) && (c = et(c, -1)), Ve(c);
}, lf = ({
  from: e,
  to: n,
  fromValue: t,
  toValue: r,
  max: o,
  min: a,
  time: i
}) => {
  const { minDate: s, maxDate: c } = xr(a, o, i);
  return t && !e || r && !n ? "invalidDate" : s && (e && En(e, s) || n && En(n, s)) ? "beforeMin" : c && (e && On(e, c) || n && On(n, c)) ? "afterMax" : n && e && En(n, e) ? i && Ye(n, e) ? "toBeforeFromTime" : "toBeforeFrom" : "";
}, yC = ({
  currentMonth: e,
  fromValue: n,
  inputFormat: t,
  max: r,
  min: o,
  singleMonth: a,
  target: i,
  time: s,
  toValue: c
}) => {
  const l = qe(n, t), d = qe(c, t), { minDate: f, maxDate: p } = xr(o, r, s), m = !lf({
    from: l,
    to: d,
    fromValue: n,
    toValue: c,
    max: r,
    min: o,
    time: s
  }), g = {
    start: e,
    end: gr(a ? e : et(e, 1))
  };
  return m ? i === "from" ? !l || ou(l, g) ? e : a ? Ve(l) : p && Ht(l, p) ? Ve(et(l, -1)) : Ve(l) : !d || ou(d, g) ? e : a || f && Ht(d, f) ? Ve(d) : Ve(et(d, -1)) : e;
}, bC = ({
  fromValue: e,
  inputFormat: n,
  outputFormat: t,
  range: r,
  toValue: o
}) => {
  const a = qe(e, n), i = qe(o, n);
  return i == null || i.setSeconds(59), !r && a ? pe(a, t) : r && a && i ? `${pe(a, t)},${pe(i, t)}` : "";
}, xC = ({
  fromValue: e,
  toValue: n,
  inputFormat: t,
  outputFormat: r,
  range: o,
  min: a,
  max: i,
  time: s
}) => {
  const c = qe(e, t), l = qe(n, t), d = lf({
    from: c,
    to: l,
    fromValue: e,
    toValue: n,
    max: i,
    min: a,
    time: s
  });
  return {
    selectedDate: d ? void 0 : c,
    selectedRange: (!d || d === "toBeforeFromTime") && c ? { from: c, to: l } : void 0,
    customValidity: d,
    value: d ? "" : bC({
      fromValue: e,
      inputFormat: t,
      outputFormat: r,
      range: o,
      toValue: n
    })
  };
}, wC = ({
  min: e,
  max: n,
  range: t,
  defaultValue: r,
  value: o,
  outputFormat: a,
  inputFormat: i,
  time: s
}) => {
  const c = me(null), l = Wl(), d = r ?? o ?? "", f = dt(() => {
    if (t) {
      const { minDate: T, maxDate: S } = xr(e, n, s);
      return !!T && !!S && Ht(T, S);
    }
    return !0;
  }, [n, e, s, t]), [
    { fromValue: p, toValue: m, fromTime: g, toTime: h, internalUpdate: v, month: w },
    b
  ] = De(() => {
    const [T, S] = (d == null ? void 0 : d.split(",").map((N) => qe(N, a))) ?? [];
    return {
      fromValue: T ? pe(T, i) : "",
      toValue: S ? pe(S, i) : "",
      fromTime: pe(T ?? new Date(0, 0, 1, 0, 0), "HH:mm"),
      toTime: pe(S ?? new Date(0, 0, 1, 23, 59), "HH:mm"),
      internalUpdate: !1,
      month: gC({
        from: T,
        to: S,
        max: n,
        min: e,
        singleMonth: f,
        time: s
      })
    };
  }), x = (T, S) => b((N) => ({
    ...N,
    ...T,
    month: yC({
      currentMonth: N.month,
      fromValue: T.fromValue ?? N.fromValue,
      inputFormat: i,
      max: n,
      min: e,
      singleMonth: f,
      target: S,
      time: s,
      toValue: T.toValue ?? N.toValue
    })
  })), { value: C, customValidity: _, selectedDate: E, selectedRange: D } = dt(
    () => xC({
      fromValue: p,
      toValue: m,
      inputFormat: i,
      outputFormat: a,
      range: t,
      time: s,
      min: e,
      max: n
    }),
    [p, i, n, e, a, s, t, m]
  );
  return le(() => {
    var S, N;
    if (!c.current) return;
    const T = c.current.value;
    c.current.value = C, (S = c.current._valueTracker) == null || S.setValue(T), c.current.setCustomValidity(_), (N = c.current) == null || N.checkValidity(), c.current.dispatchEvent(new InputEvent("change", { bubbles: !0 })), tr(l, {
      target: c.current
    });
  }, [_, C]), le(() => {
    if (typeof o == "string" && !v) {
      const [T = "", S = ""] = o.split(","), N = qe(T, a), k = qe(S, a);
      x(
        {
          fromValue: N ? pe(N, i) : void 0,
          toValue: k ? pe(k, i) : void 0,
          fromTime: N ? pe(N, "HH:mm") : g,
          toTime: k ? pe(k, "HH:mm") : h
        },
        t ? "to" : "from"
      );
    }
    return () => {
      b((T) => ({ ...T, internalUpdate: !1 }));
    };
  }, [o]), {
    fromTime: g,
    toTime: h,
    fromValue: p,
    inputRef: c,
    month: w,
    singleMonth: f,
    toValue: m,
    selectedRange: D,
    selectedDate: E,
    customValidity: _,
    handleBlur: () => {
      tr(
        l,
        {
          target: c.current
        },
        {
          touched: !0
        }
      );
    },
    handleDayPickerSelectRange: (T) => {
      const S = qe(p, i), N = qe(m, i);
      if (T != null && T.from && g) {
        const [U, j] = g.split(":").map(Number);
        T.from.setHours(S && Ye(S, T.from) ? U : 0), T.from.setMinutes(N && Ye(N, T.from) ? j : 0);
      }
      if (T != null && T.to && h) {
        const [U, j] = h.split(":").map(Number);
        T.to.setHours(N && Ye(N, T.to) ? U : 23), T.to.setMinutes(N && Ye(N, T.to) ? j : 59);
      }
      const k = T != null && T.from ? pe(T.from, i) : "", Y = T != null && T.to ? pe(T.to, i) : "";
      x(
        {
          fromValue: k,
          toValue: Y,
          fromTime: T != null && T.from ? pe(T.from, "HH:mm") : "00:00",
          toTime: T != null && T.to ? pe(T.to, "HH:mm") : "23:59",
          internalUpdate: !0
        },
        Y !== m ? "to" : "from"
      );
    },
    handleDayPickerSelectSingle: (T) => {
      if (T && g) {
        const [N, k] = g.split(":").map(Number);
        T.setHours(N), T.setMinutes(k);
      }
      const S = T ? pe(T, i) : "";
      x({ fromValue: S, internalUpdate: !0 }, "from");
    },
    handleFromTimeChange: (T) => {
      const S = qe(p, i), [N, k] = T.split(":").map(Number);
      S && T && (S.setHours(N), S.setMinutes(k)), x(
        {
          fromTime: T,
          fromValue: S ? pe(S, i) : void 0,
          internalUpdate: !0
        },
        "from"
      );
    },
    handleToTimeChange: (T) => {
      const S = qe(m, i), [N, k] = T.split(":").map(Number);
      S && T && (S.setHours(N), S.setMinutes(k)), x(
        {
          toTime: T,
          toValue: S ? pe(S, i) : void 0,
          internalUpdate: !0
        },
        "to"
      );
    },
    handleFromValueChange: (T) => {
      const S = qe(T.target.value, i);
      x(
        {
          fromValue: T.target.value,
          fromTime: S ? pe(S, "HH:mm") : g,
          internalUpdate: !0
        },
        "from"
      );
    },
    handleToValueChange: (T) => {
      const S = qe(T.target.value, i);
      x(
        {
          toValue: T.target.value,
          toTime: S ? pe(S, "HH:mm") : h,
          internalUpdate: !0
        },
        "to"
      );
    },
    handleDone: () => {
      if (t && (D != null && D.from) && !(D != null && D.to)) {
        const [T, S] = h.split(":").map(Number), N = new Date(D.from.getTime());
        N.setHours(T), N.setMinutes(S);
        const k = pe(N, i);
        x(
          {
            toValue: k,
            internalUpdate: !0
          },
          "to"
        );
      }
    },
    setMonth: (T) => {
      b((S) => ({ ...S, month: T }));
    }
  };
}, _C = ({ onClear: e, onDone: n, translations: t }) => /* @__PURE__ */ u.jsxs("div", { className: P("goat-DatePicker__Actions"), children: [
  /* @__PURE__ */ u.jsx(Ge, { variant: "ghost", onClick: e, children: t.clear }),
  /* @__PURE__ */ u.jsx(Ge, { onClick: n, children: t.done })
] }), CC = ({ translations: e }) => /* @__PURE__ */ u.jsx("div", { className: P("goat-DatePicker__Timezone"), children: /* @__PURE__ */ u.jsxs(Sn, { children: [
  /* @__PURE__ */ u.jsx(Sn.Icon, { as: bm }),
  e.timezone
] }) }), IC = {
  calendarButtonAriaLabelSingle: (e, n) => e ? `Change Date, ${pe(e, n ? "PPPp" : "PPP")}` : "Choose Date",
  calendarButtonAriaLabelRange: (e, n) => e != null && e.from && (e != null && e.to) ? `Change Date Range, from ${pe(
    e.from,
    n ? "PPPp" : "PPP"
  )} to ${pe(e.to, n ? "PPPp" : "PPP")}` : "Choose Date Range",
  clear: "Clear",
  done: "Done",
  empty: "Empty",
  timezone: `UTC ${pe(/* @__PURE__ */ new Date(), "xxx")}`,
  timeAriaLabel: "Time",
  timeFromAriaLabel: "Time from",
  timeToAriaLabel: "Time to",
  hoursAriaLabel: "hours",
  minutesAriaLabel: "minutes",
  timePeriodAriaLabel: "am/pm",
  invalidDateError: "Please enter a valid date",
  invalidDateRangeError: "Please enter a valid date range",
  invalidTimeRangeError: "Please enter a valid time range",
  am: "AM",
  pm: "PM"
}, du = A(function({
  value: n,
  setValue: t,
  min: r,
  max: o,
  placeholder: a,
  className: i,
  onFinish: s,
  onFocus: c,
  translations: l,
  ...d
}, f) {
  const [p, m] = De(n), g = go(f), h = me(0), v = (w) => {
    m(w), w != null && t(w);
  };
  return le(() => {
    m(n);
  }, [n]), le(() => {
    g.current && (g.current.innerText = (p !== null ? p.toString().padStart(2, "0") : a) ?? "");
  }, [a, p, g]), /* @__PURE__ */ u.jsx(
    "div",
    {
      ...d,
      ref: g,
      className: P(i, "goat-InputTime_Segment", {
        "goat-InputTime_Segment__empty": p === null
      }),
      style: {
        "--max-digits": o.toString().length
      },
      onKeyDown: (w) => {
        if (w.key === "Tab") return;
        if (w.preventDefault(), w.key === "Backspace") {
          h.current = h.current > 0 ? h.current - 1 : 0, v(p && p > 10 ? Math.floor(p / 10) : null);
          return;
        }
        if (w.key === "ArrowUp") {
          v((p ?? -1) + 1 > o ? r : (p ?? -1) + 1);
          return;
        }
        if (w.key === "ArrowDown") {
          v((p ?? 0) - 1 < r ? o : (p ?? 0) - 1);
          return;
        }
        const b = +w.key;
        if (isNaN(b)) return;
        h.current++;
        let x = h.current == 1 ? b : (p ?? 0) * 10 + b;
        if (x > o)
          if (b <= o) x = b;
          else return;
        (h.current === 2 || x * 10 >= o) && (s == null || s()), v(x);
      },
      onFocus: (w) => {
        h.current = 0, c == null || c(w);
      },
      contentEditable: "true",
      spellCheck: "false",
      autoCapitalize: "off",
      autoCorrect: "off",
      inputMode: "numeric",
      tabIndex: 0,
      "aria-valuemin": r,
      "aria-valuemax": o,
      "aria-valuenow": p ?? void 0,
      "aria-valuetext": p != null ? p.toString().padStart(2, "0") : l.empty
    }
  );
});
function TC(e, n = []) {
  let t = [];
  function r(a, i) {
    const s = y.createContext(i), c = t.length;
    t = [...t, i];
    function l(f) {
      const { scope: p, children: m, ...g } = f, h = (p == null ? void 0 : p[e][c]) || s, v = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u.jsx(h.Provider, { value: v, children: m });
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][c]) || s, g = y.useContext(m);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = t.map((i) => y.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, EC(o, ...n)];
}
function EC(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const t = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = n.scopeName, t;
}
function PC(e, n = []) {
  let t = [];
  function r(a, i) {
    const s = y.createContext(i), c = t.length;
    t = [...t, i];
    function l(f) {
      const { scope: p, children: m, ...g } = f, h = (p == null ? void 0 : p[e][c]) || s, v = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u.jsx(h.Provider, { value: v, children: m });
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][c]) || s, g = y.useContext(m);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = t.map((i) => y.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, SC(o, ...n)];
}
function SC(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const t = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = n.scopeName, t;
}
var ha = "rovingFocusGroup.onEntryFocus", DC = { bubbles: !1, cancelable: !0 }, jo = "RovingFocusGroup", [Ka, df, RC] = ho(jo), [NC, Kn] = PC(
  jo,
  [RC]
), [MC, OC] = NC(jo), ff = y.forwardRef(
  (e, n) => /* @__PURE__ */ u.jsx(Ka.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u.jsx(Ka.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ u.jsx(jC, { ...e, ref: n }) }) })
);
ff.displayName = jo;
var jC = y.forwardRef((e, n) => {
  const {
    __scopeRovingFocusGroup: t,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: d = !1,
    ...f
  } = e, p = y.useRef(null), m = Me(n, p), g = dr(a), [h = null, v] = Ue({
    prop: i,
    defaultProp: s,
    onChange: c
  }), [w, b] = y.useState(!1), x = tt(l), C = df(t), _ = y.useRef(!1), [E, D] = y.useState(0);
  return y.useEffect(() => {
    const T = p.current;
    if (T)
      return T.addEventListener(ha, x), () => T.removeEventListener(ha, x);
  }, [x]), /* @__PURE__ */ u.jsx(
    MC,
    {
      scope: t,
      orientation: r,
      dir: g,
      loop: o,
      currentTabStopId: h,
      onItemFocus: y.useCallback(
        (T) => v(T),
        [v]
      ),
      onItemShiftTab: y.useCallback(() => b(!0), []),
      onFocusableItemAdd: y.useCallback(
        () => D((T) => T + 1),
        []
      ),
      onFocusableItemRemove: y.useCallback(
        () => D((T) => T - 1),
        []
      ),
      children: /* @__PURE__ */ u.jsx(
        se.div,
        {
          tabIndex: w || E === 0 ? -1 : 0,
          "data-orientation": r,
          ...f,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: ne(e.onMouseDown, () => {
            _.current = !0;
          }),
          onFocus: ne(e.onFocus, (T) => {
            const S = !_.current;
            if (T.target === T.currentTarget && S && !w) {
              const N = new CustomEvent(ha, DC);
              if (T.currentTarget.dispatchEvent(N), !N.defaultPrevented) {
                const k = C().filter((q) => q.focusable), Y = k.find((q) => q.active), U = k.find((q) => q.id === h), oe = [Y, U, ...k].filter(
                  Boolean
                ).map((q) => q.ref.current);
                mf(oe, d);
              }
            }
            _.current = !1;
          }),
          onBlur: ne(e.onBlur, () => b(!1))
        }
      )
    }
  );
}), pf = "RovingFocusGroupItem", hf = y.forwardRef(
  (e, n) => {
    const {
      __scopeRovingFocusGroup: t,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      ...i
    } = e, s = It(), c = a || s, l = OC(pf, t), d = l.currentTabStopId === c, f = df(t), { onFocusableItemAdd: p, onFocusableItemRemove: m } = l;
    return y.useEffect(() => {
      if (r)
        return p(), () => m();
    }, [r, p, m]), /* @__PURE__ */ u.jsx(
      Ka.ItemSlot,
      {
        scope: t,
        id: c,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ u.jsx(
          se.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": l.orientation,
            ...i,
            ref: n,
            onMouseDown: ne(e.onMouseDown, (g) => {
              r ? l.onItemFocus(c) : g.preventDefault();
            }),
            onFocus: ne(e.onFocus, () => l.onItemFocus(c)),
            onKeyDown: ne(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                l.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget) return;
              const h = LC(g, l.orientation, l.dir);
              if (h !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey) return;
                g.preventDefault();
                let w = f().filter((b) => b.focusable).map((b) => b.ref.current);
                if (h === "last") w.reverse();
                else if (h === "prev" || h === "next") {
                  h === "prev" && w.reverse();
                  const b = w.indexOf(g.currentTarget);
                  w = l.loop ? $C(w, b + 1) : w.slice(b + 1);
                }
                setTimeout(() => mf(w));
              }
            })
          }
        )
      }
    );
  }
);
hf.displayName = pf;
var AC = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function kC(e, n) {
  return n !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function LC(e, n, t) {
  const r = kC(e.key, t);
  if (!(n === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(n === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return AC[r];
}
function mf(e, n = !1) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus({ preventScroll: n }), document.activeElement !== t)) return;
}
function $C(e, n) {
  return e.map((t, r) => e[(n + r) % e.length]);
}
var ys = ff, bs = hf, Yn = "ToggleGroup", [vf, PD] = TC(Yn, [
  Kn
]), gf = Kn(), xs = he.forwardRef((e, n) => {
  const { type: t, ...r } = e;
  if (t === "single") {
    const o = r;
    return /* @__PURE__ */ u.jsx(FC, { ...o, ref: n });
  }
  if (t === "multiple") {
    const o = r;
    return /* @__PURE__ */ u.jsx(VC, { ...o, ref: n });
  }
  throw new Error(`Missing prop \`type\` expected on \`${Yn}\``);
});
xs.displayName = Yn;
var [yf, bf] = vf(Yn), FC = he.forwardRef((e, n) => {
  const {
    value: t,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i, s] = Ue({
    prop: t,
    defaultProp: r,
    onChange: o
  });
  return /* @__PURE__ */ u.jsx(
    yf,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: i ? [i] : [],
      onItemActivate: s,
      onItemDeactivate: he.useCallback(() => s(""), [s]),
      children: /* @__PURE__ */ u.jsx(xf, { ...a, ref: n })
    }
  );
}), VC = he.forwardRef((e, n) => {
  const {
    value: t,
    defaultValue: r,
    onValueChange: o = () => {
    },
    ...a
  } = e, [i = [], s] = Ue({
    prop: t,
    defaultProp: r,
    onChange: o
  }), c = he.useCallback(
    (d) => s((f = []) => [...f, d]),
    [s]
  ), l = he.useCallback(
    (d) => s((f = []) => f.filter((p) => p !== d)),
    [s]
  );
  return /* @__PURE__ */ u.jsx(
    yf,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: c,
      onItemDeactivate: l,
      children: /* @__PURE__ */ u.jsx(xf, { ...a, ref: n })
    }
  );
});
xs.displayName = Yn;
var [HC, WC] = vf(Yn), xf = he.forwardRef(
  (e, n) => {
    const {
      __scopeToggleGroup: t,
      disabled: r = !1,
      rovingFocus: o = !0,
      orientation: a,
      dir: i,
      loop: s = !0,
      ...c
    } = e, l = gf(t), d = dr(i), f = { role: "group", dir: d, ...c };
    return /* @__PURE__ */ u.jsx(HC, { scope: t, rovingFocus: o, disabled: r, children: o ? /* @__PURE__ */ u.jsx(
      ys,
      {
        asChild: !0,
        ...l,
        orientation: a,
        dir: d,
        loop: s,
        children: /* @__PURE__ */ u.jsx(se.div, { ...f, ref: n })
      }
    ) : /* @__PURE__ */ u.jsx(se.div, { ...f, ref: n }) });
  }
), no = "ToggleGroupItem", wf = he.forwardRef(
  (e, n) => {
    const t = bf(no, e.__scopeToggleGroup), r = WC(no, e.__scopeToggleGroup), o = gf(e.__scopeToggleGroup), a = t.value.includes(e.value), i = r.disabled || e.disabled, s = { ...e, pressed: a, disabled: i }, c = he.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ u.jsx(
      bs,
      {
        asChild: !0,
        ...o,
        focusable: !i,
        active: a,
        ref: c,
        children: /* @__PURE__ */ u.jsx(fu, { ...s, ref: n })
      }
    ) : /* @__PURE__ */ u.jsx(fu, { ...s, ref: n });
  }
);
wf.displayName = no;
var fu = he.forwardRef(
  (e, n) => {
    const { __scopeToggleGroup: t, value: r, ...o } = e, a = bf(no, t), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, s = a.type === "single" ? i : void 0;
    return /* @__PURE__ */ u.jsx(
      Ci,
      {
        ...s,
        ...o,
        ref: n,
        onPressedChange: (c) => {
          c ? a.onItemActivate(r) : a.onItemDeactivate(r);
        }
      }
    );
  }
), BC = xs, KC = wf;
const _f = A(
  ({ children: e, as: n = Ge, className: t, ...r }, o) => /* @__PURE__ */ u.jsx(
    KC,
    {
      ...r,
      className: P(t, "goat-ToggleButton"),
      ref: o,
      asChild: !0,
      children: /* @__PURE__ */ u.jsx(n, { children: e })
    }
  )
);
_f.displayName = "ToggleGroupButton";
const YC = ({
  children: e,
  onValueChange: n,
  value: t,
  defaultValue: r,
  size: o,
  ...a
}) => {
  const [i, s] = De(t ?? r);
  return le(() => {
    t !== void 0 && s(t);
  }, [t]), /* @__PURE__ */ u.jsx(
    BC,
    {
      ...a,
      value: i,
      onValueChange: (c) => {
        c && (n == null || n(c), s(c));
      },
      orientation: "horizontal",
      type: "single",
      asChild: !0,
      children: /* @__PURE__ */ u.jsx(Ll, { size: o, children: e })
    }
  );
}, ma = {
  Root: YC,
  Button: _f
}, va = (e, n) => e === null || n === null ? "" : `${e.toString().padStart(2, "0")}:${n.toString().padStart(2, "0")}`, UC = (e) => ({
  h12: { min: 1, max: 12 },
  h23: { min: 0, max: 23 },
  h11: { min: 0, max: 11 },
  h24: { min: 1, max: 24 }
})[e], pu = ({
  className: e,
  value: n,
  onChange: t,
  hourCycle: r,
  translations: o,
  invalid: a,
  ...i
}) => {
  const s = me(null), { hours: c, minutes: l, timePeriod: d } = dt(
    () => vC(n, r),
    [n, r]
  ), f = ["h11", "h12"].includes(r);
  return /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    /* @__PURE__ */ u.jsxs(
      "div",
      {
        role: "group",
        className: P(
          e,
          "goat-Input",
          "goat-Input_small",
          "goat-InputTime",
          { "goat-invalid": a }
        ),
        ...i,
        children: [
          /* @__PURE__ */ u.jsx(
            du,
            {
              placeholder: "hh",
              ...UC(r),
              value: c,
              setValue: (p) => {
                t(
                  pa(
                    va(p, l),
                    d,
                    r
                  )
                );
              },
              onFinish: () => {
                var p;
                (p = s.current) == null || p.focus();
              },
              translations: o,
              "aria-label": o.hoursAriaLabel
            }
          ),
          ":",
          /* @__PURE__ */ u.jsx(
            du,
            {
              ref: s,
              placeholder: "mm",
              min: 0,
              max: 59,
              value: l,
              setValue: (p) => {
                t(
                  pa(va(c, p), d, r)
                );
              },
              translations: o,
              "aria-label": o.minutesAriaLabel
            }
          )
        ]
      }
    ),
    f && /* @__PURE__ */ u.jsxs(
      ma.Root,
      {
        size: "small",
        value: d,
        onValueChange: (p) => {
          t(
            pa(
              va(c, l),
              p,
              r
            )
          );
        },
        "aria-label": o.timePeriodAriaLabel,
        children: [
          /* @__PURE__ */ u.jsx(ma.Button, { value: "AM", children: o.am }),
          /* @__PURE__ */ u.jsx(ma.Button, { value: "PM", children: o.pm })
        ]
      }
    )
  ] });
}, SD = A(
  function({
    className: n,
    style: t,
    dayPickerProps: r,
    defaultValue: o,
    disabled: a,
    inputFormat: i,
    max: s,
    min: c,
    onBlur: l,
    onChange: d,
    onFocus: f,
    outputFormat: p,
    placeholder: m,
    popoverClassName: g,
    range: h = !1,
    rangePresets: v,
    size: w = "medium",
    translations: b,
    time: x = !1,
    timezone: C,
    value: _,
    hourCycle: E = "h23",
    ...D
  }, T) {
    const S = i ?? (x ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy"), N = p ?? (x ? "yyyy-MM-dd'T'HH:mm:ss" : "yyyy-MM-dd"), k = {
      ...IC,
      ...b
    }, {
      customValidity: Y,
      fromTime: U,
      toTime: j,
      handleFromTimeChange: oe,
      handleToTimeChange: q,
      fromValue: O,
      handleBlur: M,
      handleDayPickerSelectRange: B,
      handleDayPickerSelectSingle: R,
      inputRef: V,
      month: F,
      selectedDate: $,
      selectedRange: L,
      handleFromValueChange: G,
      setMonth: z,
      handleToValueChange: Q,
      handleDone: J,
      singleMonth: ee,
      toValue: re
    } = wC({
      defaultValue: o,
      inputFormat: S,
      max: s,
      min: c,
      outputFormat: N,
      range: h,
      time: x,
      value: _
    }), de = pr(), [W, ye] = De(!1), [X, je] = De(!1), Ae = me(null);
    fm(
      T,
      () => V.current
    );
    const { minDate: at, maxDate: Qe } = xr(c, s, x), ze = {
      initialFocus: X,
      month: F,
      onMonthChange: (xe) => z(xe),
      numberOfMonths: ee ? 1 : 2,
      fromDate: at,
      toDate: Qe,
      weekStartsOn: 1,
      ...r ?? {},
      classNames: {
        caption_between: P("goat-DatePicker__Month_between"),
        caption_end: P("goat-DatePicker__Month_last"),
        caption_start: P("goat-DatePicker__Month_first"),
        cell: P("goat-DatePicker__Cell"),
        head_cell: P("goat-DatePicker__HeadCell"),
        month: P("goat-DatePicker__Month"),
        months: P("goat-DatePicker__Months"),
        row: P("goat-DatePicker__Row"),
        table: P("goat-DatePicker__Table"),
        ...(r == null ? void 0 : r.classNames) ?? {}
      },
      components: {
        Caption: pC,
        Day: hC,
        ...(r == null ? void 0 : r.components) ?? {}
      }
    }, $t = () => {
      J(), je(!1);
    };
    return /* @__PURE__ */ u.jsxs(Xi, { open: X || W, children: [
      /* @__PURE__ */ u.jsx(jd, { asChild: !0, children: /* @__PURE__ */ u.jsxs(
        Ba.Root,
        {
          size: w,
          style: t,
          className: P(
            "goat-DatePicker",
            `goat-DatePicker_${h ? "range" : "single"}`,
            { "goat-disabled": a },
            n
          ),
          children: [
            /* @__PURE__ */ u.jsx(
              "input",
              {
                ...D,
                ref: V,
                className: P("goat-DatePicker__HiddenInput"),
                onChange: (xe) => {
                  d == null || d(xe);
                }
              }
            ),
            /* @__PURE__ */ u.jsxs(
              "div",
              {
                className: P("goat-DatePicker__InputWrapper"),
                onFocus: (xe) => {
                  ye(!0), f == null || f(xe);
                },
                onBlur: (xe) => {
                  var yt;
                  xe.stopPropagation(), xe.currentTarget.contains(xe.relatedTarget) || (M(), xe.relatedTarget && ((yt = Ae.current) != null && yt.contains(xe.relatedTarget)) && je(!0), ye(!1), l == null || l(xe));
                },
                onChange: (xe) => xe.stopPropagation(),
                onInvalid: (xe) => xe.stopPropagation(),
                children: [
                  /* @__PURE__ */ u.jsx(
                    "input",
                    {
                      id: de.id,
                      className: P("goat-Input__Text", "goat-DatePicker__Input", {
                        "goat-disabled": a
                      }),
                      value: O ?? "",
                      disabled: a,
                      onChange: G,
                      placeholder: m
                    }
                  ),
                  h && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
                    "-",
                    /* @__PURE__ */ u.jsx(
                      "input",
                      {
                        className: P(
                          "goat-Input__Text",
                          "goat-DatePicker__Input",
                          {
                            "goat-disabled": a
                          }
                        ),
                        disabled: a,
                        value: re ?? "",
                        onChange: Q,
                        placeholder: m
                      }
                    )
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ u.jsx(
              ft,
              {
                "aria-label": h ? k.calendarButtonAriaLabelRange(
                  L,
                  x
                ) : k.calendarButtonAriaLabelSingle(
                  $,
                  x
                ),
                icon: xm,
                disabled: a,
                onClick: () => je(!0)
              }
            )
          ]
        }
      ) }),
      /* @__PURE__ */ u.jsx(Zi, { children: /* @__PURE__ */ u.jsxs(
        Ji,
        {
          ref: Ae,
          className: P(
            "goat-DatePicker__Popover",
            {
              "goat-DatePicker__Popover_twomonths": !ee
            },
            g
          ),
          align: "start",
          sideOffset: 8,
          onOpenAutoFocus: (xe) => xe.preventDefault(),
          onInteractOutside: $t,
          onEscapeKeyDown: $t,
          children: [
            h && v && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              /* @__PURE__ */ u.jsx(
                mC,
                {
                  presets: v,
                  onRangeClick: B
                }
              ),
              /* @__PURE__ */ u.jsx(hu, {})
            ] }),
            h ? /* @__PURE__ */ u.jsx(
              lu,
              {
                mode: "range",
                selected: L,
                onSelect: B,
                ...ze
              }
            ) : /* @__PURE__ */ u.jsx(
              lu,
              {
                mode: "single",
                selected: $,
                onSelect: R,
                ...ze
              }
            ),
            /* @__PURE__ */ u.jsxs("div", { className: P("goat-DatePicker__Time"), children: [
              C && /* @__PURE__ */ u.jsx(CC, { translations: k }),
              x && /* @__PURE__ */ u.jsxs("div", { className: P("goat-DatePicker__TimeInputsWrapper"), children: [
                /* @__PURE__ */ u.jsx(
                  pu,
                  {
                    value: U,
                    onChange: oe,
                    invalid: !!Y,
                    hourCycle: E,
                    translations: k,
                    "aria-label": h ? k.timeFromAriaLabel : k.timeAriaLabel
                  }
                ),
                h && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
                  /* @__PURE__ */ u.jsx(Ke, { as: wm }),
                  /* @__PURE__ */ u.jsx(
                    pu,
                    {
                      value: j,
                      onChange: q,
                      invalid: !!Y,
                      hourCycle: E,
                      translations: k,
                      "aria-label": k.timeToAriaLabel
                    }
                  )
                ] })
              ] })
            ] }),
            Y && /* @__PURE__ */ u.jsx("p", { className: P("goat-Validation", "goat-Validation_negative"), children: Y === "toBeforeFromTime" ? k.invalidTimeRangeError : h ? k.invalidDateRangeError : k.invalidDateError }),
            /* @__PURE__ */ u.jsx(hu, {}),
            /* @__PURE__ */ u.jsx(
              _C,
              {
                onClear: () => h ? B(void 0) : R(void 0),
                onDone: $t,
                translations: k
              }
            )
          ]
        }
      ) })
    ] });
  }
), hu = () => /* @__PURE__ */ u.jsx("hr", { className: P("goat-DatePicker__Popover__HR") }), GC = A(function({ as: n = "div", children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-Dialog__Body", r),
      ref: a,
      children: t
    }
  );
}), zC = A(function({
  accentColor: n,
  as: t = Bv,
  children: r,
  className: o,
  closeLabel: a,
  size: i = "medium",
  style: s,
  minHeight: c,
  hideCloseIcon: l,
  radixProps: d,
  ...f
}, p) {
  return /* @__PURE__ */ u.jsxs(Di, { children: [
    /* @__PURE__ */ u.jsx(Ri, { className: "goat-Dialog__Backdrop" }),
    /* @__PURE__ */ u.jsx(To, { asChild: !0, ...d, children: /* @__PURE__ */ u.jsxs(
      t,
      {
        ...f,
        className: P("goat-Dialog", `goat-Dialog_${i}`, o),
        style: {
          ...s,
          "--goat-dialog-accent-color": n,
          "--goat-dialog-min-height": c
        },
        ref: p,
        children: [
          r,
          !l && /* @__PURE__ */ u.jsx(Po, { asChild: !0, children: /* @__PURE__ */ u.jsx(
            ft,
            {
              "aria-label": a,
              className: "goat-Dialog__Close",
              icon: Bt
            }
          ) })
        ]
      }
    ) })
  ] });
}), qC = A(function({ as: n = "div", children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-Dialog__Footer", r),
      ref: a,
      children: t
    }
  );
}), XC = A(function({ as: n = "h2", children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(Eo, { asChild: !0, children: /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-Dialog__Header", r),
      ref: a,
      children: t
    }
  ) });
}), QC = Io, DD = {
  Body: GC,
  Content: zC,
  Footer: qC,
  Header: XC,
  Root: QC,
  Trigger: Oi
}, ZC = A(function({ as: n = "div", className: t, children: r }, o) {
  const a = P("goat-Drawer__Body", t);
  return /* @__PURE__ */ u.jsx(n, { ref: o, className: a, children: r });
}), JC = ({
  children: e,
  className: n,
  ...t
}) => /* @__PURE__ */ u.jsxs(Di, { children: [
  /* @__PURE__ */ u.jsx(Ri, { className: "goat-Drawer__Overlay" }),
  /* @__PURE__ */ u.jsx(
    To,
    {
      ...t,
      className: P("goat-Drawer__Content", n),
      children: e
    }
  )
] }), e0 = A(function({ as: n = "div", className: t, children: r, ...o }, a) {
  const i = P("goat-Drawer__Footer", t);
  return /* @__PURE__ */ u.jsx(n, { ...o, ref: a, className: i, children: r });
}), t0 = A(function({
  as: n = "div",
  variant: t = "application",
  style: r,
  color: o = "coral-500",
  className: a,
  children: i,
  ...s
}, c) {
  const l = P(
    "goat-Drawer__Header",
    `goat-Drawer__Header_${t}`,
    a
  );
  return /* @__PURE__ */ u.jsxs(
    n,
    {
      ...s,
      ref: c,
      style: { ...r, "--goat-panel-header-color": kn(o) },
      className: l,
      children: [
        i,
        /* @__PURE__ */ u.jsx(Po, { asChild: !0, children: /* @__PURE__ */ u.jsx(
          ft,
          {
            className: "goat-Drawer__CloseAction",
            variant: "ghost",
            icon: Bt
          }
        ) })
      ]
    }
  );
}), n0 = A(function({ as: n = "p", className: t, children: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    rt,
    {
      ...o,
      ref: a,
      className: t,
      as: n,
      type: "body-small",
      color: "gray-600",
      children: r
    }
  );
}), r0 = A(function({ as: n = "div", className: t, children: r }, o) {
  const a = P("goat-Drawer__Text", t);
  return /* @__PURE__ */ u.jsx(Eo, { asChild: !0, children: /* @__PURE__ */ u.jsx(n, { ref: o, className: a, children: r }) });
}), o0 = A(function({ as: n = "p", className: t, children: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    rt,
    {
      ...o,
      ref: a,
      className: t,
      as: n,
      type: "header-small",
      color: "gray-900",
      children: r
    }
  );
}), on = ({ children: e, ...n }) => /* @__PURE__ */ u.jsx(Io, { ...n, children: e });
on.Header = t0;
on.Body = ZC;
on.Footer = e0;
on.Title = o0;
on.Subtitle = n0;
on.Trigger = Oi;
on.Content = JC;
on.Text = r0;
const RD = A(
  function({ row: n, className: t, ...r }, o) {
    return /* @__PURE__ */ u.jsx(
      Bl,
      {
        ...r,
        as: "fieldset",
        className: P(
          "goat-Fieldset",
          { "goat-Fieldset__row": n },
          t
        ),
        ref: o
      }
    );
  }
);
function mu(e) {
  const n = a0(
    Array.from(e.elements),
    (t) => t.name || ""
  );
  return Object.fromEntries(
    Object.entries(n).filter(([t]) => t).map(([t, r]) => [t, i0(r)])
  );
}
const a0 = (e, n) => e.reduce(
  (t, r, o) => {
    const a = n(r, o);
    return (t[a] ?? (t[a] = [])).push(r), t;
  },
  {}
);
function i0(e) {
  if (e.some(Cf))
    return ga(e.find((t) => t.checked));
  if (e.length > 1) return e.map(ga).filter(Boolean);
  const [n] = e;
  return u0(n) ? Array.from(n.options ?? []).filter((t) => t.selected).map((t) => t.value) : ga(n);
}
function ga(e) {
  var n;
  return e ? s0(e) ? e.hasAttribute("value") ? e.checked ? e.value : null : e.checked : Cf(e) ? e.value || "" : c0(e) ? (n = e.value) != null && n.length ? l0(e.value) : null : e.value : null;
}
const s0 = (e) => e.type === "checkbox", c0 = (e) => e.type === "number", Cf = (e) => e.type === "radio", u0 = (e) => e.multiple, l0 = (e) => isNaN(+e) ? 0 : +e, ND = A(function({
  children: n,
  className: t,
  disabled: r,
  onChange: o,
  onInvalid: a,
  onReset: i,
  onSubmit: s,
  ...c
}, l) {
  const [d, f] = De(!1), [p, m] = De({});
  return /* @__PURE__ */ u.jsx(Kv, { value: { disabled: r, touched: d, resetToken: p }, children: /* @__PURE__ */ u.jsx(
    "form",
    {
      ...c,
      className: P("goat-Form", t),
      onChange: (g) => {
        o == null || o(g, mu(g.currentTarget));
      },
      onInvalid: (g) => {
        g.preventDefault(), f(!0), a == null || a(g);
      },
      onReset: (g) => {
        f(!1), m({}), i == null || i(g);
      },
      onSubmit: (g) => {
        if (g.preventDefault(), f(!0), r) return;
        const { submitter: h } = g.nativeEvent;
        h != null && h.disabled || s == null || s(g, mu(g.currentTarget));
      },
      ref: l,
      children: n
    }
  ) });
}), MD = ({
  areas: e,
  center: n = !1,
  children: t,
  cols: r,
  gap: o,
  grid: a,
  placeContent: i,
  placeItems: s,
  rows: c,
  style: l,
  width: d,
  ...f
}) => /* @__PURE__ */ u.jsx(
  Ol,
  {
    ...f,
    width: d,
    style: vi({
      ...l,
      display: "grid",
      grid: a,
      // prevent grid blowout needed for columns only, see https://css-tricks.com/preventing-a-grid-blowout/
      gridTemplateColumns: typeof r == "number" ? `repeat(${r}, minmax(0, 1fr))` : r,
      gridTemplateRows: typeof c == "number" ? `repeat(${c}, 1fr)` : c,
      gridTemplateAreas: Array.isArray(e) ? e.map((p) => `"${p}"`).join(`
`) : e,
      placeContent: n ? "center" : i,
      placeItems: n ? "center" : s,
      ...Array.isArray(o) ? { rowGap: o[0], columnGap: o[1] } : { gap: o },
      width: d
    }),
    children: t
  }
), If = Se(null), d0 = ({
  children: e,
  onChange: n,
  value: t,
  onInputChange: r,
  inputValue: o,
  defaultValue: a,
  disabled: i,
  className: s,
  ...c
}) => {
  const l = gt(), [d, f] = Ue({
    defaultProp: "",
    onChange: r,
    prop: o
  }), [p, m] = Ue({
    defaultProp: a ?? [],
    prop: t,
    onChange: n
  }), g = p && p.length > 0, h = (w) => {
    m(p == null ? void 0 : p.filter((b) => b !== w));
  }, v = (w) => {
    p != null && p.includes(w) || m([...p ?? [], w]);
  };
  return /* @__PURE__ */ u.jsx(
    If.Provider,
    {
      value: {
        removeSelectedItem: h,
        addSelectedItem: v,
        disabled: i,
        inputValue: d,
        selectedItems: p ?? [],
        onInputChange: f
      },
      children: /* @__PURE__ */ u.jsx(
        "div",
        {
          ...c,
          className: P(
            "goat-Input",
            "goat-InputWithTags",
            {
              "goat-InputWithTags_WithTagsInside": g,
              "goat-invalid": l.touched && l.validity.valid === !1,
              "goat-disabled": i
            },
            s
          ),
          children: e
        }
      )
    }
  );
};
function Tf() {
  const e = ve(If);
  if (!e)
    throw new Error(
      "InputWithTags compound components cannot be rendered outside the InputWithTags component"
    );
  return e;
}
const f0 = A(function(n, t) {
  const r = me(null), o = fr(t, r), a = Tf(), i = a.selectedItems.toString(), s = yi(i);
  return le(() => {
    const c = r.current, l = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
      l,
      "value"
    ).set;
    if (s !== i && f) {
      const p = new Event("change", { bubbles: !0 });
      c == null || c.dispatchEvent(p);
    }
  }, [s, i]), /* @__PURE__ */ u.jsxs(
    "select",
    {
      ...n,
      multiple: !0,
      value: a.selectedItems,
      onChange: () => null,
      hidden: !0,
      ref: o,
      "aria-hidden": !0,
      children: [
        a.selectedItems.length ? null : /* @__PURE__ */ u.jsx("option", { value: "" }),
        a.selectedItems.map((c) => /* @__PURE__ */ u.jsx("option", { value: c }, c))
      ]
    }
  );
}), p0 = A(function({ children: n, className: t, ...r }, o) {
  const a = pr();
  return /* @__PURE__ */ u.jsx(xo, { value: a, children: /* @__PURE__ */ u.jsx(
    "label",
    {
      ...r,
      className: P("goat-InputWithTags_Label", t),
      ref: o,
      htmlFor: r.htmlFor ?? a.id,
      children: n
    }
  ) });
}), h0 = ({
  placeholder: e,
  renderTag: n,
  ...t
}) => {
  const r = Tf(), o = gt(), a = me(null), i = me(null);
  return /* @__PURE__ */ u.jsxs("div", { ...t, className: "goat-InputWithTags_List", children: [
    r.selectedItems.map(
      function(c, l) {
        const d = () => ({
          "data-goat-tag-index": l,
          disabled: !!r.disabled,
          onKeyDown: (f) => {
            var p;
            f.key === "Backspace" && (f.preventDefault(), f.stopPropagation(), r.removeSelectedItem(c), (p = a.current) == null || p.focus());
          }
        });
        return /* @__PURE__ */ u.jsx(lo, { children: n(
          (f) => {
            f.stopPropagation(), r.removeSelectedItem(c);
          },
          c,
          d
        ) }, `selected-item-${l}`);
      }
    ),
    /* @__PURE__ */ u.jsx(
      "input",
      {
        ref: a,
        className: "goat-InputWithTags_Input",
        placeholder: e,
        id: o.id,
        autoComplete: "off",
        disabled: r.disabled,
        onBlur: (s) => {
          s.currentTarget.value.length > 0 && (r.addSelectedItem(s.currentTarget.value), a.current && Oa(a.current, ""));
        },
        onKeyDown: (s) => {
          var c;
          if (s.key === "Enter" && (s.preventDefault(), s.stopPropagation(), r.addSelectedItem(s.currentTarget.value), a.current && Oa(a.current, "")), s.key === "Backspace" && !s.currentTarget.value) {
            s.preventDefault(), s.stopPropagation();
            const l = (c = i.current) == null ? void 0 : c.querySelectorAll(
              "[data-goat-tag-index]"
            ), d = l == null ? void 0 : l[l.length - 1];
            d == null || d.focus();
          }
        }
      }
    )
  ] });
}, OD = {
  Root: d0,
  List: h0,
  Label: p0,
  Input: f0
}, ws = ({
  children: e,
  className: n,
  htmlFor: t,
  type: r = "default",
  ...o
}) => {
  const a = pr();
  return /* @__PURE__ */ u.jsx(xo, { value: a, children: /* @__PURE__ */ u.jsx(
    "label",
    {
      ...o,
      className: P(
        "goat-Label",
        { "goat-Label_coupled": a.inline },
        { "goat-disabled": a.disabled },
        { "goat-Label_card": r === "card" },
        n
      ),
      htmlFor: t ?? a.id,
      children: e
    }
  ) });
}, jD = A(function({ children: n, className: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx("legend", { ...r, className: P("goat-Legend", t), ref: o, children: n });
}), m0 = A(function({
  as: n = "a",
  children: t,
  className: r,
  disabled: o,
  href: a,
  color: i = "default",
  size: s = "medium",
  variant: c = "standalone",
  ...l
}, d) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...l,
      className: P(
        "goat-Link",
        `goat-Link_${i}`,
        `goat-Link_${c}`,
        `goat-Link_${s}`,
        { "goat-disabled": o },
        r
      ),
      href: o ? void 0 : a,
      ref: d,
      children: /* @__PURE__ */ u.jsx(El, { value: { size: "small" }, children: t })
    }
  );
}), v0 = ({ className: e, ...n }) => /* @__PURE__ */ u.jsx(Ke, { ...n, className: P("goat-ListItem__AfterIcon", e) }), g0 = A(function({ as: n = "div", className: t, children: r, direction: o = "row", ...a }, i) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...a,
      className: P(
        "goat-ListItem__Content",
        `goat-ListItem__Content_${o}`,
        t
      ),
      ref: i,
      children: r
    }
  );
}), y0 = A(function({ as: n = "p", children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-ListItem__Secondary", r),
      ref: a,
      children: t
    }
  );
}), Un = A(function({ as: n = "label", children: t, className: r, disabled: o, ...a }, i) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...a,
      className: P("goat-ListItem", { "goat-disabled": o }, r),
      ref: i,
      children: t
    }
  );
});
Un.AfterIcon = v0;
Un.Content = g0;
Un.Secondary = y0;
var Ya = ["Enter", " "], b0 = ["ArrowDown", "PageUp", "Home"], Ef = ["ArrowUp", "PageDown", "End"], x0 = [...b0, ...Ef], w0 = {
  ltr: [...Ya, "ArrowRight"],
  rtl: [...Ya, "ArrowLeft"]
}, _0 = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, wr = "Menu", [sr, C0, I0] = ho(wr), [hn, Pf] = At(wr, [
  I0,
  Hn,
  Kn
]), Ao = Hn(), Sf = Kn(), [T0, mn] = hn(wr), [E0, _r] = hn(wr), Df = (e) => {
  const { __scopeMenu: n, open: t = !1, children: r, dir: o, onOpenChange: a, modal: i = !0 } = e, s = Ao(n), [c, l] = y.useState(null), d = y.useRef(!1), f = tt(a), p = dr(o);
  return y.useEffect(() => {
    const m = () => {
      d.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => d.current = !1;
    return document.addEventListener("keydown", m, { capture: !0 }), () => {
      document.removeEventListener("keydown", m, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ u.jsx(Ui, { ...s, children: /* @__PURE__ */ u.jsx(
    T0,
    {
      scope: n,
      open: t,
      onOpenChange: f,
      content: c,
      onContentChange: l,
      children: /* @__PURE__ */ u.jsx(
        E0,
        {
          scope: n,
          onClose: y.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: d,
          dir: p,
          modal: i,
          children: r
        }
      )
    }
  ) });
};
Df.displayName = wr;
var P0 = "MenuAnchor", _s = y.forwardRef(
  (e, n) => {
    const { __scopeMenu: t, ...r } = e, o = Ao(t);
    return /* @__PURE__ */ u.jsx(No, { ...o, ...r, ref: n });
  }
);
_s.displayName = P0;
var Cs = "MenuPortal", [S0, Rf] = hn(Cs, {
  forceMount: void 0
}), Nf = (e) => {
  const { __scopeMenu: n, forceMount: t, children: r, container: o } = e, a = mn(Cs, n);
  return /* @__PURE__ */ u.jsx(S0, { scope: n, forceMount: t, children: /* @__PURE__ */ u.jsx(nt, { present: t || a.open, children: /* @__PURE__ */ u.jsx($n, { asChild: !0, container: o, children: r }) }) });
};
Nf.displayName = Cs;
var xt = "MenuContent", [D0, Is] = hn(xt), Mf = y.forwardRef(
  (e, n) => {
    const t = Rf(xt, e.__scopeMenu), { forceMount: r = t.forceMount, ...o } = e, a = mn(xt, e.__scopeMenu), i = _r(xt, e.__scopeMenu);
    return /* @__PURE__ */ u.jsx(sr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u.jsx(nt, { present: r || a.open, children: /* @__PURE__ */ u.jsx(sr.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ u.jsx(R0, { ...o, ref: n }) : /* @__PURE__ */ u.jsx(N0, { ...o, ref: n }) }) }) });
  }
), R0 = y.forwardRef(
  (e, n) => {
    const t = mn(xt, e.__scopeMenu), r = y.useRef(null), o = Me(n, r);
    return y.useEffect(() => {
      const a = r.current;
      if (a) return Ti(a);
    }, []), /* @__PURE__ */ u.jsx(
      Ts,
      {
        ...e,
        ref: o,
        trapFocus: t.open,
        disableOutsidePointerEvents: t.open,
        disableOutsideScroll: !0,
        onFocusOutside: ne(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => t.onOpenChange(!1)
      }
    );
  }
), N0 = y.forwardRef((e, n) => {
  const t = mn(xt, e.__scopeMenu);
  return /* @__PURE__ */ u.jsx(
    Ts,
    {
      ...e,
      ref: n,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => t.onOpenChange(!1)
    }
  );
}), Ts = y.forwardRef(
  (e, n) => {
    const {
      __scopeMenu: t,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: l,
      onPointerDownOutside: d,
      onFocusOutside: f,
      onInteractOutside: p,
      onDismiss: m,
      disableOutsideScroll: g,
      ...h
    } = e, v = mn(xt, t), w = _r(xt, t), b = Ao(t), x = Sf(t), C = C0(t), [_, E] = y.useState(null), D = y.useRef(null), T = Me(n, D, v.onContentChange), S = y.useRef(0), N = y.useRef(""), k = y.useRef(0), Y = y.useRef(null), U = y.useRef("right"), j = y.useRef(0), oe = g ? Co : y.Fragment, q = g ? { as: ln, allowPinchZoom: !0 } : void 0, O = (B) => {
      var Q, J;
      const R = N.current + B, V = C().filter((ee) => !ee.disabled), F = document.activeElement, $ = (Q = V.find((ee) => ee.ref.current === F)) == null ? void 0 : Q.textValue, L = V.map((ee) => ee.textValue), G = B0(L, R, $), z = (J = V.find((ee) => ee.textValue === G)) == null ? void 0 : J.ref.current;
      (function ee(re) {
        N.current = re, window.clearTimeout(S.current), re !== "" && (S.current = window.setTimeout(() => ee(""), 1e3));
      })(R), z && setTimeout(() => z.focus());
    };
    y.useEffect(() => () => window.clearTimeout(S.current), []), Ii();
    const M = y.useCallback((B) => {
      var V, F;
      return U.current === ((V = Y.current) == null ? void 0 : V.side) && Y0(B, (F = Y.current) == null ? void 0 : F.area);
    }, []);
    return /* @__PURE__ */ u.jsx(
      D0,
      {
        scope: t,
        searchRef: N,
        onItemEnter: y.useCallback(
          (B) => {
            M(B) && B.preventDefault();
          },
          [M]
        ),
        onItemLeave: y.useCallback(
          (B) => {
            var R;
            M(B) || ((R = D.current) == null || R.focus(), E(null));
          },
          [M]
        ),
        onTriggerLeave: y.useCallback(
          (B) => {
            M(B) && B.preventDefault();
          },
          [M]
        ),
        pointerGraceTimerRef: k,
        onPointerGraceIntentChange: y.useCallback((B) => {
          Y.current = B;
        }, []),
        children: /* @__PURE__ */ u.jsx(oe, { ...q, children: /* @__PURE__ */ u.jsx(
          wo,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: ne(a, (B) => {
              var R;
              B.preventDefault(), (R = D.current) == null || R.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ u.jsx(
              Ln,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: l,
                onPointerDownOutside: d,
                onFocusOutside: f,
                onInteractOutside: p,
                onDismiss: m,
                children: /* @__PURE__ */ u.jsx(
                  ys,
                  {
                    asChild: !0,
                    ...x,
                    dir: w.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: _,
                    onCurrentTabStopIdChange: E,
                    onEntryFocus: ne(c, (B) => {
                      w.isUsingKeyboardRef.current || B.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ u.jsx(
                      Gi,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": zf(v.open),
                        "data-radix-menu-content": "",
                        dir: w.dir,
                        ...b,
                        ...h,
                        ref: T,
                        style: { outline: "none", ...h.style },
                        onKeyDown: ne(h.onKeyDown, (B) => {
                          const V = B.target.closest("[data-radix-menu-content]") === B.currentTarget, F = B.ctrlKey || B.altKey || B.metaKey, $ = B.key.length === 1;
                          V && (B.key === "Tab" && B.preventDefault(), !F && $ && O(B.key));
                          const L = D.current;
                          if (B.target !== L || !x0.includes(B.key)) return;
                          B.preventDefault();
                          const z = C().filter((Q) => !Q.disabled).map((Q) => Q.ref.current);
                          Ef.includes(B.key) && z.reverse(), H0(z);
                        }),
                        onBlur: ne(e.onBlur, (B) => {
                          B.currentTarget.contains(B.target) || (window.clearTimeout(S.current), N.current = "");
                        }),
                        onPointerMove: ne(
                          e.onPointerMove,
                          cr((B) => {
                            const R = B.target, V = j.current !== B.clientX;
                            if (B.currentTarget.contains(R) && V) {
                              const F = B.clientX > j.current ? "right" : "left";
                              U.current = F, j.current = B.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Mf.displayName = xt;
var M0 = "MenuGroup", Es = y.forwardRef(
  (e, n) => {
    const { __scopeMenu: t, ...r } = e;
    return /* @__PURE__ */ u.jsx(se.div, { role: "group", ...r, ref: n });
  }
);
Es.displayName = M0;
var O0 = "MenuLabel", Of = y.forwardRef(
  (e, n) => {
    const { __scopeMenu: t, ...r } = e;
    return /* @__PURE__ */ u.jsx(se.div, { ...r, ref: n });
  }
);
Of.displayName = O0;
var ro = "MenuItem", vu = "menu.itemSelect", ko = y.forwardRef(
  (e, n) => {
    const { disabled: t = !1, onSelect: r, ...o } = e, a = y.useRef(null), i = _r(ro, e.__scopeMenu), s = Is(ro, e.__scopeMenu), c = Me(n, a), l = y.useRef(!1), d = () => {
      const f = a.current;
      if (!t && f) {
        const p = new CustomEvent(vu, { bubbles: !0, cancelable: !0 });
        f.addEventListener(vu, (m) => r == null ? void 0 : r(m), { once: !0 }), ai(f, p), p.defaultPrevented ? l.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ u.jsx(
      jf,
      {
        ...o,
        ref: c,
        disabled: t,
        onClick: ne(e.onClick, d),
        onPointerDown: (f) => {
          var p;
          (p = e.onPointerDown) == null || p.call(e, f), l.current = !0;
        },
        onPointerUp: ne(e.onPointerUp, (f) => {
          var p;
          l.current || (p = f.currentTarget) == null || p.click();
        }),
        onKeyDown: ne(e.onKeyDown, (f) => {
          const p = s.searchRef.current !== "";
          t || p && f.key === " " || Ya.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
ko.displayName = ro;
var jf = y.forwardRef(
  (e, n) => {
    const { __scopeMenu: t, disabled: r = !1, textValue: o, ...a } = e, i = Is(ro, t), s = Sf(t), c = y.useRef(null), l = Me(n, c), [d, f] = y.useState(!1), [p, m] = y.useState("");
    return y.useEffect(() => {
      const g = c.current;
      g && m((g.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ u.jsx(
      sr.ItemSlot,
      {
        scope: t,
        disabled: r,
        textValue: o ?? p,
        children: /* @__PURE__ */ u.jsx(bs, { asChild: !0, ...s, focusable: !r, children: /* @__PURE__ */ u.jsx(
          se.div,
          {
            role: "menuitem",
            "data-highlighted": d ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: l,
            onPointerMove: ne(
              e.onPointerMove,
              cr((g) => {
                r ? i.onItemLeave(g) : (i.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ne(
              e.onPointerLeave,
              cr((g) => i.onItemLeave(g))
            ),
            onFocus: ne(e.onFocus, () => f(!0)),
            onBlur: ne(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), j0 = "MenuCheckboxItem", Af = y.forwardRef(
  (e, n) => {
    const { checked: t = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ u.jsx(Vf, { scope: e.__scopeMenu, checked: t, children: /* @__PURE__ */ u.jsx(
      ko,
      {
        role: "menuitemcheckbox",
        "aria-checked": oo(t) ? "mixed" : t,
        ...o,
        ref: n,
        "data-state": Ss(t),
        onSelect: ne(
          o.onSelect,
          () => r == null ? void 0 : r(oo(t) ? !0 : !t),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Af.displayName = j0;
var kf = "MenuRadioGroup", [A0, k0] = hn(
  kf,
  { value: void 0, onValueChange: () => {
  } }
), Lf = y.forwardRef(
  (e, n) => {
    const { value: t, onValueChange: r, ...o } = e, a = tt(r);
    return /* @__PURE__ */ u.jsx(A0, { scope: e.__scopeMenu, value: t, onValueChange: a, children: /* @__PURE__ */ u.jsx(Es, { ...o, ref: n }) });
  }
);
Lf.displayName = kf;
var $f = "MenuRadioItem", Ff = y.forwardRef(
  (e, n) => {
    const { value: t, ...r } = e, o = k0($f, e.__scopeMenu), a = t === o.value;
    return /* @__PURE__ */ u.jsx(Vf, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ u.jsx(
      ko,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: n,
        "data-state": Ss(a),
        onSelect: ne(
          r.onSelect,
          () => {
            var i;
            return (i = o.onValueChange) == null ? void 0 : i.call(o, t);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ff.displayName = $f;
var Ps = "MenuItemIndicator", [Vf, L0] = hn(
  Ps,
  { checked: !1 }
), Hf = y.forwardRef(
  (e, n) => {
    const { __scopeMenu: t, forceMount: r, ...o } = e, a = L0(Ps, t);
    return /* @__PURE__ */ u.jsx(
      nt,
      {
        present: r || oo(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ u.jsx(
          se.span,
          {
            ...o,
            ref: n,
            "data-state": Ss(a.checked)
          }
        )
      }
    );
  }
);
Hf.displayName = Ps;
var $0 = "MenuSeparator", Wf = y.forwardRef(
  (e, n) => {
    const { __scopeMenu: t, ...r } = e;
    return /* @__PURE__ */ u.jsx(
      se.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: n
      }
    );
  }
);
Wf.displayName = $0;
var F0 = "MenuArrow", Bf = y.forwardRef(
  (e, n) => {
    const { __scopeMenu: t, ...r } = e, o = Ao(t);
    return /* @__PURE__ */ u.jsx(zi, { ...o, ...r, ref: n });
  }
);
Bf.displayName = F0;
var V0 = "MenuSub", [AD, Kf] = hn(V0), er = "MenuSubTrigger", Yf = y.forwardRef(
  (e, n) => {
    const t = mn(er, e.__scopeMenu), r = _r(er, e.__scopeMenu), o = Kf(er, e.__scopeMenu), a = Is(er, e.__scopeMenu), i = y.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = a, l = { __scopeMenu: e.__scopeMenu }, d = y.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return y.useEffect(() => d, [d]), y.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), c(null);
      };
    }, [s, c]), /* @__PURE__ */ u.jsx(_s, { asChild: !0, ...l, children: /* @__PURE__ */ u.jsx(
      jf,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": t.open,
        "aria-controls": o.contentId,
        "data-state": zf(t.open),
        ...e,
        ref: po(n, o.onTriggerChange),
        onClick: (f) => {
          var p;
          (p = e.onClick) == null || p.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), t.open || t.onOpenChange(!0));
        },
        onPointerMove: ne(
          e.onPointerMove,
          cr((f) => {
            a.onItemEnter(f), !f.defaultPrevented && !e.disabled && !t.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              t.onOpenChange(!0), d();
            }, 100));
          })
        ),
        onPointerLeave: ne(
          e.onPointerLeave,
          cr((f) => {
            var m, g;
            d();
            const p = (m = t.content) == null ? void 0 : m.getBoundingClientRect();
            if (p) {
              const h = (g = t.content) == null ? void 0 : g.dataset.side, v = h === "right", w = v ? -5 : 5, b = p[v ? "left" : "right"], x = p[v ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + w, y: f.clientY },
                  { x: b, y: p.top },
                  { x, y: p.top },
                  { x, y: p.bottom },
                  { x: b, y: p.bottom }
                ],
                side: h
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(f), f.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ne(e.onKeyDown, (f) => {
          var m;
          const p = a.searchRef.current !== "";
          e.disabled || p && f.key === " " || w0[r.dir].includes(f.key) && (t.onOpenChange(!0), (m = t.content) == null || m.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
Yf.displayName = er;
var Uf = "MenuSubContent", Gf = y.forwardRef(
  (e, n) => {
    const t = Rf(xt, e.__scopeMenu), { forceMount: r = t.forceMount, ...o } = e, a = mn(xt, e.__scopeMenu), i = _r(xt, e.__scopeMenu), s = Kf(Uf, e.__scopeMenu), c = y.useRef(null), l = Me(n, c);
    return /* @__PURE__ */ u.jsx(sr.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ u.jsx(nt, { present: r || a.open, children: /* @__PURE__ */ u.jsx(sr.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ u.jsx(
      Ts,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (d) => {
          var f;
          i.isUsingKeyboardRef.current && ((f = c.current) == null || f.focus()), d.preventDefault();
        },
        onCloseAutoFocus: (d) => d.preventDefault(),
        onFocusOutside: ne(e.onFocusOutside, (d) => {
          d.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: ne(e.onEscapeKeyDown, (d) => {
          i.onClose(), d.preventDefault();
        }),
        onKeyDown: ne(e.onKeyDown, (d) => {
          var m;
          const f = d.currentTarget.contains(d.target), p = _0[i.dir].includes(d.key);
          f && p && (a.onOpenChange(!1), (m = s.trigger) == null || m.focus(), d.preventDefault());
        })
      }
    ) }) }) });
  }
);
Gf.displayName = Uf;
function zf(e) {
  return e ? "open" : "closed";
}
function oo(e) {
  return e === "indeterminate";
}
function Ss(e) {
  return oo(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function H0(e) {
  const n = document.activeElement;
  for (const t of e)
    if (t === n || (t.focus(), document.activeElement !== n)) return;
}
function W0(e, n) {
  return e.map((t, r) => e[(n + r) % e.length]);
}
function B0(e, n, t) {
  const o = n.length > 1 && Array.from(n).every((l) => l === n[0]) ? n[0] : n, a = t ? e.indexOf(t) : -1;
  let i = W0(e, Math.max(a, 0));
  o.length === 1 && (i = i.filter((l) => l !== t));
  const c = i.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== t ? c : void 0;
}
function K0(e, n) {
  const { x: t, y: r } = e;
  let o = !1;
  for (let a = 0, i = n.length - 1; a < n.length; i = a++) {
    const s = n[a].x, c = n[a].y, l = n[i].x, d = n[i].y;
    c > r != d > r && t < (l - s) * (r - c) / (d - c) + s && (o = !o);
  }
  return o;
}
function Y0(e, n) {
  if (!n) return !1;
  const t = { x: e.clientX, y: e.clientY };
  return K0(t, n);
}
function cr(e) {
  return (n) => n.pointerType === "mouse" ? e(n) : void 0;
}
var U0 = Df, G0 = _s, z0 = Nf, q0 = Mf, X0 = Es, Q0 = Of, Z0 = ko, J0 = Af, eI = Lf, tI = Ff, nI = Hf, rI = Wf, oI = Bf, aI = Yf, iI = Gf, Ds = "DropdownMenu", [sI, kD] = At(
  Ds,
  [Pf]
), ot = Pf(), [cI, qf] = sI(Ds), Xf = (e) => {
  const {
    __scopeDropdownMenu: n,
    children: t,
    dir: r,
    open: o,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, c = ot(n), l = y.useRef(null), [d = !1, f] = Ue({
    prop: o,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ u.jsx(
    cI,
    {
      scope: n,
      triggerId: It(),
      triggerRef: l,
      contentId: It(),
      open: d,
      onOpenChange: f,
      onOpenToggle: y.useCallback(() => f((p) => !p), [f]),
      modal: s,
      children: /* @__PURE__ */ u.jsx(U0, { ...c, open: d, onOpenChange: f, dir: r, modal: s, children: t })
    }
  );
};
Xf.displayName = Ds;
var Qf = "DropdownMenuTrigger", Zf = y.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: t, disabled: r = !1, ...o } = e, a = qf(Qf, t), i = ot(t);
    return /* @__PURE__ */ u.jsx(G0, { asChild: !0, ...i, children: /* @__PURE__ */ u.jsx(
      se.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: po(n, a.triggerRef),
        onPointerDown: ne(e.onPointerDown, (s) => {
          !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: ne(e.onKeyDown, (s) => {
          r || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
Zf.displayName = Qf;
var uI = "DropdownMenuPortal", Jf = (e) => {
  const { __scopeDropdownMenu: n, ...t } = e, r = ot(n);
  return /* @__PURE__ */ u.jsx(z0, { ...r, ...t });
};
Jf.displayName = uI;
var ep = "DropdownMenuContent", tp = y.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: t, ...r } = e, o = qf(ep, t), a = ot(t), i = y.useRef(!1);
    return /* @__PURE__ */ u.jsx(
      q0,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...r,
        ref: n,
        onCloseAutoFocus: ne(e.onCloseAutoFocus, (s) => {
          var c;
          i.current || (c = o.triggerRef.current) == null || c.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: ne(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, d = c.button === 2 || l;
          (!o.modal || d) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
tp.displayName = ep;
var lI = "DropdownMenuGroup", dI = y.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
    return /* @__PURE__ */ u.jsx(X0, { ...o, ...r, ref: n });
  }
);
dI.displayName = lI;
var fI = "DropdownMenuLabel", pI = y.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
    return /* @__PURE__ */ u.jsx(Q0, { ...o, ...r, ref: n });
  }
);
pI.displayName = fI;
var hI = "DropdownMenuItem", np = y.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
    return /* @__PURE__ */ u.jsx(Z0, { ...o, ...r, ref: n });
  }
);
np.displayName = hI;
var mI = "DropdownMenuCheckboxItem", vI = y.forwardRef((e, n) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
  return /* @__PURE__ */ u.jsx(J0, { ...o, ...r, ref: n });
});
vI.displayName = mI;
var gI = "DropdownMenuRadioGroup", yI = y.forwardRef((e, n) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
  return /* @__PURE__ */ u.jsx(eI, { ...o, ...r, ref: n });
});
yI.displayName = gI;
var bI = "DropdownMenuRadioItem", xI = y.forwardRef((e, n) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
  return /* @__PURE__ */ u.jsx(tI, { ...o, ...r, ref: n });
});
xI.displayName = bI;
var wI = "DropdownMenuItemIndicator", _I = y.forwardRef((e, n) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
  return /* @__PURE__ */ u.jsx(nI, { ...o, ...r, ref: n });
});
_I.displayName = wI;
var CI = "DropdownMenuSeparator", II = y.forwardRef((e, n) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
  return /* @__PURE__ */ u.jsx(rI, { ...o, ...r, ref: n });
});
II.displayName = CI;
var TI = "DropdownMenuArrow", EI = y.forwardRef(
  (e, n) => {
    const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
    return /* @__PURE__ */ u.jsx(oI, { ...o, ...r, ref: n });
  }
);
EI.displayName = TI;
var PI = "DropdownMenuSubTrigger", SI = y.forwardRef((e, n) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
  return /* @__PURE__ */ u.jsx(aI, { ...o, ...r, ref: n });
});
SI.displayName = PI;
var DI = "DropdownMenuSubContent", RI = y.forwardRef((e, n) => {
  const { __scopeDropdownMenu: t, ...r } = e, o = ot(t);
  return /* @__PURE__ */ u.jsx(
    iI,
    {
      ...o,
      ...r,
      ref: n,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
RI.displayName = DI;
var NI = Xf, MI = Zf, OI = tp, jI = np;
const AI = 4, gu = (e) => e * AI, kI = ({
  align: e = "start",
  children: n,
  className: t,
  alignOffset: r,
  sideOffset: o = 2,
  collisionPadding: a = 20,
  ...i
}) => /* @__PURE__ */ u.jsx(Jf, { children: /* @__PURE__ */ u.jsx(
  OI,
  {
    ...i,
    className: P("goat-Menu", t),
    align: e,
    alignOffset: r && gu(r),
    loop: !0,
    collisionPadding: a,
    sideOffset: gu(o),
    children: n
  }
) }), LI = A(function({ children: n, className: t, onSelect: r, textValue: o, disabled: a, ...i }, s) {
  return /* @__PURE__ */ u.jsx(
    jI,
    {
      asChild: !0,
      ref: s,
      onSelect: r,
      textValue: o,
      disabled: a,
      ...i,
      children: /* @__PURE__ */ u.jsx(Un, { className: P(t), disabled: a, children: n })
    }
  );
}), $I = A(function({ as: n = Ge, children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(MI, { asChild: !0, children: /* @__PURE__ */ u.jsx(n, { ...o, ref: a, className: P(r), children: t }) });
}), Rs = ({ children: e, ...n }) => /* @__PURE__ */ u.jsx(NI, { ...n, modal: !1, children: e });
Rs.Content = kI;
Rs.Item = LI;
Rs.Trigger = $I;
const FI = ({
  children: e,
  className: n,
  flow: t = "row",
  ...r
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    ...r,
    className: P(
      "goat-Notification__Content",
      `goat-Notification__Content_${t}`,
      n
    ),
    children: e
  }
), rp = Se(
  {}
), VI = () => ve(rp), HI = rp.Provider, WI = {
  attentive: { color: "yellow-500", as: Da },
  informative: { color: "blue-500", as: il },
  negative: { color: "red-500", as: Da },
  positive: { color: "green-500", as: sl }
}, BI = (e) => {
  const { sentiment: n, size: t } = VI();
  return n === "neutral" ? null : /* @__PURE__ */ u.jsx(
    Ke,
    {
      ...e,
      ...WI[n],
      className: "goat-Notification__Icon",
      size: t
    }
  );
}, KI = ({
  children: e,
  className: n,
  onDismiss: t,
  sentiment: r = "neutral",
  size: o = "medium",
  ...a
}) => /* @__PURE__ */ u.jsx(HI, { value: { sentiment: r, size: o }, children: /* @__PURE__ */ u.jsxs(
  "div",
  {
    ...a,
    className: P(
      "goat-Notification",
      `goat-Notification_${r}`,
      `goat-Notification_${o}`,
      n
    ),
    children: [
      e,
      t && /* @__PURE__ */ u.jsx(ft, { icon: Bt, size: o, onClick: t })
    ]
  }
) }), LD = {
  Content: FI,
  Icon: BI,
  Root: KI
}, Vt = {
  page: "page",
  next: "next",
  previous: "previous",
  startEllipsis: "start-ellipsis",
  endEllipsis: "end-ellipsis"
}, YI = A(function({ className: n, type: t, page: r, selected: o, as: a, ...i }, s) {
  return t === Vt.startEllipsis || t === Vt.endEllipsis ? /* @__PURE__ */ u.jsx(rt, { type: "body-medium", children: "..." }) : t === "page" ? /* @__PURE__ */ u.jsx(
    Ge,
    {
      ...i,
      as: a,
      size: "small",
      variant: o ? "outlined" : "ghost",
      className: P(
        "goat-PaginationElement",
        { "goat-active": o },
        n
      ),
      ref: s,
      children: r
    }
  ) : /* @__PURE__ */ u.jsx(
    Ge,
    {
      ...i,
      as: a,
      className: P("goat-PaginationElement", n),
      ref: s,
      size: "small",
      variant: "subtle",
      children: t === Vt.next ? /* @__PURE__ */ u.jsx(Ge.Icon, { as: oi }) : /* @__PURE__ */ u.jsx(Ge.Icon, { as: al })
    }
  );
}), UI = ({
  className: e,
  children: n,
  ...t
}) => /* @__PURE__ */ u.jsx("div", { ...t, className: P("goat-PaginationItems", e), children: n }), GI = ({
  className: e,
  children: n
}) => /* @__PURE__ */ u.jsx("ul", { className: P("goat-PaginationList", e), children: uo.map(n, (t) => /* @__PURE__ */ u.jsx("li", { className: P("goat-PaginationElementWrapper"), children: t })) }), Ns = ({ children: e, className: n, centered: t, ...r }) => /* @__PURE__ */ u.jsx(
  "nav",
  {
    ...r,
    className: P(
      "goat-Pagination",
      { "goat-Pagination_centered": t },
      n
    ),
    children: e
  }
);
Ns.Element = YI;
Ns.List = GI;
Ns.Items = UI;
const ct = 1, ya = (e, n) => {
  const t = n - e + 1;
  return Array.from({ length: t }, (r, o) => e + o);
};
function $D({
  count: e = 1,
  disabled: n = !1,
  onChange: t,
  page: r,
  siblingCount: o = 1
}) {
  const a = (m, g) => {
    t == null || t(m, g);
  }, i = ya(1, Math.min(ct, e)), s = ya(
    Math.max(e - ct + 1, ct + 1),
    e
  ), c = Math.max(
    Math.min(
      // Natural start
      r - o,
      // Lower boundary when page is high
      e - ct - o * 2 - 1
    ),
    // Greater than startPages
    ct + 2
  ), l = Math.min(
    Math.max(
      // Natural end
      r + o,
      // Upper boundary when page is low
      ct + o * 2 + 2
    ),
    // Less than endPages
    s.length > 0 ? s[0] - 2 : e - 1
  ), d = [
    Vt.previous,
    ...i,
    // Start ellipsis
    ...c > ct + 2 ? [Vt.startEllipsis] : ct + 1 < e - ct ? [ct + 1] : [],
    // Sibling pages
    ...ya(c, l),
    // End ellipsis
    ...l < e - ct - 1 ? [Vt.endEllipsis] : e - ct > ct ? [e - ct] : [],
    ...s,
    Vt.next
  ], f = (m) => {
    switch (m) {
      case "previous":
        return r - 1;
      case "next":
        return r + 1;
    }
  };
  return {
    items: d.map((m) => m === Vt.startEllipsis || m === Vt.endEllipsis ? { type: m } : typeof m == "number" ? {
      onClick: (g) => {
        a(g, m);
      },
      type: "page",
      page: m,
      selected: m === r,
      disabled: n,
      "aria-current": m === r ? "true" : void 0
    } : {
      onClick: (g) => {
        a(g, f(m));
      },
      type: m,
      page: f(m),
      selected: !1,
      disabled: n || m.indexOf("ellipsis") === -1 && (m === "next" ? r >= e : r <= 1)
    })
  };
}
const zI = A(function({
  as: n = "div",
  className: t,
  children: r,
  containerClassName: o,
  containerFlexDirection: a = "row",
  ...i
}, s) {
  return /* @__PURE__ */ u.jsx(
    "div",
    {
      className: P(
        "goat-PanelLayout__PageContainer",
        `goat-PanelLayout__PageContainer_${a}`,
        o
      ),
      children: /* @__PURE__ */ u.jsx(
        n,
        {
          ...i,
          ref: s,
          className: P("goat-PanelLayout__Page", t),
          children: r
        }
      )
    }
  );
}), qI = A(function({ className: n, children: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { ...r, ref: o, className: P("goat-PanelLayout", n), children: t });
});
qI.Page = zI;
const XI = A(function({ as: n = "div", className: t, children: r }, o) {
  const a = P("goat-Panel__Body", t);
  return /* @__PURE__ */ u.jsx(n, { ref: o, className: a, children: r });
}), op = A(function({
  children: n,
  className: t,
  persistent: r,
  autoClose: o = !1,
  as: a = "div",
  border: i,
  ...s
}, c) {
  const l = o ? {} : {
    onPointerDownOutside: (f) => {
      var p;
      f.preventDefault(), (p = s.onPointerDownOutside) == null || p.call(s, f);
    },
    onInteractOutside: (f) => {
      var p;
      f.preventDefault(), (p = s.onInteractOutside) == null || p.call(s, f);
    },
    onEscapeKeyDown: (f) => {
      var p;
      f.preventDefault(), (p = s.onEscapeKeyDown) == null || p.call(s, f);
    }
  }, d = i || (r ? "right" : "left");
  return /* @__PURE__ */ u.jsx(
    To,
    {
      ...s,
      ...l,
      forceMount: !0,
      className: P(
        "goat-Panel__Content",
        { "goat-Panel__Content_persistent": r },
        {
          [`goat-Panel__Content_border_${d}`]: d !== "none"
        },
        t
      ),
      asChild: !0,
      ref: c,
      children: /* @__PURE__ */ u.jsx(a, { children: n })
    }
  );
}), QI = A(function({ as: n = "div", className: t, children: r, ...o }, a) {
  const i = P("goat-Panel__Footer", t);
  return /* @__PURE__ */ u.jsx(n, { ...o, ref: a, className: i, children: r });
}), ZI = A(function({
  as: n = "div",
  variant: t = "application",
  style: r,
  color: o = "coral-500",
  className: a,
  children: i,
  disableClose: s,
  ...c
}, l) {
  const d = P(
    "goat-Panel__Header",
    `goat-Panel__Header_${t}`,
    a
  );
  return /* @__PURE__ */ u.jsxs(
    n,
    {
      ...c,
      ref: l,
      style: { ...r, "--goat-panel-header-color": kn(o) },
      className: d,
      children: [
        i,
        !s && /* @__PURE__ */ u.jsx(Po, { asChild: !0, children: /* @__PURE__ */ u.jsx(ft, { className: "goat-Panel__CloseAction", icon: Bt }) })
      ]
    }
  );
}), JI = A(function({ as: n = "p", className: t, children: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    rt,
    {
      ...o,
      ref: a,
      className: t,
      as: n,
      type: "body-small",
      color: "gray-600",
      children: r
    }
  );
}), eT = A(function({ as: n = "div", className: t, children: r }, o) {
  const a = P("goat-Panel__Text", t);
  return /* @__PURE__ */ u.jsx(Eo, { asChild: !0, children: /* @__PURE__ */ u.jsx(n, { ref: o, className: a, children: r }) });
}), tT = A(function({ as: n = "p", className: t, children: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    rt,
    {
      ...o,
      ref: a,
      className: t,
      as: n,
      type: "title-medium",
      color: "gray-900",
      children: r
    }
  );
}), nT = A(function({ as: n = Ge, className: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx("div", { className: "goat-Panel__Toggle", children: /* @__PURE__ */ u.jsx(
    py,
    {
      ...r,
      className: P("goat-Panel__ToggleButton", t),
      ref: o,
      asChild: !0,
      children: /* @__PURE__ */ u.jsxs(n, { variant: "ghost", size: "small", children: [
        /* @__PURE__ */ u.jsx(
          Ge.Icon,
          {
            as: _m,
            className: "goat-Panel__ToggleIcon goat-Panel__ToggleIcon_opened"
          }
        ),
        /* @__PURE__ */ u.jsx(
          Ge.Icon,
          {
            as: Cm,
            className: "goat-Panel__ToggleIcon goat-Panel__ToggleIcon_closed"
          }
        )
      ] })
    }
  ) });
}), Lt = ({ children: e, ...n }) => /* @__PURE__ */ u.jsx(Io, { ...n, modal: !1, children: e });
Lt.Content = op;
Lt.Header = ZI;
Lt.Body = XI;
Lt.Footer = QI;
Lt.Title = tT;
Lt.Subtitle = JI;
Lt.Trigger = Oi;
Lt.Content = op;
Lt.Text = eT;
Lt.Toggle = nT;
const ap = Se(
  null
);
function rT({
  children: e,
  onChange: n,
  value: t,
  defaultValue: r,
  disabled: o,
  className: a,
  renderChip: i,
  options: s,
  itemToString: c,
  multiple: l = !1,
  ...d
}) {
  const f = gt(), [p, m] = Ue({
    defaultProp: r ?? (l ? [] : void 0),
    prop: t,
    onChange: n
  }), g = (v) => oT(
    v,
    p,
    c
  ), h = (v) => {
    aT(
      v,
      p,
      m,
      c
    );
  };
  return /* @__PURE__ */ u.jsx(
    ap.Provider,
    {
      value: {
        disabled: o,
        renderChip: i,
        itemToString: c,
        items: s ?? [],
        selectedItems: p,
        toggleSelectedItem: h,
        isSelected: g,
        multiple: l
      },
      children: /* @__PURE__ */ u.jsx(
        "div",
        {
          ...d,
          className: P(
            "goat-SelectChip",
            {
              "goat-invalid": f.touched && !f.validity.valid,
              "goat-disabled": o
            },
            a
          ),
          children: e
        }
      )
    }
  );
}
function ip() {
  const e = ve(ap);
  if (!e)
    throw new Error(
      "SelectChipContext compound components cannot be rendered outside the InputWithTags component"
    );
  return e;
}
function oT(e, n, t) {
  const r = t(e);
  if (!Array.isArray(n))
    return t(n) === r;
  for (let o = 0; o < n.length; o++)
    if (t(n[o]) === r)
      return !0;
  return !1;
}
function aT(e, n, t, r) {
  if (!Array.isArray(n))
    t(e);
  else {
    const o = r(e);
    let a = !1;
    const i = [];
    for (let s = 0; s < n.length; s++)
      r(n[s]) === o ? a = !0 : i.push(n[s]);
    a || i.push(e), t(i);
  }
}
const iT = A(function(n, t) {
  const r = me(null), o = fr(t, r), a = ip(), i = a.multiple ? a.selectedItems.map(
    (l) => a.itemToString(l)
  ) : a.itemToString(a.selectedItems), s = Array.isArray(i) ? i.toString() : i, c = yi(s);
  return le(() => {
    const l = r.current, d = window.HTMLSelectElement.prototype, p = Object.getOwnPropertyDescriptor(
      d,
      "value"
    ).set;
    if (c !== s && p) {
      const m = new Event("change", { bubbles: !0 });
      l == null || l.dispatchEvent(m);
    }
  }, [c, s]), /* @__PURE__ */ u.jsxs(
    "select",
    {
      ...n,
      multiple: a.multiple,
      value: i,
      onChange: () => null,
      hidden: !0,
      ref: o,
      "aria-hidden": !0,
      children: [
        a.selectedItems ? null : /* @__PURE__ */ u.jsx("option", { value: "" }),
        a.items.map((l) => /* @__PURE__ */ u.jsx(
          "option",
          {
            value: a.itemToString(l)
          },
          a.itemToString(l)
        ))
      ]
    }
  );
}), sT = A(function({ children: n, className: t, ...r }, o) {
  const a = pr();
  return /* @__PURE__ */ u.jsx(xo, { value: a, children: /* @__PURE__ */ u.jsx(
    "label",
    {
      ...r,
      className: P("goat-SelectChipLabel", t),
      ref: o,
      htmlFor: r.htmlFor ?? a.id,
      children: n
    }
  ) });
}), cT = ({
  limitVisible: e,
  ...n
}) => {
  const t = ip(), r = e ? t.items.slice(0, e) : t.items, o = e ? t.items.slice(e) : [];
  function a(i, s) {
    return /* @__PURE__ */ u.jsx(lo, { children: t.renderChip(
      () => ({
        "data-goat-chip-index": s,
        disabled: !!t.disabled,
        pressed: t.isSelected(i)
      }),
      () => t.toggleSelectedItem(i),
      i
    ) }, `chip-item-${t.itemToString(i)}`);
  }
  return /* @__PURE__ */ u.jsxs("div", { ...n, className: "goat-SelectChipList", children: [
    r.map(a),
    o.length ? /* @__PURE__ */ u.jsx(fd, { className: "goat-SelectChipList", children: o.map(a) }) : null
  ] });
}, uT = ({
  className: e,
  ...n
}) => /* @__PURE__ */ u.jsx(
  hd,
  {
    ...n,
    className: P("goat-SelectChipCollapsible", e)
  }
), FD = {
  Root: rT,
  List: cT,
  Label: sT,
  Input: iT,
  Collapsible: uT,
  Trigger: pd
}, lT = ({
  children: e,
  className: n,
  inline: t,
  disabled: r,
  htmlFor: o,
  type: a = "default",
  ...i
}) => /* @__PURE__ */ u.jsx(
  "label",
  {
    ...i,
    className: P(
      "goat-Label",
      { "goat-Label_coupled": t },
      { "goat-disabled": r },
      { "goat-Label_card": a === "card" },
      n
    ),
    htmlFor: o,
    children: e
  }
), dT = A(
  function({
    children: n,
    className: t,
    endAligned: r,
    size: o = "medium",
    disabled: a,
    error: i,
    ...s
  }, c) {
    return /* @__PURE__ */ u.jsx(
      "div",
      {
        ...s,
        className: P(
          "goat-Input",
          `goat-Input_${o}`,
          { "goat-Input_suffixed": r },
          { "goat-disabled": a },
          { "goat-invalid": i },
          t
        ),
        ref: c,
        children: n
      }
    );
  }
), fT = A(
  function({ className: n, disabled: t, id: r, ...o }, a) {
    return /* @__PURE__ */ u.jsx(
      "input",
      {
        ...o,
        className: P("goat-Input__Text", n),
        disabled: t,
        id: r,
        ref: a
      }
    );
  }
), pT = A(
  function({ resize: n = "both", size: t, className: r, disabled: o, id: a, error: i, ...s }, c) {
    return /* @__PURE__ */ u.jsx(
      "textarea",
      {
        ...s,
        className: P(
          "goat-Input",
          "goat-Input__Area",
          `goat-Input_${t}`,
          { "goat-disabled": o },
          { "goat-invalid": i },
          r
        ),
        style: { "--goat-Input__Area-resize": n },
        disabled: o,
        id: a,
        ref: c
      }
    );
  }
), hT = {
  Root: dT,
  Text: fT,
  Area: pT
}, mT = A(function({ className: n, disabled: t, id: r, indeterminate: o, ...a }, i) {
  const s = go(i);
  return le(() => {
    s.current && (s.current.indeterminate = !s.current.checked && !!o);
  }, [o, s]), /* @__PURE__ */ u.jsx(
    "input",
    {
      ...a,
      className: P("goat-Checkbox", n),
      disabled: t,
      id: r,
      ref: s,
      type: "checkbox"
    }
  );
}), VD = { Label: lT, Input: hT, Checkbox: mT }, HD = A(function({ as: n = Ge, children: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx(es, { ...r, ref: o, asChild: !0, children: /* @__PURE__ */ u.jsx(n, { children: t }) });
}), WD = ({
  children: e,
  className: n,
  portal: t = {},
  showArrow: r,
  sideOffset: o,
  size: a = "medium",
  ...i
}) => /* @__PURE__ */ u.jsx(Zi, { ...t, children: /* @__PURE__ */ u.jsxs(
  Ji,
  {
    ...i,
    className: P(
      "goat-PopoverContent",
      `goat-PopoverContent_${a}`,
      n
    ),
    sideOffset: o ?? (r ? 8 : 16),
    children: [
      r && /* @__PURE__ */ u.jsx(Fd, { className: "goat-PopoverArrow" }),
      e
    ]
  }
) }), BD = function({
  className: n,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ u.jsx("footer", { ...r, className: P("goat-PopoverFooter", n), children: t });
}, KD = ({
  className: e,
  children: n,
  close: t,
  ...r
}) => /* @__PURE__ */ u.jsxs("header", { ...r, className: P("goat-PopoverHeader", e), children: [
  n,
  /* @__PURE__ */ u.jsx(es, { ...t, asChild: !0, children: /* @__PURE__ */ u.jsx(ft, { className: "goat-PopoverClose", icon: Bt }) })
] }), YD = Xi, UD = A(function({ as: n = Ge, className: t, children: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    kd,
    {
      ...o,
      asChild: !0,
      className: P("goat-PopoverTrigger", t),
      ref: a,
      children: /* @__PURE__ */ u.jsx(n, { children: r })
    }
  );
});
function vT(e, n = []) {
  let t = [];
  function r(a, i) {
    const s = y.createContext(i), c = t.length;
    t = [...t, i];
    function l(f) {
      const { scope: p, children: m, ...g } = f, h = (p == null ? void 0 : p[e][c]) || s, v = y.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ u.jsx(h.Provider, { value: v, children: m });
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][c]) || s, g = y.useContext(m);
      if (g) return g;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, d];
  }
  const o = () => {
    const a = t.map((i) => y.createContext(i));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return y.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [r, gT(o, ...n)];
}
function gT(...e) {
  const n = e[0];
  if (e.length === 1) return n;
  const t = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const i = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return y.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
    };
  };
  return t.scopeName = n.scopeName, t;
}
var Ms = "Progress", Os = 100, [yT, GD] = vT(Ms), [bT, xT] = yT(Ms), sp = y.forwardRef(
  (e, n) => {
    const {
      __scopeProgress: t,
      value: r = null,
      max: o,
      getValueLabel: a = wT,
      ...i
    } = e;
    (o || o === 0) && !yu(o) && console.error(_T(`${o}`, "Progress"));
    const s = yu(o) ? o : Os;
    r !== null && !bu(r, s) && console.error(CT(`${r}`, "Progress"));
    const c = bu(r, s) ? r : null, l = ao(c) ? a(c, s) : void 0;
    return /* @__PURE__ */ u.jsx(bT, { scope: t, value: c, max: s, children: /* @__PURE__ */ u.jsx(
      se.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": ao(c) ? c : void 0,
        "aria-valuetext": l,
        role: "progressbar",
        "data-state": lp(c, s),
        "data-value": c ?? void 0,
        "data-max": s,
        ...i,
        ref: n
      }
    ) });
  }
);
sp.displayName = Ms;
var cp = "ProgressIndicator", up = y.forwardRef(
  (e, n) => {
    const { __scopeProgress: t, ...r } = e, o = xT(cp, t);
    return /* @__PURE__ */ u.jsx(
      se.div,
      {
        "data-state": lp(o.value, o.max),
        "data-value": o.value ?? void 0,
        "data-max": o.max,
        ...r,
        ref: n
      }
    );
  }
);
up.displayName = cp;
function wT(e, n) {
  return `${Math.round(e / n * 100)}%`;
}
function lp(e, n) {
  return e == null ? "indeterminate" : e === n ? "complete" : "loading";
}
function ao(e) {
  return typeof e == "number";
}
function yu(e) {
  return ao(e) && !isNaN(e) && e > 0;
}
function bu(e, n) {
  return ao(e) && !isNaN(e) && e <= n && e >= 0;
}
function _T(e, n) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${n}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${Os}\`.`;
}
function CT(e, n) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${n}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${Os} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
const zD = A(
  function({ className: n, value: t, max: r, indicatorColor: o = "green-500", style: a, ...i }, s) {
    return /* @__PURE__ */ u.jsx(
      sp,
      {
        ...i,
        value: t,
        max: r,
        className: P("goat-ProgressBar", n),
        ref: s,
        children: /* @__PURE__ */ u.jsx(
          up,
          {
            className: "goat-ProgressBarIndicator",
            style: {
              ...a,
              "--goat-progressbar-indicator-color": kn(o),
              transform: `translateX(-${100 - t / r * 100}%)`
            }
          }
        )
      }
    );
  }
), qD = A(function({ className: n, disabled: t, id: r, ...o }, a) {
  const i = gt({ disabled: t, id: r, inline: !0 });
  return /* @__PURE__ */ u.jsx(
    "input",
    {
      ...o,
      "aria-describedby": i.describedBy(o),
      className: P("goat-Radio", { "goat-touched": i.touched }, n),
      disabled: i.disabled,
      id: i.id,
      ref: a,
      type: "radio"
    }
  );
});
function XD({ children: e, ...n }) {
  return /* @__PURE__ */ u.jsx(dd, { ...n, direction: "row", children: e });
}
const IT = A(function({ className: n, size: t = "medium", variant: r = "default", clearProps: o = {}, ...a }, i) {
  const s = go(i);
  return /* @__PURE__ */ u.jsxs(
    Ba.Root,
    {
      className: P(
        "goat-Search",
        `goat-Search_${t}`,
        `goat-Search_${r}`,
        n
      ),
      size: t,
      children: [
        /* @__PURE__ */ u.jsx(Ke, { as: Im, size: t }),
        /* @__PURE__ */ u.jsx(Ba.Text, { ...a, ref: s }),
        /* @__PURE__ */ u.jsx(
          ft,
          {
            ...o,
            disabled: a.disabled,
            icon: Bt,
            onClick: (c) => {
              var l;
              s.current && Oa(s.current, ""), (l = o.onClick) == null || l.call(o, c);
            },
            size: t
          }
        )
      ]
    }
  );
}), dp = Se(null), fp = Se(
  null
), pp = Se(
  null
);
function qt() {
  const e = ve(dp);
  if (!e)
    throw new Error(
      "Select compound components cannot be rendered outside the Select component"
    );
  return e;
}
function Lo() {
  const e = ve(fp);
  if (!e)
    throw new Error(
      "Select compound components cannot be rendered outside the Select component"
    );
  return e;
}
function hp() {
  return ve(pp);
}
function TT({
  className: e,
  children: n,
  collisionPadding: t = 20,
  limitHeightToAvailable: r,
  lockWidthToAnchor: o,
  ...a
}) {
  const i = qt();
  return /* @__PURE__ */ u.jsx(
    Yi,
    {
      collisionPadding: t,
      sideOffset: 8,
      ...a,
      ...i.getMenuProps(),
      className: P(
        "goat-SelectContent",
        {
          "goat-SelectContent__limitHeightToAvailable": r,
          "goat-SelectContent__lockWidthToAnchor": o
        },
        e
      ),
      children: n
    }
  );
}
const ET = A(function({
  as: n = Ge,
  children: t,
  className: r,
  context: o,
  options: a,
  type: i = "button",
  tabIndex: s = 0,
  ...c
}, l) {
  const d = gt();
  return /* @__PURE__ */ u.jsx(
    mr,
    {
      ...c,
      type: i,
      asChild: !0,
      className: P(
        {
          "goat-active": o.isOpen,
          "goat-invalid": d.touched && d.validity.valid === !1
        },
        r
      ),
      ...o.getToggleButtonProps({
        ref: l,
        tabIndex: s,
        ...a
      }),
      children: /* @__PURE__ */ u.jsx(n, { children: t })
    }
  );
}), PT = A(
  function({ ...n }, t) {
    const r = qt(), o = r.selectedItems ?? [], a = me(null), i = fr(t, a), s = r.multiple ? o.map((d) => r.itemToString(d)) : r.itemToString(r.selectedItem), c = Array.isArray(s) ? s.toString() : s, l = yi(c);
    return le(() => {
      const d = a.current;
      if (l !== c) {
        const f = new Event("change", { bubbles: !0 });
        d == null || d.dispatchEvent(f);
      }
    }, [l, c]), /* @__PURE__ */ u.jsxs(
      "select",
      {
        ...n,
        multiple: r.multiple,
        value: s,
        onChange: () => null,
        hidden: !0,
        ref: i,
        "aria-hidden": !0,
        children: [
          s ? null : /* @__PURE__ */ u.jsx("option", { value: "" }),
          r.items.map((d) => /* @__PURE__ */ u.jsx(
            "option",
            {
              value: r.itemToString(d)
            },
            r.itemToString(d)
          ))
        ]
      }
    );
  }
), ST = ({
  children: e,
  className: n,
  ...t
}) => {
  const { inputRef: r } = Lo(), { getLabelProps: o, disabled: a, openMenu: i } = qt(), s = (c) => {
    var l;
    a || (i(), r == null || r.focus(), (l = t.onClick) == null || l.call(t, c));
  };
  return /* @__PURE__ */ u.jsx(
    "label",
    {
      ...t,
      ...o(),
      onClick: s,
      className: P("goat-SelectLabel", n),
      children: e
    }
  );
}, DT = ({
  children: e,
  className: n,
  ...t
}) => /* @__PURE__ */ u.jsx("div", { className: P("goat-SelectLayout", n), ...t, children: e }), RT = ({
  // list item height is 40px so this will show 5 items and some of the next item to indicate overflow, adjust as needed
  maxHeight: e = `${5 * 40 + 20}px`,
  maxWidth: n = "100%",
  className: t,
  itemClassName: r,
  ...o
}) => {
  var s;
  const a = qt(), i = new Set(
    (s = a.selectedItems) == null ? void 0 : s.map(a.itemToString)
  );
  return a.isOpen ? /* @__PURE__ */ u.jsx(
    "div",
    {
      ...o,
      className: P("goat-SelectContentOverflowWrapper", t),
      style: {
        "--goat-Select-max-height": e,
        "--goat-Select-max-width": n
      },
      children: a.filteredItems.map((c, l) => {
        const d = a.itemToString(c), f = a.selectedItem && a.itemToString(a.selectedItem), p = a.multiple ? i.has(d) : f === d, m = a.labelToNode(c);
        return /* @__PURE__ */ u.jsx(
          Un,
          {
            as: "div",
            ...a.getItemProps({
              item: c,
              index: l,
              ...a.multiple ? {
                "aria-selected": p
              } : {}
            }),
            className: P(r, "goat-SelectItem", {
              "goat-selected": a.multiple ? !1 : p,
              "goat-active": a.highlightedIndex === l
            }),
            children: a.multiple ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              /* @__PURE__ */ u.jsx(Kl, { checked: p, onChange: () => null }),
              /* @__PURE__ */ u.jsx("span", { className: "goat-SelectItem__text", children: m })
            ] }) : /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
              /* @__PURE__ */ u.jsx("span", { className: "goat-SelectItem__text", children: m }),
              /* @__PURE__ */ u.jsx(
                Ke,
                {
                  as: ol,
                  size: "small",
                  className: P("goat-SelectIcon", {
                    "goat-SelectIcon_visible": p
                  })
                }
              )
            ] })
          },
          d
        );
      })
    }
  ) : null;
};
function NT(e) {
  return e;
}
const MT = ({ className: e, ...n }) => {
  const t = qt(), r = hp(), { setInputRef: o } = Lo(), a = (r == null ? void 0 : r.getDropdownProps) ?? NT;
  return /* @__PURE__ */ u.jsx(
    ws,
    {
      ...n,
      className: P("goat-SelectWithSearch", e, {
        "goat-SelectWithSearch__closed": !t.isOpen,
        "goat-SelectWithSearch__hidden": !t.isSearchable
      }),
      children: /* @__PURE__ */ u.jsx(
        IT,
        {
          ...t.getInputProps(
            a({
              onChange: (i) => {
                i.stopPropagation();
              },
              tabIndex: t.isOpen ? 0 : -1,
              disabled: t.disabled,
              ref: o,
              ...r ? { preventKeyAction: t.isOpen } : {}
            })
          ),
          variant: "select"
        }
      )
    }
  );
};
function Ct(e, n) {
  if (e == null) return {};
  var t = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (n.includes(r)) continue;
    t[r] = e[r];
  }
  return t;
}
function ce() {
  return ce = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, ce.apply(null, arguments);
}
function Ua(e, n) {
  return Ua = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, r) {
    return t.__proto__ = r, t;
  }, Ua(e, n);
}
function mp(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, Ua(e, n);
}
var Ga = { exports: {} }, jr = { exports: {} }, _e = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xu;
function OT() {
  if (xu) return _e;
  xu = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function x(_) {
    if (typeof _ == "object" && _ !== null) {
      var E = _.$$typeof;
      switch (E) {
        case n:
          switch (_ = _.type, _) {
            case c:
            case l:
            case r:
            case a:
            case o:
            case f:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case s:
                case d:
                case g:
                case m:
                case i:
                  return _;
                default:
                  return E;
              }
          }
        case t:
          return E;
      }
    }
  }
  function C(_) {
    return x(_) === l;
  }
  return _e.AsyncMode = c, _e.ConcurrentMode = l, _e.ContextConsumer = s, _e.ContextProvider = i, _e.Element = n, _e.ForwardRef = d, _e.Fragment = r, _e.Lazy = g, _e.Memo = m, _e.Portal = t, _e.Profiler = a, _e.StrictMode = o, _e.Suspense = f, _e.isAsyncMode = function(_) {
    return C(_) || x(_) === c;
  }, _e.isConcurrentMode = C, _e.isContextConsumer = function(_) {
    return x(_) === s;
  }, _e.isContextProvider = function(_) {
    return x(_) === i;
  }, _e.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === n;
  }, _e.isForwardRef = function(_) {
    return x(_) === d;
  }, _e.isFragment = function(_) {
    return x(_) === r;
  }, _e.isLazy = function(_) {
    return x(_) === g;
  }, _e.isMemo = function(_) {
    return x(_) === m;
  }, _e.isPortal = function(_) {
    return x(_) === t;
  }, _e.isProfiler = function(_) {
    return x(_) === a;
  }, _e.isStrictMode = function(_) {
    return x(_) === o;
  }, _e.isSuspense = function(_) {
    return x(_) === f;
  }, _e.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === r || _ === l || _ === a || _ === o || _ === f || _ === p || typeof _ == "object" && _ !== null && (_.$$typeof === g || _.$$typeof === m || _.$$typeof === i || _.$$typeof === s || _.$$typeof === d || _.$$typeof === v || _.$$typeof === w || _.$$typeof === b || _.$$typeof === h);
  }, _e.typeOf = x, _e;
}
var Ce = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wu;
function jT() {
  return wu || (wu = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function x(W) {
      return typeof W == "string" || typeof W == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      W === r || W === l || W === a || W === o || W === f || W === p || typeof W == "object" && W !== null && (W.$$typeof === g || W.$$typeof === m || W.$$typeof === i || W.$$typeof === s || W.$$typeof === d || W.$$typeof === v || W.$$typeof === w || W.$$typeof === b || W.$$typeof === h);
    }
    function C(W) {
      if (typeof W == "object" && W !== null) {
        var ye = W.$$typeof;
        switch (ye) {
          case n:
            var X = W.type;
            switch (X) {
              case c:
              case l:
              case r:
              case a:
              case o:
              case f:
                return X;
              default:
                var je = X && X.$$typeof;
                switch (je) {
                  case s:
                  case d:
                  case g:
                  case m:
                  case i:
                    return je;
                  default:
                    return ye;
                }
            }
          case t:
            return ye;
        }
      }
    }
    var _ = c, E = l, D = s, T = i, S = n, N = d, k = r, Y = g, U = m, j = t, oe = a, q = o, O = f, M = !1;
    function B(W) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(W) || C(W) === c;
    }
    function R(W) {
      return C(W) === l;
    }
    function V(W) {
      return C(W) === s;
    }
    function F(W) {
      return C(W) === i;
    }
    function $(W) {
      return typeof W == "object" && W !== null && W.$$typeof === n;
    }
    function L(W) {
      return C(W) === d;
    }
    function G(W) {
      return C(W) === r;
    }
    function z(W) {
      return C(W) === g;
    }
    function Q(W) {
      return C(W) === m;
    }
    function J(W) {
      return C(W) === t;
    }
    function ee(W) {
      return C(W) === a;
    }
    function re(W) {
      return C(W) === o;
    }
    function de(W) {
      return C(W) === f;
    }
    Ce.AsyncMode = _, Ce.ConcurrentMode = E, Ce.ContextConsumer = D, Ce.ContextProvider = T, Ce.Element = S, Ce.ForwardRef = N, Ce.Fragment = k, Ce.Lazy = Y, Ce.Memo = U, Ce.Portal = j, Ce.Profiler = oe, Ce.StrictMode = q, Ce.Suspense = O, Ce.isAsyncMode = B, Ce.isConcurrentMode = R, Ce.isContextConsumer = V, Ce.isContextProvider = F, Ce.isElement = $, Ce.isForwardRef = L, Ce.isFragment = G, Ce.isLazy = z, Ce.isMemo = Q, Ce.isPortal = J, Ce.isProfiler = ee, Ce.isStrictMode = re, Ce.isSuspense = de, Ce.isValidElementType = x, Ce.typeOf = C;
  }()), Ce;
}
var _u;
function vp() {
  return _u || (_u = 1, process.env.NODE_ENV === "production" ? jr.exports = OT() : jr.exports = jT()), jr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ba, Cu;
function AT() {
  if (Cu) return ba;
  Cu = 1;
  var e = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(i).map(function(d) {
        return i[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        l[d] = d;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ba = o() ? Object.assign : function(a, i) {
    for (var s, c = r(a), l, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var f in s)
        n.call(s, f) && (c[f] = s[f]);
      if (e) {
        l = e(s);
        for (var p = 0; p < l.length; p++)
          t.call(s, l[p]) && (c[l[p]] = s[l[p]]);
      }
    }
    return c;
  }, ba;
}
var xa, Iu;
function js() {
  if (Iu) return xa;
  Iu = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return xa = e, xa;
}
var wa, Tu;
function gp() {
  return Tu || (Tu = 1, wa = Function.call.bind(Object.prototype.hasOwnProperty)), wa;
}
var _a, Eu;
function kT() {
  if (Eu) return _a;
  Eu = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var n = js(), t = {}, r = gp();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in a)
        if (r(a, d)) {
          var f;
          try {
            if (typeof a[d] != "function") {
              var p = Error(
                (c || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = a[d](i, d, c, s, null, n);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in t)) {
            t[f.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, _a = o, _a;
}
var Ca, Pu;
function LT() {
  if (Pu) return Ca;
  Pu = 1;
  var e = vp(), n = AT(), t = js(), r = gp(), o = kT(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Ca = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(R) {
      var V = R && (l && R[l] || R[d]);
      if (typeof V == "function")
        return V;
    }
    var p = "<<anonymous>>", m = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: b(),
      arrayOf: x,
      element: C(),
      elementType: _(),
      instanceOf: E,
      node: N(),
      objectOf: T,
      oneOf: D,
      oneOfType: S,
      shape: Y,
      exact: U
    };
    function g(R, V) {
      return R === V ? R !== 0 || 1 / R === 1 / V : R !== R && V !== V;
    }
    function h(R, V) {
      this.message = R, this.data = V && typeof V == "object" ? V : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function v(R) {
      if (process.env.NODE_ENV !== "production")
        var V = {}, F = 0;
      function $(G, z, Q, J, ee, re, de) {
        if (J = J || p, re = re || Q, de !== t) {
          if (c) {
            var W = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw W.name = "Invariant Violation", W;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = J + ":" + Q;
            !V[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + re + "` prop on `" + J + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), V[ye] = !0, F++);
          }
        }
        return z[Q] == null ? G ? z[Q] === null ? new h("The " + ee + " `" + re + "` is marked as required " + ("in `" + J + "`, but its value is `null`.")) : new h("The " + ee + " `" + re + "` is marked as required in " + ("`" + J + "`, but its value is `undefined`.")) : null : R(z, Q, J, ee, re);
      }
      var L = $.bind(null, !1);
      return L.isRequired = $.bind(null, !0), L;
    }
    function w(R) {
      function V(F, $, L, G, z, Q) {
        var J = F[$], ee = q(J);
        if (ee !== R) {
          var re = O(J);
          return new h(
            "Invalid " + G + " `" + z + "` of type " + ("`" + re + "` supplied to `" + L + "`, expected ") + ("`" + R + "`."),
            { expectedType: R }
          );
        }
        return null;
      }
      return v(V);
    }
    function b() {
      return v(i);
    }
    function x(R) {
      function V(F, $, L, G, z) {
        if (typeof R != "function")
          return new h("Property `" + z + "` of component `" + L + "` has invalid PropType notation inside arrayOf.");
        var Q = F[$];
        if (!Array.isArray(Q)) {
          var J = q(Q);
          return new h("Invalid " + G + " `" + z + "` of type " + ("`" + J + "` supplied to `" + L + "`, expected an array."));
        }
        for (var ee = 0; ee < Q.length; ee++) {
          var re = R(Q, ee, L, G, z + "[" + ee + "]", t);
          if (re instanceof Error)
            return re;
        }
        return null;
      }
      return v(V);
    }
    function C() {
      function R(V, F, $, L, G) {
        var z = V[F];
        if (!s(z)) {
          var Q = q(z);
          return new h("Invalid " + L + " `" + G + "` of type " + ("`" + Q + "` supplied to `" + $ + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(R);
    }
    function _() {
      function R(V, F, $, L, G) {
        var z = V[F];
        if (!e.isValidElementType(z)) {
          var Q = q(z);
          return new h("Invalid " + L + " `" + G + "` of type " + ("`" + Q + "` supplied to `" + $ + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(R);
    }
    function E(R) {
      function V(F, $, L, G, z) {
        if (!(F[$] instanceof R)) {
          var Q = R.name || p, J = B(F[$]);
          return new h("Invalid " + G + " `" + z + "` of type " + ("`" + J + "` supplied to `" + L + "`, expected ") + ("instance of `" + Q + "`."));
        }
        return null;
      }
      return v(V);
    }
    function D(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function V(F, $, L, G, z) {
        for (var Q = F[$], J = 0; J < R.length; J++)
          if (g(Q, R[J]))
            return null;
        var ee = JSON.stringify(R, function(de, W) {
          var ye = O(W);
          return ye === "symbol" ? String(W) : W;
        });
        return new h("Invalid " + G + " `" + z + "` of value `" + String(Q) + "` " + ("supplied to `" + L + "`, expected one of " + ee + "."));
      }
      return v(V);
    }
    function T(R) {
      function V(F, $, L, G, z) {
        if (typeof R != "function")
          return new h("Property `" + z + "` of component `" + L + "` has invalid PropType notation inside objectOf.");
        var Q = F[$], J = q(Q);
        if (J !== "object")
          return new h("Invalid " + G + " `" + z + "` of type " + ("`" + J + "` supplied to `" + L + "`, expected an object."));
        for (var ee in Q)
          if (r(Q, ee)) {
            var re = R(Q, ee, L, G, z + "." + ee, t);
            if (re instanceof Error)
              return re;
          }
        return null;
      }
      return v(V);
    }
    function S(R) {
      if (!Array.isArray(R))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var V = 0; V < R.length; V++) {
        var F = R[V];
        if (typeof F != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + M(F) + " at index " + V + "."
          ), i;
      }
      function $(L, G, z, Q, J) {
        for (var ee = [], re = 0; re < R.length; re++) {
          var de = R[re], W = de(L, G, z, Q, J, t);
          if (W == null)
            return null;
          W.data && r(W.data, "expectedType") && ee.push(W.data.expectedType);
        }
        var ye = ee.length > 0 ? ", expected one of type [" + ee.join(", ") + "]" : "";
        return new h("Invalid " + Q + " `" + J + "` supplied to " + ("`" + z + "`" + ye + "."));
      }
      return v($);
    }
    function N() {
      function R(V, F, $, L, G) {
        return j(V[F]) ? null : new h("Invalid " + L + " `" + G + "` supplied to " + ("`" + $ + "`, expected a ReactNode."));
      }
      return v(R);
    }
    function k(R, V, F, $, L) {
      return new h(
        (R || "React class") + ": " + V + " type `" + F + "." + $ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + L + "`."
      );
    }
    function Y(R) {
      function V(F, $, L, G, z) {
        var Q = F[$], J = q(Q);
        if (J !== "object")
          return new h("Invalid " + G + " `" + z + "` of type `" + J + "` " + ("supplied to `" + L + "`, expected `object`."));
        for (var ee in R) {
          var re = R[ee];
          if (typeof re != "function")
            return k(L, G, z, ee, O(re));
          var de = re(Q, ee, L, G, z + "." + ee, t);
          if (de)
            return de;
        }
        return null;
      }
      return v(V);
    }
    function U(R) {
      function V(F, $, L, G, z) {
        var Q = F[$], J = q(Q);
        if (J !== "object")
          return new h("Invalid " + G + " `" + z + "` of type `" + J + "` " + ("supplied to `" + L + "`, expected `object`."));
        var ee = n({}, F[$], R);
        for (var re in ee) {
          var de = R[re];
          if (r(R, re) && typeof de != "function")
            return k(L, G, z, re, O(de));
          if (!de)
            return new h(
              "Invalid " + G + " `" + z + "` key `" + re + "` supplied to `" + L + "`.\nBad object: " + JSON.stringify(F[$], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(R), null, "  ")
            );
          var W = de(Q, re, L, G, z + "." + re, t);
          if (W)
            return W;
        }
        return null;
      }
      return v(V);
    }
    function j(R) {
      switch (typeof R) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !R;
        case "object":
          if (Array.isArray(R))
            return R.every(j);
          if (R === null || s(R))
            return !0;
          var V = f(R);
          if (V) {
            var F = V.call(R), $;
            if (V !== R.entries) {
              for (; !($ = F.next()).done; )
                if (!j($.value))
                  return !1;
            } else
              for (; !($ = F.next()).done; ) {
                var L = $.value;
                if (L && !j(L[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function oe(R, V) {
      return R === "symbol" ? !0 : V ? V["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && V instanceof Symbol : !1;
    }
    function q(R) {
      var V = typeof R;
      return Array.isArray(R) ? "array" : R instanceof RegExp ? "object" : oe(V, R) ? "symbol" : V;
    }
    function O(R) {
      if (typeof R > "u" || R === null)
        return "" + R;
      var V = q(R);
      if (V === "object") {
        if (R instanceof Date)
          return "date";
        if (R instanceof RegExp)
          return "regexp";
      }
      return V;
    }
    function M(R) {
      var V = O(R);
      switch (V) {
        case "array":
        case "object":
          return "an " + V;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + V;
        default:
          return V;
      }
    }
    function B(R) {
      return !R.constructor || !R.constructor.name ? p : R.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, Ca;
}
var Ia, Su;
function $T() {
  if (Su) return Ia;
  Su = 1;
  var e = js();
  function n() {
  }
  function t() {
  }
  return t.resetWarningCache = n, Ia = function() {
    function r(i, s, c, l, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: n
    };
    return a.PropTypes = a, a;
  }, Ia;
}
if (process.env.NODE_ENV !== "production") {
  var FT = vp(), VT = !0;
  Ga.exports = LT()(FT.isElement, VT);
} else
  Ga.exports = $T()();
var HT = Ga.exports;
const K = /* @__PURE__ */ Sm(HT);
var za = { exports: {} }, Ie = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Du;
function WT() {
  if (Du) return Ie;
  Du = 1;
  var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function h(v) {
    if (typeof v == "object" && v !== null) {
      var w = v.$$typeof;
      switch (w) {
        case e:
          switch (v = v.type, v) {
            case t:
            case o:
            case r:
            case l:
            case d:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case s:
                case i:
                case c:
                case p:
                case f:
                case a:
                  return v;
                default:
                  return w;
              }
          }
        case n:
          return w;
      }
    }
  }
  return Ie.ContextConsumer = i, Ie.ContextProvider = a, Ie.Element = e, Ie.ForwardRef = c, Ie.Fragment = t, Ie.Lazy = p, Ie.Memo = f, Ie.Portal = n, Ie.Profiler = o, Ie.StrictMode = r, Ie.Suspense = l, Ie.SuspenseList = d, Ie.isAsyncMode = function() {
    return !1;
  }, Ie.isConcurrentMode = function() {
    return !1;
  }, Ie.isContextConsumer = function(v) {
    return h(v) === i;
  }, Ie.isContextProvider = function(v) {
    return h(v) === a;
  }, Ie.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === e;
  }, Ie.isForwardRef = function(v) {
    return h(v) === c;
  }, Ie.isFragment = function(v) {
    return h(v) === t;
  }, Ie.isLazy = function(v) {
    return h(v) === p;
  }, Ie.isMemo = function(v) {
    return h(v) === f;
  }, Ie.isPortal = function(v) {
    return h(v) === n;
  }, Ie.isProfiler = function(v) {
    return h(v) === o;
  }, Ie.isStrictMode = function(v) {
    return h(v) === r;
  }, Ie.isSuspense = function(v) {
    return h(v) === l;
  }, Ie.isSuspenseList = function(v) {
    return h(v) === d;
  }, Ie.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === t || v === o || v === r || v === l || v === d || v === m || typeof v == "object" && v !== null && (v.$$typeof === p || v.$$typeof === f || v.$$typeof === a || v.$$typeof === i || v.$$typeof === c || v.$$typeof === g || v.getModuleId !== void 0);
  }, Ie.typeOf = h, Ie;
}
var Te = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ru;
function BT() {
  return Ru || (Ru = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), n = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = !1, h = !1, v = !1, w = !1, b = !1, x;
    x = Symbol.for("react.module.reference");
    function C(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === t || X === o || b || X === r || X === l || X === d || w || X === m || g || h || v || typeof X == "object" && X !== null && (X.$$typeof === p || X.$$typeof === f || X.$$typeof === a || X.$$typeof === i || X.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === x || X.getModuleId !== void 0));
    }
    function _(X) {
      if (typeof X == "object" && X !== null) {
        var je = X.$$typeof;
        switch (je) {
          case e:
            var Ae = X.type;
            switch (Ae) {
              case t:
              case o:
              case r:
              case l:
              case d:
                return Ae;
              default:
                var at = Ae && Ae.$$typeof;
                switch (at) {
                  case s:
                  case i:
                  case c:
                  case p:
                  case f:
                  case a:
                    return at;
                  default:
                    return je;
                }
            }
          case n:
            return je;
        }
      }
    }
    var E = i, D = a, T = e, S = c, N = t, k = p, Y = f, U = n, j = o, oe = r, q = l, O = d, M = !1, B = !1;
    function R(X) {
      return M || (M = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function V(X) {
      return B || (B = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(X) {
      return _(X) === i;
    }
    function $(X) {
      return _(X) === a;
    }
    function L(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function G(X) {
      return _(X) === c;
    }
    function z(X) {
      return _(X) === t;
    }
    function Q(X) {
      return _(X) === p;
    }
    function J(X) {
      return _(X) === f;
    }
    function ee(X) {
      return _(X) === n;
    }
    function re(X) {
      return _(X) === o;
    }
    function de(X) {
      return _(X) === r;
    }
    function W(X) {
      return _(X) === l;
    }
    function ye(X) {
      return _(X) === d;
    }
    Te.ContextConsumer = E, Te.ContextProvider = D, Te.Element = T, Te.ForwardRef = S, Te.Fragment = N, Te.Lazy = k, Te.Memo = Y, Te.Portal = U, Te.Profiler = j, Te.StrictMode = oe, Te.Suspense = q, Te.SuspenseList = O, Te.isAsyncMode = R, Te.isConcurrentMode = V, Te.isContextConsumer = F, Te.isContextProvider = $, Te.isElement = L, Te.isForwardRef = G, Te.isFragment = z, Te.isLazy = Q, Te.isMemo = J, Te.isPortal = ee, Te.isProfiler = re, Te.isStrictMode = de, Te.isSuspense = W, Te.isSuspenseList = ye, Te.isValidElementType = C, Te.typeOf = _;
  }()), Te;
}
process.env.NODE_ENV === "production" ? za.exports = WT() : za.exports = BT();
var Nu = za.exports;
const Mu = (e) => typeof e == "object" && e != null && e.nodeType === 1, Ou = (e, n) => (!n || e !== "hidden") && e !== "visible" && e !== "clip", Ta = (e, n) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const t = getComputedStyle(e, null);
    return Ou(t.overflowY, n) || Ou(t.overflowX, n) || ((r) => {
      const o = ((a) => {
        if (!a.ownerDocument || !a.ownerDocument.defaultView) return null;
        try {
          return a.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!o && (o.clientHeight < r.scrollHeight || o.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, Ar = (e, n, t, r, o, a, i, s) => a < e && i > n || a > e && i < n ? 0 : a <= e && s <= t || i >= n && s >= t ? a - e - r : i > n && s < t || a < e && s > t ? i - n + o : 0, KT = (e) => {
  const n = e.parentElement;
  return n ?? (e.getRootNode().host || null);
}, YT = (e, n) => {
  var t, r, o, a;
  if (typeof document > "u") return [];
  const { scrollMode: i, block: s, inline: c, boundary: l, skipOverflowHiddenElements: d } = n, f = typeof l == "function" ? l : (q) => q !== l;
  if (!Mu(e)) throw new TypeError("Invalid target");
  const p = document.scrollingElement || document.documentElement, m = [];
  let g = e;
  for (; Mu(g) && f(g); ) {
    if (g = KT(g), g === p) {
      m.push(g);
      break;
    }
    g != null && g === document.body && Ta(g) && !Ta(document.documentElement) || g != null && Ta(g, d) && m.push(g);
  }
  const h = (r = (t = window.visualViewport) == null ? void 0 : t.width) != null ? r : innerWidth, v = (a = (o = window.visualViewport) == null ? void 0 : o.height) != null ? a : innerHeight, { scrollX: w, scrollY: b } = window, { height: x, width: C, top: _, right: E, bottom: D, left: T } = e.getBoundingClientRect(), { top: S, right: N, bottom: k, left: Y } = ((q) => {
    const O = window.getComputedStyle(q);
    return { top: parseFloat(O.scrollMarginTop) || 0, right: parseFloat(O.scrollMarginRight) || 0, bottom: parseFloat(O.scrollMarginBottom) || 0, left: parseFloat(O.scrollMarginLeft) || 0 };
  })(e);
  let U = s === "start" || s === "nearest" ? _ - S : s === "end" ? D + k : _ + x / 2 - S + k, j = c === "center" ? T + C / 2 - Y + N : c === "end" ? E + N : T - Y;
  const oe = [];
  for (let q = 0; q < m.length; q++) {
    const O = m[q], { height: M, width: B, top: R, right: V, bottom: F, left: $ } = O.getBoundingClientRect();
    if (i === "if-needed" && _ >= 0 && T >= 0 && D <= v && E <= h && _ >= R && D <= F && T >= $ && E <= V) return oe;
    const L = getComputedStyle(O), G = parseInt(L.borderLeftWidth, 10), z = parseInt(L.borderTopWidth, 10), Q = parseInt(L.borderRightWidth, 10), J = parseInt(L.borderBottomWidth, 10);
    let ee = 0, re = 0;
    const de = "offsetWidth" in O ? O.offsetWidth - O.clientWidth - G - Q : 0, W = "offsetHeight" in O ? O.offsetHeight - O.clientHeight - z - J : 0, ye = "offsetWidth" in O ? O.offsetWidth === 0 ? 0 : B / O.offsetWidth : 0, X = "offsetHeight" in O ? O.offsetHeight === 0 ? 0 : M / O.offsetHeight : 0;
    if (p === O) ee = s === "start" ? U : s === "end" ? U - v : s === "nearest" ? Ar(b, b + v, v, z, J, b + U, b + U + x, x) : U - v / 2, re = c === "start" ? j : c === "center" ? j - h / 2 : c === "end" ? j - h : Ar(w, w + h, h, G, Q, w + j, w + j + C, C), ee = Math.max(0, ee + b), re = Math.max(0, re + w);
    else {
      ee = s === "start" ? U - R - z : s === "end" ? U - F + J + W : s === "nearest" ? Ar(R, F, M, z, J + W, U, U + x, x) : U - (R + M / 2) + W / 2, re = c === "start" ? j - $ - G : c === "center" ? j - ($ + B / 2) + de / 2 : c === "end" ? j - V + Q + de : Ar($, V, B, G, Q + de, j, j + C, C);
      const { scrollLeft: je, scrollTop: Ae } = O;
      ee = X === 0 ? 0 : Math.max(0, Math.min(Ae + ee / X, O.scrollHeight - M / X + W)), re = ye === 0 ? 0 : Math.max(0, Math.min(je + re / ye, O.scrollWidth - B / ye + de)), U += Ae - ee, j += je - re;
    }
    oe.push({ el: O, top: ee, left: re });
  }
  return oe;
};
var UT = 0;
function ju(e) {
  return typeof e == "function" ? e : ut;
}
function ut() {
}
function yp(e, n) {
  if (e) {
    var t = YT(e, {
      boundary: n,
      block: "nearest",
      scrollMode: "if-needed"
    });
    t.forEach(function(r) {
      var o = r.el, a = r.top, i = r.left;
      o.scrollTop = a, o.scrollLeft = i;
    });
  }
}
function Au(e, n, t) {
  var r = e === n || n instanceof t.Node && e.contains && e.contains(n);
  return r;
}
function As(e, n) {
  var t;
  function r() {
    t && clearTimeout(t);
  }
  function o() {
    for (var a = arguments.length, i = new Array(a), s = 0; s < a; s++)
      i[s] = arguments[s];
    r(), t = setTimeout(function() {
      t = null, e.apply(void 0, i);
    }, n);
  }
  return o.cancel = r, o;
}
function ke() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return function(r) {
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      a[i - 1] = arguments[i];
    return n.some(function(s) {
      return s && s.apply(void 0, [r].concat(a)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Jt() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  return function(r) {
    n.forEach(function(o) {
      typeof o == "function" ? o(r) : o && (o.current = r);
    });
  };
}
function bp() {
  return String(UT++);
}
function GT(e) {
  var n = e.isOpen, t = e.resultCount, r = e.previousResultCount;
  return n ? t ? t !== r ? t + " result" + (t === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function ku(e, n) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && n ? n : e;
}
function xp(e) {
  return typeof e.type == "string";
}
function wp(e) {
  return e.props;
}
function zT(e, n) {
  console.error('The property "' + n + '" is required in "' + e + '"');
}
var qT = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function kr(e) {
  e === void 0 && (e = {});
  var n = {};
  return qT.forEach(function(t) {
    e.hasOwnProperty(t) && (n[t] = e[t]);
  }), n;
}
function ur(e, n) {
  return !e || !n ? e : Object.keys(e).reduce(function(t, r) {
    return t[r] = io(n, r) ? n[r] : e[r], t;
  }, {});
}
function io(e, n) {
  return e[n] !== void 0;
}
function lr(e) {
  var n = e.key, t = e.keyCode;
  return t >= 37 && t <= 40 && n.indexOf("Arrow") !== 0 ? "Arrow" + n : n;
}
function XT(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function un(e, n, t, r, o) {
  var a = t.length;
  if (a === 0)
    return -1;
  var i = a - 1;
  (typeof e != "number" || e < 0 || e > i) && (e = n > 0 ? -1 : i + 1);
  var s = e + n;
  s < 0 ? s = i : s > i && (s = 0);
  var c = jn(s, n < 0, t, r, o);
  return c === -1 ? e >= a ? -1 : e : c;
}
function jn(e, n, t, r, o) {
  o === void 0 && (o = !1);
  var a = t.length;
  if (n) {
    for (var i = e; i >= 0; i--)
      if (!r(t[i], i))
        return i;
  } else
    for (var s = e; s < a; s++)
      if (!r(t[s], s))
        return s;
  return o ? jn(n ? a - 1 : 0, n, t, r) : -1;
}
function so(e, n, t, r) {
  return r === void 0 && (r = !0), t && n.some(function(o) {
    return o && (Au(o, e, t) || r && Au(o, t.document.activeElement, t));
  });
}
var ks = ut;
process.env.NODE_ENV !== "production" && (ks = function(n, t, r) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(n).forEach(function(a) {
    t[a] !== void 0 && r[a] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + a + '" to be uncontrolled. ' + o) : t[a] === void 0 && r[a] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + a + '" to be controlled. ' + o);
  });
});
var QT = As(function(e) {
  _p(e).textContent = "";
}, 500);
function _p(e) {
  var n = e.getElementById("a11y-status-message");
  return n || (n = e.createElement("div"), n.setAttribute("id", "a11y-status-message"), n.setAttribute("role", "status"), n.setAttribute("aria-live", "polite"), n.setAttribute("aria-relevant", "additions text"), Object.assign(n.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(n), n);
}
function Cp(e, n) {
  if (!(!e || !n)) {
    var t = _p(n);
    t.textContent = e, QT(n);
  }
}
function ZT(e) {
  var n = e == null ? void 0 : e.getElementById("a11y-status-message");
  n && n.remove();
}
var Ip = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, Tp = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Ep = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, Br = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, Kr = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Pp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Sp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Dp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, Rp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Np = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Mp = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, Op = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, jp = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, qa = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Ap = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, kp = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Lp = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, JT = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: Ap,
  blurInput: Mp,
  changeInput: Op,
  clickButton: qa,
  clickItem: Np,
  controlledPropUpdatedSelectedItem: kp,
  itemMouseEnter: Ep,
  keyDownArrowDown: Kr,
  keyDownArrowUp: Br,
  keyDownEnd: Rp,
  keyDownEnter: Sp,
  keyDownEscape: Pp,
  keyDownHome: Dp,
  keyDownSpaceButton: jp,
  mouseUp: Tp,
  touchEnd: Lp,
  unknown: Ip
}), eE = ["refKey", "ref"], tE = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], nE = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], rE = ["refKey", "ref"], oE = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], aE = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(n) {
    function t(o) {
      var a;
      a = n.call(this, o) || this, a.id = a.props.id || "downshift-" + bp(), a.menuId = a.props.menuId || a.id + "-menu", a.labelId = a.props.labelId || a.id + "-label", a.inputId = a.props.inputId || a.id + "-input", a.getItemId = a.props.getItemId || function(b) {
        return a.id + "-item-" + b;
      }, a.items = [], a.itemCount = null, a.previousResultCount = 0, a.timeoutIds = [], a.internalSetTimeout = function(b, x) {
        var C = setTimeout(function() {
          a.timeoutIds = a.timeoutIds.filter(function(_) {
            return _ !== C;
          }), b();
        }, x);
        a.timeoutIds.push(C);
      }, a.setItemCount = function(b) {
        a.itemCount = b;
      }, a.unsetItemCount = function() {
        a.itemCount = null;
      }, a.isItemDisabled = function(b, x) {
        var C = a.getItemNodeFromIndex(x);
        return C && C.hasAttribute("disabled");
      }, a.setHighlightedIndex = function(b, x) {
        b === void 0 && (b = a.props.defaultHighlightedIndex), x === void 0 && (x = {}), x = kr(x), a.internalSetState(ce({
          highlightedIndex: b
        }, x));
      }, a.clearSelection = function(b) {
        a.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: a.props.defaultHighlightedIndex,
          isOpen: a.props.defaultIsOpen
        }, b);
      }, a.selectItem = function(b, x, C) {
        x = kr(x), a.internalSetState(ce({
          isOpen: a.props.defaultIsOpen,
          highlightedIndex: a.props.defaultHighlightedIndex,
          selectedItem: b,
          inputValue: a.props.itemToString(b)
        }, x), C);
      }, a.selectItemAtIndex = function(b, x, C) {
        var _ = a.items[b];
        _ != null && a.selectItem(_, x, C);
      }, a.selectHighlightedItem = function(b, x) {
        return a.selectItemAtIndex(a.getState().highlightedIndex, b, x);
      }, a.internalSetState = function(b, x) {
        var C, _, E = {}, D = typeof b == "function";
        return !D && b.hasOwnProperty("inputValue") && a.props.onInputValueChange(b.inputValue, ce({}, a.getStateAndHelpers(), b)), a.setState(function(T) {
          var S;
          T = a.getState(T);
          var N = D ? b(T) : b;
          N = a.props.stateReducer(T, N), C = N.hasOwnProperty("selectedItem");
          var k = {};
          return C && N.selectedItem !== T.selectedItem && (_ = N.selectedItem), (S = N).type || (S.type = Ip), Object.keys(N).forEach(function(Y) {
            T[Y] !== N[Y] && (E[Y] = N[Y]), Y !== "type" && (N[Y], io(a.props, Y) || (k[Y] = N[Y]));
          }), D && N.hasOwnProperty("inputValue") && a.props.onInputValueChange(N.inputValue, ce({}, a.getStateAndHelpers(), N)), k;
        }, function() {
          ju(x)();
          var T = Object.keys(E).length > 1;
          T && a.props.onStateChange(E, a.getStateAndHelpers()), C && a.props.onSelect(b.selectedItem, a.getStateAndHelpers()), _ !== void 0 && a.props.onChange(_, a.getStateAndHelpers()), a.props.onUserAction(E, a.getStateAndHelpers());
        });
      }, a.rootRef = function(b) {
        return a._rootNode = b;
      }, a.getRootProps = function(b, x) {
        var C, _ = b === void 0 ? {} : b, E = _.refKey, D = E === void 0 ? "ref" : E, T = _.ref, S = Ct(_, eE), N = x === void 0 ? {} : x, k = N.suppressRefError, Y = k === void 0 ? !1 : k;
        a.getRootProps.called = !0, a.getRootProps.refKey = D, a.getRootProps.suppressRefError = Y;
        var U = a.getState(), j = U.isOpen;
        return ce((C = {}, C[D] = Jt(T, a.rootRef), C.role = "combobox", C["aria-expanded"] = j, C["aria-haspopup"] = "listbox", C["aria-owns"] = j ? a.menuId : void 0, C["aria-labelledby"] = a.labelId, C), S);
      }, a.keyDownHandlers = {
        ArrowDown: function(x) {
          var C = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var _ = x.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(_, {
              type: Kr
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Kr
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var D = C.getState(), T = D.highlightedIndex, S = un(T, 1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(S, {
                  type: Kr
                });
              }
            });
        },
        ArrowUp: function(x) {
          var C = this;
          if (x.preventDefault(), this.getState().isOpen) {
            var _ = x.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(_, {
              type: Br
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: Br
            }, function() {
              var E = C.getItemCount();
              if (E > 0) {
                var D = C.getState(), T = D.highlightedIndex, S = un(T, -1, {
                  length: E
                }, C.isItemDisabled, !0);
                C.setHighlightedIndex(S, {
                  type: Br
                });
              }
            });
        },
        Enter: function(x) {
          if (x.which !== 229) {
            var C = this.getState(), _ = C.isOpen, E = C.highlightedIndex;
            if (_ && E != null) {
              x.preventDefault();
              var D = this.items[E], T = this.getItemNodeFromIndex(E);
              if (D == null || T && T.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Sp
              });
            }
          }
        },
        Escape: function(x) {
          x.preventDefault(), this.reset(ce({
            type: Pp
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, a.buttonKeyDownHandlers = ce({}, a.keyDownHandlers, {
        " ": function(x) {
          x.preventDefault(), this.toggleMenu({
            type: jp
          });
        }
      }), a.inputKeyDownHandlers = ce({}, a.keyDownHandlers, {
        Home: function(x) {
          var C = this.getState(), _ = C.isOpen;
          if (_) {
            x.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !_)) {
              var D = jn(0, !1, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(D, {
                type: Dp
              });
            }
          }
        },
        End: function(x) {
          var C = this.getState(), _ = C.isOpen;
          if (_) {
            x.preventDefault();
            var E = this.getItemCount();
            if (!(E <= 0 || !_)) {
              var D = jn(E - 1, !0, {
                length: E
              }, this.isItemDisabled);
              this.setHighlightedIndex(D, {
                type: Rp
              });
            }
          }
        }
      }), a.getToggleButtonProps = function(b) {
        var x = b === void 0 ? {} : b, C = x.onClick;
        x.onPress;
        var _ = x.onKeyDown, E = x.onKeyUp, D = x.onBlur, T = Ct(x, tE), S = a.getState(), N = S.isOpen, k = {
          onClick: ke(C, a.buttonHandleClick),
          onKeyDown: ke(_, a.buttonHandleKeyDown),
          onKeyUp: ke(E, a.buttonHandleKeyUp),
          onBlur: ke(D, a.buttonHandleBlur)
        }, Y = T.disabled ? {} : k;
        return ce({
          type: "button",
          role: "button",
          "aria-label": N ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, Y, T);
      }, a.buttonHandleKeyUp = function(b) {
        b.preventDefault();
      }, a.buttonHandleKeyDown = function(b) {
        var x = lr(b);
        a.buttonKeyDownHandlers[x] && a.buttonKeyDownHandlers[x].call(a, b);
      }, a.buttonHandleClick = function(b) {
        if (b.preventDefault(), a.props.environment) {
          var x = a.props.environment.document, C = x.body, _ = x.activeElement;
          C && C === _ && b.target.focus();
        }
        process.env.NODE_ENV === "test" ? a.toggleMenu({
          type: qa
        }) : a.internalSetTimeout(function() {
          return a.toggleMenu({
            type: qa
          });
        });
      }, a.buttonHandleBlur = function(b) {
        var x = b.target;
        a.internalSetTimeout(function() {
          if (!(a.isMouseDown || !a.props.environment)) {
            var C = a.props.environment.document.activeElement;
            (C == null || C.id !== a.inputId) && C !== x && a.reset({
              type: Ap
            });
          }
        });
      }, a.getLabelProps = function(b) {
        return ce({
          htmlFor: a.inputId,
          id: a.labelId
        }, b);
      }, a.getInputProps = function(b) {
        var x = b === void 0 ? {} : b, C = x.onKeyDown, _ = x.onBlur, E = x.onChange, D = x.onInput;
        x.onChangeText;
        var T = Ct(x, nE), S, N = {};
        S = "onChange";
        var k = a.getState(), Y = k.inputValue, U = k.isOpen, j = k.highlightedIndex;
        if (!T.disabled) {
          var oe;
          N = (oe = {}, oe[S] = ke(E, D, a.inputHandleChange), oe.onKeyDown = ke(C, a.inputHandleKeyDown), oe.onBlur = ke(_, a.inputHandleBlur), oe);
        }
        return ce({
          "aria-autocomplete": "list",
          "aria-activedescendant": U && typeof j == "number" && j >= 0 ? a.getItemId(j) : void 0,
          "aria-controls": U ? a.menuId : void 0,
          "aria-labelledby": T && T["aria-label"] ? void 0 : a.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: Y,
          id: a.inputId
        }, N, T);
      }, a.inputHandleKeyDown = function(b) {
        var x = lr(b);
        x && a.inputKeyDownHandlers[x] && a.inputKeyDownHandlers[x].call(a, b);
      }, a.inputHandleChange = function(b) {
        a.internalSetState({
          type: Op,
          isOpen: !0,
          inputValue: b.target.value,
          highlightedIndex: a.props.defaultHighlightedIndex
        });
      }, a.inputHandleBlur = function() {
        a.internalSetTimeout(function() {
          var b;
          if (!(a.isMouseDown || !a.props.environment)) {
            var x = a.props.environment.document.activeElement, C = (x == null || (b = x.dataset) == null ? void 0 : b.toggle) && a._rootNode && a._rootNode.contains(x);
            C || a.reset({
              type: Mp
            });
          }
        });
      }, a.menuRef = function(b) {
        a._menuNode = b;
      }, a.getMenuProps = function(b, x) {
        var C, _ = b === void 0 ? {} : b, E = _.refKey, D = E === void 0 ? "ref" : E, T = _.ref, S = Ct(_, rE), N = x === void 0 ? {} : x, k = N.suppressRefError, Y = k === void 0 ? !1 : k;
        return a.getMenuProps.called = !0, a.getMenuProps.refKey = D, a.getMenuProps.suppressRefError = Y, ce((C = {}, C[D] = Jt(T, a.menuRef), C.role = "listbox", C["aria-labelledby"] = S && S["aria-label"] ? void 0 : a.labelId, C.id = a.menuId, C), S);
      }, a.getItemProps = function(b) {
        var x, C = b === void 0 ? {} : b, _ = C.onMouseMove, E = C.onMouseDown, D = C.onClick;
        C.onPress;
        var T = C.index, S = C.item, N = S === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : zT("getItemProps", "item") : S, k = Ct(C, oE);
        T === void 0 ? (a.items.push(N), T = a.items.indexOf(N)) : a.items[T] = N;
        var Y = "onClick", U = D, j = (x = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: ke(_, function() {
            T !== a.getState().highlightedIndex && (a.setHighlightedIndex(T, {
              type: Ep
            }), a.avoidScrolling = !0, a.internalSetTimeout(function() {
              return a.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: ke(E, function(q) {
            q.preventDefault();
          })
        }, x[Y] = ke(U, function() {
          a.selectItemAtIndex(T, {
            type: Np
          });
        }), x), oe = k.disabled ? {
          onMouseDown: j.onMouseDown
        } : j;
        return ce({
          id: a.getItemId(T),
          role: "option",
          "aria-selected": a.getState().highlightedIndex === T
        }, oe, k);
      }, a.clearItems = function() {
        a.items = [];
      }, a.reset = function(b, x) {
        b === void 0 && (b = {}), b = kr(b), a.internalSetState(function(C) {
          var _ = C.selectedItem;
          return ce({
            isOpen: a.props.defaultIsOpen,
            highlightedIndex: a.props.defaultHighlightedIndex,
            inputValue: a.props.itemToString(_)
          }, b);
        }, x);
      }, a.toggleMenu = function(b, x) {
        b === void 0 && (b = {}), b = kr(b), a.internalSetState(function(C) {
          var _ = C.isOpen;
          return ce({
            isOpen: !_
          }, _ && {
            highlightedIndex: a.props.defaultHighlightedIndex
          }, b);
        }, function() {
          var C = a.getState(), _ = C.isOpen, E = C.highlightedIndex;
          _ && a.getItemCount() > 0 && typeof E == "number" && a.setHighlightedIndex(E, b), ju(x)();
        });
      }, a.openMenu = function(b) {
        a.internalSetState({
          isOpen: !0
        }, b);
      }, a.closeMenu = function(b) {
        a.internalSetState({
          isOpen: !1
        }, b);
      }, a.updateStatus = As(function() {
        var b;
        if ((b = a.props) != null && (b = b.environment) != null && b.document) {
          var x = a.getState(), C = a.items[x.highlightedIndex], _ = a.getItemCount(), E = a.props.getA11yStatusMessage(ce({
            itemToString: a.props.itemToString,
            previousResultCount: a.previousResultCount,
            resultCount: _,
            highlightedItem: C
          }, x));
          a.previousResultCount = _, Cp(E, a.props.environment.document);
        }
      }, 200);
      var i = a.props, s = i.defaultHighlightedIndex, c = i.initialHighlightedIndex, l = c === void 0 ? s : c, d = i.defaultIsOpen, f = i.initialIsOpen, p = f === void 0 ? d : f, m = i.initialInputValue, g = m === void 0 ? "" : m, h = i.initialSelectedItem, v = h === void 0 ? null : h, w = a.getState({
        highlightedIndex: l,
        isOpen: p,
        inputValue: g,
        selectedItem: v
      });
      return w.selectedItem != null && a.props.initialInputValue === void 0 && (w.inputValue = a.props.itemToString(w.selectedItem)), a.state = w, a;
    }
    mp(t, n);
    var r = t.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(a) {
        clearTimeout(a);
      }), this.timeoutIds = [];
    }, r.getState = function(a) {
      return a === void 0 && (a = this.state), ur(a, this.props);
    }, r.getItemCount = function() {
      var a = this.items.length;
      return this.itemCount != null ? a = this.itemCount : this.props.itemCount !== void 0 && (a = this.props.itemCount), a;
    }, r.getItemNodeFromIndex = function(a) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(a)) : null;
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var a = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(a, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(a, i) {
      var s = this.getItemCount(), c = this.getState(), l = c.highlightedIndex;
      if (s > 0) {
        var d = un(l, a, {
          length: s
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(d, i);
      }
    }, r.getStateAndHelpers = function() {
      var a = this.getState(), i = a.highlightedIndex, s = a.inputValue, c = a.selectedItem, l = a.isOpen, d = this.props.itemToString, f = this.id, p = this.getRootProps, m = this.getToggleButtonProps, g = this.getLabelProps, h = this.getMenuProps, v = this.getInputProps, w = this.getItemProps, b = this.openMenu, x = this.closeMenu, C = this.toggleMenu, _ = this.selectItem, E = this.selectItemAtIndex, D = this.selectHighlightedItem, T = this.setHighlightedIndex, S = this.clearSelection, N = this.clearItems, k = this.reset, Y = this.setItemCount, U = this.unsetItemCount, j = this.internalSetState;
      return {
        // prop getters
        getRootProps: p,
        getToggleButtonProps: m,
        getLabelProps: g,
        getMenuProps: h,
        getInputProps: v,
        getItemProps: w,
        // actions
        reset: k,
        openMenu: b,
        closeMenu: x,
        toggleMenu: C,
        selectItem: _,
        selectItemAtIndex: E,
        selectHighlightedItem: D,
        setHighlightedIndex: T,
        clearSelection: S,
        clearItems: N,
        setItemCount: Y,
        unsetItemCount: U,
        setState: j,
        // props
        itemToString: d,
        // derived
        id: f,
        // state
        highlightedIndex: i,
        inputValue: s,
        isOpen: l,
        selectedItem: c
      };
    }, r.componentDidMount = function() {
      var a = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && Lu(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          a.internalClearTimeouts();
        };
      else {
        var i = function() {
          a.isMouseDown = !0;
        }, s = function(m) {
          a.isMouseDown = !1;
          var g = so(m.target, [a._rootNode, a._menuNode], a.props.environment);
          !g && a.getState().isOpen && a.reset({
            type: Tp
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, c = function() {
          a.isTouchMove = !1;
        }, l = function() {
          a.isTouchMove = !0;
        }, d = function(m) {
          var g = so(m.target, [a._rootNode, a._menuNode], a.props.environment, !1);
          !a.isTouchMove && !g && a.getState().isOpen && a.reset({
            type: Lp
          }, function() {
            return a.props.onOuterClick(a.getStateAndHelpers());
          });
        }, f = this.props.environment;
        f.addEventListener("mousedown", i), f.addEventListener("mouseup", s), f.addEventListener("touchstart", c), f.addEventListener("touchmove", l), f.addEventListener("touchend", d), this.cleanup = function() {
          a.internalClearTimeouts(), a.updateStatus.cancel(), f.removeEventListener("mousedown", i), f.removeEventListener("mouseup", s), f.removeEventListener("touchstart", c), f.removeEventListener("touchmove", l), f.removeEventListener("touchend", d);
        };
      }
    }, r.shouldScroll = function(a, i) {
      var s = this.props.highlightedIndex === void 0 ? this.getState() : this.props, c = s.highlightedIndex, l = i.highlightedIndex === void 0 ? a : i, d = l.highlightedIndex, f = c && this.getState().isOpen && !a.isOpen, p = c !== d;
      return f || p;
    }, r.componentDidUpdate = function(a, i) {
      process.env.NODE_ENV !== "production" && (ks(this.state, a, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && Lu(this._menuNode, this.getMenuProps)), io(this.props, "selectedItem") && this.props.selectedItemChanged(a.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: kp,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(i, a) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var a = ku(this.props.children, ut);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var i = ku(a(this.getStateAndHelpers()));
      if (!i)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && iE(i, this.getRootProps), i;
      if (xp(i))
        return /* @__PURE__ */ pm(i, this.getRootProps(wp(i)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, t;
  }(hm);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: GT,
    itemToString: function(t) {
      return t == null ? "" : (process.env.NODE_ENV !== "production" && XT(t) && !t.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", t), String(t));
    },
    onStateChange: ut,
    onInputValueChange: ut,
    onUserAction: ut,
    onChange: ut,
    onSelect: ut,
    onOuterClick: ut,
    selectedItemChanged: function(t, r) {
      return t !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(t, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: yp
  }, e.stateChangeTypes = JT, e;
}();
process.env.NODE_ENV !== "production" && (aE.propTypes = {
  children: K.func,
  defaultHighlightedIndex: K.number,
  defaultIsOpen: K.bool,
  initialHighlightedIndex: K.number,
  initialSelectedItem: K.any,
  initialInputValue: K.string,
  initialIsOpen: K.bool,
  getA11yStatusMessage: K.func,
  itemToString: K.func,
  onChange: K.func,
  onSelect: K.func,
  onStateChange: K.func,
  onInputValueChange: K.func,
  onUserAction: K.func,
  onOuterClick: K.func,
  selectedItemChanged: K.func,
  stateReducer: K.func,
  itemCount: K.number,
  id: K.string,
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  suppressRefError: K.bool,
  scrollIntoView: K.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: K.any,
  isOpen: K.bool,
  inputValue: K.string,
  highlightedIndex: K.number,
  labelId: K.string,
  inputId: K.string,
  menuId: K.string,
  getItemId: K.func
  /* eslint-enable react/no-unused-prop-types */
});
function Lu(e, n) {
  var t = n.refKey;
  e || console.error('downshift: The ref prop "' + t + '" from getMenuProps was not applied correctly on your menu element.');
}
function iE(e, n) {
  var t = n.refKey, r = t !== "ref", o = !xp(e);
  o && !r && !Nu.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !o && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + t + '"'), !Nu.isForwardRef(e) && !wp(e)[t] && console.error('downshift: You must apply the ref prop "' + t + '" from getRootProps onto your root element.');
}
var $p = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function sE(e, n, t) {
  var r = e.props, o = e.type, a = {};
  Object.keys(n).forEach(function(i) {
    cE(i, e, n, t), t[i] !== n[i] && (a[i] = t[i]);
  }), r.onStateChange && Object.keys(a).length && r.onStateChange(ce({
    type: o
  }, a));
}
function cE(e, n, t, r) {
  var o = n.props, a = n.type, i = "on" + Ls(e) + "Change";
  o[i] && r[e] !== void 0 && r[e] !== t[e] && o[i](ce({
    type: a
  }, r));
}
function uE(e, n) {
  return n.changes;
}
var $u = As(function(e, n) {
  Cp(e, n);
}, 200), lE = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? ni : le, dE = "useId" in he ? function(n) {
  var t = n.id, r = n.labelId, o = n.menuId, a = n.getItemId, i = n.toggleButtonId, s = n.inputId, c = "downshift-" + he.useId();
  t || (t = c);
  var l = me({
    labelId: r || t + "-label",
    menuId: o || t + "-menu",
    getItemId: a || function(d) {
      return t + "-item-" + d;
    },
    toggleButtonId: i || t + "-toggle-button",
    inputId: s || t + "-input"
  });
  return l.current;
} : function(n) {
  var t = n.id, r = t === void 0 ? "downshift-" + bp() : t, o = n.labelId, a = n.menuId, i = n.getItemId, s = n.toggleButtonId, c = n.inputId, l = me({
    labelId: o || r + "-label",
    menuId: a || r + "-menu",
    getItemId: i || function(d) {
      return r + "-item-" + d;
    },
    toggleButtonId: s || r + "-toggle-button",
    inputId: c || r + "-input"
  });
  return l.current;
};
function Fp(e, n, t, r) {
  var o, a;
  if (e === void 0) {
    if (n === void 0)
      throw new Error(r);
    o = t[n], a = n;
  } else
    a = n === void 0 ? t.indexOf(e) : n, o = e;
  return [o, a];
}
function Ls(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function $s(e) {
  var n = me(e);
  return n.current = e, n;
}
function Vp(e, n, t, r) {
  var o = me(), a = me(), i = Pe(function(m, g) {
    a.current = g, m = ur(m, g.props);
    var h = e(m, g), v = g.props.stateReducer(m, ce({}, g, {
      changes: h
    }));
    return v;
  }, [e]), s = rl(i, n, t), c = s[0], l = s[1], d = $s(n), f = Pe(function(m) {
    return l(ce({
      props: d.current
    }, m));
  }, [d]), p = a.current;
  return le(function() {
    var m = ur(o.current, p == null ? void 0 : p.props), g = p && o.current && !r(m, c);
    g && sE(p, m, c), o.current = c;
  }, [c, p, r]), [c, f];
}
function fE(e, n, t, r) {
  var o = Vp(e, n, t, r), a = o[0], i = o[1];
  return [ur(a, n), i];
}
var nr = {
  itemToString: function(n) {
    return n ? String(n) : "";
  },
  itemToKey: function(n) {
    return n;
  },
  stateReducer: uE,
  scrollIntoView: yp,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Wt(e, n, t) {
  t === void 0 && (t = $p);
  var r = e["default" + Ls(n)];
  return r !== void 0 ? r : t[n];
}
function Pn(e, n, t) {
  t === void 0 && (t = $p);
  var r = e[n];
  if (r !== void 0)
    return r;
  var o = e["initial" + Ls(n)];
  return o !== void 0 ? o : Wt(e, n, t);
}
function pE(e) {
  var n = Pn(e, "selectedItem"), t = Pn(e, "isOpen"), r = gE(e), o = Pn(e, "inputValue");
  return {
    highlightedIndex: r < 0 && n && t ? e.items.findIndex(function(a) {
      return e.itemToKey(a) === e.itemToKey(n);
    }) : r,
    isOpen: t,
    selectedItem: n,
    inputValue: o
  };
}
function rr(e, n, t) {
  var r = e.items, o = e.initialHighlightedIndex, a = e.defaultHighlightedIndex, i = e.isItemDisabled, s = e.itemToKey, c = n.selectedItem, l = n.highlightedIndex;
  return r.length === 0 ? -1 : o !== void 0 && l === o && !i(r[o], o) ? o : a !== void 0 && !i(r[a], a) ? a : c ? r.findIndex(function(d) {
    return s(c) === s(d);
  }) : t < 0 && !i(r[r.length - 1], r.length - 1) ? r.length - 1 : t > 0 && !i(r[0], 0) ? 0 : -1;
}
function hE(e, n, t) {
  var r = me({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return le(function() {
    if (!e)
      return ut;
    var o = t.map(function(d) {
      return d.current;
    });
    function a() {
      r.current.isTouchEnd = !1, r.current.isMouseDown = !0;
    }
    function i(d) {
      r.current.isMouseDown = !1, so(d.target, o, e) || n();
    }
    function s() {
      r.current.isTouchEnd = !1, r.current.isTouchMove = !1;
    }
    function c() {
      r.current.isTouchMove = !0;
    }
    function l(d) {
      r.current.isTouchEnd = !0, !r.current.isTouchMove && !so(d.target, o, e, !1) && n();
    }
    return e.addEventListener("mousedown", a), e.addEventListener("mouseup", i), e.addEventListener("touchstart", s), e.addEventListener("touchmove", c), e.addEventListener("touchend", l), function() {
      e.removeEventListener("mousedown", a), e.removeEventListener("mouseup", i), e.removeEventListener("touchstart", s), e.removeEventListener("touchmove", c), e.removeEventListener("touchend", l);
    };
  }, [t, e, n]), r.current;
}
var Fs = function() {
  return ut;
};
process.env.NODE_ENV !== "production" && (Fs = function() {
  for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
    t[r] = arguments[r];
  var o = me(t.reduce(function(i, s) {
    return i[s] = {}, i;
  }, {}));
  le(function() {
    Object.keys(o.current).forEach(function(i) {
      var s = o.current[i];
      if (!Object.keys(s).length) {
        console.error("downshift: You forgot to call the " + i + " getter function on your component / element.");
        return;
      }
      var c = s.suppressRefError, l = s.refKey, d = s.elementRef;
      c || d != null && d.current || console.error('downshift: The ref prop "' + l + '" from ' + i + " was not applied correctly on your element.");
    });
  }, []);
  var a = Pe(function(i, s, c, l) {
    o.current[i] = {
      suppressRefError: s,
      refKey: c,
      elementRef: l
    };
  }, []);
  return a;
});
function Hp(e, n, t, r) {
  r === void 0 && (r = {});
  var o = r.document, a = Cr();
  le(function() {
    if (!(!e || a || !o)) {
      var i = e(n);
      $u(i, o);
    }
  }, t), le(function() {
    return function() {
      $u.cancel(), ZT(o);
    };
  }, [o]);
}
function mE(e) {
  var n = e.highlightedIndex, t = e.isOpen, r = e.itemRefs, o = e.getItemNodeFromIndex, a = e.menuElement, i = e.scrollIntoView, s = me(!0);
  return lE(function() {
    n < 0 || !t || !Object.keys(r.current).length || (s.current === !1 ? s.current = !0 : i(o(n), a));
  }, [n]), s;
}
var Vs = ut;
process.env.NODE_ENV !== "production" && (Vs = function(n) {
  var t = n.props, r = n.state, o = me(t), a = Cr();
  le(function() {
    a || (ks(r, o.current, t), o.current = t);
  }, [r, t, a]);
});
function Fu(e, n, t) {
  var r;
  t === void 0 && (t = !0);
  var o = ((r = e.items) == null ? void 0 : r.length) && n >= 0;
  return ce({
    isOpen: !1,
    highlightedIndex: -1
  }, o && ce({
    selectedItem: e.items[n],
    isOpen: Wt(e, "isOpen"),
    highlightedIndex: Wt(e, "highlightedIndex")
  }, t && {
    inputValue: e.itemToString(e.items[n])
  }));
}
function vE(e, n) {
  return e.isOpen === n.isOpen && e.inputValue === n.inputValue && e.highlightedIndex === n.highlightedIndex && e.selectedItem === n.selectedItem;
}
function Cr() {
  var e = he.useRef(!0);
  return he.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function Xa(e) {
  var n = Wt(e, "highlightedIndex");
  return n > -1 && e.isItemDisabled(e.items[n], n) ? -1 : n;
}
function gE(e) {
  var n = Pn(e, "highlightedIndex");
  return n > -1 && e.isItemDisabled(e.items[n], n) ? -1 : n;
}
var Yr = {
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  itemToString: K.func,
  itemToKey: K.func,
  stateReducer: K.func
}, Wp = ce({}, Yr, {
  getA11yStatusMessage: K.func,
  highlightedIndex: K.number,
  defaultHighlightedIndex: K.number,
  initialHighlightedIndex: K.number,
  isOpen: K.bool,
  defaultIsOpen: K.bool,
  initialIsOpen: K.bool,
  selectedItem: K.any,
  initialSelectedItem: K.any,
  defaultSelectedItem: K.any,
  id: K.string,
  labelId: K.string,
  menuId: K.string,
  getItemId: K.func,
  toggleButtonId: K.string,
  onSelectedItemChange: K.func,
  onHighlightedIndexChange: K.func,
  onStateChange: K.func,
  onIsOpenChange: K.func,
  scrollIntoView: K.func
});
function yE(e, n, t) {
  var r = n.type, o = n.props, a;
  switch (r) {
    case t.ItemMouseMove:
      a = {
        highlightedIndex: n.disabled ? -1 : n.index
      };
      break;
    case t.MenuMouseLeave:
      a = {
        highlightedIndex: -1
      };
      break;
    case t.ToggleButtonClick:
    case t.FunctionToggleMenu:
      a = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : rr(o, e, 0)
      };
      break;
    case t.FunctionOpenMenu:
      a = {
        isOpen: !0,
        highlightedIndex: rr(o, e, 0)
      };
      break;
    case t.FunctionCloseMenu:
      a = {
        isOpen: !1
      };
      break;
    case t.FunctionSetHighlightedIndex:
      a = {
        highlightedIndex: o.isItemDisabled(o.items[n.highlightedIndex], n.highlightedIndex) ? -1 : n.highlightedIndex
      };
      break;
    case t.FunctionSetInputValue:
      a = {
        inputValue: n.inputValue
      };
      break;
    case t.FunctionReset:
      a = {
        highlightedIndex: Xa(o),
        isOpen: Wt(o, "isOpen"),
        selectedItem: Wt(o, "selectedItem"),
        inputValue: Wt(o, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ce({}, e, a);
}
lt(lt({}, Wp), { items: K.array.isRequired, isItemDisabled: K.func });
lt(lt({}, nr), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Hs = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Ws = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Bs = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Ks = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Ys = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Us = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Gs = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, zs = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, qs = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, co = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Xs = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, Bp = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, Kp = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Qs = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, Yp = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, Up = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, Gp = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, zp = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, qp = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Zs = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Xp = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Qp = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, Js = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, Zp = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: Js,
  FunctionCloseMenu: zp,
  FunctionOpenMenu: Gp,
  FunctionReset: Qp,
  FunctionSelectItem: Zs,
  FunctionSetHighlightedIndex: qp,
  FunctionSetInputValue: Xp,
  FunctionToggleMenu: Up,
  InputBlur: co,
  InputChange: qs,
  InputClick: Xs,
  InputKeyDownArrowDown: Hs,
  InputKeyDownArrowUp: Ws,
  InputKeyDownEnd: Ys,
  InputKeyDownEnter: zs,
  InputKeyDownEscape: Bs,
  InputKeyDownHome: Ks,
  InputKeyDownPageDown: Gs,
  InputKeyDownPageUp: Us,
  ItemClick: Qs,
  ItemMouseMove: Kp,
  MenuMouseLeave: Bp,
  ToggleButtonClick: Yp
});
function bE(e) {
  var n = pE(e), t = n.selectedItem, r = n.inputValue;
  return r === "" && t && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(t)), ce({}, n, {
    inputValue: r
  });
}
var xE = ce({}, Wp, {
  items: K.array.isRequired,
  isItemDisabled: K.func,
  inputValue: K.string,
  defaultInputValue: K.string,
  initialInputValue: K.string,
  inputId: K.string,
  onInputValueChange: K.func
});
function wE(e, n, t, r) {
  var o = me(), a = Vp(e, n, t, r), i = a[0], s = a[1], c = Cr();
  return le(function() {
    if (io(n, "selectedItem")) {
      if (!c) {
        var l = n.itemToKey(n.selectedItem) !== n.itemToKey(o.current);
        l && s({
          type: Js,
          inputValue: n.itemToString(n.selectedItem)
        });
      }
      o.current = i.selectedItem === o.current ? n.selectedItem : i.selectedItem;
    }
  }, [i.selectedItem, n.selectedItem]), [ur(i, n), s];
}
var Jp = ut;
process.env.NODE_ENV !== "production" && (Jp = function(n, t) {
  K.checkPropTypes(xE, n, "prop", t.name);
});
var _E = ce({}, nr, {
  isItemDisabled: function() {
    return !1;
  }
});
function CE(e, n) {
  var t, r = n.type, o = n.props, a = n.altKey, i;
  switch (r) {
    case Qs:
      i = {
        isOpen: Wt(o, "isOpen"),
        highlightedIndex: Xa(o),
        selectedItem: o.items[n.index],
        inputValue: o.itemToString(o.items[n.index])
      };
      break;
    case Hs:
      e.isOpen ? i = {
        highlightedIndex: un(e.highlightedIndex, 1, o.items, o.isItemDisabled, !0)
      } : i = {
        highlightedIndex: a && e.selectedItem == null ? -1 : rr(o, e, 1),
        isOpen: o.items.length >= 0
      };
      break;
    case Ws:
      e.isOpen ? a ? i = Fu(o, e.highlightedIndex) : i = {
        highlightedIndex: un(e.highlightedIndex, -1, o.items, o.isItemDisabled, !0)
      } : i = {
        highlightedIndex: rr(o, e, -1),
        isOpen: o.items.length >= 0
      };
      break;
    case zs:
      i = Fu(o, e.highlightedIndex);
      break;
    case Bs:
      i = ce({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Us:
      i = {
        highlightedIndex: un(e.highlightedIndex, -10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Gs:
      i = {
        highlightedIndex: un(e.highlightedIndex, 10, o.items, o.isItemDisabled, !0)
      };
      break;
    case Ks:
      i = {
        highlightedIndex: jn(0, !1, o.items, o.isItemDisabled)
      };
      break;
    case Ys:
      i = {
        highlightedIndex: jn(o.items.length - 1, !0, o.items, o.isItemDisabled)
      };
      break;
    case co:
      i = ce({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((t = o.items) == null ? void 0 : t.length) && n.selectItem && {
        selectedItem: o.items[e.highlightedIndex],
        inputValue: o.itemToString(o.items[e.highlightedIndex])
      });
      break;
    case qs:
      i = {
        isOpen: !0,
        highlightedIndex: Xa(o),
        inputValue: n.inputValue
      };
      break;
    case Xs:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : rr(o, e, 0)
      };
      break;
    case Zs:
      i = {
        selectedItem: n.selectedItem,
        inputValue: o.itemToString(n.selectedItem)
      };
      break;
    case Js:
      i = {
        inputValue: n.inputValue
      };
      break;
    default:
      return yE(e, n, Zp);
  }
  return ce({}, e, i);
}
var IE = ["onMouseLeave", "refKey", "ref"], TE = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], EE = ["onClick", "onPress", "refKey", "ref"], PE = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
Ze.stateChangeTypes = Zp;
function Ze(e) {
  e === void 0 && (e = {}), Jp(e, Ze);
  var n = ce({}, _E, e), t = n.items, r = n.scrollIntoView, o = n.environment, a = n.getA11yStatusMessage, i = wE(CE, n, bE, vE), s = i[0], c = i[1], l = s.isOpen, d = s.highlightedIndex, f = s.selectedItem, p = s.inputValue, m = me(null), g = me({}), h = me(null), v = me(null), w = Cr(), b = dE(n), x = me(), C = $s({
    state: s,
    props: n
  }), _ = Pe(function(F) {
    return g.current[b.getItemId(F)];
  }, [b]);
  Hp(a, s, [l, d, f, p], o);
  var E = mE({
    menuElement: m.current,
    highlightedIndex: d,
    isOpen: l,
    itemRefs: g,
    scrollIntoView: r,
    getItemNodeFromIndex: _
  });
  Vs({
    props: n,
    state: s
  }), le(function() {
    var F = Pn(n, "isOpen");
    F && h.current && h.current.focus();
  }, []), le(function() {
    w || (x.current = t.length);
  });
  var D = hE(o, Pe(function() {
    C.current.state.isOpen && c({
      type: co,
      selectItem: !1
    });
  }, [c, C]), dt(function() {
    return [m, v, h];
  }, [m.current, v.current, h.current])), T = Fs("getInputProps", "getMenuProps");
  le(function() {
    l || (g.current = {});
  }, [l]), le(function() {
    var F;
    !l || !(o != null && o.document) || !(h != null && (F = h.current) != null && F.focus) || o.document.activeElement !== h.current && h.current.focus();
  }, [l, o]);
  var S = dt(function() {
    return {
      ArrowDown: function($) {
        $.preventDefault(), c({
          type: Hs,
          altKey: $.altKey
        });
      },
      ArrowUp: function($) {
        $.preventDefault(), c({
          type: Ws,
          altKey: $.altKey
        });
      },
      Home: function($) {
        C.current.state.isOpen && ($.preventDefault(), c({
          type: Ks
        }));
      },
      End: function($) {
        C.current.state.isOpen && ($.preventDefault(), c({
          type: Ys
        }));
      },
      Escape: function($) {
        var L = C.current.state;
        (L.isOpen || L.inputValue || L.selectedItem || L.highlightedIndex > -1) && ($.preventDefault(), c({
          type: Bs
        }));
      },
      Enter: function($) {
        var L = C.current.state;
        !L.isOpen || $.which === 229 || ($.preventDefault(), c({
          type: zs
        }));
      },
      PageUp: function($) {
        C.current.state.isOpen && ($.preventDefault(), c({
          type: Us
        }));
      },
      PageDown: function($) {
        C.current.state.isOpen && ($.preventDefault(), c({
          type: Gs
        }));
      }
    };
  }, [c, C]), N = Pe(function(F) {
    return ce({
      id: b.labelId,
      htmlFor: b.inputId
    }, F);
  }, [b]), k = Pe(function(F, $) {
    var L, G = F === void 0 ? {} : F, z = G.onMouseLeave, Q = G.refKey, J = Q === void 0 ? "ref" : Q, ee = G.ref, re = Ct(G, IE), de = $ === void 0 ? {} : $, W = de.suppressRefError, ye = W === void 0 ? !1 : W;
    return T("getMenuProps", ye, J, m), ce((L = {}, L[J] = Jt(ee, function(X) {
      m.current = X;
    }), L.id = b.menuId, L.role = "listbox", L["aria-labelledby"] = re && re["aria-label"] ? void 0 : "" + b.labelId, L.onMouseLeave = ke(z, function() {
      c({
        type: Bp
      });
    }), L), re);
  }, [c, T, b]), Y = Pe(function(F) {
    var $, L, G = F === void 0 ? {} : F, z = G.item, Q = G.index, J = G.refKey, ee = J === void 0 ? "ref" : J, re = G.ref, de = G.onMouseMove, W = G.onMouseDown, ye = G.onClick;
    G.onPress;
    var X = G.disabled, je = Ct(G, TE);
    X !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var Ae = C.current, at = Ae.props, Qe = Ae.state, ze = Fp(z, Q, at.items, "Pass either item or index to getItemProps!"), $t = ze[0], xe = ze[1], yt = at.isItemDisabled($t, xe), zn = "onClick", vn = ye, _t = function() {
      D.isTouchEnd || xe === Qe.highlightedIndex || (E.current = !1, c({
        type: Kp,
        index: xe,
        disabled: yt
      }));
    }, Dt = function() {
      c({
        type: Qs,
        index: xe
      });
    }, it = function(Pr) {
      return Pr.preventDefault();
    };
    return ce(($ = {}, $[ee] = Jt(re, function(pt) {
      pt && (g.current[b.getItemId(xe)] = pt);
    }), $["aria-disabled"] = yt, $["aria-selected"] = xe === Qe.highlightedIndex, $.id = b.getItemId(xe), $.role = "option", $), !yt && (L = {}, L[zn] = ke(vn, Dt), L), {
      onMouseMove: ke(de, _t),
      onMouseDown: ke(W, it)
    }, je);
  }, [c, b, C, D, E]), U = Pe(function(F) {
    var $, L = F === void 0 ? {} : F, G = L.onClick;
    L.onPress;
    var z = L.refKey, Q = z === void 0 ? "ref" : z, J = L.ref, ee = Ct(L, EE), re = C.current.state, de = function() {
      c({
        type: Yp
      });
    };
    return ce(($ = {}, $[Q] = Jt(J, function(W) {
      v.current = W;
    }), $["aria-controls"] = b.menuId, $["aria-expanded"] = re.isOpen, $.id = b.toggleButtonId, $.tabIndex = -1, $), !ee.disabled && ce({}, {
      onClick: ke(G, de)
    }), ee);
  }, [c, C, b]), j = Pe(function(F, $) {
    var L, G = F === void 0 ? {} : F, z = G.onKeyDown, Q = G.onChange, J = G.onInput, ee = G.onBlur;
    G.onChangeText;
    var re = G.onClick, de = G.refKey, W = de === void 0 ? "ref" : de, ye = G.ref, X = Ct(G, PE), je = $ === void 0 ? {} : $, Ae = je.suppressRefError, at = Ae === void 0 ? !1 : Ae;
    T("getInputProps", at, W, h);
    var Qe = C.current.state, ze = function(it) {
      var pt = lr(it);
      pt && S[pt] && S[pt](it);
    }, $t = function(it) {
      c({
        type: qs,
        inputValue: it.target.value
      });
    }, xe = function(it) {
      if (o != null && o.document && Qe.isOpen && !D.isMouseDown) {
        var pt = it.relatedTarget === null && o.document.activeElement !== o.document.body;
        c({
          type: co,
          selectItem: !pt
        });
      }
    }, yt = function() {
      c({
        type: Xs
      });
    }, zn = "onChange", vn = {};
    if (!X.disabled) {
      var _t;
      vn = (_t = {}, _t[zn] = ke(Q, J, $t), _t.onKeyDown = ke(z, ze), _t.onBlur = ke(ee, xe), _t.onClick = ke(re, yt), _t);
    }
    return ce((L = {}, L[W] = Jt(ye, function(Dt) {
      h.current = Dt;
    }), L["aria-activedescendant"] = Qe.isOpen && Qe.highlightedIndex > -1 ? b.getItemId(Qe.highlightedIndex) : "", L["aria-autocomplete"] = "list", L["aria-controls"] = b.menuId, L["aria-expanded"] = Qe.isOpen, L["aria-labelledby"] = X && X["aria-label"] ? void 0 : b.labelId, L.autoComplete = "off", L.id = b.inputId, L.role = "combobox", L.value = Qe.inputValue, L), vn, X);
  }, [c, b, o, S, C, D, T]), oe = Pe(function() {
    c({
      type: Up
    });
  }, [c]), q = Pe(function() {
    c({
      type: zp
    });
  }, [c]), O = Pe(function() {
    c({
      type: Gp
    });
  }, [c]), M = Pe(function(F) {
    c({
      type: qp,
      highlightedIndex: F
    });
  }, [c]), B = Pe(function(F) {
    c({
      type: Zs,
      selectedItem: F
    });
  }, [c]), R = Pe(function(F) {
    c({
      type: Xp,
      inputValue: F
    });
  }, [c]), V = Pe(function() {
    c({
      type: Qp
    });
  }, [c]);
  return {
    // prop getters.
    getItemProps: Y,
    getLabelProps: N,
    getMenuProps: k,
    getInputProps: j,
    getToggleButtonProps: U,
    // actions.
    toggleMenu: oe,
    openMenu: O,
    closeMenu: q,
    setHighlightedIndex: M,
    setInputValue: R,
    selectItem: B,
    reset: V,
    // state.
    highlightedIndex: d,
    isOpen: l,
    selectedItem: f,
    inputValue: p
  };
}
var eh = {
  activeIndex: -1,
  selectedItems: []
};
function Vu(e, n) {
  return Pn(e, n, eh);
}
function Hu(e, n) {
  return Wt(e, n, eh);
}
function SE(e) {
  var n = Vu(e, "activeIndex"), t = Vu(e, "selectedItems");
  return {
    activeIndex: n,
    selectedItems: t
  };
}
function Wu(e) {
  if (e.shiftKey || e.metaKey || e.ctrlKey || e.altKey)
    return !1;
  var n = e.target;
  return !(n instanceof HTMLInputElement && // if element is a text input
  n.value !== "" && // and we have text in it
  // and cursor is either not at the start or is currently highlighting text.
  (n.selectionStart !== 0 || n.selectionEnd !== 0));
}
function DE(e, n) {
  return e.selectedItems === n.selectedItems && e.activeIndex === n.activeIndex;
}
var RE = {
  stateReducer: Yr.stateReducer,
  itemToKey: Yr.itemToKey,
  environment: Yr.environment,
  selectedItems: K.array,
  initialSelectedItems: K.array,
  defaultSelectedItems: K.array,
  getA11yStatusMessage: K.func,
  activeIndex: K.number,
  initialActiveIndex: K.number,
  defaultActiveIndex: K.number,
  onActiveIndexChange: K.func,
  onSelectedItemsChange: K.func,
  keyNavigationNext: K.string,
  keyNavigationPrevious: K.string
}, NE = {
  itemToKey: nr.itemToKey,
  stateReducer: nr.stateReducer,
  environment: nr.environment,
  keyNavigationNext: "ArrowRight",
  keyNavigationPrevious: "ArrowLeft"
}, th = ut;
process.env.NODE_ENV !== "production" && (th = function(n, t) {
  K.checkPropTypes(RE, n, "prop", t.name);
});
var ec = process.env.NODE_ENV !== "production" ? "__selected_item_click__" : 0, tc = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_delete__" : 1, nc = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_backspace__" : 2, rc = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_next__" : 3, oc = process.env.NODE_ENV !== "production" ? "__selected_item_keydown_navigation_previous__" : 4, ac = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_navigation_previous__" : 5, ic = process.env.NODE_ENV !== "production" ? "__dropdown_keydown_backspace__" : 6, sc = process.env.NODE_ENV !== "production" ? "__dropdown_click__" : 7, cc = process.env.NODE_ENV !== "production" ? "__function_add_selected_item__" : 8, uc = process.env.NODE_ENV !== "production" ? "__function_remove_selected_item__" : 9, lc = process.env.NODE_ENV !== "production" ? "__function_set_selected_items__" : 10, dc = process.env.NODE_ENV !== "production" ? "__function_set_active_index__" : 11, fc = process.env.NODE_ENV !== "production" ? "__function_reset__" : 12, ME = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DropdownClick: sc,
  DropdownKeyDownBackspace: ic,
  DropdownKeyDownNavigationPrevious: ac,
  FunctionAddSelectedItem: cc,
  FunctionRemoveSelectedItem: uc,
  FunctionReset: fc,
  FunctionSetActiveIndex: dc,
  FunctionSetSelectedItems: lc,
  SelectedItemClick: ec,
  SelectedItemKeyDownBackspace: nc,
  SelectedItemKeyDownDelete: tc,
  SelectedItemKeyDownNavigationNext: rc,
  SelectedItemKeyDownNavigationPrevious: oc
});
function OE(e, n) {
  var t = n.type, r = n.index, o = n.props, a = n.selectedItem, i = e.activeIndex, s = e.selectedItems, c;
  switch (t) {
    case ec:
      c = {
        activeIndex: r
      };
      break;
    case oc:
      c = {
        activeIndex: i - 1 < 0 ? 0 : i - 1
      };
      break;
    case rc:
      c = {
        activeIndex: i + 1 >= s.length ? -1 : i + 1
      };
      break;
    case nc:
    case tc: {
      if (i < 0)
        break;
      var l = i;
      s.length === 1 ? l = -1 : i === s.length - 1 && (l = s.length - 2), c = ce({
        selectedItems: [].concat(s.slice(0, i), s.slice(i + 1))
      }, {
        activeIndex: l
      });
      break;
    }
    case ac:
      c = {
        activeIndex: s.length - 1
      };
      break;
    case ic:
      c = {
        selectedItems: s.slice(0, s.length - 1)
      };
      break;
    case cc:
      c = {
        selectedItems: [].concat(s, [a])
      };
      break;
    case sc:
      c = {
        activeIndex: -1
      };
      break;
    case uc: {
      var d = i, f = s.findIndex(function(g) {
        return o.itemToKey(g) === o.itemToKey(a);
      });
      if (f < 0)
        break;
      s.length === 1 ? d = -1 : f === s.length - 1 && (d = s.length - 2), c = {
        selectedItems: [].concat(s.slice(0, f), s.slice(f + 1)),
        activeIndex: d
      };
      break;
    }
    case lc: {
      var p = n.selectedItems;
      c = {
        selectedItems: p
      };
      break;
    }
    case dc: {
      var m = n.activeIndex;
      c = {
        activeIndex: m
      };
      break;
    }
    case fc:
      c = {
        activeIndex: Hu(o, "activeIndex"),
        selectedItems: Hu(o, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return ce({}, e, c);
}
var jE = ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"], AE = ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"];
cn.stateChangeTypes = ME;
function cn(e) {
  e === void 0 && (e = {}), th(e, cn);
  var n = ce({}, NE, e), t = n.getA11yStatusMessage, r = n.environment, o = n.keyNavigationNext, a = n.keyNavigationPrevious, i = fE(OE, n, SE, DE), s = i[0], c = i[1], l = s.activeIndex, d = s.selectedItems, f = Cr(), p = me(null), m = me();
  m.current = [];
  var g = $s({
    state: s,
    props: n
  });
  Hp(t, s, [l, d], r), le(function() {
    f || (l === -1 && p.current ? p.current.focus() : m.current[l] && m.current[l].focus());
  }, [l]), Vs({
    props: n,
    state: s
  });
  var h = Fs("getDropdownProps"), v = dt(function() {
    var S;
    return S = {}, S[a] = function() {
      c({
        type: oc
      });
    }, S[o] = function() {
      c({
        type: rc
      });
    }, S.Delete = function() {
      c({
        type: tc
      });
    }, S.Backspace = function() {
      c({
        type: nc
      });
    }, S;
  }, [c, o, a]), w = dt(function() {
    var S;
    return S = {}, S[a] = function(N) {
      Wu(N) && c({
        type: ac
      });
    }, S.Backspace = function(k) {
      Wu(k) && c({
        type: ic
      });
    }, S;
  }, [c, a]), b = Pe(function(S) {
    var N, k = S === void 0 ? {} : S, Y = k.refKey, U = Y === void 0 ? "ref" : Y, j = k.ref, oe = k.onClick, q = k.onKeyDown, O = k.selectedItem, M = k.index, B = Ct(k, jE), R = g.current.state, V = Fp(O, M, R.selectedItems, "Pass either item or index to getSelectedItemProps!"), F = V[1], $ = F > -1 && F === R.activeIndex, L = function() {
      c({
        type: ec,
        index: F
      });
    }, G = function(Q) {
      var J = lr(Q);
      J && v[J] && v[J](Q);
    };
    return ce((N = {}, N[U] = Jt(j, function(z) {
      z && m.current.push(z);
    }), N.tabIndex = $ ? 0 : -1, N.onClick = ke(oe, L), N.onKeyDown = ke(q, G), N), B);
  }, [c, g, v]), x = Pe(function(S, N) {
    var k, Y = S === void 0 ? {} : S, U = Y.refKey, j = U === void 0 ? "ref" : U, oe = Y.ref, q = Y.onKeyDown, O = Y.onClick, M = Y.preventKeyAction, B = M === void 0 ? !1 : M, R = Ct(Y, AE), V = N === void 0 ? {} : N, F = V.suppressRefError, $ = F === void 0 ? !1 : F;
    h("getDropdownProps", $, j, p);
    var L = function(Q) {
      var J = lr(Q);
      J && w[J] && w[J](Q);
    }, G = function() {
      c({
        type: sc
      });
    };
    return ce((k = {}, k[j] = Jt(oe, function(z) {
      z && (p.current = z);
    }), k), !B && {
      onKeyDown: ke(q, L),
      onClick: ke(O, G)
    }, R);
  }, [c, w, h]), C = Pe(function(S) {
    c({
      type: cc,
      selectedItem: S
    });
  }, [c]), _ = Pe(function(S) {
    c({
      type: uc,
      selectedItem: S
    });
  }, [c]), E = Pe(function(S) {
    c({
      type: lc,
      selectedItems: S
    });
  }, [c]), D = Pe(function(S) {
    c({
      type: dc,
      activeIndex: S
    });
  }, [c]), T = Pe(function() {
    c({
      type: fc
    });
  }, [c]);
  return {
    getSelectedItemProps: b,
    getDropdownProps: x,
    addSelectedItem: C,
    removeSelectedItem: _,
    setSelectedItems: E,
    setActiveIndex: D,
    reset: T,
    selectedItems: d,
    activeIndex: l
  };
}
function kE({
  children: e
}) {
  const n = qt(), t = n.selectedItems ?? [], { getSelectedItemProps: r, removeSelectedItem: o, getDropdownProps: a } = cn({
    selectedItems: t,
    onStateChange({ selectedItems: i, type: s }) {
      switch (s) {
        case cn.stateChangeTypes.SelectedItemKeyDownBackspace:
        case cn.stateChangeTypes.SelectedItemKeyDownDelete:
        case cn.stateChangeTypes.DropdownKeyDownBackspace:
        case cn.stateChangeTypes.FunctionRemoveSelectedItem:
          n.setSelectedItems(i);
          break;
      }
    }
  });
  return /* @__PURE__ */ u.jsx(
    pp.Provider,
    {
      value: { getSelectedItemProps: r, removeSelectedItem: o, getDropdownProps: a },
      children: e
    }
  );
}
const LE = [" ", "Enter", "ArrowUp", "ArrowDown"], $E = A(function({ size: n = "medium", className: t, placeholder: r, ...o }, a) {
  const i = qt(), s = hp(), { triggerRef: c, setTriggerRef: l } = Lo(), d = i.selectedItems ?? [], f = d.length > 0, p = gt();
  if (!s)
    throw new Error(
      "SelectWithTagsTrigger must be used inside SelectTagContext"
    );
  const { getSelectedItemProps: m, removeSelectedItem: g } = s;
  return /* @__PURE__ */ u.jsxs(
    mr,
    {
      ...o,
      className: P(
        "goat-Select",
        "goat-SelectWithTags",
        `goat-Select_${n}`,
        {
          "goat-SelectWithTags_WithTagsInside": f,
          "goat-Select_placeholder": !f,
          "goat-active": i.isOpen,
          "goat-invalid": p.touched && p.validity.valid === !1,
          "goat-disabled": i.disabled
        },
        t
      ),
      ...i.getToggleButtonProps({
        ref: gi(a, l),
        tabIndex: i.disabled ? -1 : 0,
        disabled: i.disabled,
        onKeyDown: (h) => {
          LE.includes(h.key) && !i.isOpen && c && c === h.target && (i.openMenu(), h.preventDefault());
        }
      }),
      children: [
        f ? /* @__PURE__ */ u.jsx("div", { className: "goat-SelectWithTags_Tags", children: d.map(
          function(v, w) {
            var b;
            return /* @__PURE__ */ u.jsx(
              lo,
              {
                children: (b = i.renderTag) == null ? void 0 : b.call(
                  i,
                  () => m({
                    selectedItem: v,
                    index: w,
                    disabled: i.disabled,
                    tabIndex: i.disabled ? -1 : 0
                  }),
                  (x) => {
                    x.stopPropagation(), g(v);
                  },
                  v
                )
              },
              `selected-item-${i.itemToString(
                v
              )}`
            );
          }
        ) }) : /* @__PURE__ */ u.jsx("span", { children: r }),
        /* @__PURE__ */ u.jsx(Ke, { as: fo, size: n })
      ]
    }
  );
});
function FE(e = "", n, t, r, o) {
  if (n) {
    const s = (r == null ? void 0 : r.length) === 0;
    return {
      labelNode: s ? e : `${o(r[0])}${r.length > 1 ? ` (+${r.length - 1})` : ""}`,
      isPlaceHolder: s
    };
  }
  const a = t === null;
  return {
    labelNode: a ? e : o(t),
    isPlaceHolder: a
  };
}
const VE = [" ", "Enter", "ArrowUp", "ArrowDown"], HE = A(
  function({
    className: n,
    placeholder: t,
    size: r = "medium",
    type: o = "button",
    ...a
  }, i) {
    const s = qt(), { setTriggerRef: c } = Lo(), l = s.selectedItems ?? [], { isPlaceHolder: d, labelNode: f } = FE(
      t,
      s.multiple,
      s.selectedItem,
      l,
      s.labelToNode
    ), p = gt();
    return /* @__PURE__ */ u.jsx(
      mr,
      {
        ...a,
        type: o,
        asChild: !0,
        className: P(
          "goat-Select",
          `goat-Select_${r}`,
          {
            "goat-active": s.isOpen,
            "goat-invalid": p.touched && p.validity.valid === !1,
            "goat-Select_placeholder": d
          },
          n
        ),
        ...s.getToggleButtonProps({
          ref: gi(i, c),
          disabled: s.disabled,
          tabIndex: 0,
          onKeyDown: (m) => {
            VE.includes(m.key) && !s.isOpen && (s.openMenu(), m.preventDefault());
          }
        }),
        children: /* @__PURE__ */ u.jsxs("button", { children: [
          f,
          /* @__PURE__ */ u.jsx(Ke, { as: fo, size: r, className: "goat-Select_Chevron" })
        ] })
      }
    );
  }
);
function WE(e, n) {
  const { changes: t, type: r } = n;
  switch (r) {
    case Ze.stateChangeTypes.ControlledPropUpdatedSelectedItem:
      return {
        ...t,
        inputValue: e.inputValue
      };
    case Ze.stateChangeTypes.ItemClick:
      return {
        ...t,
        inputValue: e.inputValue,
        isOpen: !0
        // keep menu open after selection.
      };
    case Ze.stateChangeTypes.InputKeyDownEnter:
      return {
        ...t,
        isOpen: !0,
        // keep menu open after selection.
        highlightedIndex: e.highlightedIndex,
        inputValue: e.inputValue
      };
    case Ze.stateChangeTypes.InputBlur:
      return {
        ...t,
        selectedItem: null,
        inputValue: ""
      };
    default:
      return t;
  }
}
function BE(e, n) {
  const { changes: t, type: r } = n;
  switch (r) {
    case Ze.stateChangeTypes.InputBlur:
    case Ze.stateChangeTypes.ControlledPropUpdatedSelectedItem:
    case Ze.stateChangeTypes.InputKeyDownEnter:
    case Ze.stateChangeTypes.InputKeyDownEscape:
    case Ze.stateChangeTypes.ToggleButtonClick:
    case Ze.stateChangeTypes.ItemClick:
      return {
        ...t,
        inputValue: ""
      };
    default:
      return t;
  }
}
function KE(e, n) {
  const t = [];
  for (let r = 0; r < e.length; r++)
    t.push(n(e[r]));
  return t.join(",");
}
function YE({
  valueToString: e,
  options: n,
  searchFilter: t,
  ...r
}, o) {
  const [a, i] = Ue({
    defaultProp: "",
    onChange: r.onInputChange,
    prop: r.inputValue
  }), [s, c] = Ue({
    defaultProp: r.defaultValue && Array.isArray(r.defaultValue) ? r.defaultValue : [],
    prop: Array.isArray(r.value) ? r.value : void 0,
    onChange: Array.isArray(r.value) ? r.onChange : void 0
  }), l = KE(n, e), d = dt(() => t ? n.filter(
    (p) => !a || t(p, a)
  ) : n, [l, a]);
  return {
    downshift: Ze({
      items: d,
      itemToString: e,
      defaultSelectedItem: r.multiple || Array.isArray(r.defaultValue) ? null : r.defaultValue,
      selectedItem: r.multiple || Array.isArray(r.value) ? null : r.value,
      stateReducer: r.multiple ? WE : BE,
      onInputValueChange({ inputValue: p = "" }) {
        i(p);
      },
      onIsOpenChange: (p) => {
        !p.isOpen && [
          Ze.stateChangeTypes.InputKeyDownEnter,
          Ze.stateChangeTypes.InputKeyDownEscape,
          Ze.stateChangeTypes.FunctionCloseMenu
        ].includes(p.type) && o && o.focus();
      },
      onSelectedItemChange: ({
        selectedItem: p
      }) => {
        var m;
        if (r.multiple) {
          if (!p || !s)
            return;
          const g = s.findIndex(
            (v) => e(v) === e(p)
          );
          let h = [];
          g > 0 ? h = [
            ...s.slice(0, g),
            ...s.slice(g + 1)
          ] : g === 0 ? h = s.slice(1) : h = [...s, p], c(h);
        } else {
          (m = r.onChange) == null || m.call(
            r,
            p
          );
          return;
        }
      }
    }),
    filteredItems: d,
    selectedItems: s,
    setSelectedItems: c
  };
}
const UE = ({
  className: e,
  noHover: n,
  children: t,
  ...r
}) => qt().isOpen ? /* @__PURE__ */ u.jsx(
  Un,
  {
    ...r,
    as: "div",
    className: P(e, "goat-SelectDummyItem", {
      "goat-SelectDummyItem__noHover": n
    }),
    children: t
  }
) : null;
function wt({
  children: e,
  disabled: n,
  labelToNode: t,
  renderTag: r,
  ...o
}) {
  const [a, i] = De(null), [s, c] = De(null), { downshift: l, filteredItems: d, selectedItems: f, setSelectedItems: p } = YE(o, s);
  return /* @__PURE__ */ u.jsx(Bi, { children: /* @__PURE__ */ u.jsx(
    fp.Provider,
    {
      value: { inputRef: a, triggerRef: s, setTriggerRef: c, setInputRef: i },
      children: /* @__PURE__ */ u.jsx(
        dp.Provider,
        {
          value: {
            ...l,
            selectedItems: f,
            setSelectedItems: p,
            isSearchable: !!o.searchFilter,
            renderTag: r,
            itemToString: o.valueToString,
            filteredItems: d,
            items: o.options,
            disabled: !!n,
            multiple: !!o.multiple,
            labelToNode: t
          },
          children: e
        }
      )
    }
  ) });
}
wt.displayName = "Select";
wt.Trigger = HE;
wt.Content = TT;
wt.CustomTrigger = ET;
wt.Input = PT;
wt.Label = ST;
wt.List = RT;
wt.Search = MT;
wt.TagContext = kE;
wt.TagsTrigger = $E;
wt.Layout = DT;
wt.DummyItem = UE;
const GE = A(function({ as: n = "div", children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-Sidebar__Content", r),
      ref: a,
      children: t
    }
  );
}), nh = Se({
  floating: !1,
  sidebarRef: null
}), pc = () => {
  const e = ve(nh);
  if (e === void 0)
    throw new Error("useSidebarContext must be used within a SidebarContext");
  return e;
}, rh = Se(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
), zE = () => {
  const e = ve(rh);
  if (e === void 0)
    throw new Error(
      "useSidebarContextSetFloating must be used within a SidebarContextSetFloating"
    );
  return e;
}, oh = Se(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
), qE = () => {
  const e = ve(oh);
  if (e === void 0)
    throw new Error(
      "useSidebarContextSetOpen must be used within a SidebarContextSetRef"
    );
  return e;
}, ah = Se(
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
), XE = () => {
  const e = ve(ah);
  if (e === void 0)
    throw new Error(
      "useSidebarContextFocusWithin must be used within a SidebarContextFocusWithin"
    );
  return e;
}, QE = A(function({ as: n = "div", children: t, className: r, label: o, ...a }, i) {
  return /* @__PURE__ */ u.jsxs(
    n,
    {
      ...a,
      className: P("goat-Sidebar__Group", r),
      ref: i,
      children: [
        o && /* @__PURE__ */ u.jsx("div", { className: "goat-Sidebar__GroupLabel", children: o }),
        /* @__PURE__ */ u.jsx("div", { className: "goat-Sidebar__List", children: t })
      ]
    }
  );
}), ZE = A(function({ as: n = "div", className: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...r,
      className: P("goat-Sidebar__Header", t),
      ref: o
    }
  );
}), JE = A(function({ active: n, as: t = "a", className: r, children: o, disabled: a, href: i, ...s }, c) {
  return /* @__PURE__ */ u.jsx(
    t,
    {
      ...s,
      className: P(
        "goat-Sidebar__Item",
        { "goat-active": n },
        { "goat-disabled": a },
        r
      ),
      href: a ? void 0 : i,
      ref: c,
      children: o
    }
  );
}), eP = A(
  function({ className: n, onClick: t, ariaLabelFloating: r, ariaLabelLocked: o, ...a }, i) {
    const s = pc(), c = zE(), l = (d) => {
      t == null || t(d), c(!s.floating), d.detail && (d.currentTarget.focus(), d.currentTarget.blur());
    };
    return /* @__PURE__ */ u.jsx(
      ft,
      {
        ...a,
        "aria-label": s.floating ? r : o,
        className: P("goat-Sidebar__Lock", n),
        icon: Tm,
        onClick: l,
        ref: i
      }
    );
  }
), tP = A(function({
  as: n = "button",
  avatar: t,
  avatarBgColor: r,
  children: o,
  className: a,
  company: i,
  name: s,
  ...c
}, l) {
  return /* @__PURE__ */ u.jsxs(
    n,
    {
      ...c,
      className: P("goat-Sidebar__Profile", a),
      ref: l,
      children: [
        /* @__PURE__ */ u.jsxs("div", { className: "goat-Sidebar__User", children: [
          /* @__PURE__ */ u.jsx(
            "div",
            {
              className: "goat-Sidebar__Avatar",
              style: { backgroundColor: r },
              children: t
            }
          ),
          /* @__PURE__ */ u.jsxs("div", { className: "goat-Sidebar__UserInfo", children: [
            /* @__PURE__ */ u.jsx("div", { children: s }),
            /* @__PURE__ */ u.jsx("div", { children: i })
          ] })
        ] }),
        /* @__PURE__ */ u.jsx("div", { className: "goat-Sidebar__ProfileList", children: o })
      ]
    }
  );
}), nP = A(function({ as: n = "nav", className: t, ...r }, o) {
  const [a, i] = De(null), s = pc(), c = fr(i, o), l = qE();
  return le(() => {
    l(a);
  }, [a, l]), /* @__PURE__ */ u.jsx(
    n,
    {
      ...r,
      className: P(
        "goat-Sidebar",
        { "goat-Sidebar_floating": s.floating },
        t
      ),
      tabIndex: -1,
      ref: c
    }
  );
}), rP = A(function({ as: n = ft, icon: t = Em, alwaysShow: r, onClick: o, ...a }, i) {
  const s = pc(), c = XE(), l = (d) => {
    o == null || o(d), c == null || c();
  };
  return s.floating || r ? /* @__PURE__ */ u.jsx(n, { ...a, icon: t, onClick: l, ref: i }) : null;
}), oP = A(function({ as: n = "div", children: t, className: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-Sidebar__Items", r),
      ref: a,
      children: t
    }
  );
}), Xt = ({
  children: e,
  floating: n,
  onFloatingChange: t
}) => {
  const [r, o] = De(!1), [a, i] = De(null);
  le(() => {
    n !== void 0 && n !== r && o(n);
  }, [r, n]);
  const s = Pe(
    (l) => {
      t ? t(l) : o(l);
    },
    [t]
  ), c = Pe(() => {
    a && a.focus();
  }, [a]);
  return /* @__PURE__ */ u.jsx(rh.Provider, { value: s, children: /* @__PURE__ */ u.jsx(oh.Provider, { value: i, children: /* @__PURE__ */ u.jsx(ah.Provider, { value: c, children: /* @__PURE__ */ u.jsx(nh.Provider, { value: { sidebarRef: a, floating: r }, children: e }) }) }) });
};
Xt.Content = GE;
Xt.Items = oP;
Xt.Group = QE;
Xt.Header = ZE;
Xt.Item = JE;
Xt.Lock = eP;
Xt.Profile = tP;
Xt.Root = nP;
Xt.Trigger = rP;
const aP = A(function({ children: n, className: t, sentiment: r = "neutral", contrast: o = "low", ...a }, i) {
  return /* @__PURE__ */ u.jsxs(
    Sn,
    {
      ...a,
      color: o === "low" ? "gray" : uv[r],
      variant: "contained",
      className: P("goat-StatusTag", `goat-StatusTag_${r}`, t),
      ref: i,
      children: [
        /* @__PURE__ */ u.jsx(
          bi,
          {
            contrast: r === "neutral" ? "low" : "high",
            sentiment: r
          }
        ),
        n
      ]
    }
  );
});
aP.Remove = wi;
const iP = ({
  children: e,
  className: n,
  columnSpan: t = "auto",
  ...r
}) => /* @__PURE__ */ u.jsx(
  "div",
  {
    ...r,
    className: P("goat-SummaryCell", n),
    style: {
      ...r.style,
      "--goat-summary-column-end": typeof t == "number" ? `span ${t}` : t
    },
    children: e
  }
), sP = ({
  children: e,
  className: n,
  ...t
}) => /* @__PURE__ */ u.jsx("dd", { ...t, className: P("goat-SummaryValue", n), children: e }), cP = ({
  children: e,
  className: n,
  ...t
}) => /* @__PURE__ */ u.jsx("dt", { ...t, className: P("goat-SummaryTitle", n), children: e }), hc = A(function({
  children: n,
  className: t,
  gap: r = Cl(6),
  columns: o = 8,
  minWidth: a = "80px",
  vertical: i = !1,
  list: s = !1,
  noBorder: c = !1,
  ...l
}, d) {
  return /* @__PURE__ */ u.jsx(
    "dl",
    {
      ...l,
      className: P(
        "goat-SummaryCard",
        { "goat-SummaryCard_vertical": i },
        { "goat-SummaryCard_list": s },
        { "goat-SummaryCard_noBorder": c },
        t
      ),
      style: {
        ...l.style,
        "--goat-summary-layout-gap": r,
        "--goat-summary-column-count": o,
        "--goat-summary-item--min-width": a
      },
      ref: d,
      children: n
    }
  );
});
hc.Title = cP;
hc.Cell = iP;
hc.Description = sP;
const uP = ({
  children: e,
  ...n
}) => /* @__PURE__ */ u.jsx(ji.Content, { ...n, children: e }), lP = ({
  children: e,
  triggerProps: n = {}
}) => /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
  e,
  /* @__PURE__ */ u.jsx("div", { className: "goat-SummaryCardCollapsibleToggle", children: /* @__PURE__ */ u.jsx(ji.Trigger, { variant: "ghost", ...n, children: /* @__PURE__ */ u.jsx(Ke, { as: fo }) }) })
] }), ih = ({ children: e, ...n }) => /* @__PURE__ */ u.jsx(ji.Root, { ...n, children: /* @__PURE__ */ u.jsx("div", { className: "goat-SummaryCardCollapsible", children: e }) });
ih.Collapsed = uP;
ih.Visible = lP;
function dP(e) {
  const n = y.useRef({ value: e, previous: e });
  return y.useMemo(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
var mc = "Switch", [fP, QD] = At(mc), [pP, hP] = fP(mc), sh = y.forwardRef(
  (e, n) => {
    const {
      __scopeSwitch: t,
      name: r,
      checked: o,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      form: d,
      ...f
    } = e, [p, m] = y.useState(null), g = Me(n, (x) => m(x)), h = y.useRef(!1), v = p ? d || !!p.closest("form") : !0, [w = !1, b] = Ue({
      prop: o,
      defaultProp: a,
      onChange: l
    });
    return /* @__PURE__ */ u.jsxs(pP, { scope: t, checked: w, disabled: s, children: [
      /* @__PURE__ */ u.jsx(
        se.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": i,
          "data-state": lh(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...f,
          ref: g,
          onClick: ne(e.onClick, (x) => {
            b((C) => !C), v && (h.current = x.isPropagationStopped(), h.current || x.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ u.jsx(
        mP,
        {
          control: p,
          bubbles: !h.current,
          name: r,
          value: c,
          checked: w,
          required: i,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
sh.displayName = mc;
var ch = "SwitchThumb", uh = y.forwardRef(
  (e, n) => {
    const { __scopeSwitch: t, ...r } = e, o = hP(ch, t);
    return /* @__PURE__ */ u.jsx(
      se.span,
      {
        "data-state": lh(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...r,
        ref: n
      }
    );
  }
);
uh.displayName = ch;
var mP = (e) => {
  const { control: n, checked: t, bubbles: r = !0, ...o } = e, a = y.useRef(null), i = dP(t), s = Td(n);
  return y.useEffect(() => {
    const c = a.current, l = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (i !== t && f) {
      const p = new Event("click", { bubbles: r });
      f.call(c, t), c.dispatchEvent(p);
    }
  }, [i, t, r]), /* @__PURE__ */ u.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: t,
      ...o,
      tabIndex: -1,
      ref: a,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function lh(e) {
  return e ? "checked" : "unchecked";
}
var vP = sh, gP = uh;
const yP = ({ checked: e, className: n, size: t, ...r }) => /* @__PURE__ */ u.jsx(
  gP,
  {
    ...r,
    className: P(
      "goat-Switch__Thumb",
      `goat-Switch__Thumb_${t}`,
      { "goat-Switch__Thumb_checked": e },
      n
    )
  }
), bP = ({
  checked: e,
  children: n,
  className: t,
  disabled: r,
  onChange: o,
  size: a,
  ...i
}) => /* @__PURE__ */ u.jsx(
  vP,
  {
    ...i,
    checked: e,
    className: P(
      "goat-Switch",
      `goat-Switch_${a}`,
      { "goat-Switch_checked": e },
      { "goat-Switch_disabled": r },
      t
    ),
    disabled: r,
    onCheckedChange: o,
    children: n
  }
), xP = ({ children: e, when: n }) => /* @__PURE__ */ u.jsx(u.Fragment, { children: n ? uo.toArray(e).reverse() : e }), ZD = ({
  children: e,
  labelPlacement: n = "before",
  onChange: t,
  size: r = "medium",
  disabled: o,
  id: a,
  ...i
}) => {
  const s = gt({ disabled: o, id: a });
  return /* @__PURE__ */ u.jsx(
    ws,
    {
      className: n !== "top" ? "goat-Label_coupled" : void 0,
      children: /* @__PURE__ */ u.jsxs(xP, { when: n === "after", children: [
        /* @__PURE__ */ u.jsx(
          rt,
          {
            color: n === "top" ? "gray-600" : void 0,
            type: n === "top" || r === "small" ? "body-small" : "body-medium",
            children: e
          }
        ),
        /* @__PURE__ */ u.jsx(
          bP,
          {
            ...i,
            id: s.id,
            disabled: s.disabled,
            onChange: t,
            size: r,
            children: /* @__PURE__ */ u.jsx(
              yP,
              {
                ...i,
                id: s.id,
                disabled: s.disabled,
                size: r
              }
            )
          }
        )
      ] })
    }
  );
}, Gn = Se({}), Ir = Se({}), Bu = "tbody", wP = A(function({ children: n, as: t, className: r, align: o, ...a }, i) {
  const s = ve(Gn), c = P("goat-TableBody", r), l = dt(
    () => ({ align: o, variant: "body" }),
    [o]
  ), d = t ?? (s != null && s.interactive ? "div" : Bu);
  return /* @__PURE__ */ u.jsx(Ir.Provider, { value: l, children: /* @__PURE__ */ u.jsx(
    d,
    {
      ...a,
      className: c,
      ref: i,
      role: d === Bu ? void 0 : "rowgroup",
      children: n
    }
  ) });
}), _P = ({
  as: e,
  interactive: n,
  isHeadCell: t
}) => {
  const r = t ? "columnheader" : "cell";
  return e ? { Component: e, role: r } : n ? { Component: "div", role: r } : { Component: t ? "th" : "td" };
}, dh = A(function({
  width: n = "auto",
  children: t,
  className: r,
  align: o,
  as: a,
  sentiment: i,
  style: s,
  ...c
}, l) {
  const d = ve(Ir), f = ve(Gn), p = (d == null ? void 0 : d.variant) === "head", m = (d == null ? void 0 : d.variant) === "foot", g = o ?? (d == null ? void 0 : d.align) ?? (f == null ? void 0 : f.align) ?? "left", { Component: h, role: v } = _P({
    as: a,
    interactive: f == null ? void 0 : f.interactive,
    isHeadCell: p
  }), w = P(
    "goat-TableCell",
    {
      "goat-TableCellHead": p,
      "goat-TableCellFoot": m
    },
    `goat-TableCell_align-${g}`,
    { "goat-TableCell_sentiment": !!i },
    { [`goat-TableCell_${i}`]: !!i },
    r
  );
  return /* @__PURE__ */ u.jsx(
    h,
    {
      ...c,
      style: { ...s, width: n },
      className: w,
      ref: l,
      role: v,
      children: t
    }
  );
}), CP = A(function({ className: n, checkboxProps: t, ...r }, o) {
  const a = P("goat-TableCellCheckbox", n);
  return /* @__PURE__ */ u.jsx(dh, { ...r, className: a, ref: o, children: /* @__PURE__ */ u.jsx(ws, { className: "goat-TableCheckbox", children: /* @__PURE__ */ u.jsx(Kl, { ...t }) }) });
}), Ku = "tfoot", IP = A(function({ children: n, as: t, className: r, align: o, ...a }, i) {
  const s = ve(Gn), c = P("goat-TableFooter", r), l = dt(
    () => ({ align: o, variant: "foot" }),
    [o]
  ), d = t ?? (s != null && s.interactive ? "div" : Ku);
  return /* @__PURE__ */ u.jsx(Ir.Provider, { value: l, children: /* @__PURE__ */ u.jsx(
    d,
    {
      ...a,
      className: c,
      ref: i,
      role: d === Ku ? void 0 : "rowgroup",
      children: n
    }
  ) });
}), Yu = "thead", TP = A(function({ children: n, as: t, align: r, className: o, ...a }, i) {
  const s = ve(Gn), c = P(
    "goat-TableHead",
    { "goat-TableHead_sticky": s == null ? void 0 : s.sticky },
    o
  ), l = dt(
    () => ({ align: r, variant: "head" }),
    [r]
  ), d = t ?? (s != null && s.interactive ? "div" : Yu);
  return /* @__PURE__ */ u.jsx(Ir.Provider, { value: l, children: /* @__PURE__ */ u.jsx(
    d,
    {
      ...a,
      className: c,
      ref: i,
      role: d === Yu ? void 0 : "rowgroup",
      children: n
    }
  ) });
}), EP = A(function({ children: n, as: t, className: r, ...o }, a) {
  const i = P("goat-TableLayout", r), s = t ?? "div";
  return /* @__PURE__ */ u.jsx(s, { ...o, className: i, ref: a, children: n });
}), Uu = "table", PP = A(function({
  children: n,
  className: t,
  align: r,
  sticky: o,
  noBorder: a,
  interactive: i,
  as: s,
  hover: c,
  tableLayout: l = "auto",
  style: d,
  ...f
}, p) {
  const m = P(
    "goat-TableRoot",
    { "goat-TableRoot_noBorder": a },
    t
  ), g = dt(
    () => ({ align: r, hover: c, interactive: i, sticky: o }),
    [r, c, i, o]
  ), h = s ?? (g != null && g.interactive ? "div" : Uu);
  return /* @__PURE__ */ u.jsx(Gn.Provider, { value: g, children: /* @__PURE__ */ u.jsx(
    h,
    {
      ...f,
      style: { ...d, "--goat-table-layout": l },
      className: m,
      ref: p,
      role: h === Uu ? void 0 : "table",
      children: n
    }
  ) });
}), Gu = "tr", SP = A(function({ as: n, children: t, className: r, isSelected: o, ...a }, i) {
  const s = ve(Gn), c = ve(Ir), l = (c == null ? void 0 : c.variant) === "head", d = s == null ? void 0 : s.hover, f = P(
    "goat-TableRow",
    { "goat-TableRow_hover": !l && d },
    { "goat-TableRow_selected": !l && o },
    r
  ), p = n ?? (s != null && s.interactive ? "div" : Gu);
  return /* @__PURE__ */ u.jsx(
    p,
    {
      ...a,
      className: f,
      ref: i,
      role: p === Gu ? void 0 : "row",
      children: t
    }
  );
}), DP = wP, RP = dh, NP = TP, MP = SP, OP = EP, jP = PP, AP = IP, kP = CP, Lr = {
  Body: DP,
  Cell: RP,
  Head: NP,
  Layout: OP,
  Row: MP,
  Root: jP,
  Checkbox: kP,
  Footer: AP
};
var vc = "Tabs", [LP, JD] = At(vc, [
  Kn
]), fh = Kn(), [$P, gc] = LP(vc), ph = y.forwardRef(
  (e, n) => {
    const {
      __scopeTabs: t,
      value: r,
      onValueChange: o,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: c = "automatic",
      ...l
    } = e, d = dr(s), [f, p] = Ue({
      prop: r,
      onChange: o,
      defaultProp: a
    });
    return /* @__PURE__ */ u.jsx(
      $P,
      {
        scope: t,
        baseId: It(),
        value: f,
        onValueChange: p,
        orientation: i,
        dir: d,
        activationMode: c,
        children: /* @__PURE__ */ u.jsx(
          se.div,
          {
            dir: d,
            "data-orientation": i,
            ...l,
            ref: n
          }
        )
      }
    );
  }
);
ph.displayName = vc;
var hh = "TabsList", mh = y.forwardRef(
  (e, n) => {
    const { __scopeTabs: t, loop: r = !0, ...o } = e, a = gc(hh, t), i = fh(t);
    return /* @__PURE__ */ u.jsx(
      ys,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: r,
        children: /* @__PURE__ */ u.jsx(
          se.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...o,
            ref: n
          }
        )
      }
    );
  }
);
mh.displayName = hh;
var vh = "TabsTrigger", gh = y.forwardRef(
  (e, n) => {
    const { __scopeTabs: t, value: r, disabled: o = !1, ...a } = e, i = gc(vh, t), s = fh(t), c = xh(i.baseId, r), l = wh(i.baseId, r), d = r === i.value;
    return /* @__PURE__ */ u.jsx(
      bs,
      {
        asChild: !0,
        ...s,
        focusable: !o,
        active: d,
        children: /* @__PURE__ */ u.jsx(
          se.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": d,
            "aria-controls": l,
            "data-state": d ? "active" : "inactive",
            "data-disabled": o ? "" : void 0,
            disabled: o,
            id: c,
            ...a,
            ref: n,
            onMouseDown: ne(e.onMouseDown, (f) => {
              !o && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(r) : f.preventDefault();
            }),
            onKeyDown: ne(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && i.onValueChange(r);
            }),
            onFocus: ne(e.onFocus, () => {
              const f = i.activationMode !== "manual";
              !d && !o && f && i.onValueChange(r);
            })
          }
        )
      }
    );
  }
);
gh.displayName = vh;
var yh = "TabsContent", bh = y.forwardRef(
  (e, n) => {
    const { __scopeTabs: t, value: r, forceMount: o, children: a, ...i } = e, s = gc(yh, t), c = xh(s.baseId, r), l = wh(s.baseId, r), d = r === s.value, f = y.useRef(d);
    return y.useEffect(() => {
      const p = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(p);
    }, []), /* @__PURE__ */ u.jsx(nt, { present: o || d, children: ({ present: p }) => /* @__PURE__ */ u.jsx(
      se.div,
      {
        "data-state": d ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": c,
        hidden: !p,
        id: l,
        tabIndex: 0,
        ...i,
        ref: n,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: p && a
      }
    ) });
  }
);
bh.displayName = yh;
function xh(e, n) {
  return `${e}-trigger-${n}`;
}
function wh(e, n) {
  return `${e}-content-${n}`;
}
const FP = A(function({ as: n = "div", value: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx(bh, { asChild: !0, value: t, children: /* @__PURE__ */ u.jsx(n, { ...r, ref: o }) });
}), VP = A(function({ as: n = "button", className: t, value: r, ...o }, a) {
  return /* @__PURE__ */ u.jsx(gh, { asChild: !0, value: r, children: /* @__PURE__ */ u.jsx(
    n,
    {
      ...o,
      className: P("goat-Tabs__Trigger", t),
      ref: a
    }
  ) });
}), _h = Se(
  {}
), HP = _h.Provider, WP = (e, n) => ve(_h).set(e, n), eR = A(function({ children: n, label: t, ...r }, o) {
  const a = me(""), i = Pe(
    () => /* @__PURE__ */ u.jsx(FP, { value: a.current, children: n }),
    [n]
  );
  return WP(a, i), /* @__PURE__ */ u.jsx(VP, { ...r, ref: o, value: a.current, children: t });
}), BP = A(function({ as: n = "div", className: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx(mh, { asChild: !0, children: /* @__PURE__ */ u.jsx(
    n,
    {
      ...r,
      className: P("goat-Tabs__List", t),
      ref: o
    }
  ) });
}), KP = A(function({
  as: n = "div",
  className: t,
  defaultValue: r,
  onValueChange: o,
  size: a = "medium",
  value: i,
  noGap: s,
  ...c
}, l) {
  return /* @__PURE__ */ u.jsx(
    ph,
    {
      asChild: !0,
      defaultValue: r,
      onValueChange: o,
      value: i,
      children: /* @__PURE__ */ u.jsx(
        n,
        {
          ...c,
          className: P(
            "goat-Tabs",
            `goat-Tabs_${a}`,
            { "goat-Tabs_noGap": s },
            t
          ),
          ref: l
        }
      )
    }
  );
}), zu = "~", tR = A(function({ children: n, defaultTab: t = 0, ...r }, o) {
  const a = me(/* @__PURE__ */ new Map()), i = Cv(Il());
  return /* @__PURE__ */ u.jsx(
    HP,
    {
      value: {
        set(s, c) {
          s.current || (s.current = a.current.size === t ? zu : String(a.current.size)), c !== a.current.get(s.current) && (a.current.set(s.current, c), i());
        }
      },
      children: /* @__PURE__ */ u.jsxs(KP, { ...r, defaultValue: zu, ref: o, children: [
        /* @__PURE__ */ u.jsx(BP, { children: n }),
        [...a.current].map(([s, c]) => /* @__PURE__ */ u.jsx(lo, { children: c() }, s))
      ] })
    }
  );
});
var YP = "VisuallyHidden", $o = y.forwardRef(
  (e, n) => /* @__PURE__ */ u.jsx(
    se.span,
    {
      ...e,
      ref: n,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
$o.displayName = YP;
var UP = $o, yc = "ToastProvider", [bc, GP, zP] = ho("Toast"), [Ch, nR] = At("Toast", [zP]), [qP, Fo] = Ch(yc), Ih = (e) => {
  const {
    __scopeToast: n,
    label: t = "Notification",
    duration: r = 5e3,
    swipeDirection: o = "right",
    swipeThreshold: a = 50,
    children: i
  } = e, [s, c] = y.useState(null), [l, d] = y.useState(0), f = y.useRef(!1), p = y.useRef(!1);
  return t.trim() || console.error(
    `Invalid prop \`label\` supplied to \`${yc}\`. Expected non-empty \`string\`.`
  ), /* @__PURE__ */ u.jsx(bc.Provider, { scope: n, children: /* @__PURE__ */ u.jsx(
    qP,
    {
      scope: n,
      label: t,
      duration: r,
      swipeDirection: o,
      swipeThreshold: a,
      toastCount: l,
      viewport: s,
      onViewportChange: c,
      onToastAdd: y.useCallback(() => d((m) => m + 1), []),
      onToastRemove: y.useCallback(() => d((m) => m - 1), []),
      isFocusedToastEscapeKeyDownRef: f,
      isClosePausedRef: p,
      children: i
    }
  ) });
};
Ih.displayName = yc;
var Th = "ToastViewport", XP = ["F8"], Qa = "toast.viewportPause", Za = "toast.viewportResume", Eh = y.forwardRef(
  (e, n) => {
    const {
      __scopeToast: t,
      hotkey: r = XP,
      label: o = "Notifications ({hotkey})",
      ...a
    } = e, i = Fo(Th, t), s = GP(t), c = y.useRef(null), l = y.useRef(null), d = y.useRef(null), f = y.useRef(null), p = Me(n, f, i.onViewportChange), m = r.join("+").replace(/Key/g, "").replace(/Digit/g, ""), g = i.toastCount > 0;
    y.useEffect(() => {
      const v = (w) => {
        var x;
        r.length !== 0 && r.every((C) => w[C] || w.code === C) && ((x = f.current) == null || x.focus());
      };
      return document.addEventListener("keydown", v), () => document.removeEventListener("keydown", v);
    }, [r]), y.useEffect(() => {
      const v = c.current, w = f.current;
      if (g && v && w) {
        const b = () => {
          if (!i.isClosePausedRef.current) {
            const E = new CustomEvent(Qa);
            w.dispatchEvent(E), i.isClosePausedRef.current = !0;
          }
        }, x = () => {
          if (i.isClosePausedRef.current) {
            const E = new CustomEvent(Za);
            w.dispatchEvent(E), i.isClosePausedRef.current = !1;
          }
        }, C = (E) => {
          !v.contains(E.relatedTarget) && x();
        }, _ = () => {
          v.contains(document.activeElement) || x();
        };
        return v.addEventListener("focusin", b), v.addEventListener("focusout", C), v.addEventListener("pointermove", b), v.addEventListener("pointerleave", _), window.addEventListener("blur", b), window.addEventListener("focus", x), () => {
          v.removeEventListener("focusin", b), v.removeEventListener("focusout", C), v.removeEventListener("pointermove", b), v.removeEventListener("pointerleave", _), window.removeEventListener("blur", b), window.removeEventListener("focus", x);
        };
      }
    }, [g, i.isClosePausedRef]);
    const h = y.useCallback(
      ({ tabbingDirection: v }) => {
        const b = s().map((x) => {
          const C = x.ref.current, _ = [C, ...uS(C)];
          return v === "forwards" ? _ : _.reverse();
        });
        return (v === "forwards" ? b.reverse() : b).flat();
      },
      [s]
    );
    return y.useEffect(() => {
      const v = f.current;
      if (v) {
        const w = (b) => {
          var _, E, D;
          const x = b.altKey || b.ctrlKey || b.metaKey;
          if (b.key === "Tab" && !x) {
            const T = document.activeElement, S = b.shiftKey;
            if (b.target === v && S) {
              (_ = l.current) == null || _.focus();
              return;
            }
            const Y = h({ tabbingDirection: S ? "backwards" : "forwards" }), U = Y.findIndex((j) => j === T);
            Ea(Y.slice(U + 1)) ? b.preventDefault() : S ? (E = l.current) == null || E.focus() : (D = d.current) == null || D.focus();
          }
        };
        return v.addEventListener("keydown", w), () => v.removeEventListener("keydown", w);
      }
    }, [s, h]), /* @__PURE__ */ u.jsxs(
      lg,
      {
        ref: c,
        role: "region",
        "aria-label": o.replace("{hotkey}", m),
        tabIndex: -1,
        style: { pointerEvents: g ? void 0 : "none" },
        children: [
          g && /* @__PURE__ */ u.jsx(
            Ja,
            {
              ref: l,
              onFocusFromOutsideViewport: () => {
                const v = h({
                  tabbingDirection: "forwards"
                });
                Ea(v);
              }
            }
          ),
          /* @__PURE__ */ u.jsx(bc.Slot, { scope: t, children: /* @__PURE__ */ u.jsx(se.ol, { tabIndex: -1, ...a, ref: p }) }),
          g && /* @__PURE__ */ u.jsx(
            Ja,
            {
              ref: d,
              onFocusFromOutsideViewport: () => {
                const v = h({
                  tabbingDirection: "backwards"
                });
                Ea(v);
              }
            }
          )
        ]
      }
    );
  }
);
Eh.displayName = Th;
var Ph = "ToastFocusProxy", Ja = y.forwardRef(
  (e, n) => {
    const { __scopeToast: t, onFocusFromOutsideViewport: r, ...o } = e, a = Fo(Ph, t);
    return /* @__PURE__ */ u.jsx(
      $o,
      {
        "aria-hidden": !0,
        tabIndex: 0,
        ...o,
        ref: n,
        style: { position: "fixed" },
        onFocus: (i) => {
          var l;
          const s = i.relatedTarget;
          !((l = a.viewport) != null && l.contains(s)) && r();
        }
      }
    );
  }
);
Ja.displayName = Ph;
var Vo = "Toast", QP = "toast.swipeStart", ZP = "toast.swipeMove", JP = "toast.swipeCancel", eS = "toast.swipeEnd", Sh = y.forwardRef(
  (e, n) => {
    const { forceMount: t, open: r, defaultOpen: o, onOpenChange: a, ...i } = e, [s = !0, c] = Ue({
      prop: r,
      defaultProp: o,
      onChange: a
    });
    return /* @__PURE__ */ u.jsx(nt, { present: t || s, children: /* @__PURE__ */ u.jsx(
      rS,
      {
        open: s,
        ...i,
        ref: n,
        onClose: () => c(!1),
        onPause: tt(e.onPause),
        onResume: tt(e.onResume),
        onSwipeStart: ne(e.onSwipeStart, (l) => {
          l.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: ne(e.onSwipeMove, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "move"), l.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${f}px`);
        }),
        onSwipeCancel: ne(e.onSwipeCancel, (l) => {
          l.currentTarget.setAttribute("data-swipe", "cancel"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: ne(e.onSwipeEnd, (l) => {
          const { x: d, y: f } = l.detail.delta;
          l.currentTarget.setAttribute("data-swipe", "end"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), l.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), l.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${d}px`), l.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${f}px`), c(!1);
        })
      }
    ) });
  }
);
Sh.displayName = Vo;
var [tS, nS] = Ch(Vo, {
  onClose() {
  }
}), rS = y.forwardRef(
  (e, n) => {
    const {
      __scopeToast: t,
      type: r = "foreground",
      duration: o,
      open: a,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: c,
      onResume: l,
      onSwipeStart: d,
      onSwipeMove: f,
      onSwipeCancel: p,
      onSwipeEnd: m,
      ...g
    } = e, h = Fo(Vo, t), [v, w] = y.useState(null), b = Me(n, (j) => w(j)), x = y.useRef(null), C = y.useRef(null), _ = o || h.duration, E = y.useRef(0), D = y.useRef(_), T = y.useRef(0), { onToastAdd: S, onToastRemove: N } = h, k = tt(() => {
      var oe;
      (v == null ? void 0 : v.contains(document.activeElement)) && ((oe = h.viewport) == null || oe.focus()), i();
    }), Y = y.useCallback(
      (j) => {
        !j || j === 1 / 0 || (window.clearTimeout(T.current), E.current = (/* @__PURE__ */ new Date()).getTime(), T.current = window.setTimeout(k, j));
      },
      [k]
    );
    y.useEffect(() => {
      const j = h.viewport;
      if (j) {
        const oe = () => {
          Y(D.current), l == null || l();
        }, q = () => {
          const O = (/* @__PURE__ */ new Date()).getTime() - E.current;
          D.current = D.current - O, window.clearTimeout(T.current), c == null || c();
        };
        return j.addEventListener(Qa, q), j.addEventListener(Za, oe), () => {
          j.removeEventListener(Qa, q), j.removeEventListener(Za, oe);
        };
      }
    }, [h.viewport, _, c, l, Y]), y.useEffect(() => {
      a && !h.isClosePausedRef.current && Y(_);
    }, [a, _, h.isClosePausedRef, Y]), y.useEffect(() => (S(), () => N()), [S, N]);
    const U = y.useMemo(() => v ? Ah(v) : null, [v]);
    return h.viewport ? /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
      U && /* @__PURE__ */ u.jsx(
        oS,
        {
          __scopeToast: t,
          role: "status",
          "aria-live": r === "foreground" ? "assertive" : "polite",
          "aria-atomic": !0,
          children: U
        }
      ),
      /* @__PURE__ */ u.jsx(tS, { scope: t, onClose: k, children: ri.createPortal(
        /* @__PURE__ */ u.jsx(bc.ItemSlot, { scope: t, children: /* @__PURE__ */ u.jsx(
          ug,
          {
            asChild: !0,
            onEscapeKeyDown: ne(s, () => {
              h.isFocusedToastEscapeKeyDownRef.current || k(), h.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ u.jsx(
              se.li,
              {
                role: "status",
                "aria-live": "off",
                "aria-atomic": !0,
                tabIndex: 0,
                "data-state": a ? "open" : "closed",
                "data-swipe-direction": h.swipeDirection,
                ...g,
                ref: b,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: ne(e.onKeyDown, (j) => {
                  j.key === "Escape" && (s == null || s(j.nativeEvent), j.nativeEvent.defaultPrevented || (h.isFocusedToastEscapeKeyDownRef.current = !0, k()));
                }),
                onPointerDown: ne(e.onPointerDown, (j) => {
                  j.button === 0 && (x.current = { x: j.clientX, y: j.clientY });
                }),
                onPointerMove: ne(e.onPointerMove, (j) => {
                  if (!x.current) return;
                  const oe = j.clientX - x.current.x, q = j.clientY - x.current.y, O = !!C.current, M = ["left", "right"].includes(h.swipeDirection), B = ["left", "up"].includes(h.swipeDirection) ? Math.min : Math.max, R = M ? B(0, oe) : 0, V = M ? 0 : B(0, q), F = j.pointerType === "touch" ? 10 : 2, $ = { x: R, y: V }, L = { originalEvent: j, delta: $ };
                  O ? (C.current = $, $r(ZP, f, L, {
                    discrete: !1
                  })) : qu($, h.swipeDirection, F) ? (C.current = $, $r(QP, d, L, {
                    discrete: !1
                  }), j.target.setPointerCapture(j.pointerId)) : (Math.abs(oe) > F || Math.abs(q) > F) && (x.current = null);
                }),
                onPointerUp: ne(e.onPointerUp, (j) => {
                  const oe = C.current, q = j.target;
                  if (q.hasPointerCapture(j.pointerId) && q.releasePointerCapture(j.pointerId), C.current = null, x.current = null, oe) {
                    const O = j.currentTarget, M = { originalEvent: j, delta: oe };
                    qu(oe, h.swipeDirection, h.swipeThreshold) ? $r(eS, m, M, {
                      discrete: !0
                    }) : $r(
                      JP,
                      p,
                      M,
                      {
                        discrete: !0
                      }
                    ), O.addEventListener("click", (B) => B.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        h.viewport
      ) })
    ] }) : null;
  }
), oS = (e) => {
  const { __scopeToast: n, children: t, ...r } = e, o = Fo(Vo, n), [a, i] = y.useState(!1), [s, c] = y.useState(!1);
  return sS(() => i(!0)), y.useEffect(() => {
    const l = window.setTimeout(() => c(!0), 1e3);
    return () => window.clearTimeout(l);
  }, []), s ? null : /* @__PURE__ */ u.jsx($n, { asChild: !0, children: /* @__PURE__ */ u.jsx($o, { ...r, children: a && /* @__PURE__ */ u.jsxs(u.Fragment, { children: [
    o.label,
    " ",
    t
  ] }) }) });
}, aS = "ToastTitle", Dh = y.forwardRef(
  (e, n) => {
    const { __scopeToast: t, ...r } = e;
    return /* @__PURE__ */ u.jsx(se.div, { ...r, ref: n });
  }
);
Dh.displayName = aS;
var iS = "ToastDescription", Rh = y.forwardRef(
  (e, n) => {
    const { __scopeToast: t, ...r } = e;
    return /* @__PURE__ */ u.jsx(se.div, { ...r, ref: n });
  }
);
Rh.displayName = iS;
var Nh = "ToastAction", Mh = y.forwardRef(
  (e, n) => {
    const { altText: t, ...r } = e;
    return t.trim() ? /* @__PURE__ */ u.jsx(jh, { altText: t, asChild: !0, children: /* @__PURE__ */ u.jsx(xc, { ...r, ref: n }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${Nh}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
Mh.displayName = Nh;
var Oh = "ToastClose", xc = y.forwardRef(
  (e, n) => {
    const { __scopeToast: t, ...r } = e, o = nS(Oh, t);
    return /* @__PURE__ */ u.jsx(jh, { asChild: !0, children: /* @__PURE__ */ u.jsx(
      se.button,
      {
        type: "button",
        ...r,
        ref: n,
        onClick: ne(e.onClick, o.onClose)
      }
    ) });
  }
);
xc.displayName = Oh;
var jh = y.forwardRef((e, n) => {
  const { __scopeToast: t, altText: r, ...o } = e;
  return /* @__PURE__ */ u.jsx(
    se.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": r || void 0,
      ...o,
      ref: n
    }
  );
});
function Ah(e) {
  const n = [];
  return Array.from(e.childNodes).forEach((r) => {
    if (r.nodeType === r.TEXT_NODE && r.textContent && n.push(r.textContent), cS(r)) {
      const o = r.ariaHidden || r.hidden || r.style.display === "none", a = r.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (a) {
          const i = r.dataset.radixToastAnnounceAlt;
          i && n.push(i);
        } else
          n.push(...Ah(r));
    }
  }), n;
}
function $r(e, n, t, { discrete: r }) {
  const o = t.originalEvent.currentTarget, a = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: t });
  n && o.addEventListener(e, n, { once: !0 }), r ? ai(o, a) : o.dispatchEvent(a);
}
var qu = (e, n, t = 0) => {
  const r = Math.abs(e.x), o = Math.abs(e.y), a = r > o;
  return n === "left" || n === "right" ? a && r > t : !a && o > t;
};
function sS(e = () => {
}) {
  const n = tt(e);
  Kt(() => {
    let t = 0, r = 0;
    return t = window.requestAnimationFrame(() => r = window.requestAnimationFrame(n)), () => {
      window.cancelAnimationFrame(t), window.cancelAnimationFrame(r);
    };
  }, [n]);
}
function cS(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function uS(e) {
  const n = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) n.push(t.currentNode);
  return n;
}
function Ea(e) {
  const n = document.activeElement;
  return e.some((t) => t === n ? !0 : (t.focus(), document.activeElement !== n));
}
var lS = Sh;
const dS = ({ className: e, ...n }) => /* @__PURE__ */ u.jsx(
  xc,
  {
    ...n,
    className: P(e, "goat-ToastClose"),
    asChild: !0,
    children: /* @__PURE__ */ u.jsx(ft, { variant: "ghost-inverted", icon: Bt })
  }
), fS = ({
  className: e,
  children: n,
  ...t
}) => /* @__PURE__ */ u.jsx(
  Rh,
  {
    ...t,
    className: P(e, "goat-ToastDescription"),
    asChild: !0,
    children: /* @__PURE__ */ u.jsx(rt, { as: "div", type: "body-medium", color: "white", children: n })
  }
), pS = ({ sentiment: e }) => e === "positive" ? /* @__PURE__ */ u.jsx(Ke, { className: "goat-ToastIcon", as: sl }) : e === "negative" ? /* @__PURE__ */ u.jsx(Ke, { className: "goat-ToastIcon", as: Pm }) : e === "informative" ? /* @__PURE__ */ u.jsx(Ke, { className: "goat-ToastIcon", as: il }) : e === "attentive" ? /* @__PURE__ */ u.jsx(Ke, { className: "goat-ToastIcon", as: Da }) : null, hS = ({
  className: e,
  children: n,
  ...t
}) => /* @__PURE__ */ u.jsx(
  Dh,
  {
    ...t,
    className: P(e, "goat-ToastTitle"),
    asChild: !0,
    children: /* @__PURE__ */ u.jsx(rt, { as: "div", type: "title-medium", color: "white", children: n })
  }
), mS = ({ className: e, ...n }) => /* @__PURE__ */ u.jsx(
  Eh,
  {
    ...n,
    className: P(e, "goat-ToastViewport")
  }
), vS = ({
  className: e,
  children: n,
  ...t
}) => /* @__PURE__ */ u.jsx(
  Mh,
  {
    ...t,
    className: P(e, "goat-ToastAction"),
    asChild: !0,
    children: /* @__PURE__ */ u.jsx(m0, { as: "button", color: "inverted", children: n })
  }
), Tr = A(function({
  as: n = "li",
  children: t,
  className: r,
  dismissable: o,
  icon: a,
  sentiment: i = "neutral",
  ...s
}, c) {
  return /* @__PURE__ */ u.jsx(
    lS,
    {
      ...s,
      className: P(r, "goat-Toast", `goat-Toast_${i}`),
      ref: c,
      asChild: !0,
      children: /* @__PURE__ */ u.jsxs(n, { children: [
        a && /* @__PURE__ */ u.jsx(pS, { sentiment: i }),
        /* @__PURE__ */ u.jsx("div", { className: "goat-ToastContent", children: t }),
        o && /* @__PURE__ */ u.jsx(dS, {})
      ] })
    }
  );
});
Tr.Provider = Ih;
Tr.Viewport = mS;
Tr.Title = hS;
Tr.Description = fS;
Tr.Action = vS;
var [Ho, rR] = At("Tooltip", [
  Hn
]), Wo = Hn(), kh = "TooltipProvider", gS = 700, ei = "tooltip.open", [yS, wc] = Ho(kh), Lh = (e) => {
  const {
    __scopeTooltip: n,
    delayDuration: t = gS,
    skipDelayDuration: r = 300,
    disableHoverableContent: o = !1,
    children: a
  } = e, [i, s] = y.useState(!0), c = y.useRef(!1), l = y.useRef(0);
  return y.useEffect(() => {
    const d = l.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ u.jsx(
    yS,
    {
      scope: n,
      isOpenDelayed: i,
      delayDuration: t,
      onOpen: y.useCallback(() => {
        window.clearTimeout(l.current), s(!1);
      }, []),
      onClose: y.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s(!0),
          r
        );
      }, [r]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: y.useCallback((d) => {
        c.current = d;
      }, []),
      disableHoverableContent: o,
      children: a
    }
  );
};
Lh.displayName = kh;
var Bo = "Tooltip", [bS, Er] = Ho(Bo), $h = (e) => {
  const {
    __scopeTooltip: n,
    children: t,
    open: r,
    defaultOpen: o = !1,
    onOpenChange: a,
    disableHoverableContent: i,
    delayDuration: s
  } = e, c = wc(Bo, e.__scopeTooltip), l = Wo(n), [d, f] = y.useState(null), p = It(), m = y.useRef(0), g = i ?? c.disableHoverableContent, h = s ?? c.delayDuration, v = y.useRef(!1), [w = !1, b] = Ue({
    prop: r,
    defaultProp: o,
    onChange: (D) => {
      D ? (c.onOpen(), document.dispatchEvent(new CustomEvent(ei))) : c.onClose(), a == null || a(D);
    }
  }), x = y.useMemo(() => w ? v.current ? "delayed-open" : "instant-open" : "closed", [w]), C = y.useCallback(() => {
    window.clearTimeout(m.current), v.current = !1, b(!0);
  }, [b]), _ = y.useCallback(() => {
    window.clearTimeout(m.current), b(!1);
  }, [b]), E = y.useCallback(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      v.current = !0, b(!0);
    }, h);
  }, [h, b]);
  return y.useEffect(() => () => window.clearTimeout(m.current), []), /* @__PURE__ */ u.jsx(Ui, { ...l, children: /* @__PURE__ */ u.jsx(
    bS,
    {
      scope: n,
      contentId: p,
      open: w,
      stateAttribute: x,
      trigger: d,
      onTriggerChange: f,
      onTriggerEnter: y.useCallback(() => {
        c.isOpenDelayed ? E() : C();
      }, [c.isOpenDelayed, E, C]),
      onTriggerLeave: y.useCallback(() => {
        g ? _() : window.clearTimeout(m.current);
      }, [_, g]),
      onOpen: C,
      onClose: _,
      disableHoverableContent: g,
      children: t
    }
  ) });
};
$h.displayName = Bo;
var ti = "TooltipTrigger", Fh = y.forwardRef(
  (e, n) => {
    const { __scopeTooltip: t, ...r } = e, o = Er(ti, t), a = wc(ti, t), i = Wo(t), s = y.useRef(null), c = Me(n, s, o.onTriggerChange), l = y.useRef(!1), d = y.useRef(!1), f = y.useCallback(() => l.current = !1, []);
    return y.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ u.jsx(No, { asChild: !0, ...i, children: /* @__PURE__ */ u.jsx(
      se.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...r,
        ref: c,
        onPointerMove: ne(e.onPointerMove, (p) => {
          p.pointerType !== "touch" && !d.current && !a.isPointerInTransitRef.current && (o.onTriggerEnter(), d.current = !0);
        }),
        onPointerLeave: ne(e.onPointerLeave, () => {
          o.onTriggerLeave(), d.current = !1;
        }),
        onPointerDown: ne(e.onPointerDown, () => {
          l.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: ne(e.onFocus, () => {
          l.current || o.onOpen();
        }),
        onBlur: ne(e.onBlur, o.onClose),
        onClick: ne(e.onClick, o.onClose)
      }
    ) });
  }
);
Fh.displayName = ti;
var _c = "TooltipPortal", [xS, wS] = Ho(_c, {
  forceMount: void 0
}), Vh = (e) => {
  const { __scopeTooltip: n, forceMount: t, children: r, container: o } = e, a = Er(_c, n);
  return /* @__PURE__ */ u.jsx(xS, { scope: n, forceMount: t, children: /* @__PURE__ */ u.jsx(nt, { present: t || a.open, children: /* @__PURE__ */ u.jsx($n, { asChild: !0, container: o, children: r }) }) });
};
Vh.displayName = _c;
var An = "TooltipContent", Hh = y.forwardRef(
  (e, n) => {
    const t = wS(An, e.__scopeTooltip), { forceMount: r = t.forceMount, side: o = "top", ...a } = e, i = Er(An, e.__scopeTooltip);
    return /* @__PURE__ */ u.jsx(nt, { present: r || i.open, children: i.disableHoverableContent ? /* @__PURE__ */ u.jsx(Wh, { side: o, ...a, ref: n }) : /* @__PURE__ */ u.jsx(_S, { side: o, ...a, ref: n }) });
  }
), _S = y.forwardRef((e, n) => {
  const t = Er(An, e.__scopeTooltip), r = wc(An, e.__scopeTooltip), o = y.useRef(null), a = Me(n, o), [i, s] = y.useState(null), { trigger: c, onClose: l } = t, d = o.current, { onPointerInTransitChange: f } = r, p = y.useCallback(() => {
    s(null), f(!1);
  }, [f]), m = y.useCallback(
    (g, h) => {
      const v = g.currentTarget, w = { x: g.clientX, y: g.clientY }, b = TS(w, v.getBoundingClientRect()), x = ES(w, b), C = PS(h.getBoundingClientRect()), _ = DS([...x, ...C]);
      s(_), f(!0);
    },
    [f]
  );
  return y.useEffect(() => () => p(), [p]), y.useEffect(() => {
    if (c && d) {
      const g = (v) => m(v, d), h = (v) => m(v, c);
      return c.addEventListener("pointerleave", g), d.addEventListener("pointerleave", h), () => {
        c.removeEventListener("pointerleave", g), d.removeEventListener("pointerleave", h);
      };
    }
  }, [c, d, m, p]), y.useEffect(() => {
    if (i) {
      const g = (h) => {
        const v = h.target, w = { x: h.clientX, y: h.clientY }, b = (c == null ? void 0 : c.contains(v)) || (d == null ? void 0 : d.contains(v)), x = !SS(w, i);
        b ? p() : x && (p(), l());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [c, d, i, l, p]), /* @__PURE__ */ u.jsx(Wh, { ...e, ref: a });
}), [CS, IS] = Ho(Bo, { isInside: !1 }), Wh = y.forwardRef(
  (e, n) => {
    const {
      __scopeTooltip: t,
      children: r,
      "aria-label": o,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      ...s
    } = e, c = Er(An, t), l = Wo(t), { onClose: d } = c;
    return y.useEffect(() => (document.addEventListener(ei, d), () => document.removeEventListener(ei, d)), [d]), y.useEffect(() => {
      if (c.trigger) {
        const f = (p) => {
          const m = p.target;
          m != null && m.contains(c.trigger) && d();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [c.trigger, d]), /* @__PURE__ */ u.jsx(
      Ln,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: i,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: d,
        children: /* @__PURE__ */ u.jsxs(
          Gi,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...s,
            ref: n,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ u.jsx(cl, { children: r }),
              /* @__PURE__ */ u.jsx(CS, { scope: t, isInside: !0, children: /* @__PURE__ */ u.jsx(UP, { id: c.contentId, role: "tooltip", children: o || r }) })
            ]
          }
        )
      }
    );
  }
);
Hh.displayName = An;
var Bh = "TooltipArrow", Kh = y.forwardRef(
  (e, n) => {
    const { __scopeTooltip: t, ...r } = e, o = Wo(t);
    return IS(
      Bh,
      t
    ).isInside ? null : /* @__PURE__ */ u.jsx(zi, { ...o, ...r, ref: n });
  }
);
Kh.displayName = Bh;
function TS(e, n) {
  const t = Math.abs(n.top - e.y), r = Math.abs(n.bottom - e.y), o = Math.abs(n.right - e.x), a = Math.abs(n.left - e.x);
  switch (Math.min(t, r, o, a)) {
    case a:
      return "left";
    case o:
      return "right";
    case t:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function ES(e, n, t = 5) {
  const r = [];
  switch (n) {
    case "top":
      r.push(
        { x: e.x - t, y: e.y + t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "bottom":
      r.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x + t, y: e.y - t }
      );
      break;
    case "left":
      r.push(
        { x: e.x + t, y: e.y - t },
        { x: e.x + t, y: e.y + t }
      );
      break;
    case "right":
      r.push(
        { x: e.x - t, y: e.y - t },
        { x: e.x - t, y: e.y + t }
      );
      break;
  }
  return r;
}
function PS(e) {
  const { top: n, right: t, bottom: r, left: o } = e;
  return [
    { x: o, y: n },
    { x: t, y: n },
    { x: t, y: r },
    { x: o, y: r }
  ];
}
function SS(e, n) {
  const { x: t, y: r } = e;
  let o = !1;
  for (let a = 0, i = n.length - 1; a < n.length; i = a++) {
    const s = n[a].x, c = n[a].y, l = n[i].x, d = n[i].y;
    c > r != d > r && t < (l - s) * (r - c) / (d - c) + s && (o = !o);
  }
  return o;
}
function DS(e) {
  const n = e.slice();
  return n.sort((t, r) => t.x < r.x ? -1 : t.x > r.x ? 1 : t.y < r.y ? -1 : t.y > r.y ? 1 : 0), RS(n);
}
function RS(e) {
  if (e.length <= 1) return e.slice();
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const o = e[r];
    for (; n.length >= 2; ) {
      const a = n[n.length - 1], i = n[n.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) n.pop();
      else break;
    }
    n.push(o);
  }
  n.pop();
  const t = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const o = e[r];
    for (; t.length >= 2; ) {
      const a = t[t.length - 1], i = t[t.length - 2];
      if ((a.x - i.x) * (o.y - i.y) >= (a.y - i.y) * (o.x - i.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  return t.pop(), n.length === 1 && t.length === 1 && n[0].x === t[0].x && n[0].y === t[0].y ? n : n.concat(t);
}
var NS = Lh, MS = $h, OS = Fh, jS = Vh, AS = Hh, Xu = Kh;
const kS = A(function({
  as: n = "div",
  children: t,
  className: r,
  side: o = "right",
  sideOffset: a = 4,
  mode: i = "default",
  portalProps: s = {},
  ...c
}, l) {
  return /* @__PURE__ */ u.jsx(jS, { ...s, children: /* @__PURE__ */ u.jsx(
    AS,
    {
      ...c,
      asChild: !0,
      className: P("goat-Tooltip", `goat-Tooltip_${i}`, r),
      side: o,
      sideOffset: a,
      ref: l,
      children: /* @__PURE__ */ u.jsxs(n, { children: [
        i === "light" && /* @__PURE__ */ u.jsx(
          Xu,
          {
            className: P("goat-Tooltip__ArrowStroke_light", r),
            height: 7,
            width: 11
          }
        ),
        /* @__PURE__ */ u.jsx(
          Xu,
          {
            className: P(`goat-Tooltip__Arrow_${i}`, r),
            height: 6,
            width: 11
          }
        ),
        t
      ] })
    }
  ) });
}), LS = A(function({ className: n, ...t }, r) {
  return /* @__PURE__ */ u.jsx(
    "button",
    {
      ...t,
      className: P("goat-Tooltip__Trigger", n),
      ref: r,
      type: "button"
    }
  );
}), $S = A(function({ as: n = LS, children: t, ...r }, o) {
  return /* @__PURE__ */ u.jsx(OS, { ...r, asChild: !0, ref: o, children: /* @__PURE__ */ u.jsx(n, { children: t }) });
}), Yh = ({
  children: e,
  disabled: n,
  delayDuration: t = 100,
  open: r,
  ...o
}) => /* @__PURE__ */ u.jsx(NS, { children: /* @__PURE__ */ u.jsx(
  MS,
  {
    ...o,
    delayDuration: t,
    open: r ?? (n ? !1 : void 0),
    children: e
  }
) });
Yh.Trigger = $S;
Yh.Content = kS;
const oR = ({
  children: e,
  trend: n = "increase",
  sentiment: t = "positive",
  disabled: r = !1,
  className: o,
  ...a
}) => {
  const i = P(
    "goat-TrendTag",
    {
      "goat-TrendTag_disabled": r,
      [`goat-TrendTag_${t}`]: !r
    },
    o
  );
  return /* @__PURE__ */ u.jsxs("div", { className: i, ...a, children: [
    /* @__PURE__ */ u.jsx("div", { className: P(`goat-TrendTag_${n}`), children: /* @__PURE__ */ u.jsx(
      "svg",
      {
        width: "12",
        height: "10",
        viewBox: "0 0 12 10",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ u.jsx("path", { d: "M0.596591 10L6.05114 0.727272L11.5057 10H0.596591Z" })
      }
    ) }),
    e
  ] });
}, aR = A(function({
  as: n = "p",
  children: t,
  className: r,
  if: o,
  sentiment: a = o && o !== "valid" ? "negative" : "neutral",
  ...i
}, s) {
  const c = gt(), l = Vl(), d = i.id ?? l;
  return le(() => c.addDescribedById(d), [d]), VS(c, o) ? null : /* @__PURE__ */ u.jsx(
    n,
    {
      ...i,
      className: P(
        "goat-Validation",
        `goat-Validation_${a}`,
        r
      ),
      id: d,
      ref: s,
      children: t || FS(o, c)
    }
  );
}), FS = (e, n) => e === "customError" && n.validity.customError && n.validationMessage;
function VS(e, n) {
  return n ? n === "valid" ? e.touched && !e.validity.valid : e.touched ? n === "invalid" ? e.validity.valid : !e.validity[n] : !0 : !1;
}
const Uh = Se({
  header: null,
  top: 0
}), HS = () => {
  const e = ve(Uh);
  if (!e)
    throw new Error(
      "VirtualTable compound components cannot be rendered outside the VirtualTable component"
    );
  return e;
};
function Qu(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
var Zu = Number.isNaN || function(n) {
  return typeof n == "number" && n !== n;
};
function WS(e, n) {
  return !!(e === n || Zu(e) && Zu(n));
}
function BS(e, n) {
  if (e.length !== n.length)
    return !1;
  for (var t = 0; t < e.length; t++)
    if (!WS(e[t], n[t]))
      return !1;
  return !0;
}
function Pa(e, n) {
  n === void 0 && (n = BS);
  var t, r = [], o, a = !1;
  function i() {
    for (var s = [], c = 0; c < arguments.length; c++)
      s[c] = arguments[c];
    return a && t === this && n(s, r) || (o = e.apply(this, s), a = !0, t = this, r = s), o;
  }
  return i;
}
var KS = typeof performance == "object" && typeof performance.now == "function", Ju = KS ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function el(e) {
  cancelAnimationFrame(e.id);
}
function YS(e, n) {
  var t = Ju();
  function r() {
    Ju() - t >= n ? e.call(null) : o.id = requestAnimationFrame(r);
  }
  var o = {
    id: requestAnimationFrame(r)
  };
  return o;
}
var Sa = -1;
function tl(e) {
  if (e === void 0 && (e = !1), Sa === -1 || e) {
    var n = document.createElement("div"), t = n.style;
    t.width = "50px", t.height = "50px", t.overflow = "scroll", document.body.appendChild(n), Sa = n.offsetWidth - n.clientWidth, document.body.removeChild(n);
  }
  return Sa;
}
var Cn = null;
function nl(e) {
  if (e === void 0 && (e = !1), Cn === null || e) {
    var n = document.createElement("div"), t = n.style;
    t.width = "50px", t.height = "50px", t.overflow = "scroll", t.direction = "rtl";
    var r = document.createElement("div"), o = r.style;
    return o.width = "100px", o.height = "100px", n.appendChild(r), document.body.appendChild(n), n.scrollLeft > 0 ? Cn = "positive-descending" : (n.scrollLeft = 1, n.scrollLeft === 0 ? Cn = "negative" : Cn = "positive-ascending"), document.body.removeChild(n), Cn;
  }
  return Cn;
}
process.env.NODE_ENV;
var US = 150, GS = function(n, t) {
  return n;
}, Ur = null, Gr = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (Ur = /* @__PURE__ */ new WeakSet(), Gr = /* @__PURE__ */ new WeakSet());
function zS(e) {
  var n, t = e.getItemOffset, r = e.getEstimatedTotalSize, o = e.getItemSize, a = e.getOffsetForIndexAndAlignment, i = e.getStartIndexForOffset, s = e.getStopIndexForStartIndex, c = e.initInstanceProps, l = e.shouldResetStyleCacheOnItemSizeChange, d = e.validateProps;
  return n = /* @__PURE__ */ function(f) {
    mp(p, f);
    function p(g) {
      var h;
      return h = f.call(this, g) || this, h._instanceProps = c(h.props, Qu(h)), h._outerRef = void 0, h._resetIsScrollingTimeoutId = null, h.state = {
        instance: Qu(h),
        isScrolling: !1,
        scrollDirection: "forward",
        scrollOffset: typeof h.props.initialScrollOffset == "number" ? h.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: !1
      }, h._callOnItemsRendered = void 0, h._callOnItemsRendered = Pa(function(v, w, b, x) {
        return h.props.onItemsRendered({
          overscanStartIndex: v,
          overscanStopIndex: w,
          visibleStartIndex: b,
          visibleStopIndex: x
        });
      }), h._callOnScroll = void 0, h._callOnScroll = Pa(function(v, w, b) {
        return h.props.onScroll({
          scrollDirection: v,
          scrollOffset: w,
          scrollUpdateWasRequested: b
        });
      }), h._getItemStyle = void 0, h._getItemStyle = function(v) {
        var w = h.props, b = w.direction, x = w.itemSize, C = w.layout, _ = h._getItemStyleCache(l && x, l && C, l && b), E;
        if (_.hasOwnProperty(v))
          E = _[v];
        else {
          var D = t(h.props, v, h._instanceProps), T = o(h.props, v, h._instanceProps), S = b === "horizontal" || C === "horizontal", N = b === "rtl", k = S ? D : 0;
          _[v] = E = {
            position: "absolute",
            left: N ? void 0 : k,
            right: N ? k : void 0,
            top: S ? 0 : D,
            height: S ? "100%" : T,
            width: S ? T : "100%"
          };
        }
        return E;
      }, h._getItemStyleCache = void 0, h._getItemStyleCache = Pa(function(v, w, b) {
        return {};
      }), h._onScrollHorizontal = function(v) {
        var w = v.currentTarget, b = w.clientWidth, x = w.scrollLeft, C = w.scrollWidth;
        h.setState(function(_) {
          if (_.scrollOffset === x)
            return null;
          var E = h.props.direction, D = x;
          if (E === "rtl")
            switch (nl()) {
              case "negative":
                D = -x;
                break;
              case "positive-descending":
                D = C - b - x;
                break;
            }
          return D = Math.max(0, Math.min(D, C - b)), {
            isScrolling: !0,
            scrollDirection: _.scrollOffset < D ? "forward" : "backward",
            scrollOffset: D,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._onScrollVertical = function(v) {
        var w = v.currentTarget, b = w.clientHeight, x = w.scrollHeight, C = w.scrollTop;
        h.setState(function(_) {
          if (_.scrollOffset === C)
            return null;
          var E = Math.max(0, Math.min(C, x - b));
          return {
            isScrolling: !0,
            scrollDirection: _.scrollOffset < E ? "forward" : "backward",
            scrollOffset: E,
            scrollUpdateWasRequested: !1
          };
        }, h._resetIsScrollingDebounced);
      }, h._outerRefSetter = function(v) {
        var w = h.props.outerRef;
        h._outerRef = v, typeof w == "function" ? w(v) : w != null && typeof w == "object" && w.hasOwnProperty("current") && (w.current = v);
      }, h._resetIsScrollingDebounced = function() {
        h._resetIsScrollingTimeoutId !== null && el(h._resetIsScrollingTimeoutId), h._resetIsScrollingTimeoutId = YS(h._resetIsScrolling, US);
      }, h._resetIsScrolling = function() {
        h._resetIsScrollingTimeoutId = null, h.setState({
          isScrolling: !1
        }, function() {
          h._getItemStyleCache(-1, null);
        });
      }, h;
    }
    p.getDerivedStateFromProps = function(h, v) {
      return qS(h, v), d(h), null;
    };
    var m = p.prototype;
    return m.scrollTo = function(h) {
      h = Math.max(0, h), this.setState(function(v) {
        return v.scrollOffset === h ? null : {
          scrollDirection: v.scrollOffset < h ? "forward" : "backward",
          scrollOffset: h,
          scrollUpdateWasRequested: !0
        };
      }, this._resetIsScrollingDebounced);
    }, m.scrollToItem = function(h, v) {
      v === void 0 && (v = "auto");
      var w = this.props, b = w.itemCount, x = w.layout, C = this.state.scrollOffset;
      h = Math.max(0, Math.min(h, b - 1));
      var _ = 0;
      if (this._outerRef) {
        var E = this._outerRef;
        x === "vertical" ? _ = E.scrollWidth > E.clientWidth ? tl() : 0 : _ = E.scrollHeight > E.clientHeight ? tl() : 0;
      }
      this.scrollTo(a(this.props, h, v, C, this._instanceProps, _));
    }, m.componentDidMount = function() {
      var h = this.props, v = h.direction, w = h.initialScrollOffset, b = h.layout;
      if (typeof w == "number" && this._outerRef != null) {
        var x = this._outerRef;
        v === "horizontal" || b === "horizontal" ? x.scrollLeft = w : x.scrollTop = w;
      }
      this._callPropsCallbacks();
    }, m.componentDidUpdate = function() {
      var h = this.props, v = h.direction, w = h.layout, b = this.state, x = b.scrollOffset, C = b.scrollUpdateWasRequested;
      if (C && this._outerRef != null) {
        var _ = this._outerRef;
        if (v === "horizontal" || w === "horizontal")
          if (v === "rtl")
            switch (nl()) {
              case "negative":
                _.scrollLeft = -x;
                break;
              case "positive-ascending":
                _.scrollLeft = x;
                break;
              default:
                var E = _.clientWidth, D = _.scrollWidth;
                _.scrollLeft = D - E - x;
                break;
            }
          else
            _.scrollLeft = x;
        else
          _.scrollTop = x;
      }
      this._callPropsCallbacks();
    }, m.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && el(this._resetIsScrollingTimeoutId);
    }, m.render = function() {
      var h = this.props, v = h.children, w = h.className, b = h.direction, x = h.height, C = h.innerRef, _ = h.innerElementType, E = h.innerTagName, D = h.itemCount, T = h.itemData, S = h.itemKey, N = S === void 0 ? GS : S, k = h.layout, Y = h.outerElementType, U = h.outerTagName, j = h.style, oe = h.useIsScrolling, q = h.width, O = this.state.isScrolling, M = b === "horizontal" || k === "horizontal", B = M ? this._onScrollHorizontal : this._onScrollVertical, R = this._getRangeToRender(), V = R[0], F = R[1], $ = [];
      if (D > 0)
        for (var L = V; L <= F; L++)
          $.push(qo(v, {
            data: T,
            key: N(L, T),
            index: L,
            isScrolling: oe ? O : void 0,
            style: this._getItemStyle(L)
          }));
      var G = r(this.props, this._instanceProps);
      return qo(Y || U || "div", {
        className: w,
        onScroll: B,
        ref: this._outerRefSetter,
        style: ce({
          position: "relative",
          height: x,
          width: q,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: b
        }, j)
      }, qo(_ || E || "div", {
        children: $,
        ref: C,
        style: {
          height: M ? "100%" : G,
          pointerEvents: O ? "none" : void 0,
          width: M ? G : "100%"
        }
      }));
    }, m._callPropsCallbacks = function() {
      if (typeof this.props.onItemsRendered == "function") {
        var h = this.props.itemCount;
        if (h > 0) {
          var v = this._getRangeToRender(), w = v[0], b = v[1], x = v[2], C = v[3];
          this._callOnItemsRendered(w, b, x, C);
        }
      }
      if (typeof this.props.onScroll == "function") {
        var _ = this.state, E = _.scrollDirection, D = _.scrollOffset, T = _.scrollUpdateWasRequested;
        this._callOnScroll(E, D, T);
      }
    }, m._getRangeToRender = function() {
      var h = this.props, v = h.itemCount, w = h.overscanCount, b = this.state, x = b.isScrolling, C = b.scrollDirection, _ = b.scrollOffset;
      if (v === 0)
        return [0, 0, 0, 0];
      var E = i(this.props, _, this._instanceProps), D = s(this.props, E, _, this._instanceProps), T = !x || C === "backward" ? Math.max(1, w) : 1, S = !x || C === "forward" ? Math.max(1, w) : 1;
      return [Math.max(0, E - T), Math.max(0, Math.min(v - 1, D + S)), E, D];
    }, p;
  }(mm), n.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    layout: "vertical",
    overscanCount: 2,
    useIsScrolling: !1
  }, n;
}
var qS = function(n, t) {
  var r = n.children, o = n.direction, a = n.height, i = n.layout, s = n.innerTagName, c = n.outerTagName, l = n.width, d = t.instance;
  if (process.env.NODE_ENV !== "production") {
    (s != null || c != null) && Gr && !Gr.has(d) && (Gr.add(d), console.warn("The innerTagName and outerTagName props have been deprecated. Please use the innerElementType and outerElementType props instead."));
    var f = o === "horizontal" || i === "horizontal";
    switch (o) {
      case "horizontal":
      case "vertical":
        Ur && !Ur.has(d) && (Ur.add(d), console.warn('The direction prop should be either "ltr" (default) or "rtl". Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.'));
        break;
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + o + '" was specified.'));
    }
    switch (i) {
      case "horizontal":
      case "vertical":
        break;
      default:
        throw Error('An invalid "layout" prop has been specified. Value should be either "horizontal" or "vertical". ' + ('"' + i + '" was specified.'));
    }
    if (r == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (r === null ? "null" : typeof r) + '" was specified.'));
    if (f && typeof l != "number")
      throw Error('An invalid "width" prop has been specified. Horizontal lists must specify a number for width. ' + ('"' + (l === null ? "null" : typeof l) + '" was specified.'));
    if (!f && typeof a != "number")
      throw Error('An invalid "height" prop has been specified. Vertical lists must specify a number for height. ' + ('"' + (a === null ? "null" : typeof a) + '" was specified.'));
  }
}, XS = /* @__PURE__ */ zS({
  getItemOffset: function(n, t) {
    var r = n.itemSize;
    return t * r;
  },
  getItemSize: function(n, t) {
    var r = n.itemSize;
    return r;
  },
  getEstimatedTotalSize: function(n) {
    var t = n.itemCount, r = n.itemSize;
    return r * t;
  },
  getOffsetForIndexAndAlignment: function(n, t, r, o, a, i) {
    var s = n.direction, c = n.height, l = n.itemCount, d = n.itemSize, f = n.layout, p = n.width, m = s === "horizontal" || f === "horizontal", g = m ? p : c, h = Math.max(0, l * d - g), v = Math.min(h, t * d), w = Math.max(0, t * d - g + d + i);
    switch (r === "smart" && (o >= w - g && o <= v + g ? r = "auto" : r = "center"), r) {
      case "start":
        return v;
      case "end":
        return w;
      case "center": {
        var b = Math.round(w + (v - w) / 2);
        return b < Math.ceil(g / 2) ? 0 : b > h + Math.floor(g / 2) ? h : b;
      }
      case "auto":
      default:
        return o >= w && o <= v ? o : o < w ? w : v;
    }
  },
  getStartIndexForOffset: function(n, t) {
    var r = n.itemCount, o = n.itemSize;
    return Math.max(0, Math.min(r - 1, Math.floor(t / o)));
  },
  getStopIndexForStartIndex: function(n, t, r) {
    var o = n.direction, a = n.height, i = n.itemCount, s = n.itemSize, c = n.layout, l = n.width, d = o === "horizontal" || c === "horizontal", f = t * s, p = d ? l : a, m = Math.ceil((p + r - f) / s);
    return Math.max(0, Math.min(
      i - 1,
      t + m - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(n) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(n) {
    var t = n.itemSize;
    if (process.env.NODE_ENV !== "production" && typeof t != "number")
      throw Error('An invalid "itemSize" prop has been specified. Value should be a number. ' + ('"' + (t === null ? "null" : typeof t) + '" was specified.'));
  }
});
const QS = A(function({ children: n, as: t, className: r, ...o }, a) {
  const i = P("goat-VirtualTable_Footer", r), s = t ?? "div";
  return /* @__PURE__ */ u.jsx(s, { ...o, className: i, ref: a, children: n });
}), ZS = A(function({ children: n, as: t, className: r, ...o }, a) {
  const i = P("goat-VirtualTable_Layout", r), s = t ?? "figure";
  return /* @__PURE__ */ u.jsx(s, { ...o, className: i, ref: a, children: n });
}), JS = A(function({ children: n, ...t }, r) {
  const { top: o, header: a, tableProps: i, footer: s } = HS();
  return /* @__PURE__ */ u.jsx("div", { ...t, children: /* @__PURE__ */ u.jsxs(
    Lr.Root,
    {
      ...i,
      ref: r,
      style: { top: o, position: "absolute", width: "100%" },
      children: [
        /* @__PURE__ */ u.jsx(Lr.Head, { children: a }),
        /* @__PURE__ */ u.jsx(Lr.Body, { children: n }),
        s && /* @__PURE__ */ u.jsx(Lr.Footer, { children: s })
      ]
    }
  ) });
}), eD = 56, tD = A(
  function({
    children: n,
    tableProps: t,
    header: r,
    footer: o,
    onItemsRendered: a,
    itemCount: i,
    ...s
  }, c) {
    const l = me(), d = fr(c, l), [f, p] = De(0);
    return /* @__PURE__ */ u.jsx(
      Uh.Provider,
      {
        value: { header: r, top: f, footer: o, tableProps: t },
        children: /* @__PURE__ */ u.jsx(
          XS,
          {
            ...s,
            itemCount: i,
            width: "100%",
            itemSize: eD,
            onItemsRendered: (m) => {
              const g = l.current && // eslint-disable-next-line @typescript-eslint/no-explicit-any
              l.current._getItemStyle(m.overscanStartIndex);
              g && p(g.top), a && a(m);
            },
            ref: d,
            children: n
          }
        )
      }
    );
  }
), iR = {
  Table: tD,
  Root: JS,
  Layout: ZS,
  Footer: QS
};
export {
  yo as Accordion,
  bo as AppTopbar,
  bi as Badge,
  Ol as Box,
  Ov as BrandIcon,
  jl as BrandTag,
  Al as Breadcrumb,
  Ge as Button,
  Ll as ButtonGroup,
  Bv as Card,
  Kl as Checkbox,
  vD as Chip,
  bD as Col,
  ji as Collapsible,
  SD as DatePicker,
  DD as Dialog,
  on as Drawer,
  hD as Field,
  RD as Fieldset,
  ND as Form,
  MD as Grid,
  wD as H1,
  fC as H2,
  _D as H3,
  CD as H4,
  ID as H5,
  Ke as Icon,
  ft as IconButton,
  Ba as Input,
  OD as InputWithTags,
  ws as Label,
  jD as Legend,
  m0 as Link,
  Un as ListItem,
  $v as Loader,
  Rs as Menu,
  LD as Notification,
  TD as P,
  Ns as Pagination,
  Lt as Panel,
  qI as PanelLayout,
  HD as PopoverClose,
  WD as PopoverContent,
  BD as PopoverFooter,
  KD as PopoverHeader,
  YD as PopoverRoot,
  UD as PopoverTrigger,
  pD as PrimerLoader,
  zD as ProgressBar,
  qD as Radio,
  XD as Row,
  VD as S,
  IT as Search,
  wt as Select,
  FD as SelectChip,
  Xt as Sidebar,
  ED as Span,
  aP as StatusTag,
  hc as Summary,
  ih as SummaryCollapsible,
  ZD as Switch,
  eR as Tab,
  FP as TabContent,
  BP as TabList,
  KP as TabRoot,
  VP as TabTrigger,
  Lr as Table,
  tR as Tabs,
  Sn as Tag,
  rt as Text,
  Tr as Toast,
  ma as Toggle,
  Yh as Tooltip,
  xi as Topbar,
  oR as TrendTag,
  aR as Validation,
  iR as VirtualTable,
  uD as animationTimingFunction,
  fv as borderRadius,
  kn as color,
  gi as composeRefs,
  cD as contrasts,
  P as cx,
  uv as sentimentColor,
  sD as sentiments,
  Oa as setInputValue,
  dv as shallowClone,
  _l as shallowEquals,
  Cl as space,
  vi as sx,
  lD as time,
  dD as typography,
  mD as useCheckboxGroup,
  fr as useComposedRefs,
  Ue as useControllableState,
  Cv as useDebounce,
  gt as useField,
  go as useForwardedRef,
  $D as usePagination,
  yi as usePrevious,
  Il as useReRender,
  fD as useReRenderEffect,
  qt as useSelectContext,
  HS as useVirtualTableContext
};
